import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { useFetchData } from '../graphql/customFetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AccWithDirChargeDelTaxReportEntry = {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  businessName: Scalars['String']['output'];
  directChargeAmount: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  taxYear: Scalars['Int']['output'];
};

export type AccountBalanceReport = {
  accountDetails: Array<AccountBalanceReportEntry>;
  reportDate?: Maybe<Scalars['String']['output']>;
};

export type AccountBalanceReportEntry = {
  accountNbr?: Maybe<Scalars['String']['output']>;
  acctJurisdiction?: Maybe<Scalars['Float']['output']>;
  acctTaxYear?: Maybe<Scalars['Float']['output']>;
  acctType?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  currentBalance?: Maybe<Scalars['Float']['output']>;
  delinquentBalance?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  mailingAddress1?: Maybe<Scalars['String']['output']>;
  mailingAddress2?: Maybe<Scalars['String']['output']>;
  mailingCareOf?: Maybe<Scalars['String']['output']>;
  mailingCity?: Maybe<Scalars['String']['output']>;
  mailingName?: Maybe<Scalars['String']['output']>;
  mailingState?: Maybe<Scalars['String']['output']>;
  mailingZip?: Maybe<Scalars['String']['output']>;
  penalty?: Maybe<Scalars['Float']['output']>;
  situsAddress1?: Maybe<Scalars['String']['output']>;
  situsAddress2?: Maybe<Scalars['String']['output']>;
  situsCareOf?: Maybe<Scalars['String']['output']>;
  situsCity?: Maybe<Scalars['String']['output']>;
  situsName?: Maybe<Scalars['String']['output']>;
  situsState?: Maybe<Scalars['String']['output']>;
  situsZip?: Maybe<Scalars['String']['output']>;
  totalBalance?: Maybe<Scalars['Float']['output']>;
};

export type AccountByAppraiserRegion = {
  accountId: Scalars['Int']['output'];
  accountNumber: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region: Scalars['String']['output'];
  regionId: Scalars['Int']['output'];
};

export type AccountByIndustrialPark = {
  accountId: Scalars['Int']['output'];
  accountNumber: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  code: Scalars['String']['output'];
  industrialParkId: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type AccountDelinquency = {
  accountId: Scalars['Int']['output'];
  accountNumber: Scalars['String']['output'];
  accountType?: Maybe<Scalars['String']['output']>;
  businessName: Scalars['String']['output'];
  delinquentBalance: Scalars['Float']['output'];
  lastPaymentDate?: Maybe<Scalars['String']['output']>;
  originalDelinquentYear: Scalars['Int']['output'];
  paymentPlan: PaymentPlanTemplate;
  summary: DelinquentFinancialSummary;
  totalCharges: Scalars['Float']['output'];
  totalInterest: Scalars['Float']['output'];
  totalPenalties: Scalars['Float']['output'];
  totalTax: Scalars['Float']['output'];
  transactions: Array<DelinquentTransaction>;
};

export type AccountReportEntry = {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  associatedAccounts: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isExempt: Scalars['Boolean']['output'];
  isReconciled: Scalars['Boolean']['output'];
  netAssmntChargeWithTotalDirect: Scalars['Float']['output'];
  payments: Scalars['Float']['output'];
  penalty: Scalars['Float']['output'];
  taxYear: Scalars['Int']['output'];
  totalTaxable: Scalars['Float']['output'];
  yearEndBalance: Scalars['Float']['output'];
};

export enum AccountSearchStatus {
  Found = 'FOUND',
  NotFound = 'NOT_FOUND'
}

export type AccountStatusInput = {
  accountId: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
};

export type AccountSummary = {
  assessmentCharge?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  currentBalance?: Maybe<Scalars['Float']['output']>;
  delinquentBalance?: Maybe<Scalars['Float']['output']>;
  directCharge?: Maybe<Scalars['Float']['output']>;
  interest?: Maybe<Scalars['Float']['output']>;
  payments?: Maybe<Scalars['Float']['output']>;
  penaltyCharge?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  taxable?: Maybe<Scalars['Float']['output']>;
  totalBalance?: Maybe<Scalars['Float']['output']>;
  totalBalanceWithDelinquent?: Maybe<Scalars['Float']['output']>;
};

export type AccountSummaryInput = {
  assessmentCharge?: InputMaybe<Scalars['Float']['input']>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  currentBalance?: InputMaybe<Scalars['Float']['input']>;
  delinquentBalance?: InputMaybe<Scalars['Float']['input']>;
  directCharge?: InputMaybe<Scalars['Float']['input']>;
  interest?: InputMaybe<Scalars['Float']['input']>;
  payments?: InputMaybe<Scalars['Float']['input']>;
  penaltyCharge?: InputMaybe<Scalars['Float']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  taxable?: InputMaybe<Scalars['Float']['input']>;
  totalBalance?: InputMaybe<Scalars['Float']['input']>;
};

/** Identify the category in which the Business Account falls into */
export type AccountType = {
  id: Scalars['ID']['output'];
  /** Human-readable label used to display in the application */
  label: Scalars['String']['output'];
};

export type AccountTypeInput = {
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
};

export type AccountsToOneYearExemptReportEntry = {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  taxYear: Scalars['Int']['output'];
};

export type AccountsWithCreditBalanceReportEntry = {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isExempt: Scalars['Boolean']['output'];
  taxYear: Scalars['Int']['output'];
  yearEndBalance: Scalars['String']['output'];
};

export type AccountsWithInvalidTaxAreaReportEntry = {
  accountNbr?: Maybe<Scalars['String']['output']>;
  acctTypeDescr?: Maybe<Scalars['String']['output']>;
  acctTypeId?: Maybe<Scalars['Int']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  exempt?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  leaseMasterAccountNbr?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  taxDistrict?: Maybe<Scalars['String']['output']>;
  taxYear?: Maybe<Scalars['Float']['output']>;
};

export type AccountsWithMissingTaxRateReportEntry = BasicReportResult & {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  leaseMasterAccountNbr?: Maybe<Scalars['String']['output']>;
  taxDistrict: Scalars['String']['output'];
  taxYear: Scalars['Int']['output'];
  telecomAccountNbr?: Maybe<Scalars['String']['output']>;
};

export type AccountsWithPriorYearCreditChargeReportEntry = {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  businessName: Scalars['String']['output'];
  directChargeAmount: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  taxYear: Scalars['Int']['output'];
};

/** Mailing Address: is the required primary's mailing address. A location identified by street, city, and state */
export type Address = {
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  inCareOf?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** Mailing Address validations are run on zod */
export type AddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryInput>;
  inCareOf?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AllCodes = {
  sicCodes: Array<CodeRow>;
  sicSiloCodes: Array<CodeRow>;
  subSiloCodes: Array<CodeRow>;
};

export type AllocateHoldingsToSubAccountsInput = {
  accountNumber: Scalars['String']['input'];
  businessName: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  payment: PaymentHoldingInput;
  postmarkDate: Scalars['String']['input'];
  subAccounts: Array<SubAccountAllocationInput>;
};

export type AppraiserRegion = {
  accountCount: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  newBusinessCount: Scalars['Int']['output'];
  region: Scalars['String']['output'];
  updateDate: Scalars['String']['output'];
  updatedBy: Scalars['Int']['output'];
};

export type AppraiserRegionJurConfig = {
  areaName?: Maybe<Scalars['String']['output']>;
  groupingLabel1?: Maybe<Scalars['String']['output']>;
  groupingLabel2?: Maybe<Scalars['String']['output']>;
};

export type AppraiserRegionSearchResult = {
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type ApproveMassAccountBatchResponse = {
  createdAccounts: Array<BatchCreatedAccounts>;
  failedAccounts: Array<BatchFailedAccounts>;
};

export type Asset = {
  classification?: Maybe<Scalars['String']['output']>;
  classificationDescription?: Maybe<Scalars['String']['output']>;
  costPer?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  ein?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  percentGood?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  taxableValue?: Maybe<Scalars['Int']['output']>;
  updateDate?: Maybe<Scalars['String']['output']>;
  yearAcquired?: Maybe<Scalars['Int']['output']>;
};

export type AssetInput = {
  classification: Scalars['String']['input'];
  costPer: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  percentGood: Scalars['Float']['input'];
  quantity: Scalars['Int']['input'];
  taxableValue: Scalars['Int']['input'];
  yearAcquired: Scalars['Int']['input'];
};

export type AssetResponse = {
  accountNumber?: Maybe<Scalars['String']['output']>;
  assets: Array<Asset>;
  isActive: Scalars['Boolean']['output'];
  isExempt: Scalars['Boolean']['output'];
};

export type AssociatedAccount = {
  accountId?: Maybe<Scalars['Int']['output']>;
  accountNumber: Scalars['String']['output'];
  accountType?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isExempt: Scalars['Boolean']['output'];
  isReconciled: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  taxableValue?: Maybe<Scalars['Float']['output']>;
};

export type AssociatedAccountAddress = {
  accountNumber: Scalars['String']['output'];
  address?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
};

export type AssociatedAccountGroup = {
  accounts: Array<AssociatedAccount>;
  id: Scalars['Int']['output'];
  totalTaxableValue: Scalars['Float']['output'];
};

export type AssociatedAccountGroupInput = {
  accountId: Scalars['Int']['input'];
  accounts: Array<AssociatedAccountInput>;
  id: Scalars['Int']['input'];
};

export type AssociatedAccountInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountNumber: Scalars['String']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isExempt?: InputMaybe<Scalars['Boolean']['input']>;
  isReconciled?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  taxableValue?: InputMaybe<Scalars['Float']['input']>;
};

export type Audit = {
  auditYear?: Maybe<Scalars['Int']['output']>;
  auditedBy?: Maybe<Scalars['String']['output']>;
};

export type AuditInput = {
  auditYear?: InputMaybe<Scalars['Int']['input']>;
};

export type Auth = {
  token: Scalars['String']['output'];
};

export type AuthenticationType = FailedAuthType | SuccessfulAuthType;

export type BalanceDueReasonEntry = {
  id: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
};

export type Bankruptcy = {
  bankruptcyType?: Maybe<AccountType>;
};

export type BankruptcyInput = {
  bankruptcyType?: InputMaybe<AccountTypeInput>;
};

export type BaseContact = {
  contactType?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneExtension?: Maybe<Scalars['String']['output']>;
};

export type BaseContactInput = {
  contactType?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExtension?: InputMaybe<Scalars['String']['input']>;
};

export type BasicCost = {
  baseYear: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  percentGood: Scalars['Float']['output'];
  propertyYear: Scalars['Int']['output'];
  scheduleId: Scalars['Int']['output'];
};

export type BasicCostInput = {
  baseYear: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  percentGood: Scalars['Float']['input'];
  propertyYear: Scalars['Int']['input'];
  scheduleId: Scalars['Int']['input'];
};

export type BasicReportResult = {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  leaseMasterAccountNbr?: Maybe<Scalars['String']['output']>;
  taxYear: Scalars['Int']['output'];
  telecomAccountNbr?: Maybe<Scalars['String']['output']>;
};

export type BasicReportResultType = BasicReportResult & {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  leaseMasterAccountNbr?: Maybe<Scalars['String']['output']>;
  taxYear: Scalars['Int']['output'];
  telecomAccountNbr?: Maybe<Scalars['String']['output']>;
};

export type BatchBusinessAccount = {
  accountNumber?: Maybe<Scalars['String']['output']>;
  accountType?: Maybe<Scalars['Int']['output']>;
  appraiserRegion?: Maybe<Scalars['Int']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  cityCode?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<BaseContact>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mailingAddress?: Maybe<Address>;
  parcelNumber?: Maybe<Scalars['String']['output']>;
  parcelUseType?: Maybe<Scalars['Int']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  situsAddress?: Maybe<Address>;
  status: BatchStatus;
  taxArea?: Maybe<Scalars['String']['output']>;
  taxSubArea?: Maybe<Scalars['String']['output']>;
};

export type BatchBusinessAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<Scalars['Int']['input']>;
  appraiserRegion?: InputMaybe<Scalars['Int']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  cityCode?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<BaseContactInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  mailingAddress?: InputMaybe<AddressInput>;
  parcelNumber?: InputMaybe<Scalars['String']['input']>;
  parcelUseType?: InputMaybe<Scalars['Int']['input']>;
  sicCode?: InputMaybe<Scalars['String']['input']>;
  situsAddress?: InputMaybe<AddressInput>;
  status: BatchStatusInput;
  taxArea?: InputMaybe<Scalars['String']['input']>;
  taxSubArea?: InputMaybe<Scalars['String']['input']>;
};

export type BatchBusinessAccountMin = {
  accountType?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mailingAddress?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  status: BatchStatus;
};

export type BatchCreatedAccounts = {
  accountId: Scalars['Int']['output'];
  accountNumber: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type BatchFailedAccounts = {
  errorMessage: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type BatchSearchResult = {
  batchStatus: Scalars['String']['output'];
  batchStatusId: Scalars['Int']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  canBeEdited: Scalars['Boolean']['output'];
  canBePaid: Scalars['Boolean']['output'];
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  processedDate?: Maybe<Scalars['String']['output']>;
  refundsCount: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export type BatchStatus = {
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BatchStatusInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type BulkUpdateAppraiserRegionInput = {
  fileName: Scalars['String']['input'];
};

export type BulkUpdateAppraiserRegionResult = {
  failedRows: Scalars['Int']['output'];
  results: Array<BulkUpdateAppraiserRegionResultRow>;
  rowsRead: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  updatedAccounts: Scalars['Int']['output'];
};

export type BulkUpdateAppraiserRegionResultRow = {
  accountNumber: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
};

export type BulkUpdateIndustrialParkInput = {
  fileName: Scalars['String']['input'];
};

export type BulkUpdateIndustrialParkResult = {
  failedRows: Scalars['Int']['output'];
  results: Array<BulkUpdateIndustrialParkResultRow>;
  rowsRead: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  updatedAccounts: Scalars['Int']['output'];
};

export type BulkUpdateIndustrialParkResultRow = {
  accountNumber: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
};

export type BusinessAccount = {
  accountNumber: Scalars['String']['output'];
  accountStatus?: Maybe<Scalars['String']['output']>;
  accountSummary?: Maybe<AccountSummary>;
  accountType: AccountType;
  adminLink?: Maybe<Scalars['String']['output']>;
  applyPenalty: Scalars['Boolean']['output'];
  areaNumber: Scalars['String']['output'];
  audit: Audit;
  businessAppraiserRegion?: Maybe<BusinessAppraiserRegionRow>;
  businessName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  ein?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<EntityType>;
  filingStatus: FilingStatus;
  hasAssociatedAccounts: Scalars['Boolean']['output'];
  hasCurrentPaymentPlan?: Maybe<Scalars['Boolean']['output']>;
  hasDelinquentPaymentPlan?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  industrialPark?: Maybe<IndustrialParkOption>;
  isAccountReadOnly: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isHomeOccupational?: Maybe<Scalars['Boolean']['output']>;
  lastModified: LastModified;
  leaseMasterNumberAssociation?: Maybe<Scalars['String']['output']>;
  naicsCategory?: Maybe<NaicsCategory>;
  naicsCode?: Maybe<NaicsCode>;
  parcelNumber?: Maybe<Scalars['String']['output']>;
  parcelUseType?: Maybe<ParcelUseType>;
  pin: Scalars['String']['output'];
  primaryContact: Contact;
  reconciliation: Reconciliation;
  registeredEntityName?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<CodeRowMaster>;
  situsAddress: SitusAddress;
  website?: Maybe<Scalars['String']['output']>;
  yearOpened?: Maybe<Scalars['Int']['output']>;
};

export type BusinessAccountInput = {
  accountNumber: Scalars['String']['input'];
  accountSummary?: InputMaybe<AccountSummaryInput>;
  accountType: AccountTypeInput;
  adminLink?: InputMaybe<Scalars['String']['input']>;
  applyPenalty: Scalars['Boolean']['input'];
  areaNumber: Scalars['String']['input'];
  audit: AuditInput;
  businessAppraiserRegion?: InputMaybe<BusinessAppraiserRegionRowInput>;
  businessName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EntityTypeInput>;
  filingStatus: FilingStatusInput;
  id: Scalars['ID']['input'];
  industrialPark?: InputMaybe<IndustrialParkOptionInput>;
  isHomeOccupational: Scalars['Boolean']['input'];
  naicsCode?: InputMaybe<NaicsCodeInput>;
  parcelNumber?: InputMaybe<Scalars['String']['input']>;
  parcelUseType?: InputMaybe<ParcelUseTypeInput>;
  registeredEntityName?: InputMaybe<Scalars['String']['input']>;
  sicCode?: InputMaybe<CodeRowMasterInput>;
  situsAddress: SitusAddressInput;
  website?: InputMaybe<Scalars['String']['input']>;
  yearOpened?: InputMaybe<Scalars['Int']['input']>;
};

export type BusinessAppraiserRegion = {
  columnsNames: BusinessAppraiserRegionColumns;
  regionName: Scalars['String']['output'];
  rows: Array<BusinessAppraiserRegionRow>;
};

export type BusinessAppraiserRegionColumns = {
  groupingLabel1: Scalars['String']['output'];
  groupingLabel2: Scalars['String']['output'];
};

export type BusinessAppraiserRegionRow = {
  groupingValue1: Scalars['String']['output'];
  groupingValue2: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  regionName: Scalars['String']['output'];
};

export type BusinessAppraiserRegionRowInput = {
  groupingValue1: Scalars['String']['input'];
  groupingValue2: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  regionName: Scalars['String']['input'];
};

export type CyDeletedWithDelinquentPaymentReportEntry = {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  amount: Scalars['Float']['output'];
  balance: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  leaseMasterAccountNbr?: Maybe<Scalars['String']['output']>;
  taxYear: Scalars['Int']['output'];
  telecomAccountNbr?: Maybe<Scalars['String']['output']>;
};

export type CyDeletedWithPaymentReportEntry = {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  amount: Scalars['Float']['output'];
  balance: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  taxYear: Scalars['Int']['output'];
};

export type CalculateAccountDelinquencyInput = {
  accountId: Scalars['Int']['input'];
  amount?: InputMaybe<Scalars['Float']['input']>;
  dateReceived?: InputMaybe<Scalars['String']['input']>;
  delinquentBalance: Scalars['Float']['input'];
  summary: DelinquentFinancialSummaryInput;
  totalCharges: Scalars['Float']['input'];
  totalInterest: Scalars['Float']['input'];
  totalPenalties: Scalars['Float']['input'];
  totalTax: Scalars['Float']['input'];
  transactions: Array<DelinquentTransactionInput>;
};

export type CalculateMasterAccountInterestInput = {
  isTelecom?: InputMaybe<Scalars['Boolean']['input']>;
  masterAccountId: Scalars['Int']['input'];
  postmarkDate: Scalars['String']['input'];
};

export type CalculatePaymentPlanInput = {
  accountId: Scalars['Int']['input'];
  accountNumber: Scalars['String']['input'];
  accountTypeId: Scalars['Int']['input'];
  amountPerMonth?: InputMaybe<Scalars['Float']['input']>;
  calculationType: PaymentPlanCalculationType;
  currentInterestDate?: InputMaybe<Scalars['String']['input']>;
  delinquentInterestDate?: InputMaybe<Scalars['String']['input']>;
  numberOfMonths?: InputMaybe<Scalars['Int']['input']>;
  paymentPlan?: InputMaybe<PaymentPlanInput>;
  planType: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
  terms: Array<Scalars['Int']['input']>;
};

export type CalculateTaxableValueInput = {
  classification: Scalars['String']['input'];
  costPer: Scalars['Float']['input'];
  quantity: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
  yearAcquired: Scalars['Int']['input'];
};

export type CalculateTaxableValueResponse = {
  percentGood: Scalars['Float']['output'];
  taxableValue: Scalars['Float']['output'];
};

export type CalculatedPenalty = {
  penalty?: Maybe<Scalars['Float']['output']>;
};

export type ChangeMcatTelecomTaxAreaStatusInput = {
  active: Scalars['Boolean']['input'];
  jurisdictionId: Scalars['Int']['input'];
  subAccountId: Scalars['Int']['input'];
  telecomMasterId: Scalars['Int']['input'];
};

export type ChangeTelecomSubAccountStatusParams = {
  accountId: Scalars['Int']['input'];
  active: Scalars['Boolean']['input'];
  telecomMasterId: Scalars['Int']['input'];
};

export type Classification = {
  basicCost?: Maybe<Array<BasicCost>>;
  clsf?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  scheduleId?: Maybe<Scalars['Int']['output']>;
};


export type ClassificationBasicCostArgs = {
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassificationInput = {
  clsf: Scalars['String']['input'];
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleId: Scalars['Int']['input'];
};

export type CodeRow = {
  code: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
};

export type CodeRowInput = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CodeRowMaster = {
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  sicCode: Scalars['String']['output'];
  sicCodeDescription?: Maybe<Scalars['String']['output']>;
  sicSiloCode: Scalars['String']['output'];
  subSiloCode: Scalars['String']['output'];
};

export type CodeRowMasterInput = {
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  sicCode: Scalars['String']['input'];
  sicCodeDescription?: InputMaybe<Scalars['String']['input']>;
  sicSiloCode: Scalars['String']['input'];
  subSiloCode: Scalars['String']['input'];
};

/** Point of Contact that can recieve messages from the County */
export type Contact = {
  cellphone?: Maybe<Scalars['String']['output']>;
  contactType?: Maybe<ContactType>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  mailingAddress?: Maybe<Address>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneExtension?: Maybe<Scalars['String']['output']>;
  sameAsBusinessAddress?: Maybe<Scalars['Boolean']['output']>;
};

/** Main Point of Contact that will recieve mail from the County */
export type ContactInput = {
  cellphone?: InputMaybe<Scalars['String']['input']>;
  contactType: ContactTypeInput;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  mailingAddress?: InputMaybe<AddressInput>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExtension?: InputMaybe<Scalars['String']['input']>;
  sameAsBusinessAddress?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies the relationship between the Contact and the Account */
export type ContactType = {
  id: Scalars['ID']['output'];
  /** Human-readable label used to display in the application */
  label: Scalars['String']['output'];
};

export type ContactTypeInput = {
  id: Scalars['ID']['input'];
  /** Human-readable label used to display in the application */
  label: Scalars['String']['input'];
};

export type CountOfAccountsByAcctTypeReportEntry = {
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  currentYear: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  notes: Scalars['String']['output'];
  priorYear: Scalars['Int']['output'];
};

export type Country = {
  code: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CountryInput = {
  code: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CountyContact = {
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CountyContactInput = {
  email: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CountySettings = {
  contacts: Array<CountyContact>;
  countyName?: Maybe<Scalars['String']['output']>;
  locationAddress?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  supportLinkURL?: Maybe<Scalars['String']['output']>;
  supportPhone?: Maybe<Scalars['String']['output']>;
  workDays?: Maybe<Scalars['String']['output']>;
  workHours?: Maybe<Scalars['String']['output']>;
};

export type CreateBatchInput = {
  refunds: Array<CreateRefundInput>;
};

/** Business Account */
export type CreateBusinessAccountInput = {
  /** Account Type: identify the category in which the Business Account falls into */
  accountType: AccountTypeInput;
  /** Area Number aka Taxable Area: is a geographic area created by the overlapping boundaries of one or more taxing entities. */
  areaNumber: Scalars['String']['input'];
  /** Business Appraiser Region: inner geographic area created by each county for Appraisers. */
  businessAppraiserRegion?: InputMaybe<BusinessAppraiserRegionRowInput>;
  /** Business Name aka DBA Name: is the frienly name that the business uses for custumers. */
  businessName: Scalars['String']['input'];
  /** Mailing Address: is the primary's contact mailing address used by the county for sending important mails. */
  mailingAddress: AddressInput;
  /** Parcel Number: is a unique identifier for your particular piece of land. https://parcels.utah.gov/ */
  parcelNumber?: InputMaybe<Scalars['String']['input']>;
  /** Same As Business Address: when this field is true the mailing address will be the same as the situs address. */
  sameAsBusinessAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** SIC Code: are four-digit numerical codes that categorize the industries that companies belong to based on their business activities. */
  sicCode?: InputMaybe<CodeRowMasterInput>;
  /** Situs Address: is the physical business address. */
  situsAddress: SitusAddressInput;
};

export type CreateDelinquentPaymentInput = {
  accountId: Scalars['Int']['input'];
  accountNumber: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  checkNumber?: InputMaybe<Scalars['String']['input']>;
  dateReceived: Scalars['String']['input'];
  delinquentBalance: Scalars['Float']['input'];
  paymentType: Scalars['Int']['input'];
  receivedFrom: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
  transactions: Array<DelinquentTransactionInput>;
};

export type CreateDelinquentPaymentResponse = {
  delinquency: AccountDelinquency;
  paymentId: Scalars['Int']['output'];
};

export type CreateDelinquentReturnedPayment = {
  accountId: Scalars['Int']['output'];
  dateReturned: Scalars['String']['output'];
  paymentId: Scalars['Int']['output'];
};

export type CreateDelinquentReturnedPaymentInput = {
  accountId: Scalars['Int']['input'];
  dateReturned: Scalars['String']['input'];
  paymentId: Scalars['Int']['input'];
};

export type CreateHoldingAccountInput = {
  jurisdictionId: Scalars['Int']['input'];
  leaseMasterId: Scalars['ID']['input'];
  subAccountId: Scalars['ID']['input'];
  taxDistrict: Scalars['String']['input'];
};

export type CreateHoldingAccountResponse = {
  value: Scalars['String']['output'];
};

export type CreateLessorAccountInput = {
  accountType: AccountTypeInput;
  businessName: Scalars['String']['input'];
  mailingAddress: AddressInput;
  sicCode?: InputMaybe<CodeRowMasterInput>;
};

export type CreateMassAccountBatchInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  jurisdiction: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type CreateMassAccountBatchResponse = {
  errors: Array<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type CreateMovePermitInput = {
  accountId: Scalars['Int']['input'];
  accountNumber: Scalars['String']['input'];
  addressFrom: MovePermitAddressInput;
  addressTo: MovePermitAddressInput;
  datePaid?: InputMaybe<Scalars['String']['input']>;
  issueDate: Scalars['String']['input'];
  leaseMasterAccountNumber?: InputMaybe<Scalars['String']['input']>;
  modelDescription?: InputMaybe<Scalars['String']['input']>;
  modelYear?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  ownerName: Scalars['String']['input'];
  permitIssuedTo?: InputMaybe<Scalars['String']['input']>;
  receiptNumber?: InputMaybe<Scalars['Int']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  taxAmountPaid?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePaymentInput = {
  accountId: Scalars['Int']['input'];
  businessName: Scalars['String']['input'];
  checkNumber?: InputMaybe<Scalars['String']['input']>;
  dateReceived: Scalars['String']['input'];
  howReceived: Scalars['Int']['input'];
  interestPaid: Scalars['Float']['input'];
  paymentAmount: Scalars['Float']['input'];
  paymentType: Scalars['Int']['input'];
  receiptNumber: Scalars['Int']['input'];
  receivedFrom: Scalars['String']['input'];
};

export type CreateRefundInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  address: RefundAddressInput;
  isSpecial: Scalars['Boolean']['input'];
  leaseMasterId?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  refundReasonId: Scalars['Int']['input'];
  specialAmount?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['Int']['input'];
};

export type CreateTelecomBusinessAccountInput = {
  businessName: Scalars['String']['input'];
  mailingAddress: AddressInput;
};

export type CurrentYearDeletedWithDelinqBalanceReportEntry = {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  amount: Scalars['Float']['output'];
  businessName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  leaseMasterAccountNbr?: Maybe<Scalars['String']['output']>;
  taxYear: Scalars['Int']['output'];
  telecomAccountNbr?: Maybe<Scalars['String']['output']>;
};

export type CurrentYearRollingToDelinquentTablesEntry = {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  amount: Scalars['Float']['output'];
  businessName?: Maybe<Scalars['String']['output']>;
  howReceived?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isReconciled?: Maybe<Scalars['Boolean']['output']>;
  leaseMasterAccountNbr?: Maybe<Scalars['String']['output']>;
  taxYear: Scalars['Float']['output'];
  telecomAccountNbr?: Maybe<Scalars['String']['output']>;
};

export type DailyPaymentTotal = {
  cash: Scalars['Float']['output'];
  check: Scalars['Float']['output'];
  credit: Scalars['Float']['output'];
  eChecks: Scalars['Float']['output'];
  returnedChecks?: Maybe<Scalars['Float']['output']>;
  returnedEChecks?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type DailyPaymentTotalBankDeposit = {
  cashDeposit: Scalars['Float']['output'];
  checkDeposit: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type DailyPaymentTotalReturnedItems = {
  currentChecks: Scalars['Float']['output'];
  currentEChecks: Scalars['Float']['output'];
  delinquentChecks: Scalars['Float']['output'];
  delinquentEChecks: Scalars['Float']['output'];
};

export type DailyPaymentTotals = {
  bankDeposit: DailyPaymentTotalBankDeposit;
  current: DailyPaymentTotal;
  dailyTotal: DailyPaymentTotal;
  delinquent: DailyPaymentTotal;
  returnedItems: DailyPaymentTotalReturnedItems;
};

export type DelinquentAdjustmentInput = {
  accountId: Scalars['Int']['input'];
  amount: Scalars['Float']['input'];
  delinquentYearId: Scalars['Int']['input'];
  directCharge: DirectChargeTypeInput;
  note: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
};

export type DelinquentFinancialSummary = {
  assessmentCharge: Scalars['Float']['output'];
  balance: Scalars['Float']['output'];
  balanceWithDelinquent: Scalars['Float']['output'];
  interest: Scalars['Float']['output'];
  penaltyCharge: Scalars['Float']['output'];
  totalDirectCharge: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
};

export type DelinquentFinancialSummaryInput = {
  assessmentCharge: Scalars['Float']['input'];
  balance: Scalars['Float']['input'];
  balanceWithDelinquent: Scalars['Float']['input'];
  interest: Scalars['Float']['input'];
  penaltyCharge: Scalars['Float']['input'];
  totalDirectCharge: Scalars['Float']['input'];
  totalPayments: Scalars['Float']['input'];
};

export type DelinquentPayment = {
  amount: Scalars['Float']['output'];
  checkNumber?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  ein?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isAdjustment?: Maybe<Scalars['Boolean']['output']>;
  leftOverInterest: Scalars['Boolean']['output'];
  paymentType?: Maybe<PaymentType>;
  receiptNumber: Scalars['Int']['output'];
  receivedFrom: Scalars['String']['output'];
};

export type DelinquentPaymentHistoryItem = {
  accountId: Scalars['Int']['output'];
  accountNumber?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  checkNumber?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  paymentStatus?: Maybe<PaymentStatus>;
  paymentType?: Maybe<PaymentType>;
  receiptNumber: Scalars['Int']['output'];
  receivedFrom: Scalars['String']['output'];
};

export type DelinquentPaymentVoid = {
  accountId: Scalars['Int']['output'];
  accountNumber: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  payment: DelinquentPayment;
  transactions: Array<DelinquentYearTransaction>;
};

export type DelinquentReturnedPayment = {
  accountId: Scalars['Int']['output'];
  accountNumber: Scalars['String']['output'];
  businessName?: Maybe<Scalars['String']['output']>;
  dateReturned?: Maybe<Scalars['String']['output']>;
  ein: Ein;
  payments: Array<DelinquentPayment>;
};

export type DelinquentTransaction = {
  assessmentCharge: Scalars['Float']['output'];
  calculatedAssessmentCharge: Scalars['Float']['output'];
  calculatedDirectCharges: Scalars['Float']['output'];
  calculatedInterest: Scalars['Float']['output'];
  calculatedPenalties: Scalars['Float']['output'];
  delinquentYearId: Scalars['Int']['output'];
  directCharges: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  interest: Scalars['Float']['output'];
  interestNotPaid?: Maybe<Scalars['Float']['output']>;
  interestOffset?: Maybe<Scalars['Float']['output']>;
  interestPaid?: Maybe<Scalars['Float']['output']>;
  interestUpdated?: Maybe<Scalars['Boolean']['output']>;
  penalties: Scalars['Float']['output'];
  taxDistrict: Scalars['String']['output'];
  taxYear: Scalars['Int']['output'];
  total: Scalars['Float']['output'];
  totalPaid?: Maybe<Scalars['Float']['output']>;
};

export type DelinquentTransactionInput = {
  assessmentCharge: Scalars['Float']['input'];
  delinquentYearId: Scalars['Int']['input'];
  directCharges: Scalars['Float']['input'];
  id: Scalars['Int']['input'];
  interest: Scalars['Float']['input'];
  interestNotPaid?: InputMaybe<Scalars['Float']['input']>;
  interestOffset?: InputMaybe<Scalars['Float']['input']>;
  interestPaid?: InputMaybe<Scalars['Float']['input']>;
  interestUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  penalties: Scalars['Float']['input'];
  taxDistrict: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
  total: Scalars['Float']['input'];
  totalPaid?: InputMaybe<Scalars['Float']['input']>;
};

export type DelinquentYear = {
  balance: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  taxDistrict?: Maybe<Scalars['String']['output']>;
  taxYear: Scalars['Int']['output'];
  transactions: Array<DelinquentYearTransaction>;
};

export type DelinquentYearTransaction = {
  amount: Scalars['Float']['output'];
  dateReceived?: Maybe<Scalars['String']['output']>;
  directCharge: DirectChargeType;
  ein?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isVoid?: Maybe<Scalars['Boolean']['output']>;
  receiptNumber?: Maybe<Scalars['String']['output']>;
};

export type DelinquentYearTransactionsResponse = {
  accountId: Scalars['Int']['output'];
  accountNumber: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  delinquentYearId: Scalars['Int']['output'];
  delinquentYears: Array<DelinquentYear>;
};

export type DelqPaymentVoidSearchInput = {
  accountNbr?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  receiptNbr?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type DelqPaymentVoidSearchResult = {
  accountNbr: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  businessName: Scalars['String']['output'];
  checkNumber?: Maybe<Scalars['String']['output']>;
  dateReceived: Scalars['String']['output'];
  delqAcctPaymentId: Scalars['Int']['output'];
  ein: Scalars['Int']['output'];
  isAdjustment: Scalars['Boolean']['output'];
  masterAccountNbr?: Maybe<Scalars['String']['output']>;
  paymentTypeDescr: Scalars['String']['output'];
  receiptNumber: Scalars['Float']['output'];
  receivedFrom: Scalars['String']['output'];
};

export type DirectCharge = {
  amount: Scalars['Float']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  ein: Ein;
  entryDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  type: DirectChargeType;
  updateDate: Scalars['String']['output'];
};

export type DirectChargeInput = {
  amount: Scalars['Float']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  ein: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  typeId: Scalars['Int']['input'];
};

export type DirectChargeSummary = {
  accountId: Scalars['Int']['output'];
  accountNumber: Scalars['String']['output'];
  accountSummary: FinancialSummary;
  businessName: Scalars['String']['output'];
  directCharges: Array<DirectCharge>;
  ein: Ein;
  jurisdiction: Scalars['Int']['output'];
  taxYear: Scalars['Int']['output'];
};

export type DirectChargeType = {
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type DirectChargeTypeInput = {
  description: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};

export type Ein = {
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EinInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type EditDelinquentPaymentInput = {
  accountId: Scalars['Int']['input'];
  checkNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  paymentType: Scalars['Int']['input'];
  receivedFrom: Scalars['String']['input'];
};

export type EditMovePermitInput = {
  accountId: Scalars['Int']['input'];
  accountNumber: Scalars['String']['input'];
  addressFrom: MovePermitAddressInput;
  addressTo: MovePermitAddressInput;
  datePaid?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  issueDate: Scalars['String']['input'];
  jurisdiction: Scalars['Int']['input'];
  leaseMasterAccountNumber?: InputMaybe<Scalars['String']['input']>;
  modelDescription?: InputMaybe<Scalars['String']['input']>;
  modelYear?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<MovePermitNoteInput>;
  ownerName: Scalars['String']['input'];
  permitIssuedBy: Scalars['Int']['input'];
  permitIssuedTo?: InputMaybe<Scalars['String']['input']>;
  permitTypeId: Scalars['Int']['input'];
  receiptNumber?: InputMaybe<Scalars['Int']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  taxAmountPaid?: InputMaybe<Scalars['Float']['input']>;
  taxYear: Scalars['Int']['input'];
};

export type EditPaymentInput = {
  accountId: Scalars['Int']['input'];
  accountNumber: Scalars['String']['input'];
  businessName: Scalars['String']['input'];
  checkNumber?: InputMaybe<Scalars['String']['input']>;
  dateReceived: Scalars['String']['input'];
  ein: EinInput;
  howReceived: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  paymentAmount: Scalars['Float']['input'];
  paymentStatus: Scalars['Int']['input'];
  paymentType: Scalars['Int']['input'];
  receiptNumber: Scalars['Int']['input'];
  receivedFrom: Scalars['String']['input'];
};

export type EntityNotFound = {
  message: Scalars['String']['output'];
};

export type EntityType = {
  id: Scalars['ID']['output'];
  /** Human-readable label used to display in the application */
  label: Scalars['String']['output'];
};

/** Identify the type of Business Entity this Account belongs to */
export type EntityTypeInput = {
  id: Scalars['ID']['input'];
  /** Human-readable label used to display in the application */
  label: Scalars['String']['input'];
};

export type EstimatedValuesReportEntry = BasicReportResult & {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isExempt: Scalars['Boolean']['output'];
  isReconciled: Scalars['Boolean']['output'];
  leaseMasterAccountNbr?: Maybe<Scalars['String']['output']>;
  sicCode: Scalars['String']['output'];
  sicCodeDescription: Scalars['String']['output'];
  taxYear: Scalars['Int']['output'];
  telecomAccountNbr?: Maybe<Scalars['String']['output']>;
  totalEstimatedValue: Scalars['Float']['output'];
  totalTaxable: Scalars['Float']['output'];
};

export type ExistingBusinessNotExemptBelowThresholdReportEntry = AccountReportEntry & {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  associatedAccounts: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isExempt: Scalars['Boolean']['output'];
  isReconciled: Scalars['Boolean']['output'];
  netAssmntChargeWithTotalDirect: Scalars['Float']['output'];
  payments: Scalars['Float']['output'];
  penalty: Scalars['Float']['output'];
  taxYear: Scalars['Int']['output'];
  totalTaxable: Scalars['Float']['output'];
  yearEndBalance: Scalars['Float']['output'];
};

export type ExistingBusinessNotFiledLessThanExemptReportEntry = BasicReportResult & {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  appraiserRegion?: Maybe<Scalars['String']['output']>;
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  leaseMasterAccountNbr?: Maybe<Scalars['String']['output']>;
  netAssmntCharge: Scalars['Float']['output'];
  taxDistrict: Scalars['String']['output'];
  taxRate: Scalars['Float']['output'];
  taxYear: Scalars['Int']['output'];
  telecomAccountNbr?: Maybe<Scalars['String']['output']>;
  totalTaxable: Scalars['Float']['output'];
};

export type FailedAuthType = {
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FileOutput = {
  fileContent: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type FiledStatusEnum = {
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type FilingStatus = {
  dateReceived?: Maybe<Scalars['String']['output']>;
  filingYear?: Maybe<Scalars['Int']['output']>;
  hasAttachment: Scalars['Boolean']['output'];
  hasBuildingPermit: Scalars['Boolean']['output'];
  hasExemption: Scalars['Boolean']['output'];
  howFiled?: Maybe<HowFiledEnum>;
  howReceived?: Maybe<HowReceived>;
};

export type FilingStatusInput = {
  dateReceived?: InputMaybe<Scalars['String']['input']>;
  filingYear?: InputMaybe<Scalars['Int']['input']>;
  hasAttachment: Scalars['Boolean']['input'];
  hasBuildingPermit: Scalars['Boolean']['input'];
  hasExemption: Scalars['Boolean']['input'];
  howFiled?: InputMaybe<HowFiledEnumInput>;
  howReceived?: InputMaybe<HowReceivedInput>;
};

/** Lease Master Business Account */
export type FilingStatusLeaseMaster = {
  dateReceived?: Maybe<Scalars['String']['output']>;
  filingYear?: Maybe<Scalars['Int']['output']>;
  hasAttachment?: Maybe<Scalars['Boolean']['output']>;
  hasBuildingPermit?: Maybe<Scalars['Boolean']['output']>;
  hasExemption?: Maybe<Scalars['Boolean']['output']>;
  howFiled?: Maybe<HowFiledEnum>;
  howReceived?: Maybe<HowReceived>;
};

export type FilingSummary = {
  applyPenalty?: Maybe<Scalars['Boolean']['output']>;
  balance: Scalars['Float']['output'];
  contact?: Maybe<Contact>;
  delinquentTax: Scalars['Float']['output'];
  howFiled?: Maybe<HowFiledEnum>;
  interest: Scalars['Float']['output'];
  isExempt?: Maybe<Scalars['Boolean']['output']>;
  netAssessmentCharge: Scalars['Float']['output'];
  note?: Maybe<Scalars['String']['output']>;
  payments: Scalars['Float']['output'];
  penalty: Scalars['Float']['output'];
  timeSpentFiling?: Maybe<TimeSpentFiling>;
  totalDirectCharge: Scalars['Float']['output'];
  totalTaxableValue: Scalars['Float']['output'];
};

export type FilingSummaryInput = {
  applyPenalty?: InputMaybe<Scalars['Boolean']['input']>;
  howFiled: Scalars['ID']['input'];
  isExempt?: InputMaybe<Scalars['Boolean']['input']>;
  timeSpentFiling?: InputMaybe<Scalars['ID']['input']>;
};

export enum FilterAccountTypeBy {
  AccountType = 'accountType',
  All = 'all',
  BankruptcyType = 'bankruptcyType',
  BusinessAccountType = 'businessAccountType',
  LeaseMasterType = 'leaseMasterType'
}

export type FinancialSummary = {
  assessmentCharge: Scalars['Float']['output'];
  balance: Scalars['Float']['output'];
  balanceDueWithInterest: Scalars['Float']['output'];
  interest: Scalars['Float']['output'];
  isExempt: Scalars['Boolean']['output'];
  penaltyCharge: Scalars['Float']['output'];
  taxRate: Scalars['Float']['output'];
  totalCost: Scalars['Float']['output'];
  totalDirectCharge: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
  totalTaxable: Scalars['Float']['output'];
};

export type GetBusinessAccountIdByNumberResponse = {
  accountId: Scalars['ID']['output'];
};

export type GetSearxhBusinessByAccountNumberResponse = EntityNotFound | TaxDistrictBusinessAccountRow;

export type GetSubAccountsResponse = {
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  subAccounts: Array<SubAccount>;
};

export type HomeOccupationalNonTaxableAccountsReportEntry = AccountReportEntry & {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  associatedAccounts: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  howReceived: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isExempt: Scalars['Boolean']['output'];
  isReconciled: Scalars['Boolean']['output'];
  netAssmntChargeWithTotalDirect: Scalars['Float']['output'];
  payments: Scalars['Float']['output'];
  penalty: Scalars['Float']['output'];
  taxYear: Scalars['Int']['output'];
  totalTaxable: Scalars['Float']['output'];
  yearEndBalance: Scalars['Float']['output'];
};

export type HowFiledEnum = {
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type HowFiledEnumInput = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};

export type HowFiledEnumNulleable = {
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type HowReceived = {
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type HowReceivedInput = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};

export type HowReceivedSearchResult = {
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type ImpersonatedToken = {
  token?: Maybe<Scalars['String']['output']>;
};

export type IndustrialPark = {
  accountCount: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  newBusinessCount: Scalars['Int']['output'];
};

export type IndustrialParkInput = {
  code: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
};

export type IndustrialParkOption = {
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type IndustrialParkOptionInput = {
  code: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  label: Scalars['String']['input'];
};

export type Interest = {
  interest: Scalars['Float']['output'];
};

export type IronCountyTaxableValueReportEntry = {
  account: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  propertyCode?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  taxableValue: Scalars['Float']['output'];
  yearAcquired: Scalars['Int']['output'];
};

export type IsAttachedReportEntry = BasicReportResult & {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  balance: Scalars['Float']['output'];
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  leaseMasterAccountNbr?: Maybe<Scalars['String']['output']>;
  parcelId?: Maybe<Scalars['String']['output']>;
  taxYear: Scalars['Int']['output'];
  telecomAccountNbr?: Maybe<Scalars['String']['output']>;
  totalTaxable: Scalars['Float']['output'];
};

export type Jurisdiction = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type JurisdictionInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LmTaxDistrictAcctCheckReportEntry = {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  baTaxDistrict: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  leaseMasterAcctNbr: Scalars['String']['output'];
  saTaxDistrict: Scalars['String']['output'];
  subAccountNbr: Scalars['String']['output'];
  totalTaxable: Scalars['Float']['output'];
};

export type LastModified = {
  lastChanged?: Maybe<Scalars['String']['output']>;
  lastChangedDate?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type LeaseMasterAccountSuggestion = {
  leaseMasterAccountName?: Maybe<Scalars['String']['output']>;
  leaseMasterAccountNumber: Scalars['ID']['output'];
  subAccountName?: Maybe<Scalars['String']['output']>;
  subAccountNumber: Scalars['ID']['output'];
};

export type LeaseMasterAccountWithBalanceEntry = {
  id: Scalars['Int']['output'];
  leaseMasterAccountNbr: Scalars['String']['output'];
  lmActive: Scalars['Boolean']['output'];
  lmExempt: Scalars['Boolean']['output'];
  lmHowFiled: Scalars['String']['output'];
  subAccountBalance: Scalars['Float']['output'];
  subAccountNbr: Scalars['String']['output'];
};

export type LeaseMasterAccountWithoutSubAccountsReportEntry = {
  id: Scalars['Int']['output'];
  leaseMasterAccountNbr: Scalars['String']['output'];
  subAccountCount: Scalars['Int']['output'];
};

export type LeaseMasterAssoc = {
  businessName: Scalars['String']['output'];
  isReconciled: Scalars['Boolean']['output'];
  leaseMasterAccountNbr: Scalars['String']['output'];
};

export type LeaseMasterBusinessAccount = {
  accountNumber: Scalars['String']['output'];
  accountSummary?: Maybe<AccountSummary>;
  accountType?: Maybe<AccountType>;
  adminLink?: Maybe<Scalars['String']['output']>;
  applyPenalty: Scalars['Boolean']['output'];
  audit: Audit;
  bankruptcy: Bankruptcy;
  businessAccountType?: Maybe<AccountType>;
  businessName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  ein?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<EntityType>;
  filingStatus: FilingStatusLeaseMaster;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDisabled: Scalars['Boolean']['output'];
  lastModified: LastModified;
  reconciliation: Reconciliation;
  registeredEntityName?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<CodeRowMaster>;
  telecomAccountNumber?: Maybe<Scalars['String']['output']>;
};

export type LeaseMasterBusinessAccountInput = {
  accountNumber: Scalars['String']['input'];
  accountType: AccountTypeInput;
  adminLink?: InputMaybe<Scalars['String']['input']>;
  applyPenalty: Scalars['Boolean']['input'];
  audit: AuditInput;
  bankruptcy: BankruptcyInput;
  businessAccountType: AccountTypeInput;
  businessName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EntityTypeInput>;
  filingStatus: FilingStatusInput;
  id: Scalars['ID']['input'];
  reconciliation: ReconciliationInput;
  registeredEntityName?: InputMaybe<Scalars['String']['input']>;
  sicCode?: InputMaybe<CodeRowMasterInput>;
  telecomAccountNumber?: InputMaybe<Scalars['String']['input']>;
};

export type LeaseMasterOneYearExemptReportEntry = {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isExempt: Scalars['Boolean']['output'];
  netAssmntCharge: Scalars['Float']['output'];
  payments: Scalars['Float']['output'];
  penalty: Scalars['Float']['output'];
  totalDirect: Scalars['Float']['output'];
  yearEndBalance: Scalars['Float']['output'];
};

export type LeasedAsset = {
  annualLeaseAmount?: Maybe<Scalars['Float']['output']>;
  blobName?: Maybe<Scalars['String']['output']>;
  contactLinkId?: Maybe<Scalars['ID']['output']>;
  costPer?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialValue?: Maybe<Scalars['Float']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isTransfer?: Maybe<Scalars['Boolean']['output']>;
  leaseAccountId?: Maybe<Scalars['ID']['output']>;
  leaseEndDate?: Maybe<Scalars['String']['output']>;
  leaseId?: Maybe<Scalars['ID']['output']>;
  leaseNumber?: Maybe<Scalars['ID']['output']>;
  leaseStartDate?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  yearAcquired?: Maybe<Scalars['Int']['output']>;
};

export type LeasedAssetForReconciliation = {
  accountId: Scalars['ID']['output'];
  accountNumber?: Maybe<Scalars['String']['output']>;
  blobName?: Maybe<Scalars['String']['output']>;
  contactLinkId: Scalars['ID']['output'];
  costPer?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entryDate?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isReconciled: Scalars['Boolean']['output'];
  leaseEndDate?: Maybe<Scalars['String']['output']>;
  leaseId?: Maybe<Scalars['ID']['output']>;
  leaseMasterAccountNumber?: Maybe<Scalars['String']['output']>;
  leaseNumber?: Maybe<Scalars['ID']['output']>;
  leaseStartDate?: Maybe<Scalars['String']['output']>;
  lessor?: Maybe<LeasedAssetForReconciliationLessor>;
  rentPerMonth?: Maybe<Scalars['Float']['output']>;
  subAccountNumber?: Maybe<Scalars['String']['output']>;
  yearAcquired?: Maybe<Scalars['Int']['output']>;
};

export type LeasedAssetForReconciliationLessor = {
  address?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LeasedAssetForSubAccountLocation = LeasedAssetInterface & {
  classification?: Maybe<PropertyClassification>;
  contactLinkId?: Maybe<Scalars['ID']['output']>;
  costPer?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  ein?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  leaseAccountId?: Maybe<Scalars['ID']['output']>;
  percentGood?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  taxableValue?: Maybe<Scalars['Int']['output']>;
  updateDate?: Maybe<Scalars['String']['output']>;
  yearAcquired?: Maybe<Scalars['Int']['output']>;
};

export type LeasedAssetForSubAccountLocationInput = {
  classification: Scalars['String']['input'];
  contactLinkId?: InputMaybe<Scalars['ID']['input']>;
  costPer: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  leaseAccountId?: InputMaybe<Scalars['ID']['input']>;
  percentGood: Scalars['Float']['input'];
  quantity: Scalars['Int']['input'];
  taxableValue: Scalars['Int']['input'];
  yearAcquired: Scalars['Int']['input'];
};

export type LeasedAssetInput = {
  annualLeaseAmount?: InputMaybe<Scalars['Float']['input']>;
  blobName?: InputMaybe<Scalars['String']['input']>;
  contactLinkId?: InputMaybe<Scalars['ID']['input']>;
  costPer: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  leaseAccountId?: InputMaybe<Scalars['ID']['input']>;
  leaseEndDate?: InputMaybe<Scalars['String']['input']>;
  leaseId?: InputMaybe<Scalars['ID']['input']>;
  leaseNumber?: InputMaybe<Scalars['ID']['input']>;
  leaseStartDate?: InputMaybe<Scalars['String']['input']>;
  prevBlobName?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  yearAcquired: Scalars['Int']['input'];
};

export type LeasedAssetInterface = {
  classification?: Maybe<PropertyClassification>;
  contactLinkId?: Maybe<Scalars['ID']['output']>;
  costPer?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  ein?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  leaseAccountId?: Maybe<Scalars['ID']['output']>;
  percentGood?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  taxableValue?: Maybe<Scalars['Int']['output']>;
  updateDate?: Maybe<Scalars['String']['output']>;
  yearAcquired?: Maybe<Scalars['Int']['output']>;
};

export type Lessor = {
  address?: Maybe<LessorAddress>;
  assets?: Maybe<Array<LeasedAsset>>;
  contactLinkId?: Maybe<Scalars['ID']['output']>;
  contactType?: Maybe<ContactType>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LessorAddress = {
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  inCareOf?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneExtension?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type LessorAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryInput>;
  inCareOf?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExtension?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type LessorInput = {
  address?: InputMaybe<LessorAddressInput>;
  assets?: InputMaybe<Array<LeasedAssetInput>>;
  contactLinkId?: InputMaybe<Scalars['ID']['input']>;
  contactType?: InputMaybe<ContactTypeInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type LinkedUser = {
  fullName?: Maybe<Scalars['String']['output']>;
  linkId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type McatTelecom = {
  applyPenalty?: Maybe<Scalars['Boolean']['output']>;
  businessName: Scalars['String']['output'];
  filedDate?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  telecomAccountNbr: Scalars['String']['output'];
  telecomMasterId: Scalars['Int']['output'];
  transferDate?: Maybe<Scalars['String']['output']>;
};

export type MassAccountBatch = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  totalRecords: Scalars['Int']['output'];
  uploadDate: Scalars['String']['output'];
};

export type MassPaymentAccountInfo = {
  accountId: Scalars['Int']['output'];
  businessName: Scalars['String']['output'];
  currentUserName?: Maybe<Scalars['String']['output']>;
  filedBy?: Maybe<Scalars['Int']['output']>;
  filedByDisplay?: Maybe<Scalars['String']['output']>;
  filedDate?: Maybe<Scalars['String']['output']>;
  howFiled?: Maybe<Scalars['Int']['output']>;
  howFiledDescr?: Maybe<Scalars['String']['output']>;
  howReceived?: Maybe<Scalars['Int']['output']>;
  howReceivedDescr?: Maybe<Scalars['String']['output']>;
  interest: Scalars['Float']['output'];
};

export type MassPaymentFilingStatus = {
  accountId: Scalars['Int']['output'];
  filedBy?: Maybe<Scalars['Int']['output']>;
  filedByDisplay?: Maybe<Scalars['String']['output']>;
  filedDate?: Maybe<Scalars['String']['output']>;
  howFiled?: Maybe<Scalars['Int']['output']>;
  howReceived?: Maybe<Scalars['Int']['output']>;
};

export type MassPaymentFilingStatusInput = {
  accountId: Scalars['Int']['input'];
  dateReceived: Scalars['String']['input'];
  filedBy?: InputMaybe<Scalars['Int']['input']>;
  filedDate?: InputMaybe<Scalars['String']['input']>;
  howFiled?: InputMaybe<Scalars['Int']['input']>;
  howReceived?: InputMaybe<Scalars['Int']['input']>;
  paymentAmount: Scalars['Float']['input'];
};

export type MasterAccountDelinquentSummary = {
  accountTotals: MasterAccountTotals;
  delinquentAccountTotals: MasterAccountDelinquentTotals;
  subAccountTotals: Array<SubAccountDelinquentSummary>;
};

export type MasterAccountDelinquentTotals = {
  delinquentBalance: Scalars['Float']['output'];
  totalCharges: Scalars['Float']['output'];
  totalInterest: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
  totalPenalties: Scalars['Float']['output'];
  totalTax: Scalars['Float']['output'];
};

export type MasterAccountHolding = {
  accountNumber: Scalars['String']['output'];
  businessName?: Maybe<Scalars['String']['output']>;
  delinquentBalance?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  payments: Array<PaymentHolding>;
  subAccounts: Array<SubAccountHolding>;
};

export type MasterAccountTotals = {
  currentBalance: Scalars['Float']['output'];
  totalCharges: Scalars['Float']['output'];
  totalCurrentAndDelinquent: Scalars['Float']['output'];
  totalInterest: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
  totalPenalties: Scalars['Float']['output'];
  totalTax: Scalars['Float']['output'];
};

export type MasterAsset = {
  classification: PropertyClassification;
  costPer: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  percentGood?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Int']['output'];
  subAccountId: Scalars['Int']['output'];
  subAccountNumber: Scalars['String']['output'];
  taxDistrict: Scalars['String']['output'];
  taxableValue?: Maybe<Scalars['Float']['output']>;
  yearAcquired: Scalars['Int']['output'];
};

export type MasterSimilarBusinessRow = {
  accountNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type McatAsset = {
  accountId?: Maybe<Scalars['Int']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<PropertyClassification>;
  costPer: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  ein?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isReconciled?: Maybe<Scalars['Boolean']['output']>;
  jurisdiction: Jurisdiction;
  netAsmtCharge?: Maybe<Scalars['Float']['output']>;
  percentGood: Scalars['Float']['output'];
  processDate?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  reconcileDate?: Maybe<Scalars['String']['output']>;
  taxDistrict: Scalars['String']['output'];
  taxRate?: Maybe<Scalars['Float']['output']>;
  taxYear: Scalars['Int']['output'];
  taxableValue: Scalars['Float']['output'];
  telecomAccountNumber: Scalars['String']['output'];
  telecomMasterId: Scalars['Int']['output'];
  updateDate?: Maybe<Scalars['String']['output']>;
  uploadDate?: Maybe<Scalars['String']['output']>;
  yearAcquired?: Maybe<Scalars['Int']['output']>;
};

export type McatAssetFile = {
  filename: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type McatAssetInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  classification: PropertyClassificationInput;
  costPer: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isReconciled?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdiction: JurisdictionInput;
  netAsmtCharge?: InputMaybe<Scalars['Float']['input']>;
  percentGood: Scalars['Float']['input'];
  processDate?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  reconcileDate?: InputMaybe<Scalars['String']['input']>;
  taxDistrict: Scalars['String']['input'];
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  taxYear: Scalars['Int']['input'];
  taxableValue: Scalars['Float']['input'];
  telecomAccountNumber: Scalars['String']['input'];
  telecomMasterId: Scalars['Int']['input'];
  updateDate?: InputMaybe<Scalars['String']['input']>;
  uploadDate?: InputMaybe<Scalars['String']['input']>;
  yearAcquired: Scalars['Int']['input'];
};

export type McatPropertyAssetList = {
  accountNumber: Scalars['ID']['output'];
  fileName: Scalars['String']['output'];
  validationReport?: Maybe<Scalars['String']['output']>;
};

export type MergeAppraiserRegionInput = {
  sourceRegionId: Scalars['Int']['input'];
  targetRegionId: Scalars['Int']['input'];
};

export type MergeAppraiserRegionsInput = {
  appraiserRegionFrom: Scalars['Int']['input'];
  appraiserRegionTo: Scalars['Int']['input'];
};

export type MergeAppraiserRegionsResult = {
  updatedAccounts: Scalars['Int']['output'];
};

export type MovePermit = {
  accountId: Scalars['Int']['output'];
  accountNumber: Scalars['String']['output'];
  addressFrom: MovePermitAddress;
  addressTo: MovePermitAddress;
  datePaid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  issueDate: Scalars['String']['output'];
  jurisdiction: Scalars['Int']['output'];
  leaseMasterAccountNumber?: Maybe<Scalars['String']['output']>;
  modelDescription?: Maybe<Scalars['String']['output']>;
  modelYear?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<MovePermitNote>;
  ownerName: Scalars['String']['output'];
  permitIssuedBy: Scalars['Int']['output'];
  permitIssuedTo?: Maybe<Scalars['String']['output']>;
  permitTypeId: Scalars['Int']['output'];
  receiptNumber?: Maybe<Scalars['Int']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  taxAmountPaid?: Maybe<Scalars['Float']['output']>;
  taxYear: Scalars['Int']['output'];
  updateDate: Scalars['String']['output'];
  updatedBy: Scalars['Int']['output'];
};

export type MovePermitAddress = {
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type MovePermitAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type MovePermitInitialData = {
  accountId?: Maybe<Scalars['Int']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  addressFrom: MovePermitAddress;
  addressTo: MovePermitAddress;
  datePaid?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  issueDate: Scalars['String']['output'];
  jurisdiction: Scalars['Int']['output'];
  leaseMasterAccountId?: Maybe<Scalars['Int']['output']>;
  leaseMasterAccountNumber?: Maybe<Scalars['String']['output']>;
  modelDescription?: Maybe<Scalars['String']['output']>;
  modelYear?: Maybe<Scalars['Int']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  permitIssuedBy: Scalars['Int']['output'];
  permitIssuedTo?: Maybe<Scalars['String']['output']>;
  permitTypeId: Scalars['Int']['output'];
  receiptNumber?: Maybe<Scalars['Int']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  taxAmountPaid?: Maybe<Scalars['Float']['output']>;
  taxYear: Scalars['Int']['output'];
};

export type MovePermitNote = {
  id: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type MovePermitNoteInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type MovePermitSearchInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  addressFrom?: InputMaybe<Scalars['String']['input']>;
  addressTo?: InputMaybe<Scalars['String']['input']>;
  displayCount?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  issueDate?: InputMaybe<Scalars['String']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};

export type MovePermitSearchResponse = {
  movePermits: Array<MovePermit>;
  totalRecordCount: Scalars['Int']['output'];
};

export type Mutation = {
  addRoleToUser: Scalars['Boolean']['output'];
  allocateHoldingsToSubAccounts: Array<SubAccountAllocations>;
  approveMassAccountBatch: ApproveMassAccountBatchResponse;
  bulkUpdateAppraiserRegion: BulkUpdateAppraiserRegionResult;
  bulkUpdateIndustrialPark: BulkUpdateIndustrialParkResult;
  calculateAccountDelinquency: AccountDelinquency;
  calculateInterest: Interest;
  calculateMasterAccountInterest: Array<SubAccountHolding>;
  calculatePaymentPlan: Array<PaymentPlan>;
  calculatePenalty: CalculatedPenalty;
  calculateTaxableValue: CalculateTaxableValueResponse;
  changeBusinessAccountStatus: Scalars['Boolean']['output'];
  changeLeaseMasterAccountStatus: Scalars['Boolean']['output'];
  changeLeaseMasterSubAccountStatus: Scalars['Boolean']['output'];
  changeMCATTelecomActiveStatus: Scalars['Boolean']['output'];
  changeMCATTelecomApplyPenaltyStatus: Scalars['Boolean']['output'];
  changeMCATTelecomApplyPenaltyStatusByJurisdiction: Scalars['Boolean']['output'];
  changeMCATTelecomExemptStatusByJurisdiction: Scalars['Boolean']['output'];
  changeMCATTelecomTaxAreaStatus: Scalars['Boolean']['output'];
  changePassword?: Maybe<AuthenticationType>;
  changeTelecomAccountStatus: Scalars['Boolean']['output'];
  changeTelecomSubAccountStatus: Scalars['Boolean']['output'];
  completeReconciliation: Scalars['Boolean']['output'];
  createBatch: RefundBatch;
  createBusinessAccount?: Maybe<BusinessAccount>;
  createContact: Contact;
  createDelinquentAdjustment: Scalars['Boolean']['output'];
  createDelinquentPayment: CreateDelinquentPaymentResponse;
  createDelinquentReturnedPayment: CreateDelinquentReturnedPayment;
  createHoldingAccount?: Maybe<CreateHoldingAccountResponse>;
  createLeaseMasterAccount?: Maybe<LeaseMasterBusinessAccount>;
  createLeaseMasterContact: Contact;
  createMassAccountBatch: CreateMassAccountBatchResponse;
  createMovePermit: MovePermit;
  createPayment: Payment;
  createReturnedPayment: ReturnedPayment;
  createSubAccountTaxDistrict: SubAccountTaxDistrict;
  createTelecomAccount?: Maybe<TelecomBusinessAccount>;
  createTelecomContact: Contact;
  createTelecomSubAccount: TelecomSubAccount;
  createUser: Scalars['Boolean']['output'];
  deleteBatch: Scalars['Boolean']['output'];
  deleteBatchBusinessAccount: Scalars['Boolean']['output'];
  deleteMassAccountBatch: Scalars['Boolean']['output'];
  deletePaymentPlan?: Maybe<Scalars['Boolean']['output']>;
  deleteRole: Scalars['Boolean']['output'];
  editDelinquentPayment: Scalars['Boolean']['output'];
  editMovePermit: MovePermit;
  editPayment: Payment;
  executeBafBatchPenalty: Scalars['Boolean']['output'];
  executeLeaseBatchPenalty: Scalars['Boolean']['output'];
  executeTelecomBatchPenalty: Scalars['Boolean']['output'];
  exportToCsv: FileOutput;
  forgotPassword: Scalars['Boolean']['output'];
  generatePresignedUploadFile: SasUploadFile;
  impersonateUser: ImpersonatedToken;
  login?: Maybe<AuthenticationType>;
  masterLogin?: Maybe<Auth>;
  mcatLogin?: Maybe<Auth>;
  mergeAppraiserRegions: MergeAppraiserRegionsResult;
  paperFilingToken?: Maybe<PaperFilingToken>;
  reconcileAccountInformation: ReconciliationAccountInformation;
  reconcileAssets: Array<Asset>;
  reconcileContacts: Array<Contact>;
  reconcileLeaseMasterAssets?: Maybe<Scalars['Boolean']['output']>;
  reconcileLessors: Array<Lessor>;
  reconcileSummary: FilingSummary;
  regenerateMCATTelecomPin: Scalars['String']['output'];
  regeneratePin: Scalars['String']['output'];
  removeContact: RemoveContactResponse;
  removeLeaseMasterContact: RemoveContactResponse;
  removeLinkedAccount: Scalars['Boolean']['output'];
  removeMCATTelecomWorkflow: Scalars['Boolean']['output'];
  removeRoleFromUser: Scalars['Boolean']['output'];
  removeTelecomContact: RemoveContactResponse;
  removeTelecomStagingData: Scalars['Boolean']['output'];
  reopenFiling?: Maybe<Scalars['Boolean']['output']>;
  resetPassword: SuccessfulAuthType;
  saveAccountType: Array<AccountType>;
  saveAppraiserRegion: Scalars['Boolean']['output'];
  saveAssets: Array<Asset>;
  saveAssociatedAccounts: AssociatedAccountGroup;
  saveBasicCost?: Maybe<Array<Maybe<BasicCost>>>;
  saveBatchBusinessAccount: Scalars['Boolean']['output'];
  saveBusinessAccount?: Maybe<BusinessAccount>;
  saveClassifications?: Maybe<Array<Maybe<Classification>>>;
  saveContact: Contact;
  saveCountyContacts: CountySettings;
  saveDirectCharges: DirectChargeSummary;
  saveIndustrialPark: Array<IndustrialPark>;
  saveLeaseMasterAccount?: Maybe<LeaseMasterBusinessAccount>;
  saveLeaseMasterContact: Contact;
  saveLeaseMasterNote: Array<Note>;
  saveLeasedAssetsForSubAccountLocation: Array<LeasedAssetForSubAccountLocation>;
  saveNote: Note;
  savePaymentPlan: Array<PaymentPlan>;
  savePaymentPostings: Array<PaymentPosting>;
  saveRole: Scalars['Boolean']['output'];
  saveSicCodeMasters: Array<CodeRowMaster>;
  saveSicCodes: Array<CodeRow>;
  saveSicSiloCodes: Array<CodeRow>;
  saveSubSiloCodes: Array<CodeRow>;
  saveTaxDistrictBusinessAccountList?: Maybe<Array<Maybe<TaxDistrictBusinessAccountRow>>>;
  saveTelecomAccount?: Maybe<TelecomBusinessAccount>;
  saveTelecomContact: Contact;
  saveTelecomMcatAssets: Array<McatAsset>;
  saveTelecomMcatLessor: Array<Lessor>;
  saveTelecomMcatPropertyAssetList: McatPropertyAssetList;
  saveTelecomNote: Array<Note>;
  saveTelecomSubAccount: TelecomSubAccount;
  saveTelecomSubAccountAssets: Array<Asset>;
  saveTelecomSubAccountLessor: Lessor;
  searchAssociatedAccountAddress: AssociatedAccount;
  searchBusinessByAccountNumber: GetSearxhBusinessByAccountNumberResponse;
  searchLeaseBusinessAccountInfoByNumber?: Maybe<SearchBusinessAccountInfoByNumberResponse>;
  searchTelecomBusinessAccountInfoByNumber?: Maybe<SearchBusinessAccountInfoByNumberResponse>;
  sendBatchToTreasurer: Scalars['Boolean']['output'];
  setBatchToPaid: Scalars['Boolean']['output'];
  setLeaseMasterPrimaryContact: Scalars['Boolean']['output'];
  setTelecomPrimaryContact: Scalars['Boolean']['output'];
  skipAssetReconciliation: Scalars['Boolean']['output'];
  skipLessorReconciliation: Scalars['Boolean']['output'];
  transferTelecomMcatAssetsToProduction: Scalars['Boolean']['output'];
  updateBatch: Scalars['Boolean']['output'];
  updateExemptAndGetSummaryAmount: AccountSummary;
  updateLeaseExemptAndGetSummaryAmount: AccountSummary;
  updateMassPaymentFilingStatus: MassPaymentFilingStatus;
  updateRole: Scalars['Boolean']['output'];
  updateSubAccountTaxDistrict: SubAccountTaxDistrict;
  updateTelecomExemptAndGetSummaryAmount: AccountSummary;
  updateUser: Scalars['Boolean']['output'];
  uploadAssets: UploadAssetResponse;
  uploadLeaseAssets: UploadAssetResponse;
  validateLeaseMasterAccount?: Maybe<Scalars['Boolean']['output']>;
  validateTelecomMasterAccountNumber?: Maybe<Scalars['Boolean']['output']>;
  voidDelinquentPayment: Scalars['Boolean']['output'];
};


export type MutationAddRoleToUserArgs = {
  roleId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationAllocateHoldingsToSubAccountsArgs = {
  allocation: AllocateHoldingsToSubAccountsInput;
};


export type MutationApproveMassAccountBatchArgs = {
  id: Scalars['Int']['input'];
};


export type MutationBulkUpdateAppraiserRegionArgs = {
  input: BulkUpdateAppraiserRegionInput;
};


export type MutationBulkUpdateIndustrialParkArgs = {
  input: BulkUpdateIndustrialParkInput;
};


export type MutationCalculateAccountDelinquencyArgs = {
  delinquency: CalculateAccountDelinquencyInput;
  reset?: InputMaybe<Scalars['Boolean']['input']>;
  taxYear: Scalars['Int']['input'];
};


export type MutationCalculateInterestArgs = {
  accountId: Scalars['Int']['input'];
  dateReceived: Scalars['String']['input'];
};


export type MutationCalculateMasterAccountInterestArgs = {
  input: CalculateMasterAccountInterestInput;
};


export type MutationCalculatePaymentPlanArgs = {
  calculatePaymentPlanInput: CalculatePaymentPlanInput;
};


export type MutationCalculatePenaltyArgs = {
  accountId: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
};


export type MutationCalculateTaxableValueArgs = {
  input: CalculateTaxableValueInput;
};


export type MutationChangeBusinessAccountStatusArgs = {
  accountStatus: AccountStatusInput;
};


export type MutationChangeLeaseMasterAccountStatusArgs = {
  accountStatus: AccountStatusInput;
};


export type MutationChangeLeaseMasterSubAccountStatusArgs = {
  accountStatus: SubAccountStatusInput;
};


export type MutationChangeMcatTelecomActiveStatusArgs = {
  accountNumber: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};


export type MutationChangeMcatTelecomApplyPenaltyStatusArgs = {
  accountNumber: Scalars['String']['input'];
  applyPenalty: Scalars['Boolean']['input'];
};


export type MutationChangeMcatTelecomApplyPenaltyStatusByJurisdictionArgs = {
  accountNumber: Scalars['String']['input'];
  applyPenalty: Scalars['Boolean']['input'];
  jurisdictionId: Scalars['Int']['input'];
};


export type MutationChangeMcatTelecomExemptStatusByJurisdictionArgs = {
  accountNumber: Scalars['String']['input'];
  isExempt: Scalars['Boolean']['input'];
  jurisdictionId: Scalars['Int']['input'];
};


export type MutationChangeMcatTelecomTaxAreaStatusArgs = {
  input: ChangeMcatTelecomTaxAreaStatusInput;
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationChangeTelecomAccountStatusArgs = {
  active: Scalars['Boolean']['input'];
  telecomMasterId: Scalars['Int']['input'];
};


export type MutationChangeTelecomSubAccountStatusArgs = {
  params: ChangeTelecomSubAccountStatusParams;
};


export type MutationCompleteReconciliationArgs = {
  accountId: Scalars['Int']['input'];
};


export type MutationCreateBatchArgs = {
  createBatchInput: CreateBatchInput;
};


export type MutationCreateBusinessAccountArgs = {
  account: CreateBusinessAccountInput;
};


export type MutationCreateContactArgs = {
  accountId: Scalars['Int']['input'];
  contact: ContactInput;
  taxYear: Scalars['Int']['input'];
};


export type MutationCreateDelinquentAdjustmentArgs = {
  delinquentAdjustment: DelinquentAdjustmentInput;
};


export type MutationCreateDelinquentPaymentArgs = {
  payment: CreateDelinquentPaymentInput;
};


export type MutationCreateDelinquentReturnedPaymentArgs = {
  payment: CreateDelinquentReturnedPaymentInput;
};


export type MutationCreateHoldingAccountArgs = {
  holdingAccountInput: CreateHoldingAccountInput;
};


export type MutationCreateLeaseMasterAccountArgs = {
  input: CreateLessorAccountInput;
};


export type MutationCreateLeaseMasterContactArgs = {
  accountId: Scalars['Int']['input'];
  contact: ContactInput;
};


export type MutationCreateMassAccountBatchArgs = {
  batch: CreateMassAccountBatchInput;
};


export type MutationCreateMovePermitArgs = {
  movePermit: CreateMovePermitInput;
};


export type MutationCreatePaymentArgs = {
  payment: CreatePaymentInput;
};


export type MutationCreateReturnedPaymentArgs = {
  payment: ReturnedPaymentInput;
};


export type MutationCreateSubAccountTaxDistrictArgs = {
  accountId: Scalars['ID']['input'];
  taxDistrict: Scalars['String']['input'];
};


export type MutationCreateTelecomAccountArgs = {
  input: CreateTelecomBusinessAccountInput;
};


export type MutationCreateTelecomContactArgs = {
  accountId: Scalars['Int']['input'];
  contact: ContactInput;
};


export type MutationCreateTelecomSubAccountArgs = {
  taxDistrict: Scalars['String']['input'];
  telecomMasterId: Scalars['Int']['input'];
};


export type MutationCreateUserArgs = {
  newUser: NewUser;
};


export type MutationDeleteBatchArgs = {
  batchId: Scalars['Int']['input'];
};


export type MutationDeleteBatchBusinessAccountArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteMassAccountBatchArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePaymentPlanArgs = {
  paymentPlanId: Scalars['Int']['input'];
};


export type MutationDeleteRoleArgs = {
  roleId: Scalars['Int']['input'];
};


export type MutationEditDelinquentPaymentArgs = {
  payment: EditDelinquentPaymentInput;
};


export type MutationEditMovePermitArgs = {
  movePermit: EditMovePermitInput;
};


export type MutationEditPaymentArgs = {
  payment: EditPaymentInput;
};


export type MutationExecuteBafBatchPenaltyArgs = {
  taxYear: Scalars['Int']['input'];
};


export type MutationExecuteLeaseBatchPenaltyArgs = {
  taxYear: Scalars['Int']['input'];
};


export type MutationExecuteTelecomBatchPenaltyArgs = {
  taxYear: Scalars['Int']['input'];
};


export type MutationExportToCsvArgs = {
  batchId: Scalars['Int']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationGeneratePresignedUploadFileArgs = {
  input: SasUploadFileInput;
};


export type MutationImpersonateUserArgs = {
  id: Scalars['Int']['input'];
};


export type MutationLoginArgs = {
  jurisdictionId: Scalars['Int']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationMasterLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationMcatLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationMergeAppraiserRegionsArgs = {
  mergeAppraiserRegionsInput: MergeAppraiserRegionsInput;
};


export type MutationReconcileAccountInformationArgs = {
  account: ReconciliationAccountInformationInput;
};


export type MutationReconcileAssetsArgs = {
  accountId: Scalars['Int']['input'];
  assets: Array<AssetInput>;
};


export type MutationReconcileContactsArgs = {
  accountId: Scalars['Int']['input'];
  contacts: Array<ReconcileContactInput>;
};


export type MutationReconcileLeaseMasterAssetsArgs = {
  assets: Array<ReconcileLeaseMasterAssetInput>;
};


export type MutationReconcileLessorsArgs = {
  accountId: Scalars['Int']['input'];
  lessors: Array<LessorInput>;
};


export type MutationReconcileSummaryArgs = {
  accountId: Scalars['Int']['input'];
  filingSummary: FilingSummaryInput;
};


export type MutationRegenerateMcatTelecomPinArgs = {
  accountNumber: Scalars['String']['input'];
};


export type MutationRegeneratePinArgs = {
  pinInput: PinInput;
};


export type MutationRemoveContactArgs = {
  accountId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  primaryContact?: InputMaybe<ContactInput>;
};


export type MutationRemoveLeaseMasterContactArgs = {
  accountId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  primaryContact?: InputMaybe<ContactInput>;
};


export type MutationRemoveLinkedAccountArgs = {
  linkId: Scalars['ID']['input'];
};


export type MutationRemoveMcatTelecomWorkflowArgs = {
  accountNumber: Scalars['String']['input'];
};


export type MutationRemoveRoleFromUserArgs = {
  roleId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationRemoveTelecomContactArgs = {
  accountId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  primaryContact?: InputMaybe<ContactInput>;
};


export type MutationRemoveTelecomStagingDataArgs = {
  input: RemoveTelecomStagingDataInput;
};


export type MutationReopenFilingArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  encryptedValue: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationSaveAccountTypeArgs = {
  accountType: Array<AccountTypeInput>;
};


export type MutationSaveAppraiserRegionArgs = {
  appraiserRegion: SaveAppraiserRegionInput;
};


export type MutationSaveAssetsArgs = {
  accountId: Scalars['Int']['input'];
  assets: Array<AssetInput>;
};


export type MutationSaveAssociatedAccountsArgs = {
  group: AssociatedAccountGroupInput;
};


export type MutationSaveBasicCostArgs = {
  cost: SaveBasicCostByClassInput;
};


export type MutationSaveBatchBusinessAccountArgs = {
  account: BatchBusinessAccountInput;
  id: Scalars['Int']['input'];
};


export type MutationSaveBusinessAccountArgs = {
  businessAccount: BusinessAccountInput;
};


export type MutationSaveClassificationsArgs = {
  classifications: Array<ClassificationInput>;
};


export type MutationSaveContactArgs = {
  accountId: Scalars['Int']['input'];
  contact: ContactInput;
  taxYear: Scalars['Int']['input'];
};


export type MutationSaveCountyContactsArgs = {
  contactIds: Array<Scalars['String']['input']>;
};


export type MutationSaveDirectChargesArgs = {
  accountId: Scalars['Int']['input'];
  directCharges: Array<DirectChargeInput>;
  taxYear: Scalars['Int']['input'];
};


export type MutationSaveIndustrialParkArgs = {
  input: IndustrialParkInput;
};


export type MutationSaveLeaseMasterAccountArgs = {
  input: LeaseMasterBusinessAccountInput;
};


export type MutationSaveLeaseMasterContactArgs = {
  accountId: Scalars['Int']['input'];
  contact: ContactInput;
};


export type MutationSaveLeaseMasterNoteArgs = {
  note: NoteInput;
};


export type MutationSaveLeasedAssetsForSubAccountLocationArgs = {
  input: SaveLeasedAssetForSubAccountLocationInput;
};


export type MutationSaveNoteArgs = {
  note: NoteInput;
};


export type MutationSavePaymentPlanArgs = {
  savePaymentPlanInput: SavePaymentPlanInput;
};


export type MutationSavePaymentPostingsArgs = {
  dateReceived: Scalars['String']['input'];
  payments: Array<PaymentPostingInput>;
};


export type MutationSaveRoleArgs = {
  role: RoleInput;
};


export type MutationSaveSicCodeMastersArgs = {
  sicCodeMasters: Array<CodeRowMasterInput>;
};


export type MutationSaveSicCodesArgs = {
  sicCodes: Array<CodeRowInput>;
};


export type MutationSaveSicSiloCodesArgs = {
  sicSiloCodes: Array<CodeRowInput>;
};


export type MutationSaveSubSiloCodesArgs = {
  subSiloCodes: Array<CodeRowInput>;
};


export type MutationSaveTaxDistrictBusinessAccountListArgs = {
  businessAccountList: Array<TaxDistrictBusinessAccountRowInput>;
};


export type MutationSaveTelecomAccountArgs = {
  input: TelecomBusinessAccountInput;
};


export type MutationSaveTelecomContactArgs = {
  accountId: Scalars['Int']['input'];
  contact: ContactInput;
};


export type MutationSaveTelecomMcatAssetsArgs = {
  assets: Array<McatAssetInput>;
};


export type MutationSaveTelecomMcatLessorArgs = {
  input: SaveTelecomMcatLessorInput;
};


export type MutationSaveTelecomMcatPropertyAssetListArgs = {
  accountNumber: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  isLeased: Scalars['Boolean']['input'];
  taxYear: Scalars['Int']['input'];
};


export type MutationSaveTelecomNoteArgs = {
  note: NoteInput;
};


export type MutationSaveTelecomSubAccountArgs = {
  input: SaveTelecomSubAccountInput;
};


export type MutationSaveTelecomSubAccountAssetsArgs = {
  accountId: Scalars['Int']['input'];
  assets: Array<AssetInput>;
  telecomMasterId: Scalars['Int']['input'];
};


export type MutationSaveTelecomSubAccountLessorArgs = {
  accountId: Scalars['Int']['input'];
  lessor: LessorInput;
  telecomMasterId: Scalars['Int']['input'];
};


export type MutationSearchAssociatedAccountAddressArgs = {
  accountNumber: Scalars['String']['input'];
};


export type MutationSearchBusinessByAccountNumberArgs = {
  accountNumber: Scalars['String']['input'];
  leaseMasterId: Scalars['ID']['input'];
  subAccountId: Scalars['ID']['input'];
};


export type MutationSearchLeaseBusinessAccountInfoByNumberArgs = {
  accountNumber: Scalars['String']['input'];
};


export type MutationSearchTelecomBusinessAccountInfoByNumberArgs = {
  accountNumber: Scalars['String']['input'];
};


export type MutationSendBatchToTreasurerArgs = {
  batchId: Scalars['Int']['input'];
};


export type MutationSetBatchToPaidArgs = {
  batchId: Scalars['Int']['input'];
};


export type MutationSetLeaseMasterPrimaryContactArgs = {
  accountId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetTelecomPrimaryContactArgs = {
  accountId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSkipAssetReconciliationArgs = {
  accountId: Scalars['Int']['input'];
};


export type MutationSkipLessorReconciliationArgs = {
  accountId: Scalars['Int']['input'];
};


export type MutationTransferTelecomMcatAssetsToProductionArgs = {
  telecomInput: TransferTelecomAssetsToProductionInput;
};


export type MutationUpdateBatchArgs = {
  batchId: Scalars['Int']['input'];
  updateBatchInput: UpdateBatchInput;
};


export type MutationUpdateExemptAndGetSummaryAmountArgs = {
  accountId: Scalars['String']['input'];
  isExempt: Scalars['Boolean']['input'];
  taxYear: Scalars['Int']['input'];
};


export type MutationUpdateLeaseExemptAndGetSummaryAmountArgs = {
  isExempt: Scalars['Boolean']['input'];
  leaseMasterId: Scalars['String']['input'];
};


export type MutationUpdateMassPaymentFilingStatusArgs = {
  input: MassPaymentFilingStatusInput;
};


export type MutationUpdateRoleArgs = {
  role: RoleInput;
  roleId: Scalars['Int']['input'];
};


export type MutationUpdateSubAccountTaxDistrictArgs = {
  subAccountTaxDistrict: SubAccountTaxDistrictInput;
};


export type MutationUpdateTelecomExemptAndGetSummaryAmountArgs = {
  isExempt: Scalars['Boolean']['input'];
  telecomMasterId: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  id: Scalars['Int']['input'];
  updatedUser: UpdatedUser;
};


export type MutationUploadAssetsArgs = {
  uploadedAssetsInput: UploadAssetInput;
};


export type MutationUploadLeaseAssetsArgs = {
  uploadLeaseAssetsInput: UploadLeaseAssetInput;
};


export type MutationValidateLeaseMasterAccountArgs = {
  leaseMasterAccountNumber: Scalars['String']['input'];
  subAccountNumber: Scalars['String']['input'];
};


export type MutationValidateTelecomMasterAccountNumberArgs = {
  telecomAccountNumber: Scalars['String']['input'];
};


export type MutationVoidDelinquentPaymentArgs = {
  input: VoidDelinquentPaymentInput;
};

export type NaicsCategory = {
  category: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type NaicsCode = {
  category: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  subCategory: Scalars['String']['output'];
};

export type NaicsCodeInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  subCategory?: InputMaybe<Scalars['String']['input']>;
};

export type NegativeRefundChargesReportEntry = {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  amount: Scalars['Float']['output'];
  businessName?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  leaseMasterAccountNbr?: Maybe<Scalars['String']['output']>;
  taxYear: Scalars['Int']['output'];
  telecomAccountNbr?: Maybe<Scalars['String']['output']>;
};

export type NewBusinessNotReconciledReportEntry = BasicReportResult & {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  leaseMasterAccountNbr?: Maybe<Scalars['String']['output']>;
  taxYear: Scalars['Int']['output'];
  telecomAccountNbr?: Maybe<Scalars['String']['output']>;
};

export type NewUser = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type Note = {
  author: NoteAuthor;
  content: Scalars['String']['output'];
  createDate: Scalars['String']['output'];
  edited?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  section?: Maybe<Scalars['String']['output']>;
  subsection?: Maybe<Scalars['String']['output']>;
  systemGenerated: Scalars['Boolean']['output'];
  taxYear: Scalars['Int']['output'];
  updateDate: Scalars['String']['output'];
};

export type NoteAuthor = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type NoteInput = {
  accountId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};

export type OneYearExemptStatusReportEntry = AccountReportEntry & {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  associatedAccounts: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isExempt: Scalars['Boolean']['output'];
  isReconciled: Scalars['Boolean']['output'];
  netAssmntChargeWithTotalDirect: Scalars['Float']['output'];
  payments: Scalars['Float']['output'];
  penalty: Scalars['Float']['output'];
  taxYear: Scalars['Int']['output'];
  totalTaxable: Scalars['Float']['output'];
  yearEndBalance: Scalars['Float']['output'];
};

export type PyRolledToDelinquentTablesEntry = {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  amount: Scalars['Float']['output'];
  businessName?: Maybe<Scalars['String']['output']>;
  howReceived?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isReconciled?: Maybe<Scalars['Boolean']['output']>;
  leaseMasterAccountNbr?: Maybe<Scalars['String']['output']>;
  taxYear: Scalars['Float']['output'];
  telecomAccountNbr?: Maybe<Scalars['String']['output']>;
};

export type PaperFilingToken = {
  token?: Maybe<Scalars['String']['output']>;
};

/** Identifies the relationship between the Contact and the Account */
export type ParcelUseType = {
  id: Scalars['ID']['output'];
  /** Human-readable label used to display in the application */
  label: Scalars['String']['output'];
};

export type ParcelUseTypeInput = {
  id: Scalars['ID']['input'];
  /** Human-readable label used to display in the application */
  label: Scalars['String']['input'];
};

export type Payment = {
  accountId: Scalars['Int']['output'];
  accountNumber?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  checkNumber?: Maybe<Scalars['String']['output']>;
  dateReceived: Scalars['String']['output'];
  ein: Ein;
  howReceived?: Maybe<HowReceived>;
  id: Scalars['Int']['output'];
  interestAccrued?: Maybe<Scalars['Float']['output']>;
  interestPaid?: Maybe<Scalars['Float']['output']>;
  isReconciled?: Maybe<Scalars['Boolean']['output']>;
  isVoided?: Maybe<Scalars['Boolean']['output']>;
  masterAccountNumber?: Maybe<Scalars['String']['output']>;
  paymentAmount: Scalars['Float']['output'];
  paymentStatus?: Maybe<PaymentStatus>;
  paymentType?: Maybe<PaymentType>;
  penaltyAmount?: Maybe<Scalars['Float']['output']>;
  penaltyPaid?: Maybe<Scalars['Float']['output']>;
  receiptNumber: Scalars['Int']['output'];
  receivedFrom: Scalars['String']['output'];
  taxYear: Scalars['Int']['output'];
};

export type PaymentHolding = {
  amount: Scalars['Float']['output'];
  checkNumber?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<User>;
  dateReceived: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  paymentType: PaymentType;
  receiptNumber: Scalars['Int']['output'];
};

export type PaymentHoldingInput = {
  amount: Scalars['Float']['input'];
  checkNumber?: InputMaybe<Scalars['String']['input']>;
  createdBy: Scalars['Int']['input'];
  dateReceived: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  paymentType: PaymentTypeInput;
  receiptNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentPlan = {
  contractNumber: Scalars['String']['output'];
  details: Array<PaymentPlanDetail>;
  id: Scalars['Int']['output'];
  planType: Scalars['String']['output'];
  taxYear: Scalars['Int']['output'];
  terms: Array<Scalars['Int']['output']>;
  totals: PaymentPlanTotals;
};

export enum PaymentPlanCalculationType {
  ByAmounthPerMonth = 'ByAmounthPerMonth',
  ByMonth = 'ByMonth'
}

export type PaymentPlanDetail = {
  amount: Scalars['Float']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  paymentDate: Scalars['String']['output'];
};

export type PaymentPlanDetailInput = {
  amount: Scalars['Float']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDate: Scalars['String']['input'];
};

export type PaymentPlanInput = {
  contractNumber: Scalars['String']['input'];
  details: Array<PaymentPlanDetailInput>;
  id: Scalars['Int']['input'];
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  planType: Scalars['String']['input'];
  terms?: InputMaybe<Array<Scalars['Int']['input']>>;
  totals: PaymentPlanTotalsInput;
};

export type PaymentPlanSummary = {
  accountId: Scalars['Int']['output'];
  accountNumber: Scalars['String']['output'];
  accountTypeId: Scalars['Int']['output'];
  businessName: Scalars['String']['output'];
  ein: Ein;
  paymentPlanTypes: Array<Scalars['String']['output']>;
  paymentPlans: Array<PaymentPlan>;
  taxYear: Scalars['Int']['output'];
  totals: PaymentPlanTotals;
};

export type PaymentPlanTemplate = {
  id: Scalars['Int']['output'];
  terms: Array<PaymentPlanTemplateTerm>;
  total: Scalars['Float']['output'];
};

export type PaymentPlanTemplateTerm = {
  amount: Scalars['Float']['output'];
  dueDate: Scalars['String']['output'];
};

export type PaymentPlanTotals = {
  currentYearDue: Scalars['Float']['output'];
  currentYearDueWithInterest: Scalars['Float']['output'];
  delinquentBalance: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
  totalPaymentsLeft: Scalars['Int']['output'];
};

export type PaymentPlanTotalsInput = {
  currentYearDue: Scalars['Float']['input'];
  currentYearDueWithInterest: Scalars['Float']['input'];
  delinquentBalance: Scalars['Float']['input'];
  totalPayments: Scalars['Float']['input'];
  totalPaymentsLeft: Scalars['Int']['input'];
};

export type PaymentPosting = {
  amount: Scalars['Float']['output'];
  checkNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isVoided: Scalars['Boolean']['output'];
  masterAccountNumber: Scalars['String']['output'];
  paymentType: Scalars['Int']['output'];
  receiptNumber: Scalars['Int']['output'];
  receivedFrom?: Maybe<Scalars['String']['output']>;
};

export type PaymentPostingInput = {
  amount: Scalars['Float']['input'];
  checkNumber?: InputMaybe<Scalars['String']['input']>;
  masterAccountNumber: Scalars['String']['input'];
  paymentType: Scalars['Int']['input'];
  receivedFrom: Scalars['String']['input'];
};

export type PaymentStatus = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type PaymentTemplate = {
  howFiled?: Maybe<HowFiledEnum>;
  howReceived?: Maybe<HowReceived>;
  payment: Payment;
  paymentPlan: PaymentPlanTemplate;
  summary: FinancialSummary;
};

export type PaymentType = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type PaymentTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type PaymentYearSummary = {
  grandTotal: Scalars['Float']['output'];
  payments: Array<Payment>;
  totalCash: Scalars['Float']['output'];
  totalChecks: Scalars['Float']['output'];
  totalCredit: Scalars['Float']['output'];
  totalEChecks: Scalars['Float']['output'];
  totalReturnedChecks: Scalars['Float']['output'];
  totalReturnedEChecks: Scalars['Float']['output'];
};

export type Permission = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PinInput = {
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
};

export type PinResponse = {
  linkedUsers: Array<LinkedUser>;
  pin?: Maybe<Scalars['String']['output']>;
};

export type PossibleRefund = {
  accountId?: Maybe<Scalars['Int']['output']>;
  accountNumber: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  balance: Scalars['Float']['output'];
  businessName: Scalars['String']['output'];
  careOf?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isExempt: Scalars['Boolean']['output'];
  isReconciled: Scalars['Boolean']['output'];
  isSpecial: Scalars['Boolean']['output'];
  leaseMasterId?: Maybe<Scalars['Int']['output']>;
  mailingName?: Maybe<Scalars['String']['output']>;
  paymentsReceived: Scalars['Float']['output'];
  state?: Maybe<Scalars['String']['output']>;
  taxArea: Scalars['String']['output'];
  year: Scalars['Int']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** Tax District Holding Account Address */
export type PrimaryContactAddress = {
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactId: Scalars['String']['output'];
  inCareOf?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** Tax District Holding Account Address */
export type PrimaryContactAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactId?: InputMaybe<Scalars['String']['input']>;
  inCareOf?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type Profile = {
  email: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type PropertyClassification = {
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type PropertyClassificationInput = {
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  accWithDirChargeDelTaxReport: Array<AccWithDirChargeDelTaxReportEntry>;
  accountBalanceReport: AccountBalanceReport;
  accountDelinquency: AccountDelinquency;
  accountForMassPayment: MassPaymentAccountInfo;
  accountTypes: Array<AccountType>;
  accountsByAppraiserRegion: Array<AccountByAppraiserRegion>;
  accountsByIndustrialPark: Array<AccountByIndustrialPark>;
  accountsToOneYearExemptReport: Array<AccountsToOneYearExemptReportEntry>;
  accountsWithCreditBalanceReport: Array<AccountsWithCreditBalanceReportEntry>;
  accountsWithInvalidTaxAreaReport: Array<AccountsWithInvalidTaxAreaReportEntry>;
  accountsWithMissingTaxRateReport: Array<AccountsWithMissingTaxRateReportEntry>;
  accountsWithPriorYearCreditChargeReport: Array<AccountsWithPriorYearCreditChargeReportEntry>;
  allCodes: AllCodes;
  appraiserRegionJurConfig: AppraiserRegionJurConfig;
  appraiserRegions: Array<AppraiserRegion>;
  associatedAccounts: AssociatedAccountGroup;
  balanceDueReasonsList: Array<BalanceDueReasonEntry>;
  batchBusinessAccount: BatchBusinessAccount;
  contactTypes: Array<ContactType>;
  contacts: Array<Contact>;
  countOfAccountsByAcctTypeReport: Array<CountOfAccountsByAcctTypeReportEntry>;
  countries: Array<Country>;
  countySettings: CountySettings;
  currentReturnedPayment: ReturnedPayment;
  currentTaxYear: Scalars['Int']['output'];
  currentYearDeletedWithDelinqBalanceReport: Array<CurrentYearDeletedWithDelinqBalanceReportEntry>;
  currentYearRollingToDelinquentTables: Array<CurrentYearRollingToDelinquentTablesEntry>;
  currentYearSummary: PaymentYearSummary;
  cyDeletedWithDelinquentPaymentReport: Array<CyDeletedWithDelinquentPaymentReportEntry>;
  cyDeletedWithPaymentReport: Array<CyDeletedWithPaymentReportEntry>;
  dailyPaymentTotals: DailyPaymentTotals;
  delinquentPaymentHistory: Array<DelinquentPaymentHistoryItem>;
  delinquentPaymentVoid: DelinquentPaymentVoid;
  delinquentReturnedPayment: DelinquentReturnedPayment;
  delinquentYearSummary: PaymentYearSummary;
  delinquentYearTransactions: DelinquentYearTransactionsResponse;
  delqPaymentVoidSearch: Array<DelqPaymentVoidSearchResult>;
  duplicatedAssociatedBusinessAccountsReport: Array<BasicReportResultType>;
  entityTypes: Array<EntityType>;
  estimatedValuesReport: Array<EstimatedValuesReportEntry>;
  exemptAccountsWithNoFlagReport: Array<BasicReportResultType>;
  exemptionLimit: Scalars['Float']['output'];
  existingBusinessNotExemptBelowThresholdReport: Array<ExistingBusinessNotExemptBelowThresholdReportEntry>;
  existingBusinessNotFiledLessThanExemptReport: Array<ExistingBusinessNotFiledLessThanExemptReportEntry>;
  filedStatusList: Array<FiledStatusEnum>;
  generateSASReadFile: Scalars['String']['output'];
  getAssets: AssetResponse;
  getBatchStatuses: Array<BatchStatus>;
  getBusinessAccount?: Maybe<BusinessAccount>;
  getBusinessAccountIdByNumber: GetBusinessAccountIdByNumberResponse;
  getBusinessAppraiserRegionList?: Maybe<Array<BusinessAppraiserRegion>>;
  getClassifications: Array<Classification>;
  getDirectChargeTypes: Array<DirectChargeType>;
  getDirectCharges: DirectChargeSummary;
  getJurisdictions: Array<Jurisdiction>;
  getLeasedAssets?: Maybe<Array<LeasedAssetForSubAccountLocation>>;
  getMCATTelecomAccount?: Maybe<TelecomBusinessAccount>;
  getMCATTelecomContacts: Array<Contact>;
  getMCATTelecomJurisdictions: Array<Jurisdiction>;
  getMCATTelecomList: Array<McatTelecom>;
  getPaymentPlan: PaymentPlanSummary;
  getPermissions: Array<Permission>;
  getPinAndLinkedAccounts: PinResponse;
  getProfile: Profile;
  getRefundBatch: RefundBatch;
  getRefundReasons: Array<RefundReason>;
  getRole: Role;
  getRoles: Array<Role>;
  getRolesFromUser: Array<Role>;
  getSpecialRefund: PossibleRefund;
  getSubAccountByLeaseMasterIdSubAccountId: SubAccountTaxDistrict;
  getSubAccountSummary: Array<SubAccountTaxDistrict>;
  getSubAccounts: GetSubAccountsResponse;
  getTaxRate: TaxRate;
  homeOccupationalNonTaxableAccountsReport: Array<HomeOccupationalNonTaxableAccountsReportEntry>;
  howFiledList: Array<HowFiledEnum>;
  howReceivedList: Array<HowReceived>;
  industrialParkOptions: Array<IndustrialParkOption>;
  industrialParks: Array<IndustrialPark>;
  ironCountyTaxableValueReport: Array<IronCountyTaxableValueReportEntry>;
  isAttachedReport: Array<IsAttachedReportEntry>;
  leaseMasterAccountWithoutSubAccountsReport: Array<LeaseMasterAccountWithoutSubAccountsReportEntry>;
  leaseMasterAccountsWithBalanceReport: Array<LeaseMasterAccountWithBalanceEntry>;
  leaseMasterAssets: Array<MasterAsset>;
  leaseMasterAssoc: Array<LeaseMasterAssoc>;
  leaseMasterBusinessAccount?: Maybe<LeaseMasterBusinessAccount>;
  leaseMasterContact: Array<Contact>;
  leaseMasterNotes: Array<Note>;
  leaseMasterOneYearExemptReport: Array<LeaseMasterOneYearExemptReportEntry>;
  leasedAssetsForSubAccountLocation: Array<LeasedAssetForSubAccountLocation>;
  lmTaxDistrictAcctCheckReport: Array<LmTaxDistrictAcctCheckReportEntry>;
  massAccountBatch: Array<BatchBusinessAccountMin>;
  massAccountBatches: Array<MassAccountBatch>;
  massAccountTemplate: Scalars['String']['output'];
  masterAccountDelinquentSummary: MasterAccountDelinquentSummary;
  masterAssets: Array<MasterAsset>;
  movePermitInitialFormData: MovePermitInitialData;
  movePermits: MovePermitSearchResponse;
  naicsCategories: Array<NaicsCategory>;
  naicsCodes: Array<NaicsCode>;
  negativeRefundChargesReport: Array<NegativeRefundChargesReportEntry>;
  newBizAcctsNotFiledOrExemptWithNoValueReport: Array<BasicReportResultType>;
  newBusinessNotReconciledReport: Array<NewBusinessNotReconciledReportEntry>;
  notes: Array<Note>;
  oneYearExemptStatusReport: Array<OneYearExemptStatusReportEntry>;
  parcelUseTypeList: Array<ParcelUseType>;
  paymentHoldings: MasterAccountHolding;
  paymentPostings: Array<PaymentPosting>;
  paymentStatus: Array<PaymentStatus>;
  paymentTemplate: PaymentTemplate;
  paymentTypes: Array<PaymentType>;
  payments: Array<Payment>;
  pyRolledToDelinquentTablesReport: Array<PyRolledToDelinquentTablesEntry>;
  reconciliationAccountInformation: ReconciliationAccountInformationSummary;
  reconciliationAssets: Array<ReconciliationAssetSummary>;
  reconciliationContacts: Array<ReconciliationContactSummary>;
  reconciliationContext: SessionContext;
  reconciliationLessors: Array<ReconciliationLessorSummary>;
  reconciliationSummary: ReconciliationFilingSummary;
  rentalHomeOccOverExemptNotFiledReport: Array<RentalHomeOccOverExemptReportEntry>;
  rentalsTwentyOrLessUnitsReport: Array<RentalsTwentyOrLessUnitsReportEntry>;
  search: Array<User>;
  searchBatches: Array<BatchSearchResult>;
  searchBusinessAccount: SearchBusinessAccountResponse;
  searchLeaseMasterAccountSuggestions: Array<LeaseMasterAccountSuggestion>;
  searchLeaseMasterBusinessAccount?: Maybe<SearchLeaseMasterBusinessAccountResponse>;
  searchLeasedAssetForReconciliation: Array<LeasedAssetForReconciliation>;
  searchPayments: Array<Payment>;
  searchRefunds: Array<PossibleRefund>;
  sicCodeMasters: Array<CodeRowMaster>;
  sicCodes: Array<CodeRow>;
  sicSiloCodes: Array<CodeRow>;
  similarBusinesses: Array<SimilarBusinessRow>;
  similarBusinessesLeaseMaster: Array<MasterSimilarBusinessRow>;
  similarTelecomBusinesses: Array<MasterSimilarBusinessRow>;
  subAccountSearch: SubAccountLookup;
  subSiloCodes: Array<CodeRow>;
  taxAreaList: Array<TaxArea>;
  taxDistrictBusinessAccountList?: Maybe<Array<Maybe<TaxDistrictBusinessAccountRow>>>;
  telecomAssetStagingReport: Array<TelecomAssetStagingReportEntry>;
  telecomBusinessAccount?: Maybe<TelecomBusinessAccount>;
  telecomContactInfoReport: Array<TelecomContactInfoReportEntry>;
  telecomContacts: Array<Contact>;
  telecomFilingDifferenceReport: Array<TelecomFilingDifferenceReportEntry>;
  telecomMasterAssets: Array<MasterAsset>;
  telecomMcatAreas: TelecomMcatAreas;
  telecomMcatAssetFiles: Array<McatAssetFile>;
  telecomMcatAssets: Array<McatAsset>;
  telecomMcatLessors: Array<Lessor>;
  telecomMcatSearchAccounts?: Maybe<TelecomSearchResponse>;
  telecomMcatStagedAssets: Array<TelecomMcatStagedAsset>;
  telecomMcatSubAccount: TelecomSubAccount;
  telecomNotes: Array<Note>;
  telecomSearchAccounts?: Maybe<TelecomSearchResponse>;
  telecomStatsSupportPhone?: Maybe<Scalars['String']['output']>;
  telecomSubAccount: TelecomSubAccount;
  telecomSubAccountAssets: Array<Asset>;
  telecomSubAccountLessors: Array<Lessor>;
  telecomSubAccountNameMismatchReport: Array<TelecomSubAccountNameMismatchReportEntry>;
  telecomSubAccounts: Array<TelecomSubAccount>;
  telecomYearlyTaxableDifferenceReport: Array<TelecomYearlyTaxableDifferenceReportEntry>;
  timeSpentFiling: Array<TimeSpentFiling>;
  uploadAssetsTemplate: Scalars['String']['output'];
  uploadLeasedAssetsTemplate: Scalars['String']['output'];
};


export type QueryAccWithDirChargeDelTaxReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryAccountDelinquencyArgs = {
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryAccountForMassPaymentArgs = {
  accountNumber: Scalars['String']['input'];
  interestDate: Scalars['String']['input'];
};


export type QueryAccountTypesArgs = {
  filterBy?: InputMaybe<FilterAccountTypeBy>;
};


export type QueryAccountsByAppraiserRegionArgs = {
  regionId: Scalars['String']['input'];
};


export type QueryAccountsByIndustrialParkArgs = {
  industrialPark: Scalars['String']['input'];
};


export type QueryAccountsToOneYearExemptReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryAccountsWithCreditBalanceReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryAccountsWithInvalidTaxAreaReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryAccountsWithMissingTaxRateReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryAccountsWithPriorYearCreditChargeReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryAssociatedAccountsArgs = {
  accountId: Scalars['Int']['input'];
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBalanceDueReasonsListArgs = {
  isTelecom: Scalars['Boolean']['input'];
};


export type QueryBatchBusinessAccountArgs = {
  id: Scalars['Int']['input'];
};


export type QueryContactsArgs = {
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryCountOfAccountsByAcctTypeReportArgs = {
  currentTaxYear: Scalars['Int']['input'];
  priorTaxYear: Scalars['Int']['input'];
};


export type QueryCurrentReturnedPaymentArgs = {
  accountNumber: Scalars['String']['input'];
};


export type QueryCurrentYearDeletedWithDelinqBalanceReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryCurrentYearRollingToDelinquentTablesArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryCurrentYearSummaryArgs = {
  dateReceived: Scalars['String']['input'];
  ein?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCyDeletedWithDelinquentPaymentReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryCyDeletedWithPaymentReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryDailyPaymentTotalsArgs = {
  dateReceived: Scalars['String']['input'];
  ein?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDelinquentPaymentHistoryArgs = {
  accountNumber: Scalars['String']['input'];
};


export type QueryDelinquentPaymentVoidArgs = {
  receiptNumber: Scalars['String']['input'];
};


export type QueryDelinquentReturnedPaymentArgs = {
  accountNumber: Scalars['String']['input'];
};


export type QueryDelinquentYearSummaryArgs = {
  dateReceived: Scalars['String']['input'];
};


export type QueryDelinquentYearTransactionsArgs = {
  accountNumber: Scalars['String']['input'];
};


export type QueryDelqPaymentVoidSearchArgs = {
  input: DelqPaymentVoidSearchInput;
};


export type QueryDuplicatedAssociatedBusinessAccountsReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryEstimatedValuesReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryExemptAccountsWithNoFlagReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryExistingBusinessNotExemptBelowThresholdReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryExistingBusinessNotFiledLessThanExemptReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryGenerateSasReadFileArgs = {
  fileName: Scalars['String']['input'];
};


export type QueryGetAssetsArgs = {
  accountId: Scalars['Int']['input'];
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetBusinessAccountArgs = {
  accountId: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryGetBusinessAccountIdByNumberArgs = {
  accountNumber: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryGetDirectChargesArgs = {
  accountId: Scalars['ID']['input'];
  jurisdiction?: InputMaybe<Scalars['Int']['input']>;
  taxYear: Scalars['Int']['input'];
};


export type QueryGetJurisdictionsArgs = {
  isImplemented?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetLeasedAssetsArgs = {
  leaseMasterId: Scalars['ID']['input'];
};


export type QueryGetMcatTelecomAccountArgs = {
  accountNbr: Scalars['String']['input'];
  jurisdiction?: InputMaybe<Scalars['Int']['input']>;
  taxYear: Scalars['Int']['input'];
};


export type QueryGetMcatTelecomContactsArgs = {
  taxYear: Scalars['Int']['input'];
  telecomId: Scalars['String']['input'];
};


export type QueryGetMcatTelecomJurisdictionsArgs = {
  accountNbr: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryGetPaymentPlanArgs = {
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryGetPinAndLinkedAccountsArgs = {
  pinInput: PinInput;
};


export type QueryGetRefundBatchArgs = {
  refundBatchId: Scalars['Int']['input'];
};


export type QueryGetRoleArgs = {
  roleId: Scalars['Int']['input'];
};


export type QueryGetRolesFromUserArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryGetSpecialRefundArgs = {
  accountNumber: Scalars['String']['input'];
  isLeaseMaster: Scalars['Boolean']['input'];
};


export type QueryGetSubAccountByLeaseMasterIdSubAccountIdArgs = {
  leaseMasterId: Scalars['ID']['input'];
  subAccountId: Scalars['ID']['input'];
};


export type QueryGetSubAccountSummaryArgs = {
  leaseMasterId: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryGetSubAccountsArgs = {
  leaseMasterAccountNumber: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryGetTaxRateArgs = {
  accountId: Scalars['Int']['input'];
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHomeOccupationalNonTaxableAccountsReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryIronCountyTaxableValueReportArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryIsAttachedReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryLeaseMasterAccountWithoutSubAccountsReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryLeaseMasterAccountsWithBalanceReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryLeaseMasterAssetsArgs = {
  leaseMasterId: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryLeaseMasterAssocArgs = {
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryLeaseMasterBusinessAccountArgs = {
  accountNumber: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryLeaseMasterContactArgs = {
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryLeaseMasterNotesArgs = {
  leaseMasterId: Scalars['ID']['input'];
};


export type QueryLeaseMasterOneYearExemptReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryLeasedAssetsForSubAccountLocationArgs = {
  leaseMasterId: Scalars['ID']['input'];
  locationAccountId: Scalars['ID']['input'];
  subAccountId: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryLmTaxDistrictAcctCheckReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryMassAccountBatchArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMasterAccountDelinquentSummaryArgs = {
  dateReceived: Scalars['String']['input'];
  isTelecom?: InputMaybe<Scalars['Boolean']['input']>;
  masterAccountNumber: Scalars['String']['input'];
};


export type QueryMasterAssetsArgs = {
  accountId: Scalars['Int']['input'];
  isTelecom?: InputMaybe<Scalars['Boolean']['input']>;
  taxYear: Scalars['Int']['input'];
};


export type QueryMovePermitInitialFormDataArgs = {
  accountNumber: Scalars['String']['input'];
};


export type QueryMovePermitsArgs = {
  searchFilters: MovePermitSearchInput;
};


export type QueryNegativeRefundChargesReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryNewBizAcctsNotFiledOrExemptWithNoValueReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryNewBusinessNotReconciledReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryNotesArgs = {
  accountId: Scalars['ID']['input'];
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOneYearExemptStatusReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryPaymentHoldingsArgs = {
  accountNumber: Scalars['String']['input'];
};


export type QueryPaymentPostingsArgs = {
  dateReceived: Scalars['String']['input'];
  isTelecom?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaymentTemplateArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryPaymentsArgs = {
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryPyRolledToDelinquentTablesReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryReconciliationAccountInformationArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryReconciliationAssetsArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryReconciliationContactsArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryReconciliationContextArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryReconciliationLessorsArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryReconciliationSummaryArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryRentalHomeOccOverExemptNotFiledReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryRentalsTwentyOrLessUnitsReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QuerySearchArgs = {
  searchFilters?: InputMaybe<SearchFilters>;
};


export type QuerySearchBatchesArgs = {
  searchBatchInput: SearchBatchInput;
};


export type QuerySearchBusinessAccountArgs = {
  searchFilters: SearchBusinessAccountInput;
};


export type QuerySearchLeaseMasterAccountSuggestionsArgs = {
  accountNumber: Scalars['ID']['input'];
};


export type QuerySearchLeaseMasterBusinessAccountArgs = {
  filters: SearchLeaseMasterBusinessAccountInput;
};


export type QuerySearchLeasedAssetForReconciliationArgs = {
  filters: SearchLeasedAssetsForReconciliationInput;
};


export type QuerySearchPaymentsArgs = {
  filters: SearchPaymentInput;
};


export type QuerySimilarBusinessesArgs = {
  similarBusinessSearchInput: SimilarBusinessSearchInput;
};


export type QuerySimilarBusinessesLeaseMasterArgs = {
  similarBusinessSearchLeaseMasterInput: SimilarBusinessSearchLeaseMasterInput;
};


export type QuerySimilarTelecomBusinessesArgs = {
  similarTelecomBusinessInput: SimilarTelecomBusinessInput;
};


export type QuerySubAccountSearchArgs = {
  accountNumber: Scalars['String']['input'];
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTaxDistrictBusinessAccountListArgs = {
  leaseMasterId: Scalars['ID']['input'];
  subAccountId: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryTelecomAssetStagingReportArgs = {
  taxYear: Scalars['Int']['input'];
  telecomMasterId: Scalars['ID']['input'];
};


export type QueryTelecomBusinessAccountArgs = {
  accountNumber: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryTelecomContactInfoReportArgs = {
  taxYear: Scalars['Int']['input'];
  telecomMasterId: Scalars['ID']['input'];
};


export type QueryTelecomContactsArgs = {
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryTelecomFilingDifferenceReportArgs = {
  taxYear: Scalars['Int']['input'];
  telecomMasterId: Scalars['ID']['input'];
};


export type QueryTelecomMasterAssetsArgs = {
  taxYear: Scalars['Int']['input'];
  telecomMasterId: Scalars['ID']['input'];
};


export type QueryTelecomMcatAreasArgs = {
  params: TelecomMcatAreaParams;
};


export type QueryTelecomMcatAssetFilesArgs = {
  accountNumber: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
};


export type QueryTelecomMcatAssetsArgs = {
  params: TelecomMcatAssetsInput;
};


export type QueryTelecomMcatLessorsArgs = {
  params: TelecomMcatAssetsInput;
};


export type QueryTelecomMcatSearchAccountsArgs = {
  Filters?: InputMaybe<TelecomMcatSearchFilters>;
};


export type QueryTelecomMcatStagedAssetsArgs = {
  taxYear: Scalars['Int']['input'];
  telecomMasterId: Scalars['ID']['input'];
};


export type QueryTelecomMcatSubAccountArgs = {
  params: TelecomMcatSubAccountParams;
};


export type QueryTelecomNotesArgs = {
  telecomId: Scalars['ID']['input'];
};


export type QueryTelecomSearchAccountsArgs = {
  Filters?: InputMaybe<TelecomSearchFilters>;
};


export type QueryTelecomSubAccountArgs = {
  accountId: Scalars['Int']['input'];
  telecomMasterId: Scalars['Int']['input'];
};


export type QueryTelecomSubAccountAssetsArgs = {
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
  telecomMasterId: Scalars['Int']['input'];
};


export type QueryTelecomSubAccountLessorsArgs = {
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
  telecomMasterId: Scalars['Int']['input'];
};


export type QueryTelecomSubAccountNameMismatchReportArgs = {
  taxYear: Scalars['Int']['input'];
};


export type QueryTelecomSubAccountsArgs = {
  taxYear: Scalars['Int']['input'];
  telecomMasterId: Scalars['Int']['input'];
};


export type QueryTelecomYearlyTaxableDifferenceReportArgs = {
  taxYear: Scalars['Int']['input'];
  telecomMasterId: Scalars['ID']['input'];
};

export type ReconcileContactInput = {
  contact?: InputMaybe<ContactInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReconcileLeaseMasterAssetInput = {
  accountId: Scalars['ID']['input'];
  blobName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  isReconciled: Scalars['Boolean']['input'];
  leaseEndDate?: InputMaybe<Scalars['String']['input']>;
  leaseId?: InputMaybe<Scalars['ID']['input']>;
  leaseMasterAccountNumber?: InputMaybe<Scalars['String']['input']>;
  leaseNumber?: InputMaybe<Scalars['String']['input']>;
  leaseStartDate?: InputMaybe<Scalars['String']['input']>;
  prevBlobName?: InputMaybe<Scalars['String']['input']>;
  subAccountNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Reconciliation = {
  reconciledBy?: Maybe<User>;
  reconciledDate?: Maybe<Scalars['String']['output']>;
};

export type ReconciliationAccountInformation = {
  accountId: Scalars['Int']['output'];
  accountType?: Maybe<AccountType>;
  businessAppraiserRegion?: Maybe<BusinessAppraiserRegionRow>;
  currentYearPayments?: Maybe<Scalars['Float']['output']>;
  delinquentYearPayments?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<EntityType>;
  federalTaxId?: Maybe<Scalars['String']['output']>;
  howFiled?: Maybe<HowFiledEnum>;
  isAttached?: Maybe<Scalars['Boolean']['output']>;
  isHomeBusiness?: Maybe<Scalars['Boolean']['output']>;
  isReconciled?: Maybe<Scalars['Boolean']['output']>;
  jurisdiction: Scalars['Int']['output'];
  naicsCategory?: Maybe<NaicsCategory>;
  naicsCode?: Maybe<NaicsCode>;
  parcelNumber?: Maybe<Scalars['String']['output']>;
  recordType: Scalars['String']['output'];
  registeredEntityName?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<CodeRowMaster>;
  taxDistrict?: Maybe<Scalars['String']['output']>;
  taxYear: Scalars['Int']['output'];
  timeSpentFiling?: Maybe<TimeSpentFiling>;
  website?: Maybe<Scalars['String']['output']>;
  yearOpened?: Maybe<Scalars['Int']['output']>;
};

export type ReconciliationAccountInformationInput = {
  accountId: Scalars['Int']['input'];
  accountTypeId: Scalars['ID']['input'];
  appraiserRegionId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  entityTypeId: Scalars['ID']['input'];
  federalTaxId?: InputMaybe<Scalars['String']['input']>;
  howFiledId: Scalars['ID']['input'];
  isAttached: Scalars['Boolean']['input'];
  isHomeBusiness: Scalars['Boolean']['input'];
  naicsCode?: InputMaybe<Scalars['ID']['input']>;
  parcelNumber?: InputMaybe<Scalars['String']['input']>;
  registeredEntityName: Scalars['String']['input'];
  sicCode?: InputMaybe<Scalars['ID']['input']>;
  taxDistrict: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
  yearOpened: Scalars['Int']['input'];
};

export type ReconciliationAccountInformationSummary = {
  auditorVersion: ReconciliationAccountInformation;
  originalVersion?: Maybe<ReconciliationAccountInformation>;
  taxPayerVersion: ReconciliationAccountInformation;
};

export type ReconciliationAssetSummary = {
  auditorVersion?: Maybe<Asset>;
  id: Scalars['ID']['output'];
  originalVersion?: Maybe<Asset>;
  taxPayerVersion?: Maybe<Asset>;
};

export type ReconciliationContactSummary = {
  auditorVersion?: Maybe<Contact>;
  id: Scalars['ID']['output'];
  originalVersion?: Maybe<Contact>;
  taxPayerVersion?: Maybe<Contact>;
};

export type ReconciliationFilingSummary = {
  auditorVersion: FilingSummary;
  originalVersion?: Maybe<FilingSummary>;
  taxPayerVersion: FilingSummary;
};

export type ReconciliationInput = {
  reconciledBy?: InputMaybe<UserInput>;
  reconciledDate?: InputMaybe<Scalars['String']['input']>;
};

export type ReconciliationLeasedAssetSummary = {
  auditorVersion?: Maybe<LeasedAsset>;
  id: Scalars['ID']['output'];
  originalVersion?: Maybe<LeasedAsset>;
  taxPayerVersion?: Maybe<LeasedAsset>;
};

export type ReconciliationLessorSummary = {
  auditorVersion?: Maybe<Lessor>;
  id: Scalars['ID']['output'];
  leasedAssets: Array<ReconciliationLeasedAssetSummary>;
  originalVersion?: Maybe<Lessor>;
  taxPayerVersion?: Maybe<Lessor>;
};

export type Refund = {
  accountId?: Maybe<Scalars['Int']['output']>;
  accountNumber: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  balance: Scalars['Float']['output'];
  businessName: Scalars['String']['output'];
  careOf?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isExempt: Scalars['Boolean']['output'];
  isReconciled: Scalars['Boolean']['output'];
  isSpecial: Scalars['Boolean']['output'];
  leaseMasterId?: Maybe<Scalars['Int']['output']>;
  mailingName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  paymentsReceived: Scalars['Float']['output'];
  refundReason: Scalars['String']['output'];
  refundReasonId: Scalars['Int']['output'];
  state?: Maybe<Scalars['String']['output']>;
  taxArea: Scalars['String']['output'];
  year: Scalars['Int']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type RefundAddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  careOf?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  mailingName?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type RefundBatch = {
  batchStatus: Scalars['String']['output'];
  batchStatusId: Scalars['Int']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  canBeEdited: Scalars['Boolean']['output'];
  canBePaid: Scalars['Boolean']['output'];
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  processedDate?: Maybe<Scalars['String']['output']>;
  refunds: Array<Refund>;
  updatedDate: Scalars['String']['output'];
};

export type RefundReason = {
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type RemoveContactResponse = {
  isDeleted: Scalars['Boolean']['output'];
  primaryContact?: Maybe<Contact>;
};

export type RemoveTelecomStagingDataInput = {
  accountNumber: Scalars['ID']['input'];
  isLeased: Scalars['Boolean']['input'];
  jurisdiction?: InputMaybe<Scalars['Int']['input']>;
  taxYear: Scalars['Int']['input'];
};

export type RentalHomeOccOverExemptReportEntry = AccountReportEntry & {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  associatedAccounts: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isExempt: Scalars['Boolean']['output'];
  isReconciled: Scalars['Boolean']['output'];
  netAssmntChargeWithTotalDirect: Scalars['Float']['output'];
  payments: Scalars['Float']['output'];
  penalty: Scalars['Float']['output'];
  taxYear: Scalars['Int']['output'];
  totalTaxable: Scalars['Float']['output'];
  yearEndBalance: Scalars['Float']['output'];
};

export type RentalsTwentyOrLessUnitsReportEntry = AccountReportEntry & {
  accountNbr: Scalars['String']['output'];
  acctTypeDescr: Scalars['String']['output'];
  acctTypeId: Scalars['Int']['output'];
  associatedAccounts: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isExempt: Scalars['Boolean']['output'];
  isReconciled: Scalars['Boolean']['output'];
  netAssmntChargeWithTotalDirect: Scalars['Float']['output'];
  payments: Scalars['Float']['output'];
  penalty: Scalars['Float']['output'];
  taxYear: Scalars['Int']['output'];
  totalTaxable: Scalars['Float']['output'];
  yearEndBalance: Scalars['Float']['output'];
};

export type ReturnedPayment = {
  accountId: Scalars['Int']['output'];
  accountNumber: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  businessName?: Maybe<Scalars['String']['output']>;
  dateReceived: Scalars['String']['output'];
  dateReturned: Scalars['String']['output'];
  ein: Ein;
  paymentType?: Maybe<PaymentType>;
};

export type ReturnedPaymentInput = {
  accountId: Scalars['Int']['input'];
  accountNumber: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  businessName?: InputMaybe<Scalars['String']['input']>;
  dateReceived: Scalars['String']['input'];
  dateReturned: Scalars['String']['input'];
  ein: EinInput;
  paymentType: PaymentTypeInput;
};

export type Role = {
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Permission>;
};

export type RoleInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  permissionIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type RoleUser = {
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SasUploadFile = {
  blobName: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SasUploadFileInput = {
  accountId: Scalars['Int']['input'];
  fileName: Scalars['String']['input'];
  jurisdiction: Scalars['Int']['input'];
  pathType: StoragePathType;
};

export type SaveAppraiserRegionInput = {
  code: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  region: Scalars['String']['input'];
};

export type SaveBasicCostByClassInput = {
  basicCost: Array<BasicCostInput>;
  scheduleId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
};

export type SaveLeasedAssetForSubAccountLocationInput = {
  leaseMasterId: Scalars['ID']['input'];
  leasedAssets: Array<LeasedAssetForSubAccountLocationInput>;
  locationAccountId: Scalars['ID']['input'];
  subAccountId: Scalars['ID']['input'];
};

export type SavePaymentPlanInput = {
  accountId: Scalars['Int']['input'];
  accountNumber: Scalars['String']['input'];
  accountTypeId: Scalars['Int']['input'];
  paymentPlan: PaymentPlanInput;
  taxYear: Scalars['Int']['input'];
};

export type SaveTelecomMcatLessorInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  jurisdiction: Scalars['Int']['input'];
  lessor: LessorInput;
  taxDistrict: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
  telecomMasterAccountNumber: Scalars['String']['input'];
  telecomMasterId: Scalars['Int']['input'];
};

export type SaveTelecomSubAccountInput = {
  accountId: Scalars['Int']['input'];
  accountNumber: Scalars['String']['input'];
  taxDistrict: Scalars['String']['input'];
  telecomMasterId: Scalars['Int']['input'];
};

export type SavedAzureFunction = {
  accountNbr: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  isLeased: Scalars['Int']['output'];
  taxYear: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
};

export type SearchBatchInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  batchId?: InputMaybe<Scalars['Int']['input']>;
  batchStatusIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SearchBusinessAccount = {
  accountId: Scalars['Int']['output'];
  accountNbr: Scalars['String']['output'];
  address?: Maybe<SitusAddressForSearchAccount>;
  appraisalRegion?: Maybe<AppraiserRegionSearchResult>;
  balance?: Maybe<Scalars['Float']['output']>;
  businessName: Scalars['String']['output'];
  contactId?: Maybe<Scalars['Int']['output']>;
  howFiled?: Maybe<HowFiledEnumNulleable>;
  howReceived?: Maybe<HowReceivedSearchResult>;
  isActive: Scalars['Boolean']['output'];
  isReconciled?: Maybe<Scalars['Boolean']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taxDistrict?: Maybe<Scalars['String']['output']>;
  taxYear: Scalars['Float']['output'];
};

export type SearchBusinessAccountInfoByNumberResponse = {
  businessName?: Maybe<Scalars['String']['output']>;
  delinquentBalance?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  status: AccountSearchStatus;
};

export type SearchBusinessAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  businessAppraiserRegion?: InputMaybe<Scalars['Int']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  displayCount?: InputMaybe<Scalars['Int']['input']>;
  filingStatus?: InputMaybe<Scalars['String']['input']>;
  howFiled?: InputMaybe<Scalars['Int']['input']>;
  howReceived?: InputMaybe<Scalars['Int']['input']>;
  industrialPark?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isReconciled?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdiction?: InputMaybe<Scalars['Int']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchBusinessAccountResponse = {
  searchBusinessAccount: Array<Maybe<SearchBusinessAccount>>;
  totalRecordCount: Scalars['Int']['output'];
};

export type SearchFilters = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type SearchLeaseMasterBusinessAccount = {
  accountId: Scalars['ID']['output'];
  accountNumber: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  countyName?: Maybe<Scalars['String']['output']>;
  filingStatus?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isReconciled: Scalars['Boolean']['output'];
  taxYear?: Maybe<Scalars['Int']['output']>;
};

export type SearchLeaseMasterBusinessAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  displaySize?: InputMaybe<Scalars['Int']['input']>;
  filingStatus?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isReconciled?: InputMaybe<Scalars['Boolean']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchLeaseMasterBusinessAccountResponse = {
  leaseAccounts?: Maybe<Array<SearchLeaseMasterBusinessAccount>>;
  totalAccounts: Scalars['Int']['output'];
};

export type SearchLeasedAssetsForReconciliationInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  leaseMasterAccountNumber?: InputMaybe<Scalars['String']['input']>;
  lessorName?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
};

export type SearchPaymentInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkNumber?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['Int']['input']>;
  paymentType?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};

export type SessionContext = {
  accountId: Scalars['Int']['output'];
  accountNumber: Scalars['String']['output'];
  buildingPermitExists?: Maybe<Scalars['Boolean']['output']>;
  businessName: Scalars['String']['output'];
  completedSteps: Array<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  taxYear: Scalars['Int']['output'];
};

export type SimilarBusinessRow = {
  accountNumber: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  similarAddress: Scalars['String']['output'];
};

export type SimilarBusinessSearchInput = {
  businessName: Scalars['String']['input'];
  similarAddress: Scalars['String']['input'];
};

export type SimilarBusinessSearchLeaseMasterInput = {
  businessName: Scalars['String']['input'];
};

export type SimilarTelecomBusinessInput = {
  businessName: Scalars['String']['input'];
};

/** Situs Address: physical business address. */
export type SitusAddress = {
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type SitusAddressForSearchAccount = {
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type SitusAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

/**
 * According to Postal Addressing Standards - Appendix B
 * https://pe.usps.com/text/pub28/28apb.htm
 */
export enum State {
  /** Armed Forces Americas (except Canada) */
  Aa = 'AA',
  /** Armed Forces Europe, the Middle East, and Canada */
  Ae = 'AE',
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** Armed Forces Pacific */
  Ap = 'AP',
  /** Arkansas */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** District of Columbia */
  Dc = 'DC',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Federated Stated of Micronesia */
  Fm = 'FM',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Marshall Islands */
  Mh = 'MH',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palau */
  Pw = 'PW',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** Virgin Islands */
  Vi = 'VI',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY'
}

export enum StoragePathType {
  LeaseAgreement = 'LEASE_AGREEMENT',
  MassAccount = 'MASS_ACCOUNT',
  McatPropertyAssetListFileUpload = 'MCAT_PROPERTY_ASSET_LIST_FILE_UPLOAD',
  PropertyAssetListFileUpload = 'PROPERTY_ASSET_LIST_FILE_UPLOAD',
  TableMaintenance = 'TABLE_MAINTENANCE'
}

export type SubAccount = {
  accountNumber: Scalars['String']['output'];
  hasDelinquentBalance: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  taxDistrict: Scalars['String']['output'];
};

export type SubAccountAllocationInput = {
  amount: Scalars['Float']['input'];
  id: Scalars['Int']['input'];
  interest: Scalars['Float']['input'];
};

export type SubAccountAllocations = {
  amount: Scalars['Float']['output'];
  paymentId: Scalars['Int']['output'];
  receiptNumber: Scalars['Int']['output'];
  subAccountId: Scalars['Int']['output'];
};

export type SubAccountDelinquentSummary = {
  directCharges: Scalars['Float']['output'];
  interest: Scalars['Float']['output'];
  netAssessmentCharge: Scalars['Float']['output'];
  payments: Scalars['Float']['output'];
  penalties: Scalars['Float']['output'];
  subAccountId: Scalars['Int']['output'];
  subAccountNumber: Scalars['String']['output'];
  taxDistrict: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type SubAccountHolding = {
  accountNumber: Scalars['String']['output'];
  balanceDue: Scalars['Float']['output'];
  balanceDueWithInterest: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  interest: Scalars['Float']['output'];
  taxDistrict: Scalars['String']['output'];
};

export enum SubAccountKind {
  BusinessMaster = 'BUSINESS_MASTER',
  LeaseMaster = 'LEASE_MASTER',
  TelecomMaster = 'TELECOM_MASTER'
}

export type SubAccountLookup = {
  result?: Maybe<SubAccountSearchResult>;
  totalCount: Scalars['Int']['output'];
};

export type SubAccountSearchResult = {
  accountNumber: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  kind: SubAccountKind;
  leaseMasterAccountNumber?: Maybe<Scalars['String']['output']>;
  taxArea?: Maybe<Scalars['String']['output']>;
  telecomAccountNumber?: Maybe<Scalars['String']['output']>;
};

export type SubAccountStatusInput = {
  active: Scalars['Boolean']['input'];
  leaseMasterId: Scalars['ID']['input'];
  subAccountId: Scalars['ID']['input'];
};

export type SubAccountTaxDistrict = {
  accountId: Scalars['ID']['output'];
  accountNumber: Scalars['String']['output'];
  accountSummary: AccountSummary;
  bafInActiveAccountsCount: Scalars['Int']['output'];
  invalidTaxDistrictCount: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isExempt: Scalars['Boolean']['output'];
  jurisdictionId: Scalars['Int']['output'];
  leaseMasterId: Scalars['Int']['output'];
  locationCount: Scalars['Int']['output'];
  recordType: Scalars['String']['output'];
  taxDistrict: Scalars['String']['output'];
  taxYear: Scalars['Int']['output'];
  totalAssetCount: Scalars['Int']['output'];
};

export type SubAccountTaxDistrictInput = {
  accountId: Scalars['ID']['input'];
  accountNumber: Scalars['String']['input'];
  isUpdated: Scalars['Boolean']['input'];
  jurisdictionId: Scalars['Int']['input'];
  leaseMasterId: Scalars['Int']['input'];
  recordType: Scalars['String']['input'];
  taxDistrict: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
};

/** Identifies the user authentication */
export type SuccessfulAuthType = {
  token?: Maybe<Scalars['String']['output']>;
};

export type TaxArea = {
  taxArea: Scalars['String']['output'];
  taxSubArea: Array<Scalars['String']['output']>;
};

export type TaxDistrictBusinessAccountRow = {
  accountNumber?: Maybe<Scalars['String']['output']>;
  address?: Maybe<PrimaryContactAddress>;
  bafIsActive: Scalars['Boolean']['output'];
  businessAccountId: Scalars['ID']['output'];
  businessName: Scalars['String']['output'];
  invalidTaxDistrict: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isHoldingAccount: Scalars['Boolean']['output'];
  jurisdictionId: Scalars['Int']['output'];
  leaseMasterId: Scalars['ID']['output'];
  subAccountId: Scalars['ID']['output'];
};

export type TaxDistrictBusinessAccountRowInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<PrimaryContactAddressInput>;
  businessAccountId: Scalars['ID']['input'];
  businessName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isDeleted: Scalars['Boolean']['input'];
  isHoldingAccount: Scalars['Boolean']['input'];
  /** When isNewRow is true this business will be saved */
  isNewRow: Scalars['Boolean']['input'];
  isUpdated: Scalars['Boolean']['input'];
  jurisdictionId?: InputMaybe<Scalars['Int']['input']>;
  leaseMasterId: Scalars['ID']['input'];
  newAccountNumber?: InputMaybe<Scalars['String']['input']>;
  subAccountId: Scalars['ID']['input'];
};

export type TaxRate = {
  id: Scalars['ID']['output'];
  taxDistrict?: Maybe<Scalars['String']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
};

export type TelecomAccount = {
  accountNumber: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isReconciled: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
};

export type TelecomAssetStagingReportEntry = {
  accountId?: Maybe<Scalars['Int']['output']>;
  accountNbr?: Maybe<Scalars['String']['output']>;
  annuaLeaseAmt?: Maybe<Scalars['Float']['output']>;
  clsf?: Maybe<Scalars['String']['output']>;
  costPer?: Maybe<Scalars['Float']['output']>;
  countyName?: Maybe<Scalars['String']['output']>;
  customerDesc?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  initialValue?: Maybe<Scalars['Float']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isLeased?: Maybe<Scalars['Boolean']['output']>;
  isReconciled?: Maybe<Scalars['Boolean']['output']>;
  jurisdiction?: Maybe<Scalars['Int']['output']>;
  leaseEndDate?: Maybe<Scalars['String']['output']>;
  leaseStartDate?: Maybe<Scalars['String']['output']>;
  lessorAddress1?: Maybe<Scalars['String']['output']>;
  lessorAddress2?: Maybe<Scalars['String']['output']>;
  lessorCity?: Maybe<Scalars['String']['output']>;
  lessorName?: Maybe<Scalars['String']['output']>;
  lessorPhone?: Maybe<Scalars['String']['output']>;
  lessorPhoneExt?: Maybe<Scalars['String']['output']>;
  lessorState?: Maybe<Scalars['String']['output']>;
  lessorZip?: Maybe<Scalars['String']['output']>;
  netAsmntCharge?: Maybe<Scalars['Float']['output']>;
  percentGood?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  reconcileDate?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  taxDistrict?: Maybe<Scalars['String']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  taxYear: Scalars['Int']['output'];
  taxableValue?: Maybe<Scalars['Float']['output']>;
  telecomAccountNbr?: Maybe<Scalars['String']['output']>;
  telecomMasterId?: Maybe<Scalars['Int']['output']>;
  transferDate?: Maybe<Scalars['String']['output']>;
  updateDate?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  uploadDate?: Maybe<Scalars['String']['output']>;
  yearAcquired?: Maybe<Scalars['Int']['output']>;
};

export type TelecomAudit = {
  auditReconcileDate?: Maybe<Scalars['String']['output']>;
  auditYear?: Maybe<Scalars['Int']['output']>;
  auditedBy?: Maybe<User>;
};

export type TelecomAuditInput = {
  auditReconcileDate?: InputMaybe<Scalars['String']['input']>;
  auditYear?: InputMaybe<Scalars['Int']['input']>;
  auditedBy?: InputMaybe<UserInput>;
};

export type TelecomBusinessAccount = {
  accountNumber: Scalars['String']['output'];
  accountSummary?: Maybe<AccountSummary>;
  applyPenalty: Scalars['Boolean']['output'];
  audit: TelecomAudit;
  bankruptcy: Bankruptcy;
  businessAccountType?: Maybe<AccountType>;
  businessName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  ein?: Maybe<Scalars['String']['output']>;
  filingStatus: TelecomFilingStatus;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDisabled: Scalars['Boolean']['output'];
  lastModified: LastModified;
  pin?: Maybe<Scalars['String']['output']>;
  reconciliation: Reconciliation;
  registeredEntityName?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<CodeRowMaster>;
};

export type TelecomBusinessAccountInput = {
  accountNumber: Scalars['String']['input'];
  applyPenalty: Scalars['Boolean']['input'];
  audit: TelecomAuditInput;
  bankruptcy: BankruptcyInput;
  businessAccountType?: InputMaybe<AccountTypeInput>;
  businessName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  filingStatus: TelecomFilingStatusInput;
  id: Scalars['ID']['input'];
  reconciliation: ReconciliationInput;
  registeredEntityName?: InputMaybe<Scalars['String']['input']>;
  sicCode?: InputMaybe<CodeRowMasterInput>;
};

export type TelecomContactInfoReportEntry = {
  accountNbr: Scalars['String']['output'];
  address?: Maybe<Scalars['String']['output']>;
  businessName: Scalars['String']['output'];
  careOf?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactType?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  phoneExten?: Maybe<Scalars['String']['output']>;
  phoneMobile?: Maybe<Scalars['String']['output']>;
  phoneOffice?: Maybe<Scalars['String']['output']>;
  pinCode: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type TelecomFilingDifferenceReportEntry = {
  beforeValue?: Maybe<Scalars['String']['output']>;
  changeCode?: Maybe<Scalars['String']['output']>;
  clsf?: Maybe<Scalars['String']['output']>;
  columnChanged?: Maybe<Scalars['String']['output']>;
  costPer?: Maybe<Scalars['Float']['output']>;
  countyName?: Maybe<Scalars['String']['output']>;
  customerDesc?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  taxDistrict?: Maybe<Scalars['String']['output']>;
  telecomMasterId: Scalars['Int']['output'];
  yearAcquired?: Maybe<Scalars['Int']['output']>;
};

export type TelecomFilingStatus = {
  dateReceived?: Maybe<Scalars['String']['output']>;
  filingYear?: Maybe<Scalars['Int']['output']>;
  hasExemption?: Maybe<Scalars['Boolean']['output']>;
  howFiled?: Maybe<HowFiledEnum>;
  howReceived?: Maybe<HowReceived>;
};

export type TelecomFilingStatusInput = {
  dateReceived?: InputMaybe<Scalars['String']['input']>;
  filingYear?: InputMaybe<Scalars['Int']['input']>;
  hasExemption: Scalars['Boolean']['input'];
  howFiled?: InputMaybe<HowFiledEnumInput>;
  howReceived?: InputMaybe<HowReceivedInput>;
};

export type TelecomMcatAreaParams = {
  interestToDate: Scalars['String']['input'];
  jurisdiction: Scalars['Int']['input'];
  taxDistrict?: InputMaybe<Scalars['String']['input']>;
  taxYear: Scalars['Int']['input'];
  telecomMasterId: Scalars['Int']['input'];
};

export type TelecomMcatAreas = {
  accountSummary: AccountSummary;
  applyPenalty: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isExempt: Scalars['Boolean']['output'];
  jurisdiction: Jurisdiction;
  subAccounts: Array<TelecomSubAccount>;
  taxYear: Scalars['Int']['output'];
  telecomMasterId: Scalars['Int']['output'];
};

export type TelecomMcatAssetsInput = {
  jurisdiction: Scalars['Int']['input'];
  taxDistrict: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
  telecomMasterId: Scalars['Int']['input'];
};

export type TelecomMcatSearchFilters = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  displayCount?: InputMaybe<Scalars['Int']['input']>;
  filingStatus?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isReconciled?: InputMaybe<Scalars['Boolean']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  taxYear: Scalars['Int']['input'];
};

export type TelecomMcatStagedAsset = {
  accountNumber: Scalars['String']['output'];
  classification: PropertyClassification;
  costPer: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  jurisdiction: Jurisdiction;
  netAsmtCharge?: Maybe<Scalars['Float']['output']>;
  percentGood: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  taxDistrict: Scalars['String']['output'];
  taxableValue: Scalars['Float']['output'];
  telecomMasterId: Scalars['Int']['output'];
  yearAcquired: Scalars['Int']['output'];
};

export type TelecomMcatSubAccountParams = {
  interestToDate: Scalars['String']['input'];
  jurisdiction: Scalars['Int']['input'];
  taxDistrict: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
  telecomMasterId: Scalars['Int']['input'];
};

export type TelecomSearchFilters = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  displayCount?: InputMaybe<Scalars['Int']['input']>;
  filingStatus?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isReconciled?: InputMaybe<Scalars['Boolean']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  taxYear: Scalars['Int']['input'];
};

export type TelecomSearchResponse = {
  results?: Maybe<Array<TelecomAccount>>;
  totalRecordCount: Scalars['Int']['output'];
};

export type TelecomSubAccount = {
  accountId?: Maybe<Scalars['Int']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  accountSummary: AccountSummary;
  applyPenalty: Scalars['Boolean']['output'];
  hasDelinquentBalance?: Maybe<Scalars['Boolean']['output']>;
  invalidTaxDistrictCount?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  isExempt: Scalars['Boolean']['output'];
  jurisdictionId: Scalars['Int']['output'];
  taxDistrict: Scalars['String']['output'];
  totalAssetCount?: Maybe<Scalars['Int']['output']>;
};

export type TelecomSubAccountNameMismatchReportEntry = {
  id: Scalars['Int']['output'];
  isReconciled?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  subAccountBusinessName?: Maybe<Scalars['String']['output']>;
  subAccountNbr?: Maybe<Scalars['String']['output']>;
  taxDistrict?: Maybe<Scalars['String']['output']>;
  telecomAccountNbr?: Maybe<Scalars['String']['output']>;
  telecomBusinessName?: Maybe<Scalars['String']['output']>;
};

export type TelecomYearlyTaxableDifferenceReportEntry = {
  countyName?: Maybe<Scalars['String']['output']>;
  currentTaxYear?: Maybe<Scalars['Int']['output']>;
  currentYearTaxable?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  jurisdiction?: Maybe<Scalars['Int']['output']>;
  priorTaxYear?: Maybe<Scalars['Int']['output']>;
  priorYearTaxable?: Maybe<Scalars['Float']['output']>;
  telecomAccountNbr?: Maybe<Scalars['String']['output']>;
  telecomMasterId: Scalars['Int']['output'];
  yearlyDifference?: Maybe<Scalars['Float']['output']>;
};

export type TimeSpentFiling = {
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type TransferTelecomAssetsToProductionInput = {
  accountNumber: Scalars['String']['input'];
  isExempt?: InputMaybe<Scalars['Boolean']['input']>;
  reconciledDate: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
};

export type UpdateBatchInput = {
  deletedRefundsIds: Array<Scalars['Int']['input']>;
  newRefunds: Array<CreateRefundInput>;
  updatedRefunds: Array<UpdateRefundInput>;
};

export type UpdateRefundAddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  careOf?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  mailingName?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type UpdateRefundInput = {
  address: UpdateRefundAddressInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  refundId: Scalars['Int']['input'];
  refundReasonId: Scalars['Int']['input'];
};

export type UpdatedUser = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UploadAssetInput = {
  accountId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type UploadAssetResponse = {
  assets: Array<Asset>;
  errorFileName?: Maybe<Scalars['String']['output']>;
  errorFileUrl?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type UploadLeaseAssetInput = {
  accountId: Scalars['Int']['input'];
  filename: Scalars['String']['input'];
  leaseMasterId: Scalars['Int']['input'];
  subAccountId: Scalars['Int']['input'];
};

export type User = {
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<RoleUser>>;
  title?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type UserInput = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  isVerified: Scalars['Boolean']['input'];
  username: Scalars['String']['input'];
};

export type VoidDelinquentPaymentInput = {
  note: Scalars['String']['input'];
  receiptNumber: Scalars['String']['input'];
};

export type GetAccountTypesQueryVariables = Exact<{
  filterBy?: InputMaybe<FilterAccountTypeBy>;
}>;


export type GetAccountTypesQuery = { accountTypes: Array<{ id: string, label: string }> };

export type SaveAccountTypeMutationVariables = Exact<{
  accountType: Array<AccountTypeInput> | AccountTypeInput;
}>;


export type SaveAccountTypeMutation = { saveAccountType: Array<{ id: string, label: string }> };

export type GetClassificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClassificationsQuery = { getClassifications: Array<{ id: string, clsf?: string | null, scheduleId?: number | null, description?: string | null }> };

export type GetBasicCostByClassificationQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetBasicCostByClassificationQuery = { getClassifications: Array<{ id: string, clsf?: string | null, scheduleId?: number | null, description?: string | null, basicCost?: Array<{ id: string, scheduleId: number, baseYear: number, propertyYear: number, percentGood: number }> | null }> };

export type SaveClassificationsMutationVariables = Exact<{
  classifications: Array<ClassificationInput> | ClassificationInput;
}>;


export type SaveClassificationsMutation = { saveClassifications?: Array<{ id: string, clsf?: string | null, scheduleId?: number | null, description?: string | null } | null> | null };

export type SaveBasicCostMutationVariables = Exact<{
  basicCost: SaveBasicCostByClassInput;
}>;


export type SaveBasicCostMutation = { saveBasicCost?: Array<{ id: string, scheduleId: number, baseYear: number, propertyYear: number, percentGood: number } | null> | null };

export type GetAssetsQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetAssetsQuery = { uploadAssetsTemplate: string, currentTaxYear: number, getAssets: { accountNumber?: string | null, isActive: boolean, isExempt: boolean, assets: Array<{ id: string, classification?: string | null, classificationDescription?: string | null, description?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, percentGood?: number | null, taxableValue?: number | null, ein?: number | null, updateDate?: string | null, isActive?: boolean | null }> }, getClassifications: Array<{ id: string, clsf?: string | null, scheduleId?: number | null, description?: string | null }>, getTaxRate: { id: string, taxRate?: number | null } };

export type SaveAssetsMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  assets: Array<AssetInput> | AssetInput;
}>;


export type SaveAssetsMutation = { saveAssets: Array<{ id: string, classification?: string | null, classificationDescription?: string | null, description?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, percentGood?: number | null, taxableValue?: number | null, ein?: number | null, updateDate?: string | null, isActive?: boolean | null }> };

export type CalculateTaxableValueMutationVariables = Exact<{
  input: CalculateTaxableValueInput;
}>;


export type CalculateTaxableValueMutation = { calculateTaxableValue: { percentGood: number, taxableValue: number } };

export type UploadAssetsMutationVariables = Exact<{
  uploadedAssetInput: UploadAssetInput;
}>;


export type UploadAssetsMutation = { uploadAssets: { fileName: string, message: string, errorFileName?: string | null, errorFileUrl?: string | null, assets: Array<{ id: string, classification?: string | null, classificationDescription?: string | null, description?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, percentGood?: number | null, taxableValue?: number | null, ein?: number | null, updateDate?: string | null, isActive?: boolean | null }> } };

export type UploadLeaseAssetsMutationVariables = Exact<{
  uploadLeaseAssetsInput: UploadLeaseAssetInput;
}>;


export type UploadLeaseAssetsMutation = { uploadLeaseAssets: { fileName: string, message: string, errorFileName?: string | null, errorFileUrl?: string | null, assets: Array<{ id: string, classification?: string | null, classificationDescription?: string | null, description?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, percentGood?: number | null, taxableValue?: number | null, ein?: number | null, updateDate?: string | null, isActive?: boolean | null }> } };

export type GetAssociatedAccountsQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
  accountIdString: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetAssociatedAccountsQuery = { currentTaxYear: number, associatedAccounts: { id: number, totalTaxableValue: number, accounts: Array<{ id: number, accountId?: number | null, accountNumber: string, businessName?: string | null, accountType?: string | null, address?: string | null, isExempt: boolean, isReconciled: boolean, isVerified: boolean, isActive?: boolean | null, taxableValue?: number | null }> }, getBusinessAccount?: { id: string, accountNumber: string, pin: string, businessName: string, description?: string | null, parcelNumber?: string | null, areaNumber: string, accountStatus?: string | null, yearOpened?: number | null, ein?: string | null, website?: string | null, isHomeOccupational?: boolean | null, registeredEntityName?: string | null, hasAssociatedAccounts: boolean, isActive: boolean, isAccountReadOnly: boolean, sicCode?: { id: string, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string, isActive: boolean } | null, lastModified: { username?: string | null, lastChangedDate?: string | null }, reconciliation: { reconciledDate?: string | null, reconciledBy?: { id: number, fullName: string, username: string, email: string, isActive: boolean, isVerified: boolean } | null }, filingStatus: { hasBuildingPermit: boolean, hasAttachment: boolean, hasExemption: boolean, filingYear?: number | null, dateReceived?: string | null, howFiled?: { id: string, label: string } | null, howReceived?: { id: string, label: string } | null }, audit: { auditYear?: number | null }, primaryContact: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, contactType?: { id: string, label: string } | null, mailingAddress?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null }, parcelUseType?: { id: string, label: string } | null, entityType?: { id: string, label: string } | null, industrialPark?: { id: number, code: string, label: string } | null, accountType: { id: string, label: string }, businessAppraiserRegion?: { id: string, groupingValue1: string, groupingValue2: string, regionName: string } | null, situsAddress: { addressLine1: string, addressLine2?: string | null, city: string, state: string, zipCode: string }, accountSummary?: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, penaltyCharge?: number | null, interest?: number | null, payments?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null } | null } | null };

export type SaveAssociatedAccountsMutationVariables = Exact<{
  group: AssociatedAccountGroupInput;
}>;


export type SaveAssociatedAccountsMutation = { saveAssociatedAccounts: { id: number, totalTaxableValue: number, accounts: Array<{ id: number, accountId?: number | null, accountNumber: string, businessName?: string | null, accountType?: string | null, address?: string | null, isExempt: boolean, isReconciled: boolean, isVerified: boolean, isActive?: boolean | null, taxableValue?: number | null }> } };

export type SearchAccountAddressMutationVariables = Exact<{
  accountNumber: Scalars['String']['input'];
}>;


export type SearchAccountAddressMutation = { searchAssociatedAccountAddress: { id: number, accountId?: number | null, accountNumber: string, businessName?: string | null, accountType?: string | null, address?: string | null, isExempt: boolean, isReconciled: boolean, isVerified: boolean, taxableValue?: number | null } };

export type LoginMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
  jurisdictionId: Scalars['Int']['input'];
}>;


export type LoginMutation = { login?: { title?: string | null, status?: number | null } | { token?: string | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { changePassword?: { title?: string | null, status?: number | null } | { token?: string | null } | null };

export type PaperFilingTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type PaperFilingTokenMutation = { paperFilingToken?: { token?: string | null } | null };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { forgotPassword: boolean };

export type ResetPasswordMutationVariables = Exact<{
  encryptedValue: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { resetPassword: { token?: string | null } };

export type MasterLoginMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type MasterLoginMutation = { masterLogin?: { token: string } | null };

export type McatLoginMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type McatLoginMutation = { mcatLogin?: { token: string } | null };

export type GeneratePresignedUploadFileMutationVariables = Exact<{
  input: SasUploadFileInput;
}>;


export type GeneratePresignedUploadFileMutation = { generatePresignedUploadFile: { blobName: string, fileName: string, url: string } };

export type GenerateSasReadFileQueryVariables = Exact<{
  fileName: Scalars['String']['input'];
}>;


export type GenerateSasReadFileQuery = { generateSASReadFile: string };

export type ExecuteBafBatchPenaltyMutationVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type ExecuteBafBatchPenaltyMutation = { executeBafBatchPenalty: boolean };

export type ExecuteLeaseBatchPenaltyMutationVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type ExecuteLeaseBatchPenaltyMutation = { executeLeaseBatchPenalty: boolean };

export type ExecuteTelecomBatchPenaltyMutationVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type ExecuteTelecomBatchPenaltyMutation = { executeTelecomBatchPenalty: boolean };

export type SearchBusinessAccountQueryVariables = Exact<{
  searchFilters: SearchBusinessAccountInput;
}>;


export type SearchBusinessAccountQuery = { searchBusinessAccount: { totalRecordCount: number, searchBusinessAccount: Array<{ taxYear: number, accountNbr: string, accountId: number, isActive: boolean, businessName: string, contactId?: number | null, taxDistrict?: string | null, isReconciled?: boolean | null, balance?: number | null, recordType?: string | null, status?: string | null, address?: { addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null } | null, appraisalRegion?: { id?: string | null, label?: string | null } | null, howReceived?: { id?: string | null, label?: string | null } | null, howFiled?: { id?: string | null, label?: string | null } | null } | null> } };

export type GetCreateAccountInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreateAccountInfoQuery = { getBusinessAppraiserRegionList?: Array<{ regionName: string, columnsNames: { groupingLabel1: string, groupingLabel2: string }, rows: Array<{ id: string, groupingValue1: string, groupingValue2: string, regionName: string }> }> | null, countries: Array<{ code: string, name: string }>, accountTypes: Array<{ id: string, label: string }>, taxAreaList: Array<{ taxArea: string, taxSubArea: Array<string> }>, sicCodeMasters: Array<{ id: string, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string, isActive: boolean }> };

export type CreateBusinessAccountMutationVariables = Exact<{
  account: CreateBusinessAccountInput;
}>;


export type CreateBusinessAccountMutation = { createBusinessAccount?: { id: string, accountNumber: string, pin: string, businessName: string, description?: string | null, parcelNumber?: string | null, areaNumber: string, yearOpened?: number | null, ein?: string | null, website?: string | null, isHomeOccupational?: boolean | null, registeredEntityName?: string | null, hasAssociatedAccounts: boolean, applyPenalty: boolean, isActive: boolean, isAccountReadOnly: boolean, sicCode?: { id: string, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string, isActive: boolean } | null, naicsCategory?: { id: string, category: string } | null, naicsCode?: { id: string, category: string, subCategory: string } | null, lastModified: { username?: string | null, lastChangedDate?: string | null }, reconciliation: { reconciledBy?: { id: number, fullName: string, username: string, email: string, isActive: boolean, isVerified: boolean } | null }, filingStatus: { hasBuildingPermit: boolean, hasAttachment: boolean, hasExemption: boolean, filingYear?: number | null, dateReceived?: string | null, howFiled?: { id: string, label: string } | null, howReceived?: { id: string, label: string } | null }, audit: { auditYear?: number | null }, primaryContact: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, contactType?: { id: string, label: string } | null, mailingAddress?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null }, parcelUseType?: { id: string, label: string } | null, entityType?: { id: string, label: string } | null, industrialPark?: { id: number, code: string, label: string } | null, accountType: { id: string, label: string }, businessAppraiserRegion?: { id: string, groupingValue1: string, groupingValue2: string, regionName: string } | null, situsAddress: { addressLine1: string, addressLine2?: string | null, city: string, state: string, zipCode: string }, accountSummary?: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, penaltyCharge?: number | null, interest?: number | null, payments?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null, totalBalanceWithDelinquent?: number | null } | null } | null };

export type GetBusinessAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetBusinessAccountQuery = { currentTaxYear: number, getBusinessAccount?: { id: string, accountNumber: string, adminLink?: string | null, pin: string, businessName: string, description?: string | null, parcelNumber?: string | null, areaNumber: string, accountStatus?: string | null, yearOpened?: number | null, ein?: string | null, website?: string | null, isHomeOccupational?: boolean | null, registeredEntityName?: string | null, hasAssociatedAccounts: boolean, isActive: boolean, isAccountReadOnly: boolean, applyPenalty: boolean, leaseMasterNumberAssociation?: string | null, hasCurrentPaymentPlan?: boolean | null, hasDelinquentPaymentPlan?: boolean | null, sicCode?: { id: string, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string, isActive: boolean } | null, naicsCategory?: { id: string, category: string } | null, naicsCode?: { id: string, category: string, subCategory: string } | null, lastModified: { username?: string | null, lastChangedDate?: string | null }, reconciliation: { reconciledDate?: string | null, reconciledBy?: { id: number, fullName: string, username: string, email: string, isActive: boolean, isVerified: boolean } | null }, filingStatus: { hasBuildingPermit: boolean, hasAttachment: boolean, hasExemption: boolean, filingYear?: number | null, dateReceived?: string | null, howFiled?: { id: string, label: string } | null, howReceived?: { id: string, label: string } | null }, audit: { auditYear?: number | null }, primaryContact: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, contactType?: { id: string, label: string } | null, mailingAddress?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null }, parcelUseType?: { id: string, label: string } | null, entityType?: { id: string, label: string } | null, industrialPark?: { id: number, code: string, label: string } | null, accountType: { id: string, label: string }, businessAppraiserRegion?: { id: string, groupingValue1: string, groupingValue2: string, regionName: string } | null, situsAddress: { addressLine1: string, addressLine2?: string | null, city: string, state: string, zipCode: string }, accountSummary?: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, penaltyCharge?: number | null, interest?: number | null, payments?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null, totalBalanceWithDelinquent?: number | null } | null } | null, industrialParkOptions: Array<{ id: number, code: string, label: string }>, parcelUseTypeList: Array<{ id: string, label: string }>, howFiledList: Array<{ id: string, label: string }>, howReceivedList: Array<{ id: string, label: string }>, accountTypes: Array<{ id: string, label: string }>, taxAreaList: Array<{ taxArea: string, taxSubArea: Array<string> }>, countries: Array<{ code: string, name: string }>, contactTypes: Array<{ id: string, label: string }>, entityTypes: Array<{ id: string, label: string }>, getBusinessAppraiserRegionList?: Array<{ regionName: string, columnsNames: { groupingLabel1: string, groupingLabel2: string }, rows: Array<{ id: string, groupingValue1: string, groupingValue2: string, regionName: string }> }> | null, sicCodeMasters: Array<{ id: string, isActive: boolean, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string }>, naicsCategories: Array<{ id: string, category: string }>, naicsCodes: Array<{ id: string, category: string, subCategory: string }> };

export type SaveBusinessAccountMutationVariables = Exact<{
  businessAccount: BusinessAccountInput;
}>;


export type SaveBusinessAccountMutation = { saveBusinessAccount?: { id: string, accountNumber: string, businessName: string, description?: string | null, parcelNumber?: string | null, areaNumber: string, yearOpened?: number | null, ein?: string | null, website?: string | null, isHomeOccupational?: boolean | null, registeredEntityName?: string | null, hasAssociatedAccounts: boolean, isActive: boolean, isAccountReadOnly: boolean, applyPenalty: boolean, sicCode?: { id: string, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string, isActive: boolean } | null, naicsCategory?: { id: string, category: string } | null, naicsCode?: { id: string, category: string, subCategory: string } | null, lastModified: { username?: string | null, lastChangedDate?: string | null }, reconciliation: { reconciledDate?: string | null, reconciledBy?: { id: number, fullName: string, username: string, email: string, isActive: boolean, isVerified: boolean } | null }, filingStatus: { hasBuildingPermit: boolean, hasAttachment: boolean, hasExemption: boolean, filingYear?: number | null, dateReceived?: string | null, howFiled?: { id: string, label: string } | null, howReceived?: { id: string, label: string } | null }, audit: { auditYear?: number | null }, parcelUseType?: { id: string, label: string } | null, entityType?: { id: string, label: string } | null, industrialPark?: { id: number, code: string, label: string } | null, accountType: { id: string, label: string }, businessAppraiserRegion?: { id: string, groupingValue1: string, groupingValue2: string, regionName: string } | null, situsAddress: { addressLine1: string, addressLine2?: string | null, city: string, state: string, zipCode: string }, accountSummary?: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, penaltyCharge?: number | null, interest?: number | null, payments?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null, totalBalanceWithDelinquent?: number | null } | null } | null };

export type RegeneratePinMutationVariables = Exact<{
  pinInput: PinInput;
}>;


export type RegeneratePinMutation = { regeneratePin: string };

export type ChangeBusinessAccountStatusMutationVariables = Exact<{
  accountStatus: AccountStatusInput;
}>;


export type ChangeBusinessAccountStatusMutation = { changeBusinessAccountStatus: boolean };

export type GetPinAndLinkedAccountsQueryVariables = Exact<{
  pinInput: PinInput;
}>;


export type GetPinAndLinkedAccountsQuery = { getPinAndLinkedAccounts: { pin?: string | null, linkedUsers: Array<{ linkId: string, userId: string, username?: string | null, fullName?: string | null }> } };

export type RemoveLinkedAccountMutationVariables = Exact<{
  linkId: Scalars['ID']['input'];
}>;


export type RemoveLinkedAccountMutation = { removeLinkedAccount: boolean };

export type CalculatePenaltyMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type CalculatePenaltyMutation = { calculatePenalty: { penalty?: number | null } };

export type UpdateExemptAndGetSummaryAmountMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  isExempt: Scalars['Boolean']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type UpdateExemptAndGetSummaryAmountMutation = { updateExemptAndGetSummaryAmount: { assessmentCharge?: number | null, cost?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, directCharge?: number | null, interest?: number | null, payments?: number | null, penaltyCharge?: number | null, taxRate?: number | null, taxable?: number | null, totalBalance?: number | null, totalBalanceWithDelinquent?: number | null } };

export type GetBusinessAccountIdByNumberQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetBusinessAccountIdByNumberQuery = { getBusinessAccountIdByNumber: { accountId: string } };

export type SearchBusinessByAccountNumberMutationVariables = Exact<{
  accountNumber: Scalars['String']['input'];
  leaseMasterId: Scalars['ID']['input'];
  subAccountId: Scalars['ID']['input'];
}>;


export type SearchBusinessByAccountNumberMutation = { searchBusinessByAccountNumber: { __typename: 'EntityNotFound', message: string } | { __typename: 'TaxDistrictBusinessAccountRow', leaseMasterId: string, subAccountId: string, businessAccountId: string, jurisdictionId: number, isHoldingAccount: boolean, accountNumber?: string | null, businessName: string, invalidTaxDistrict: boolean, bafIsActive: boolean, isActive: boolean, address?: { contactId: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null } | null } };

export type GetTaxDistrictBusinessAccountListQueryVariables = Exact<{
  leaseMasterId: Scalars['ID']['input'];
  subAccountId: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetTaxDistrictBusinessAccountListQuery = { taxDistrictBusinessAccountList?: Array<{ jurisdictionId: number, leaseMasterId: string, subAccountId: string, businessAccountId: string, isHoldingAccount: boolean, accountNumber?: string | null, businessName: string, invalidTaxDistrict: boolean, bafIsActive: boolean, isActive: boolean, address?: { contactId: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null } | null } | null> | null };

export type SaveTaxDistrictBusinessAccountListMutationVariables = Exact<{
  businessAccountList: Array<TaxDistrictBusinessAccountRowInput> | TaxDistrictBusinessAccountRowInput;
}>;


export type SaveTaxDistrictBusinessAccountListMutation = { saveTaxDistrictBusinessAccountList?: Array<{ jurisdictionId: number, leaseMasterId: string, subAccountId: string, businessAccountId: string, isHoldingAccount: boolean, accountNumber?: string | null, businessName: string, invalidTaxDistrict: boolean, bafIsActive: boolean, isActive: boolean, address?: { contactId: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null } | null } | null> | null };

export type CreateHoldingAccountMutationVariables = Exact<{
  holdingAccountInput: CreateHoldingAccountInput;
}>;


export type CreateHoldingAccountMutation = { createHoldingAccount?: { value: string } | null };

export type ReopenFilingMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type ReopenFilingMutation = { reopenFiling?: boolean | null };

export type GetBusinessAppraiserRegionListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessAppraiserRegionListQuery = { getBusinessAppraiserRegionList?: Array<{ regionName: string, columnsNames: { groupingLabel1: string, groupingLabel2: string }, rows: Array<{ id: string, groupingValue1: string, groupingValue2: string, regionName: string }> }> | null };

export type GetRegionAndIdListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegionAndIdListQuery = { getBusinessAppraiserRegionList?: Array<{ rows: Array<{ id: string, groupingValue1: string, groupingValue2: string }> }> | null };

export type GetAppraiserRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppraiserRegionsQuery = { appraiserRegions: Array<{ id: number, region: string, name: string, code: string, accountCount: number, newBusinessCount: number, isActive: boolean, updateDate: string, updatedBy: number }> };

export type SaveAppraiserRegionMutationVariables = Exact<{
  appraiserRegion: SaveAppraiserRegionInput;
}>;


export type SaveAppraiserRegionMutation = { saveAppraiserRegion: boolean };

export type AccountsByAppraiserRegionQueryVariables = Exact<{
  regionId: Scalars['String']['input'];
}>;


export type AccountsByAppraiserRegionQuery = { accountsByAppraiserRegion: Array<{ id: number, accountId: number, accountNumber: string, businessName: string, regionId: number, name: string, code: string, region: string }> };

export type GetAppraiserRegionJurConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppraiserRegionJurConfigQuery = { appraiserRegionJurConfig: { areaName?: string | null, groupingLabel1?: string | null, groupingLabel2?: string | null } };

export type MergeAppraiserRegionsMutationVariables = Exact<{
  mergeAppraiserRegionsInput: MergeAppraiserRegionsInput;
}>;


export type MergeAppraiserRegionsMutation = { mergeAppraiserRegions: { updatedAccounts: number } };

export type BulkUpdateAppraiserRegionMutationVariables = Exact<{
  input: BulkUpdateAppraiserRegionInput;
}>;


export type BulkUpdateAppraiserRegionMutation = { bulkUpdateAppraiserRegion: { status: string, rowsRead: number, updatedAccounts: number, failedRows: number, results: Array<{ rowNumber: number, accountNumber: string, businessName: string, errorMessage: string }> } };

export type GetCreateContactDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreateContactDataQuery = { countries: Array<{ code: string, name: string }>, contactTypes: Array<{ id: string, label: string }> };

export type GetContactListQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetContactListQuery = { contacts: Array<{ id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, isPrimary?: boolean | null, sameAsBusinessAddress?: boolean | null, contactType?: { id: string, label: string } | null, mailingAddress?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null }> };

export type CreateContactMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
  contact: ContactInput;
}>;


export type CreateContactMutation = { createContact: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, isPrimary?: boolean | null, sameAsBusinessAddress?: boolean | null, contactType?: { id: string, label: string } | null, mailingAddress?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null } };

export type SaveContactMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
  contact: ContactInput;
}>;


export type SaveContactMutation = { saveContact: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, isPrimary?: boolean | null, sameAsBusinessAddress?: boolean | null, contactType?: { id: string, label: string } | null, mailingAddress?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null } };

export type RemoveContactMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  primaryContact?: InputMaybe<ContactInput>;
}>;


export type RemoveContactMutation = { removeContact: { isDeleted: boolean, primaryContact?: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, isPrimary?: boolean | null, sameAsBusinessAddress?: boolean | null, contactType?: { id: string, label: string } | null, mailingAddress?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null } | null } };

export type CreateLeaseMasterContactMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  contact: ContactInput;
}>;


export type CreateLeaseMasterContactMutation = { createLeaseMasterContact: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, isPrimary?: boolean | null, sameAsBusinessAddress?: boolean | null, contactType?: { id: string, label: string } | null, mailingAddress?: { addressLine1?: string | null, addressLine2?: string | null, inCareOf?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null } };

export type SaveLeaseMasterContactMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  contact: ContactInput;
}>;


export type SaveLeaseMasterContactMutation = { saveLeaseMasterContact: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, isPrimary?: boolean | null, sameAsBusinessAddress?: boolean | null, contactType?: { id: string, label: string } | null, mailingAddress?: { addressLine1?: string | null, addressLine2?: string | null, inCareOf?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null } };

export type RemoveLeaseMasterContactMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  primaryContact?: InputMaybe<ContactInput>;
}>;


export type RemoveLeaseMasterContactMutation = { removeLeaseMasterContact: { isDeleted: boolean, primaryContact?: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, isPrimary?: boolean | null, sameAsBusinessAddress?: boolean | null, contactType?: { id: string, label: string } | null, mailingAddress?: { addressLine1?: string | null, addressLine2?: string | null, inCareOf?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null } | null } };

export type GetLeaseMasterContactsQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetLeaseMasterContactsQuery = { leaseMasterContact: Array<{ id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, isPrimary?: boolean | null, sameAsBusinessAddress?: boolean | null, contactType?: { id: string, label: string } | null, mailingAddress?: { addressLine1?: string | null, addressLine2?: string | null, inCareOf?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null }> };

export type SetLeaseMasterPrimaryContactMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
}>;


export type SetLeaseMasterPrimaryContactMutation = { setLeaseMasterPrimaryContact: boolean };

export type GetTelecomContactsQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetTelecomContactsQuery = { telecomContacts: Array<{ id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, isPrimary?: boolean | null, sameAsBusinessAddress?: boolean | null, contactType?: { id: string, label: string } | null, mailingAddress?: { addressLine1?: string | null, addressLine2?: string | null, inCareOf?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null }> };

export type CreateTelecomContactMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  contact: ContactInput;
}>;


export type CreateTelecomContactMutation = { createTelecomContact: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, isPrimary?: boolean | null, sameAsBusinessAddress?: boolean | null, contactType?: { id: string, label: string } | null, mailingAddress?: { addressLine1?: string | null, addressLine2?: string | null, inCareOf?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null } };

export type SaveTelecomContactMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  contact: ContactInput;
}>;


export type SaveTelecomContactMutation = { saveTelecomContact: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, isPrimary?: boolean | null, sameAsBusinessAddress?: boolean | null, contactType?: { id: string, label: string } | null, mailingAddress?: { addressLine1?: string | null, addressLine2?: string | null, inCareOf?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null } };

export type RemoveTelecomContactMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  primaryContact?: InputMaybe<ContactInput>;
}>;


export type RemoveTelecomContactMutation = { removeTelecomContact: { isDeleted: boolean, primaryContact?: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, isPrimary?: boolean | null, sameAsBusinessAddress?: boolean | null, contactType?: { id: string, label: string } | null, mailingAddress?: { addressLine1?: string | null, addressLine2?: string | null, inCareOf?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null } | null } };

export type SetTelecomPrimaryContactMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
}>;


export type SetTelecomPrimaryContactMutation = { setTelecomPrimaryContact: boolean };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { countries: Array<{ code: string, name: string }> };

export type GetCountySettingsQueryVariables = Exact<{
  searchFilters?: InputMaybe<SearchFilters>;
}>;


export type GetCountySettingsQuery = { countySettings: { countyName?: string | null, supportPhone?: string | null, supportEmail?: string | null, workDays?: string | null, workHours?: string | null, locationAddress?: string | null, mailingAddress?: string | null, supportLinkURL?: string | null, contacts: Array<{ id: number, name: string, title?: string | null, email: string, phone?: string | null }> }, search: Array<{ id: number, username: string, email: string, fullName: string, title?: string | null, phone?: string | null, isActive: boolean, isVerified: boolean }> };

export type SaveCountyContactsMutationVariables = Exact<{
  contacts: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SaveCountyContactsMutation = { saveCountyContacts: { countyName?: string | null, supportPhone?: string | null, supportEmail?: string | null, workDays?: string | null, workHours?: string | null, locationAddress?: string | null, mailingAddress?: string | null, supportLinkURL?: string | null, contacts: Array<{ id: number, name: string, title?: string | null, email: string, phone?: string | null }> } };

export type GetCurrentTaxYearQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentTaxYearQuery = { currentTaxYear: number };

export type AccountDelinquencyQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
  accountIdString: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type AccountDelinquencyQuery = { accountDelinquency: { accountId: number, accountNumber: string, businessName: string, accountType?: string | null, originalDelinquentYear: number, totalInterest: number, totalPenalties: number, totalCharges: number, totalTax: number, delinquentBalance: number, lastPaymentDate?: string | null, transactions: Array<{ id: number, delinquentYearId: number, taxYear: number, taxDistrict: string, assessmentCharge: number, calculatedAssessmentCharge: number, directCharges: number, calculatedDirectCharges: number, penalties: number, calculatedPenalties: number, interest: number, calculatedInterest: number, total: number, interestPaid?: number | null, interestNotPaid?: number | null, interestOffset?: number | null, interestUpdated?: boolean | null, totalPaid?: number | null }>, summary: { assessmentCharge: number, totalDirectCharge: number, totalPayments: number, penaltyCharge: number, interest: number, balance: number, balanceWithDelinquent: number }, paymentPlan: { id: number, total: number, terms: Array<{ dueDate: string, amount: number }> } }, paymentTypes: Array<{ id: number, description?: string | null }>, getBusinessAccount?: { id: string, accountNumber: string, isActive: boolean, filingStatus: { hasAttachment: boolean, howFiled?: { id: string, label: string } | null } } | null };

export type CalculateAccountDelinquencyMutationVariables = Exact<{
  delinquency: CalculateAccountDelinquencyInput;
  taxYear: Scalars['Int']['input'];
  reset?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CalculateAccountDelinquencyMutation = { calculateAccountDelinquency: { accountId: number, totalInterest: number, totalPenalties: number, totalCharges: number, totalTax: number, delinquentBalance: number, transactions: Array<{ id: number, delinquentYearId: number, taxYear: number, taxDistrict: string, assessmentCharge: number, calculatedAssessmentCharge: number, directCharges: number, calculatedDirectCharges: number, penalties: number, calculatedPenalties: number, interest: number, calculatedInterest: number, total: number, interestPaid?: number | null, interestNotPaid?: number | null, interestOffset?: number | null, interestUpdated?: boolean | null, totalPaid?: number | null }>, summary: { assessmentCharge: number, totalDirectCharge: number, totalPayments: number, penaltyCharge: number, interest: number, balance: number, balanceWithDelinquent: number } } };

export type CreateDelinquentPaymentMutationVariables = Exact<{
  payment: CreateDelinquentPaymentInput;
}>;


export type CreateDelinquentPaymentMutation = { createDelinquentPayment: { paymentId: number, delinquency: { accountId: number, accountNumber: string, businessName: string, accountType?: string | null, originalDelinquentYear: number, totalInterest: number, totalPenalties: number, totalCharges: number, totalTax: number, delinquentBalance: number, lastPaymentDate?: string | null, transactions: Array<{ id: number, delinquentYearId: number, taxYear: number, taxDistrict: string, assessmentCharge: number, calculatedAssessmentCharge: number, directCharges: number, calculatedDirectCharges: number, penalties: number, calculatedPenalties: number, interest: number, calculatedInterest: number, total: number, interestPaid?: number | null, interestNotPaid?: number | null, interestOffset?: number | null, interestUpdated?: boolean | null, totalPaid?: number | null }>, summary: { assessmentCharge: number, totalDirectCharge: number, totalPayments: number, penaltyCharge: number, interest: number, balance: number, balanceWithDelinquent: number }, paymentPlan: { id: number, total: number, terms: Array<{ dueDate: string, amount: number }> } } } };

export type EditDelinquentPaymentMutationVariables = Exact<{
  payment: EditDelinquentPaymentInput;
}>;


export type EditDelinquentPaymentMutation = { editDelinquentPayment: boolean };

export type DelinquentYearSummaryQueryVariables = Exact<{
  dateReceived: Scalars['String']['input'];
}>;


export type DelinquentYearSummaryQuery = { delinquentYearSummary: { totalCash: number, totalChecks: number, totalCredit: number, totalEChecks: number, totalReturnedChecks: number, totalReturnedEChecks: number, grandTotal: number, payments: Array<{ id: number, receiptNumber: number, accountId: number, accountNumber?: string | null, businessName?: string | null, receivedFrom: string, dateReceived: string, paymentAmount: number, checkNumber?: string | null, isVoided?: boolean | null, paymentType?: { id: number, description?: string | null } | null, paymentStatus?: { id: number, description?: string | null } | null, ein: { id: number, name: string } }> } };

export type DelinquentPaymentHistoryQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
}>;


export type DelinquentPaymentHistoryQuery = { delinquentPaymentHistory: Array<{ id: number, receiptNumber: number, accountId: number, accountNumber?: string | null, receivedFrom: string, amount: number, checkNumber?: string | null, date: string, paymentType?: { id: number, description?: string | null } | null, paymentStatus?: { id: number, description?: string | null } | null }> };

export type GetDelinquentYearTransactionsQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
}>;


export type GetDelinquentYearTransactionsQuery = { delinquentYearTransactions: { accountId: number, accountNumber: string, businessName: string, delinquentYearId: number, delinquentYears: Array<{ id: number, taxYear: number, taxDistrict?: string | null, balance: number, transactions: Array<{ id: number, amount: number, dateReceived?: string | null, receiptNumber?: string | null, ein?: number | null, isVoid?: boolean | null, directCharge: { id: number, description: string } }> }> } };

export type CreateDelinquentAdjustmentMutationVariables = Exact<{
  delinquentAdjustment: DelinquentAdjustmentInput;
}>;


export type CreateDelinquentAdjustmentMutation = { createDelinquentAdjustment: boolean };

export type GetSubAccountsForDelinquencyQueryVariables = Exact<{
  leaseMasterAccountNumber: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetSubAccountsForDelinquencyQuery = { getSubAccounts: { id: number, businessName: string, subAccounts: Array<{ id: number, accountNumber: string, taxDistrict: string, hasDelinquentBalance: boolean }> }, paymentTypes: Array<{ id: number, description?: string | null }> };

export type MasterAccountDelinquencyQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type MasterAccountDelinquencyQuery = { accountDelinquency: { accountId: number, accountNumber: string, businessName: string, accountType?: string | null, originalDelinquentYear: number, totalInterest: number, totalPenalties: number, totalCharges: number, totalTax: number, delinquentBalance: number, lastPaymentDate?: string | null, transactions: Array<{ id: number, delinquentYearId: number, taxYear: number, taxDistrict: string, assessmentCharge: number, calculatedAssessmentCharge: number, directCharges: number, calculatedDirectCharges: number, penalties: number, calculatedPenalties: number, interest: number, calculatedInterest: number, total: number }>, summary: { assessmentCharge: number, totalDirectCharge: number, totalPayments: number, penaltyCharge: number, interest: number, balance: number, balanceWithDelinquent: number }, paymentPlan: { id: number, total: number, terms: Array<{ dueDate: string, amount: number }> } } };

export type MasterAccountDelinquentSummaryQueryVariables = Exact<{
  masterAccountNumber: Scalars['String']['input'];
  dateReceived: Scalars['String']['input'];
  isTelecom?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MasterAccountDelinquentSummaryQuery = { masterAccountDelinquentSummary: { accountTotals: { totalPayments: number, totalTax: number, totalCharges: number, totalPenalties: number, totalInterest: number, currentBalance: number, totalCurrentAndDelinquent: number }, delinquentAccountTotals: { totalPayments: number, totalTax: number, totalCharges: number, totalPenalties: number, totalInterest: number, delinquentBalance: number }, subAccountTotals: Array<{ subAccountId: number, subAccountNumber: string, taxDistrict: string, payments: number, netAssessmentCharge: number, directCharges: number, penalties: number, interest: number, total: number }> } };

export type GetTelecomSubAccountsForDelinquencyQueryVariables = Exact<{
  telecomMasterId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetTelecomSubAccountsForDelinquencyQuery = { telecomSubAccounts: Array<{ accountId?: number | null, accountNumber?: string | null, taxDistrict: string, hasDelinquentBalance?: boolean | null }>, paymentTypes: Array<{ id: number, description?: string | null }> };

export type GetDirectChargeTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDirectChargeTypesQuery = { getDirectChargeTypes: Array<{ id: number, description: string }> };

export type GetDirectChargesQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  accountIdString: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetDirectChargesQuery = { getDirectCharges: { accountId: number, accountNumber: string, taxYear: number, jurisdiction: number, businessName: string, ein: { id: number, name: string }, accountSummary: { assessmentCharge: number, balance: number, balanceDueWithInterest: number, interest: number, isExempt: boolean, penaltyCharge: number, taxRate: number, totalCost: number, totalDirectCharge: number, totalPayments: number, totalTaxable: number }, directCharges: Array<{ id: number, amount: number, comment?: string | null, isActive: boolean, updateDate: string, entryDate: string, ein: { id: number, name: string }, type: { id: number, description: string } }> }, getDirectChargeTypes: Array<{ id: number, description: string }>, getBusinessAccount?: { id: string, accountNumber: string, isActive: boolean } | null };

export type GetSubAccountDirectChargesQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
  jurisdiction?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSubAccountDirectChargesQuery = { getDirectCharges: { accountId: number, accountNumber: string, taxYear: number, jurisdiction: number, businessName: string, ein: { id: number, name: string }, accountSummary: { assessmentCharge: number, balance: number, balanceDueWithInterest: number, interest: number, isExempt: boolean, penaltyCharge: number, taxRate: number, totalCost: number, totalDirectCharge: number, totalPayments: number, totalTaxable: number }, directCharges: Array<{ id: number, amount: number, comment?: string | null, isActive: boolean, updateDate: string, entryDate: string, ein: { id: number, name: string }, type: { id: number, description: string } }> }, getDirectChargeTypes: Array<{ id: number, description: string }> };

export type SaveDirectChargesMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
  directCharges: Array<DirectChargeInput> | DirectChargeInput;
}>;


export type SaveDirectChargesMutation = { saveDirectCharges: { accountId: number, accountNumber: string, taxYear: number, jurisdiction: number, businessName: string, ein: { id: number, name: string }, accountSummary: { assessmentCharge: number, balance: number, balanceDueWithInterest: number, interest: number, isExempt: boolean, penaltyCharge: number, taxRate: number, totalCost: number, totalDirectCharge: number, totalPayments: number, totalTaxable: number }, directCharges: Array<{ id: number, amount: number, comment?: string | null, isActive: boolean, updateDate: string, entryDate: string, ein: { id: number, name: string }, type: { id: number, description: string } }> } };

export type GetEntityTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEntityTypesQuery = { entityTypes: Array<{ id: string, label: string }> };

export type FiledStatusListQueryVariables = Exact<{ [key: string]: never; }>;


export type FiledStatusListQuery = { filedStatusList: Array<{ id: string, label: string }> };

export type HowFiledListQueryVariables = Exact<{ [key: string]: never; }>;


export type HowFiledListQuery = { howFiledList: Array<{ id: string, label: string }> };

export type HowReceivedQueryVariables = Exact<{ [key: string]: never; }>;


export type HowReceivedQuery = { howReceivedList: Array<{ id: string, label: string }> };

export type GetIndustrialParkOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIndustrialParkOptionsQuery = { industrialParkOptions: Array<{ id: number, code: string, label: string }> };

export type GetIndustrialParksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIndustrialParksQuery = { industrialParks: Array<{ id: number, code: string, label: string, accountCount: number, newBusinessCount: number, isActive: boolean }> };

export type SaveIndustrialParkMutationVariables = Exact<{
  input: IndustrialParkInput;
}>;


export type SaveIndustrialParkMutation = { saveIndustrialPark: Array<{ id: number, code: string, label: string, accountCount: number, newBusinessCount: number, isActive: boolean }> };

export type AccountsByIndustrialParkQueryVariables = Exact<{
  industrialPark: Scalars['String']['input'];
}>;


export type AccountsByIndustrialParkQuery = { accountsByIndustrialPark: Array<{ accountId: number, accountNumber: string, businessName: string, industrialParkId: number, code: string, label: string }> };

export type BulkUpdateIndustrialParkMutationVariables = Exact<{
  input: BulkUpdateIndustrialParkInput;
}>;


export type BulkUpdateIndustrialParkMutation = { bulkUpdateIndustrialPark: { status: string, rowsRead: number, updatedAccounts: number, failedRows: number, results: Array<{ rowNumber: number, accountNumber: string, businessName: string, errorMessage: string }> } };

export type GetJurisdictionsQueryVariables = Exact<{
  isImplemented?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetJurisdictionsQuery = { getJurisdictions: Array<{ id: string, name: string }> };

export type GetLeaseMasterAssetsQueryVariables = Exact<{
  leaseMasterId: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetLeaseMasterAssetsQuery = { leaseMasterAssets: Array<{ id: number, subAccountId: number, subAccountNumber: string, taxDistrict: string, description?: string | null, yearAcquired: number, quantity: number, costPer: number, percentGood?: number | null, taxableValue?: number | null, isActive: boolean, classification: { id: string, label?: string | null } }> };

export type LeaseMasterAssocQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type LeaseMasterAssocQuery = { leaseMasterAssoc: Array<{ businessName: string, leaseMasterAccountNbr: string, isReconciled: boolean }> };

export type GetLeaseMasterBusinessAccountQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetLeaseMasterBusinessAccountQuery = { leaseMasterBusinessAccount?: { id: string, accountNumber: string, adminLink?: string | null, businessName: string, registeredEntityName?: string | null, description?: string | null, ein?: string | null, telecomAccountNumber?: string | null, applyPenalty: boolean, isActive: boolean, isDisabled: boolean, sicCode?: { id: string, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string, isActive: boolean } | null, lastModified: { username?: string | null, lastChanged?: string | null }, reconciliation: { reconciledDate?: string | null, reconciledBy?: { id: number, fullName: string, username: string, email: string, isActive: boolean, isVerified: boolean } | null }, filingStatus: { hasAttachment?: boolean | null, hasBuildingPermit?: boolean | null, hasExemption?: boolean | null, dateReceived?: string | null, howFiled?: { id: string, label: string } | null, howReceived?: { id: string, label: string } | null }, audit: { auditYear?: number | null }, bankruptcy: { bankruptcyType?: { id: string, label: string } | null }, entityType?: { id: string, label: string } | null, accountType?: { id: string, label: string } | null, businessAccountType?: { id: string, label: string } | null, accountSummary?: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, payments?: number | null, interest?: number | null, penaltyCharge?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null } | null } | null };

export type SaveLeaseMasterAccountMutationVariables = Exact<{
  input: LeaseMasterBusinessAccountInput;
}>;


export type SaveLeaseMasterAccountMutation = { saveLeaseMasterAccount?: { id: string, accountNumber: string, adminLink?: string | null, businessName: string, registeredEntityName?: string | null, description?: string | null, ein?: string | null, telecomAccountNumber?: string | null, applyPenalty: boolean, isActive: boolean, isDisabled: boolean, sicCode?: { id: string, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string, isActive: boolean } | null, lastModified: { username?: string | null, lastChanged?: string | null }, reconciliation: { reconciledDate?: string | null, reconciledBy?: { id: number, fullName: string, username: string, email: string, isActive: boolean, isVerified: boolean } | null }, filingStatus: { hasAttachment?: boolean | null, hasBuildingPermit?: boolean | null, hasExemption?: boolean | null, dateReceived?: string | null, howFiled?: { id: string, label: string } | null, howReceived?: { id: string, label: string } | null }, audit: { auditYear?: number | null }, bankruptcy: { bankruptcyType?: { id: string, label: string } | null }, entityType?: { id: string, label: string } | null, accountType?: { id: string, label: string } | null, businessAccountType?: { id: string, label: string } | null, accountSummary?: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, payments?: number | null, penaltyCharge?: number | null, interest?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null } | null } | null };

export type CreateLeaseMasterAccountMutationVariables = Exact<{
  input: CreateLessorAccountInput;
}>;


export type CreateLeaseMasterAccountMutation = { createLeaseMasterAccount?: { id: string, accountNumber: string, businessName: string, description?: string | null, ein?: string | null, sicCode?: { id: string, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string } | null, accountType?: { id: string, label: string } | null, accountSummary?: { assessmentCharge?: number | null, directCharge?: number | null, penaltyCharge?: number | null, payments?: number | null } | null, reconciliation: { reconciledDate?: string | null, reconciledBy?: { id: number, fullName: string, username: string, email: string, isActive: boolean, isVerified: boolean } | null }, filingStatus: { howReceived?: { id: string, label: string } | null } } | null };

export type SearchLeaseMasterBusinessAccountQueryVariables = Exact<{
  filters: SearchLeaseMasterBusinessAccountInput;
}>;


export type SearchLeaseMasterBusinessAccountQuery = { searchLeaseMasterBusinessAccount?: { totalAccounts: number, leaseAccounts?: Array<{ accountId: string, accountNumber: string, businessName: string, isActive: boolean, isReconciled: boolean, filingStatus?: string | null, taxYear?: number | null, countyName?: string | null }> | null } | null };

export type ValidateTelecomMasterAccountMutationVariables = Exact<{
  telecomAccountNumber: Scalars['String']['input'];
}>;


export type ValidateTelecomMasterAccountMutation = { validateTelecomMasterAccountNumber?: boolean | null };

export type ChangeLeaseMasterAccountStatusMutationVariables = Exact<{
  accountStatus: AccountStatusInput;
}>;


export type ChangeLeaseMasterAccountStatusMutation = { changeLeaseMasterAccountStatus: boolean };

export type UpdateLeaseExemptAndGetSummaryAmountMutationVariables = Exact<{
  leaseMasterId: Scalars['String']['input'];
  isExempt: Scalars['Boolean']['input'];
}>;


export type UpdateLeaseExemptAndGetSummaryAmountMutation = { updateLeaseExemptAndGetSummaryAmount: { assessmentCharge?: number | null, cost?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, directCharge?: number | null, interest?: number | null, payments?: number | null, penaltyCharge?: number | null, taxRate?: number | null, taxable?: number | null, totalBalance?: number | null, totalBalanceWithDelinquent?: number | null } };

export type SearchLeaseBusinessAccountInfoByNumberMutationVariables = Exact<{
  accountNumber: Scalars['String']['input'];
}>;


export type SearchLeaseBusinessAccountInfoByNumberMutation = { searchLeaseBusinessAccountInfoByNumber?: { id?: string | null, businessName?: string | null, delinquentBalance?: number | null, status: AccountSearchStatus } | null };

export type ChangeLeaseMasterSubAccountStatusMutationVariables = Exact<{
  accountStatus: SubAccountStatusInput;
}>;


export type ChangeLeaseMasterSubAccountStatusMutation = { changeLeaseMasterSubAccountStatus: boolean };

export type ValidateLeaseMasterAccountMutationVariables = Exact<{
  leaseMasterAccountNumber: Scalars['String']['input'];
  subAccountNumber: Scalars['String']['input'];
}>;


export type ValidateLeaseMasterAccountMutation = { validateLeaseMasterAccount?: boolean | null };

export type GetSubAccountLocationAssetsQueryVariables = Exact<{
  leaseMasterId: Scalars['ID']['input'];
  subAccountId: Scalars['ID']['input'];
  subAccountNumericId: Scalars['Int']['input'];
  locationAccountId: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetSubAccountLocationAssetsQuery = { uploadLeasedAssetsTemplate: string, leasedAssetsForSubAccountLocation: Array<{ id: string, leaseAccountId?: string | null, contactLinkId?: string | null, description?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, percentGood?: number | null, taxableValue?: number | null, isActive?: boolean | null, ein?: number | null, updateDate?: string | null, classification?: { id: string, label?: string | null } | null }>, getClassifications: Array<{ id: string, clsf?: string | null, scheduleId?: number | null, description?: string | null }>, getTaxRate: { id: string, taxRate?: number | null } };

export type SaveSubAccountLocationAssetsMutationVariables = Exact<{
  input: SaveLeasedAssetForSubAccountLocationInput;
}>;


export type SaveSubAccountLocationAssetsMutation = { saveLeasedAssetsForSubAccountLocation: Array<{ id: string, leaseAccountId?: string | null, contactLinkId?: string | null, description?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, percentGood?: number | null, taxableValue?: number | null, isActive?: boolean | null, ein?: number | null, updateDate?: string | null, classification?: { id: string, label?: string | null } | null }> };

export type SearchLeasedAssetsForReconciliationQueryVariables = Exact<{
  filters: SearchLeasedAssetsForReconciliationInput;
}>;


export type SearchLeasedAssetsForReconciliationQuery = { searchLeasedAssetForReconciliation: Array<{ id: string, accountId: string, accountNumber?: string | null, leaseMasterAccountNumber?: string | null, subAccountNumber?: string | null, contactLinkId: string, description?: string | null, yearAcquired?: number | null, rentPerMonth?: number | null, costPer?: number | null, leaseStartDate?: string | null, leaseEndDate?: string | null, leaseId?: string | null, leaseNumber?: string | null, fileUrl?: string | null, fileName?: string | null, blobName?: string | null, entryDate?: string | null, isActive: boolean, isReconciled: boolean, lessor?: { name?: string | null, address?: string | null } | null }> };

export type SearchLeaseMasterAccountSuggestionsQueryVariables = Exact<{
  accountNumber: Scalars['ID']['input'];
}>;


export type SearchLeaseMasterAccountSuggestionsQuery = { searchLeaseMasterAccountSuggestions: Array<{ leaseMasterAccountName?: string | null, leaseMasterAccountNumber: string, subAccountNumber: string }> };

export type ReconcileLeaseMasterAssetsMutationVariables = Exact<{
  assets: Array<ReconcileLeaseMasterAssetInput> | ReconcileLeaseMasterAssetInput;
}>;


export type ReconcileLeaseMasterAssetsMutation = { reconcileLeaseMasterAssets?: boolean | null };

export type GetMassAccountBatchesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMassAccountBatchesQuery = { massAccountTemplate: string, massAccountBatches: Array<{ id: number, description?: string | null, status: string, uploadDate: string, totalRecords: number }> };

export type GetMassAccountBatchQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetMassAccountBatchQuery = { massAccountBatch: Array<{ id: number, businessName?: string | null, address?: string | null, mailingAddress?: string | null, accountType?: string | null, sicCode?: string | null, status: { id: number, name: string } }> };

export type CreateMassAccountBatchMutationVariables = Exact<{
  batch: CreateMassAccountBatchInput;
}>;


export type CreateMassAccountBatchMutation = { createMassAccountBatch: { id?: number | null, errors: Array<string> } };

export type DeleteMassAccountBatchMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteMassAccountBatchMutation = { deleteMassAccountBatch: boolean };

export type ApproveMassAccountBatchMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ApproveMassAccountBatchMutation = { approveMassAccountBatch: { createdAccounts: Array<{ id: number, accountId: number, accountNumber: string, businessName: string }>, failedAccounts: Array<{ id: number, errorMessage: string }> } };

export type GetBatchBusinessAccountDictionariesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBatchBusinessAccountDictionariesQuery = { getBusinessAppraiserRegionList?: Array<{ regionName: string, columnsNames: { groupingLabel1: string, groupingLabel2: string }, rows: Array<{ id: string, groupingValue1: string, groupingValue2: string, regionName: string }> }> | null, countries: Array<{ code: string, name: string }>, accountTypes: Array<{ id: string, label: string }>, taxAreaList: Array<{ taxArea: string, taxSubArea: Array<string> }>, sicCodeMasters: Array<{ id: string, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string, isActive: boolean }>, parcelUseTypeList: Array<{ id: string, label: string }>, contactTypes: Array<{ id: string, label: string }> };

export type GetBatchBusinessAccountQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetBatchBusinessAccountQuery = { batchBusinessAccount: { id: number, businessName?: string | null, description?: string | null, accountType?: number | null, sicCode?: string | null, parcelUseType?: number | null, parcelNumber?: string | null, accountNumber?: string | null, taxArea?: string | null, taxSubArea?: string | null, appraiserRegion?: number | null, cityCode?: string | null, mailingAddress?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null, situsAddress?: { addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null, contact?: { name?: string | null, contactType?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null } | null, status: { id: number, name: string } } };

export type SaveBatchBusinessAccountMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  account: BatchBusinessAccountInput;
}>;


export type SaveBatchBusinessAccountMutation = { saveBatchBusinessAccount: boolean };

export type DeleteBatchBusinessAccountMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteBatchBusinessAccountMutation = { deleteBatchBusinessAccount: boolean };

export type AccountForMassPaymentQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
  interestDate: Scalars['String']['input'];
}>;


export type AccountForMassPaymentQuery = { accountForMassPayment: { accountId: number, businessName: string, howFiled?: number | null, howFiledDescr?: string | null, howReceived?: number | null, howReceivedDescr?: string | null, filedDate?: string | null, filedBy?: number | null, filedByDisplay?: string | null, currentUserName?: string | null, interest: number } };

export type UpdateMassPaymentFilingStatusMutationVariables = Exact<{
  input: MassPaymentFilingStatusInput;
}>;


export type UpdateMassPaymentFilingStatusMutation = { updateMassPaymentFilingStatus: { accountId: number, howFiled?: number | null, howReceived?: number | null, filedDate?: string | null, filedBy?: number | null, filedByDisplay?: string | null } };

export type MovePermitInitialFormDataQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
}>;


export type MovePermitInitialFormDataQuery = { movePermitInitialFormData: { taxYear: number, jurisdiction: number, accountId?: number | null, accountNumber?: string | null, leaseMasterAccountId?: number | null, leaseMasterAccountNumber?: string | null, issueDate: string, ownerName?: string | null, modelDescription?: string | null, modelYear?: number | null, serialNumber?: string | null, permitIssuedTo?: string | null, permitIssuedBy: number, taxAmountPaid?: number | null, datePaid?: string | null, receiptNumber?: number | null, isActive: boolean, addressFrom: { address?: string | null, city?: string | null, state?: string | null }, addressTo: { address?: string | null, city?: string | null, state?: string | null } } };

export type CreateMovePermitMutationVariables = Exact<{
  movePermit: CreateMovePermitInput;
}>;


export type CreateMovePermitMutation = { createMovePermit: { id: number, taxYear: number, jurisdiction: number, accountId: number, accountNumber: string, leaseMasterAccountNumber?: string | null, permitTypeId: number, issueDate: string, ownerName: string, modelDescription?: string | null, modelYear?: number | null, serialNumber?: string | null, permitIssuedTo?: string | null, permitIssuedBy: number, taxAmountPaid?: number | null, datePaid?: string | null, receiptNumber?: number | null, updateDate: string, updatedBy: number, isActive: boolean, addressFrom: { address?: string | null, city?: string | null, state?: string | null }, addressTo: { address?: string | null, city?: string | null, state?: string | null }, note?: { id: number, text?: string | null } | null } };

export type EditMovePermitMutationVariables = Exact<{
  movePermit: EditMovePermitInput;
}>;


export type EditMovePermitMutation = { editMovePermit: { id: number, taxYear: number, jurisdiction: number, accountId: number, accountNumber: string, leaseMasterAccountNumber?: string | null, permitTypeId: number, issueDate: string, ownerName: string, modelDescription?: string | null, modelYear?: number | null, serialNumber?: string | null, permitIssuedTo?: string | null, permitIssuedBy: number, taxAmountPaid?: number | null, datePaid?: string | null, receiptNumber?: number | null, updateDate: string, updatedBy: number, isActive: boolean, addressFrom: { address?: string | null, city?: string | null, state?: string | null }, addressTo: { address?: string | null, city?: string | null, state?: string | null }, note?: { id: number, text?: string | null } | null } };

export type SearchMovePermitsQueryVariables = Exact<{
  searchFilters: MovePermitSearchInput;
}>;


export type SearchMovePermitsQuery = { movePermits: { totalRecordCount: number, movePermits: Array<{ id: number, taxYear: number, jurisdiction: number, accountId: number, accountNumber: string, leaseMasterAccountNumber?: string | null, permitTypeId: number, issueDate: string, ownerName: string, modelDescription?: string | null, modelYear?: number | null, serialNumber?: string | null, permitIssuedTo?: string | null, permitIssuedBy: number, taxAmountPaid?: number | null, datePaid?: string | null, receiptNumber?: number | null, updateDate: string, updatedBy: number, isActive: boolean, addressFrom: { address?: string | null, city?: string | null, state?: string | null }, addressTo: { address?: string | null, city?: string | null, state?: string | null }, note?: { id: number, text?: string | null } | null }> } };

export type GetSubAccountsForMovePermitQueryVariables = Exact<{
  leaseMasterAccountNumber: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetSubAccountsForMovePermitQuery = { getSubAccounts: { id: number, businessName: string, subAccounts: Array<{ id: number, accountNumber: string, taxDistrict: string, hasDelinquentBalance: boolean }> } };

export type GetNotesQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetNotesQuery = { notes: Array<{ id: string, content: string, section?: string | null, subsection?: string | null, systemGenerated: boolean, taxYear: number, createDate: string, updateDate: string, edited?: boolean | null, author: { id: string, name: string } }> };

export type GetLeaseMasterNotesQueryVariables = Exact<{
  leaseMasterId: Scalars['ID']['input'];
}>;


export type GetLeaseMasterNotesQuery = { leaseMasterNotes: Array<{ id: string, content: string, section?: string | null, subsection?: string | null, systemGenerated: boolean, taxYear: number, createDate: string, updateDate: string, edited?: boolean | null, author: { id: string, name: string } }> };

export type GetTelecomNotesQueryVariables = Exact<{
  telecomId: Scalars['ID']['input'];
}>;


export type GetTelecomNotesQuery = { telecomNotes: Array<{ id: string, content: string, section?: string | null, subsection?: string | null, systemGenerated: boolean, taxYear: number, createDate: string, updateDate: string, edited?: boolean | null, author: { id: string, name: string } }> };

export type SaveNoteMutationVariables = Exact<{
  note: NoteInput;
}>;


export type SaveNoteMutation = { saveNote: { id: string, content: string, section?: string | null, subsection?: string | null, systemGenerated: boolean, taxYear: number, createDate: string, updateDate: string, edited?: boolean | null, author: { id: string, name: string } } };

export type SaveLeaseMasterNoteMutationVariables = Exact<{
  note: NoteInput;
}>;


export type SaveLeaseMasterNoteMutation = { saveLeaseMasterNote: Array<{ id: string, content: string, section?: string | null, subsection?: string | null, systemGenerated: boolean, taxYear: number, createDate: string, updateDate: string, edited?: boolean | null, author: { id: string, name: string } }> };

export type SaveTelecomNoteMutationVariables = Exact<{
  note: NoteInput;
}>;


export type SaveTelecomNoteMutation = { saveTelecomNote: Array<{ id: string, content: string, section?: string | null, subsection?: string | null, systemGenerated: boolean, taxYear: number, createDate: string, updateDate: string, edited?: boolean | null, author: { id: string, name: string } }> };

export type GetPaymentPlansQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetPaymentPlansQuery = { getPaymentPlan: { accountId: number, accountNumber: string, accountTypeId: number, businessName: string, taxYear: number, paymentPlanTypes: Array<string>, ein: { id: number, name: string }, paymentPlans: Array<{ id: number, contractNumber: string, planType: string, taxYear: number, terms: Array<number>, details: Array<{ id: number, amount: number, paymentDate: string, comment?: string | null, isPaid?: boolean | null }>, totals: { currentYearDue: number, currentYearDueWithInterest: number, delinquentBalance: number, totalPayments: number, totalPaymentsLeft: number } }>, totals: { delinquentBalance: number, currentYearDue: number, currentYearDueWithInterest: number, totalPayments: number, totalPaymentsLeft: number } } };

export type CalculatePaymentPlanMutationVariables = Exact<{
  calculatePaymentPlanInput: CalculatePaymentPlanInput;
}>;


export type CalculatePaymentPlanMutation = { calculatePaymentPlan: Array<{ id: number, contractNumber: string, planType: string, taxYear: number, terms: Array<number>, details: Array<{ id: number, amount: number, paymentDate: string, comment?: string | null, isPaid?: boolean | null, isUpdated?: boolean | null, isDeleted?: boolean | null }>, totals: { currentYearDue: number, currentYearDueWithInterest: number, delinquentBalance: number, totalPayments: number, totalPaymentsLeft: number } }> };

export type SavePaymentPlanMutationVariables = Exact<{
  savePaymentPlanInput: SavePaymentPlanInput;
}>;


export type SavePaymentPlanMutation = { savePaymentPlan: Array<{ id: number, contractNumber: string, planType: string, terms: Array<number>, taxYear: number, details: Array<{ id: number, amount: number, paymentDate: string, comment?: string | null, isPaid?: boolean | null }>, totals: { currentYearDue: number, currentYearDueWithInterest: number, delinquentBalance: number, totalPayments: number, totalPaymentsLeft: number } }> };

export type DeletePaymentPlanMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePaymentPlanMutation = { deletePaymentPlan?: boolean | null };

export type GetPaymentPostingsQueryVariables = Exact<{
  dateReceived: Scalars['String']['input'];
  isTelecom?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPaymentPostingsQuery = { paymentPostings: Array<{ id: number, receiptNumber: number, paymentType: number, amount: number, masterAccountNumber: string, receivedFrom?: string | null, checkNumber?: string | null, isVoided: boolean }>, paymentTypes: Array<{ id: number, description?: string | null }> };

export type SavePaymentPostingsMutationVariables = Exact<{
  dateReceived: Scalars['String']['input'];
  payments: Array<PaymentPostingInput> | PaymentPostingInput;
}>;


export type SavePaymentPostingsMutation = { savePaymentPostings: Array<{ id: number, receiptNumber: number, paymentType: number, amount: number, masterAccountNumber: string, receivedFrom?: string | null, checkNumber?: string | null, isVoided: boolean }> };

export type GetPaymentHoldingsQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
}>;


export type GetPaymentHoldingsQuery = { paymentHoldings: { id: number, accountNumber: string, businessName?: string | null, delinquentBalance?: number | null, payments: Array<{ id: number, receiptNumber: number, amount: number, checkNumber?: string | null, dateReceived: string, paymentType: { id: number, description?: string | null }, createdBy?: { id: number, username: string, fullName: string, email: string, isActive: boolean, isVerified: boolean } | null }>, subAccounts: Array<{ id: number, accountNumber: string, taxDistrict: string, interest: number, balanceDue: number, balanceDueWithInterest: number }> } };

export type AllocatePaymentsMutationVariables = Exact<{
  allocation: AllocateHoldingsToSubAccountsInput;
}>;


export type AllocatePaymentsMutation = { allocateHoldingsToSubAccounts: Array<{ subAccountId: number, paymentId: number, receiptNumber: number, amount: number }> };

export type CalculateMasterAccountInterestMutationVariables = Exact<{
  input: CalculateMasterAccountInterestInput;
}>;


export type CalculateMasterAccountInterestMutation = { calculateMasterAccountInterest: Array<{ id: number, accountNumber: string, taxDistrict: string, interest: number, balanceDue: number, balanceDueWithInterest: number }> };

export type GetPaymentOverviewQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
  directChargeAccountId: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetPaymentOverviewQuery = { getDirectCharges: { accountId: number, accountNumber: string, taxYear: number, jurisdiction: number, businessName: string, ein: { id: number, name: string }, accountSummary: { assessmentCharge: number, balance: number, balanceDueWithInterest: number, interest: number, isExempt: boolean, penaltyCharge: number, taxRate: number, totalCost: number, totalDirectCharge: number, totalPayments: number, totalTaxable: number }, directCharges: Array<{ amount: number, comment?: string | null, id: number, isActive: boolean, updateDate: string, ein: { id: number, name: string }, type: { id: number, description: string } }> }, getDirectChargeTypes: Array<{ id: number, description: string }>, getPaymentPlan: { accountId: number, accountNumber: string, accountTypeId: number, businessName: string, taxYear: number, paymentPlanTypes: Array<string>, ein: { id: number, name: string }, paymentPlans: Array<{ id: number, contractNumber: string, planType: string, terms: Array<number>, details: Array<{ id: number, amount: number, paymentDate: string, comment?: string | null, isPaid?: boolean | null }>, totals: { currentYearDue: number, currentYearDueWithInterest: number, delinquentBalance: number, totalPayments: number, totalPaymentsLeft: number } }> } };

export type GetAccountPaymentsQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
  accountIdString: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetAccountPaymentsQuery = { paymentTypes: Array<{ id: number, description?: string | null }>, paymentStatus: Array<{ id: number, description?: string | null }>, howReceivedList: Array<{ id: string, label: string }>, payments: Array<{ id: number, accountId: number, accountNumber?: string | null, taxYear: number, receiptNumber: number, businessName?: string | null, paymentAmount: number, interestPaid?: number | null, interestAccrued?: number | null, penaltyAmount?: number | null, penaltyPaid?: number | null, receivedFrom: string, dateReceived: string, checkNumber?: string | null, isReconciled?: boolean | null, paymentType?: { id: number, description?: string | null } | null, paymentStatus?: { id: number, description?: string | null } | null, howReceived?: { id: string, label: string } | null, ein: { id: number, name: string } }>, getBusinessAccount?: { id: string, accountNumber: string, businessName: string, isActive: boolean, filingStatus: { hasAttachment: boolean, howFiled?: { id: string, label: string } | null } } | null };

export type SearchPaymentsQueryVariables = Exact<{
  filters: SearchPaymentInput;
}>;


export type SearchPaymentsQuery = { searchPayments: Array<{ id: number, accountId: number, accountNumber?: string | null, taxYear: number, receiptNumber: number, businessName?: string | null, paymentAmount: number, interestPaid?: number | null, interestAccrued?: number | null, penaltyAmount?: number | null, penaltyPaid?: number | null, receivedFrom: string, dateReceived: string, checkNumber?: string | null, masterAccountNumber?: string | null, paymentType?: { id: number, description?: string | null } | null, paymentStatus?: { id: number, description?: string | null } | null, howReceived?: { id: string, label: string } | null, ein: { id: number, name: string } }> };

export type GetPaymentCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentCollectionsQuery = { paymentTypes: Array<{ id: number, description?: string | null }>, paymentStatus: Array<{ id: number, description?: string | null }>, howReceivedList: Array<{ id: string, label: string }> };

export type GetAccountPaymentInitialValuesQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
}>;


export type GetAccountPaymentInitialValuesQuery = { paymentTemplate: { payment: { id: number, accountId: number, accountNumber?: string | null, taxYear: number, receiptNumber: number, businessName?: string | null, paymentAmount: number, interestPaid?: number | null, interestAccrued?: number | null, penaltyAmount?: number | null, penaltyPaid?: number | null, receivedFrom: string, dateReceived: string, checkNumber?: string | null, paymentType?: { id: number, description?: string | null } | null, paymentStatus?: { id: number, description?: string | null } | null, ein: { id: number, name: string } }, summary: { assessmentCharge: number, totalDirectCharge: number, totalPayments: number, penaltyCharge: number, totalCost: number, totalTaxable: number, interest: number, balance: number, balanceDueWithInterest: number, taxRate: number, isExempt: boolean }, paymentPlan: { id: number, total: number, terms: Array<{ amount: number, dueDate: string }> }, howFiled?: { id: string, label: string } | null, howReceived?: { id: string, label: string } | null } };

export type CurrentReturnedPaymentQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
}>;


export type CurrentReturnedPaymentQuery = { currentReturnedPayment: { accountNumber: string, businessName?: string | null, accountId: number, dateReturned: string, dateReceived: string, amount: number, ein: { id: number, name: string }, paymentType?: { id: number, description?: string | null } | null } };

export type DelinquentReturnedPaymentQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
}>;


export type DelinquentReturnedPaymentQuery = { delinquentReturnedPayment: { businessName?: string | null, accountNumber: string, accountId: number, dateReturned?: string | null, ein: { id: number, name: string }, payments: Array<{ id: number, date: string, receiptNumber: number, receivedFrom: string, amount: number, checkNumber?: string | null, leftOverInterest: boolean, paymentType?: { id: number, description?: string | null } | null }> } };

export type PaymentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentTypesQuery = { paymentTypes: Array<{ description?: string | null, id: number }> };

export type CreatePaymentMutationVariables = Exact<{
  payment: CreatePaymentInput;
}>;


export type CreatePaymentMutation = { createPayment: { id: number, accountId: number, taxYear: number, receiptNumber: number, businessName?: string | null, paymentAmount: number, interestPaid?: number | null, interestAccrued?: number | null, penaltyAmount?: number | null, penaltyPaid?: number | null, receivedFrom: string, dateReceived: string, checkNumber?: string | null, paymentType?: { id: number, description?: string | null } | null, paymentStatus?: { id: number, description?: string | null } | null, ein: { id: number, name: string } } };

export type EditPaymentMutationVariables = Exact<{
  payment: EditPaymentInput;
}>;


export type EditPaymentMutation = { editPayment: { id: number, receiptNumber: number, accountId: number, accountNumber?: string | null, businessName?: string | null, receivedFrom: string, dateReceived: string, paymentAmount: number, isReconciled?: boolean | null, checkNumber?: string | null, masterAccountNumber?: string | null, paymentType?: { id: number, description?: string | null } | null, paymentStatus?: { id: number, description?: string | null } | null, ein: { id: number, name: string } } };

export type PaymentCurrentYearSummaryQueryVariables = Exact<{
  dateReceived: Scalars['String']['input'];
  ein?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaymentCurrentYearSummaryQuery = { currentYearSummary: { totalCash: number, totalChecks: number, totalCredit: number, totalEChecks: number, totalReturnedChecks: number, totalReturnedEChecks: number, grandTotal: number, payments: Array<{ id: number, receiptNumber: number, accountId: number, accountNumber?: string | null, taxYear: number, businessName?: string | null, receivedFrom: string, dateReceived: string, paymentAmount: number, isReconciled?: boolean | null, checkNumber?: string | null, masterAccountNumber?: string | null, paymentType?: { id: number, description?: string | null } | null, paymentStatus?: { id: number, description?: string | null } | null, howReceived?: { id: string, label: string } | null, ein: { id: number, name: string } }> } };

export type DailyPaymentTotalsQueryVariables = Exact<{
  dateReceived: Scalars['String']['input'];
  ein?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DailyPaymentTotalsQuery = { dailyPaymentTotals: { current: { cash: number, check: number, credit: number, eChecks: number, returnedChecks?: number | null, returnedEChecks?: number | null, total: number }, delinquent: { cash: number, check: number, credit: number, eChecks: number, returnedChecks?: number | null, returnedEChecks?: number | null, total: number }, dailyTotal: { cash: number, check: number, credit: number, eChecks: number, returnedChecks?: number | null, returnedEChecks?: number | null, total: number }, bankDeposit: { cashDeposit: number, checkDeposit: number, total: number }, returnedItems: { currentChecks: number, currentEChecks: number, delinquentChecks: number, delinquentEChecks: number } } };

export type CalculateInterestMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  dateReceived: Scalars['String']['input'];
}>;


export type CalculateInterestMutation = { calculateInterest: { interest: number } };

export type CreateReturnedPaymentMutationVariables = Exact<{
  payment: ReturnedPaymentInput;
}>;


export type CreateReturnedPaymentMutation = { createReturnedPayment: { accountNumber: string, businessName?: string | null, accountId: number, dateReturned: string, dateReceived: string, amount: number, ein: { id: number, name: string }, paymentType?: { id: number, description?: string | null } | null } };

export type CreateDelinquentReturnedPaymentMutationVariables = Exact<{
  payment: CreateDelinquentReturnedPaymentInput;
}>;


export type CreateDelinquentReturnedPaymentMutation = { createDelinquentReturnedPayment: { accountId: number, dateReturned: string, paymentId: number } };

export type GetDelinquentPaymentVoidQueryVariables = Exact<{
  receiptNumber: Scalars['String']['input'];
}>;


export type GetDelinquentPaymentVoidQuery = { delinquentPaymentVoid: { accountId: number, accountNumber: string, businessName: string, payment: { id: number, date: string, receiptNumber: number, receivedFrom: string, amount: number, checkNumber?: string | null, ein?: number | null, leftOverInterest: boolean, isAdjustment?: boolean | null, paymentType?: { id: number, description?: string | null } | null }, transactions: Array<{ id: number, amount: number, receiptNumber?: string | null, dateReceived?: string | null, ein?: number | null, directCharge: { id: number, description: string } }> } };

export type VoidDelinquentPaymentMutationVariables = Exact<{
  input: VoidDelinquentPaymentInput;
}>;


export type VoidDelinquentPaymentMutation = { voidDelinquentPayment: boolean };

export type GetDelqPaymentVoidSearchQueryVariables = Exact<{
  input: DelqPaymentVoidSearchInput;
}>;


export type GetDelqPaymentVoidSearchQuery = { delqPaymentVoidSearch: Array<{ delqAcctPaymentId: number, accountNbr: string, businessName: string, dateReceived: string, receiptNumber: number, paymentTypeDescr: string, checkNumber?: string | null, amount: number, receivedFrom: string, isAdjustment: boolean, masterAccountNbr?: string | null, ein: number }> };

export type GetSubAccountPaymentsQueryVariables = Exact<{
  filters: SearchPaymentInput;
}>;


export type GetSubAccountPaymentsQuery = { searchPayments: Array<{ id: number, accountId: number, accountNumber?: string | null, taxYear: number, receiptNumber: number, businessName?: string | null, paymentAmount: number, interestPaid?: number | null, interestAccrued?: number | null, penaltyAmount?: number | null, penaltyPaid?: number | null, receivedFrom: string, dateReceived: string, checkNumber?: string | null, paymentType?: { id: number, description?: string | null } | null, paymentStatus?: { id: number, description?: string | null } | null, howReceived?: { id: string, label: string } | null, ein: { id: number, name: string } }>, paymentTypes: Array<{ id: number, description?: string | null }>, paymentStatus: Array<{ id: number, description?: string | null }> };

export type GetReconciliationAccountInformationQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
}>;


export type GetReconciliationAccountInformationQuery = { reconciliationAccountInformation: { originalVersion?: { jurisdiction: number, taxYear: number, accountId: number, recordType: string, federalTaxId?: string | null, description?: string | null, registeredEntityName?: string | null, isHomeBusiness?: boolean | null, isAttached?: boolean | null, isReconciled?: boolean | null, yearOpened?: number | null, website?: string | null, taxDistrict?: string | null, parcelNumber?: string | null, currentYearPayments?: number | null, delinquentYearPayments?: number | null, accountType?: { id: string, label: string } | null, entityType?: { id: string, label: string } | null, sicCode?: { id: string, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string, isActive: boolean } | null, naicsCode?: { id: string, category: string, subCategory: string } | null, naicsCategory?: { id: string, category: string } | null, businessAppraiserRegion?: { id: string, groupingValue1: string, groupingValue2: string, regionName: string } | null, howFiled?: { id: string, label: string } | null, timeSpentFiling?: { id: string, label: string } | null } | null, taxPayerVersion: { jurisdiction: number, taxYear: number, accountId: number, recordType: string, federalTaxId?: string | null, description?: string | null, registeredEntityName?: string | null, isHomeBusiness?: boolean | null, isAttached?: boolean | null, isReconciled?: boolean | null, yearOpened?: number | null, website?: string | null, taxDistrict?: string | null, parcelNumber?: string | null, currentYearPayments?: number | null, delinquentYearPayments?: number | null, accountType?: { id: string, label: string } | null, entityType?: { id: string, label: string } | null, sicCode?: { id: string, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string, isActive: boolean } | null, naicsCode?: { id: string, category: string, subCategory: string } | null, naicsCategory?: { id: string, category: string } | null, businessAppraiserRegion?: { id: string, groupingValue1: string, groupingValue2: string, regionName: string } | null, howFiled?: { id: string, label: string } | null, timeSpentFiling?: { id: string, label: string } | null }, auditorVersion: { jurisdiction: number, taxYear: number, accountId: number, recordType: string, federalTaxId?: string | null, description?: string | null, registeredEntityName?: string | null, isHomeBusiness?: boolean | null, isAttached?: boolean | null, isReconciled?: boolean | null, yearOpened?: number | null, website?: string | null, taxDistrict?: string | null, parcelNumber?: string | null, currentYearPayments?: number | null, delinquentYearPayments?: number | null, accountType?: { id: string, label: string } | null, entityType?: { id: string, label: string } | null, sicCode?: { id: string, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string, isActive: boolean } | null, naicsCode?: { id: string, category: string, subCategory: string } | null, naicsCategory?: { id: string, category: string } | null, businessAppraiserRegion?: { id: string, groupingValue1: string, groupingValue2: string, regionName: string } | null, howFiled?: { id: string, label: string } | null, timeSpentFiling?: { id: string, label: string } | null } }, entityTypes: Array<{ id: string, label: string }>, howFiledList: Array<{ id: string, label: string }>, sicCodeMasters: Array<{ id: string, isActive: boolean, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string }>, getBusinessAppraiserRegionList?: Array<{ regionName: string, columnsNames: { groupingLabel1: string, groupingLabel2: string }, rows: Array<{ id: string, groupingValue1: string, groupingValue2: string, regionName: string }> }> | null, naicsCategories: Array<{ id: string, category: string }>, naicsCodes: Array<{ id: string, category: string, subCategory: string }> };

export type ReconcileAccountInformationMutationVariables = Exact<{
  account: ReconciliationAccountInformationInput;
}>;


export type ReconcileAccountInformationMutation = { reconcileAccountInformation: { jurisdiction: number, taxYear: number, accountId: number, recordType: string, federalTaxId?: string | null, description?: string | null, registeredEntityName?: string | null, isHomeBusiness?: boolean | null, isAttached?: boolean | null, isReconciled?: boolean | null, yearOpened?: number | null, website?: string | null, taxDistrict?: string | null, parcelNumber?: string | null, currentYearPayments?: number | null, delinquentYearPayments?: number | null, accountType?: { id: string, label: string } | null, entityType?: { id: string, label: string } | null, sicCode?: { id: string, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string, isActive: boolean } | null, naicsCode?: { id: string, category: string, subCategory: string } | null, naicsCategory?: { id: string, category: string } | null, businessAppraiserRegion?: { id: string, groupingValue1: string, groupingValue2: string, regionName: string } | null, howFiled?: { id: string, label: string } | null, timeSpentFiling?: { id: string, label: string } | null } };

export type GetReconciliationContactsQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
  accountIdString: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetReconciliationContactsQuery = { reconciliationContacts: Array<{ id: string, originalVersion?: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, isPrimary?: boolean | null, sameAsBusinessAddress?: boolean | null, contactType?: { id: string, label: string } | null, mailingAddress?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null } | null, taxPayerVersion?: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, isPrimary?: boolean | null, sameAsBusinessAddress?: boolean | null, contactType?: { id: string, label: string } | null, mailingAddress?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null } | null, auditorVersion?: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, isPrimary?: boolean | null, sameAsBusinessAddress?: boolean | null, contactType?: { id: string, label: string } | null, mailingAddress?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null } | null }>, getBusinessAccount?: { id: string, situsAddress: { addressLine1: string, addressLine2?: string | null, city: string, state: string, zipCode: string } } | null, countries: Array<{ code: string, name: string }>, contactTypes: Array<{ id: string, label: string }> };

export type ReconcileContactsMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  contacts: Array<ReconcileContactInput> | ReconcileContactInput;
}>;


export type ReconcileContactsMutation = { reconcileContacts: Array<{ id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, isPrimary?: boolean | null, sameAsBusinessAddress?: boolean | null, contactType?: { id: string, label: string } | null, mailingAddress?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null }> };

export type GetReconciliationAssetsQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
  accountIdString: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetReconciliationAssetsQuery = { reconciliationAssets: Array<{ id: string, originalVersion?: { id: string, classification?: string | null, classificationDescription?: string | null, costPer?: number | null, description?: string | null, percentGood?: number | null, quantity?: number | null, taxableValue?: number | null, yearAcquired?: number | null, isActive?: boolean | null } | null, taxPayerVersion?: { id: string, classification?: string | null, classificationDescription?: string | null, costPer?: number | null, description?: string | null, percentGood?: number | null, quantity?: number | null, taxableValue?: number | null, yearAcquired?: number | null, isActive?: boolean | null } | null, auditorVersion?: { id: string, classification?: string | null, classificationDescription?: string | null, costPer?: number | null, description?: string | null, percentGood?: number | null, quantity?: number | null, taxableValue?: number | null, yearAcquired?: number | null, isActive?: boolean | null } | null }>, getClassifications: Array<{ id: string, clsf?: string | null, scheduleId?: number | null, description?: string | null }>, getTaxRate: { id: string, taxRate?: number | null }, getBusinessAccount?: { id: string, filingStatus: { hasExemption: boolean } } | null };

export type ReconcileAssetsMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  assets: Array<AssetInput> | AssetInput;
}>;


export type ReconcileAssetsMutation = { reconcileAssets: Array<{ id: string, classification?: string | null, classificationDescription?: string | null, costPer?: number | null, description?: string | null, percentGood?: number | null, quantity?: number | null, taxableValue?: number | null, yearAcquired?: number | null }> };

export type SkipAssetReconciliationMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
}>;


export type SkipAssetReconciliationMutation = { skipAssetReconciliation: boolean };

export type GetReconciliationLessorsQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
}>;


export type GetReconciliationLessorsQuery = { reconciliationLessors: Array<{ id: string, originalVersion?: { id?: string | null, contactLinkId?: string | null, name?: string | null, contactType?: { id: string, label: string } | null, address?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null } | null, taxPayerVersion?: { id?: string | null, contactLinkId?: string | null, name?: string | null, contactType?: { id: string, label: string } | null, address?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null } | null, auditorVersion?: { id?: string | null, contactLinkId?: string | null, name?: string | null, contactType?: { id: string, label: string } | null, address?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null } | null, leasedAssets: Array<{ id: string, originalVersion?: { id: string, leaseId?: string | null, leaseAccountId?: string | null, leaseNumber?: string | null, contactLinkId?: string | null, description?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, annualLeaseAmount?: number | null, initialValue?: number | null, leaseStartDate?: string | null, leaseEndDate?: string | null, fileUrl?: string | null, fileName?: string | null, blobName?: string | null, isActive?: boolean | null } | null, taxPayerVersion?: { id: string, leaseId?: string | null, leaseAccountId?: string | null, leaseNumber?: string | null, contactLinkId?: string | null, description?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, annualLeaseAmount?: number | null, initialValue?: number | null, leaseStartDate?: string | null, leaseEndDate?: string | null, fileUrl?: string | null, fileName?: string | null, blobName?: string | null, isActive?: boolean | null } | null, auditorVersion?: { id: string, leaseId?: string | null, leaseAccountId?: string | null, leaseNumber?: string | null, contactLinkId?: string | null, description?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, annualLeaseAmount?: number | null, initialValue?: number | null, leaseStartDate?: string | null, leaseEndDate?: string | null, fileUrl?: string | null, fileName?: string | null, blobName?: string | null, isActive?: boolean | null } | null }> }> };

export type ReconcileLessorsMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  lessors: Array<LessorInput> | LessorInput;
}>;


export type ReconcileLessorsMutation = { reconcileLessors: Array<{ id?: string | null, contactLinkId?: string | null, name?: string | null, contactType?: { id: string, label: string } | null, address?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null, assets?: Array<{ id: string, leaseId?: string | null, leaseAccountId?: string | null, leaseNumber?: string | null, contactLinkId?: string | null, description?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, annualLeaseAmount?: number | null, initialValue?: number | null, leaseStartDate?: string | null, leaseEndDate?: string | null, fileUrl?: string | null, fileName?: string | null, blobName?: string | null }> | null }> };

export type SkipLessorReconciliationMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
}>;


export type SkipLessorReconciliationMutation = { skipLessorReconciliation: boolean };

export type GetReconciliationFilingSummaryQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
}>;


export type GetReconciliationFilingSummaryQuery = { reconciliationSummary: { originalVersion?: { totalDirectCharge: number, totalTaxableValue: number, netAssessmentCharge: number, penalty: number, interest: number, delinquentTax: number, payments: number, balance: number, note?: string | null, isExempt?: boolean | null, applyPenalty?: boolean | null, contact?: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null } | null, howFiled?: { id: string, label: string } | null, timeSpentFiling?: { id: string, label: string } | null } | null, taxPayerVersion: { totalDirectCharge: number, totalTaxableValue: number, netAssessmentCharge: number, penalty: number, interest: number, delinquentTax: number, payments: number, balance: number, note?: string | null, isExempt?: boolean | null, applyPenalty?: boolean | null, contact?: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null } | null, howFiled?: { id: string, label: string } | null, timeSpentFiling?: { id: string, label: string } | null }, auditorVersion: { totalDirectCharge: number, totalTaxableValue: number, netAssessmentCharge: number, penalty: number, interest: number, delinquentTax: number, payments: number, balance: number, note?: string | null, isExempt?: boolean | null, applyPenalty?: boolean | null, contact?: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null } | null, howFiled?: { id: string, label: string } | null, timeSpentFiling?: { id: string, label: string } | null } }, timeSpentFiling: Array<{ id: string, label: string }>, howFiledList: Array<{ id: string, label: string }> };

export type ReconcileFilingSummaryMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  filingSummary: FilingSummaryInput;
}>;


export type ReconcileFilingSummaryMutation = { reconcileSummary: { totalDirectCharge: number, totalTaxableValue: number, netAssessmentCharge: number, penalty: number, interest: number, delinquentTax: number, payments: number, balance: number, note?: string | null, contact?: { id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null } | null, howFiled?: { id: string, label: string } | null, timeSpentFiling?: { id: string, label: string } | null } };

export type CompleteReconciliationMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
}>;


export type CompleteReconciliationMutation = { completeReconciliation: boolean };

export type SearchRefundsQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchRefundsQuery = { searchRefunds: Array<{ year: number, accountId?: number | null, leaseMasterId?: number | null, accountNumber: string, taxArea: string, businessName: string, accountType: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, careOf?: string | null, mailingName?: string | null, balance: number, isActive: boolean, isExempt: boolean, isReconciled: boolean, paymentsReceived: number, isSpecial: boolean }> };

export type GetSpecialRefundQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
  isLeaseMaster: Scalars['Boolean']['input'];
}>;


export type GetSpecialRefundQuery = { getSpecialRefund: { year: number, accountId?: number | null, leaseMasterId?: number | null, accountNumber: string, taxArea: string, businessName: string, accountType: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, careOf?: string | null, mailingName?: string | null, balance: number, isActive: boolean, isExempt: boolean, isReconciled: boolean, paymentsReceived: number, isSpecial: boolean } };

export type GetRefundBatchQueryVariables = Exact<{
  refundBatchId: Scalars['Int']['input'];
}>;


export type GetRefundBatchQuery = { getRefundBatch: { id: number, batchStatusId: number, batchStatus: string, createdDate: string, updatedDate: string, canBeEdited: boolean, canBeDeleted: boolean, canBePaid: boolean, processedDate?: string | null, refunds: Array<{ id: number, year: number, accountId?: number | null, leaseMasterId?: number | null, accountNumber: string, taxArea: string, businessName: string, accountType: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, careOf?: string | null, mailingName?: string | null, balance: number, isActive: boolean, isExempt: boolean, isReconciled: boolean, paymentsReceived: number, isSpecial: boolean, refundReason: string, refundReasonId: number, notes?: string | null }> } };

export type SearchBatchesQueryVariables = Exact<{
  searchBatchInput: SearchBatchInput;
}>;


export type SearchBatchesQuery = { searchBatches: Array<{ id: number, batchStatusId: number, batchStatus: string, createdDate: string, updatedDate: string, processedDate?: string | null, refundsCount: number, canBeEdited: boolean, canBeDeleted: boolean, canBePaid: boolean }> };

export type GetBatchStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBatchStatusesQuery = { getBatchStatuses: Array<{ id: number, name: string }> };

export type GetRefundReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRefundReasonsQuery = { getRefundReasons: Array<{ id: number, name: string }> };

export type CreateBatchMutationVariables = Exact<{
  createBatchInput: CreateBatchInput;
}>;


export type CreateBatchMutation = { createBatch: { id: number } };

export type DeleteBatchMutationVariables = Exact<{
  batchId: Scalars['Int']['input'];
}>;


export type DeleteBatchMutation = { deleteBatch: boolean };

export type UpdateBatchMutationVariables = Exact<{
  batchId: Scalars['Int']['input'];
  updateBatchInput: UpdateBatchInput;
}>;


export type UpdateBatchMutation = { updateBatch: boolean };

export type SendBatchToTreasurerMutationVariables = Exact<{
  batchId: Scalars['Int']['input'];
}>;


export type SendBatchToTreasurerMutation = { sendBatchToTreasurer: boolean };

export type SetBatchToPaidMutationVariables = Exact<{
  batchId: Scalars['Int']['input'];
}>;


export type SetBatchToPaidMutation = { setBatchToPaid: boolean };

export type ExportToCsvMutationVariables = Exact<{
  batchId: Scalars['Int']['input'];
}>;


export type ExportToCsvMutation = { exportToCsv: { fileContent: string, fileName: string } };

export type GetRentalHomeOccOverExemptReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetRentalHomeOccOverExemptReportQuery = { rentalHomeOccOverExemptNotFiledReport: Array<{ id: number, accountNbr: string, taxYear: number, businessName: string, acctTypeId: number, acctTypeDescr: string, isReconciled: boolean, isExempt: boolean, totalTaxable: number, netAssmntChargeWithTotalDirect: number, penalty: number, payments: number, yearEndBalance: number, associatedAccounts: string }> };

export type GetIsAttachedReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetIsAttachedReportQuery = { isAttachedReport: Array<{ id: number, accountNbr: string, acctTypeDescr: string, acctTypeId: number, balance: number, businessName: string, parcelId?: string | null, taxYear: number, totalTaxable: number }> };

export type GetCyDeletedWithPaymentReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetCyDeletedWithPaymentReportQuery = { cyDeletedWithPaymentReport: Array<{ id: number, accountNbr: string, amount: number, balance: number, acctTypeDescr: string, acctTypeId: number, taxYear: number }> };

export type GetRentalsTwentyOrLessUnitsReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetRentalsTwentyOrLessUnitsReportQuery = { rentalsTwentyOrLessUnitsReport: Array<{ id: number, accountNbr: string, taxYear: number, businessName: string, acctTypeId: number, acctTypeDescr: string, isReconciled: boolean, isExempt: boolean, totalTaxable: number, netAssmntChargeWithTotalDirect: number, penalty: number, payments: number, yearEndBalance: number, associatedAccounts: string }> };

export type GetExistingBusinessNotExemptBelowThresholdReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetExistingBusinessNotExemptBelowThresholdReportQuery = { existingBusinessNotExemptBelowThresholdReport: Array<{ id: number, accountNbr: string, taxYear: number, businessName: string, acctTypeId: number, acctTypeDescr: string, isReconciled: boolean, isExempt: boolean, totalTaxable: number, netAssmntChargeWithTotalDirect: number, penalty: number, payments: number, yearEndBalance: number, associatedAccounts: string }> };

export type GetDuplicatedAssociatedBusinessAccountsReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetDuplicatedAssociatedBusinessAccountsReportQuery = { duplicatedAssociatedBusinessAccountsReport: Array<{ id: number, accountNbr: string, taxYear: number, businessName: string, acctTypeId: number, acctTypeDescr: string }> };

export type GetExistingBusinessNotFiledLessThanExemptReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetExistingBusinessNotFiledLessThanExemptReportQuery = { existingBusinessNotFiledLessThanExemptReport: Array<{ id: number, accountNbr: string, acctTypeDescr: string, acctTypeId: number, businessName: string, taxYear: number, totalTaxable: number, taxDistrict: string, taxRate: number, appraiserRegion?: string | null, netAssmntCharge: number }> };

export type GetAccountBalanceReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountBalanceReportQuery = { accountBalanceReport: { reportDate?: string | null, accountDetails: Array<{ id: number, accountNbr?: string | null, acctJurisdiction?: number | null, acctTaxYear?: number | null, acctType?: string | null, businessName?: string | null, mailingName?: string | null, mailingCareOf?: string | null, mailingAddress1?: string | null, mailingAddress2?: string | null, mailingCity?: string | null, mailingState?: string | null, mailingZip?: string | null, situsName?: string | null, situsCareOf?: string | null, situsAddress1?: string | null, situsAddress2?: string | null, situsCity?: string | null, situsState?: string | null, situsZip?: string | null, penalty?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null }> } };

export type GetBalanceDueReasonsListQueryVariables = Exact<{
  isTelecom: Scalars['Boolean']['input'];
}>;


export type GetBalanceDueReasonsListQuery = { balanceDueReasonsList: Array<{ id: number, reason: string }> };

export type GetAccountsWithCreditBalanceReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetAccountsWithCreditBalanceReportQuery = { accountsWithCreditBalanceReport: Array<{ id: number, accountNbr: string, taxYear: number, businessName: string, acctTypeId: number, acctTypeDescr: string, yearEndBalance: string, isExempt: boolean }> };

export type GetCurrentYearDeletedWithDelinqBalanceReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetCurrentYearDeletedWithDelinqBalanceReportQuery = { currentYearDeletedWithDelinqBalanceReport: Array<{ id: number, accountNbr: string, taxYear: number, businessName?: string | null, acctTypeId: number, acctTypeDescr: string, amount: number, leaseMasterAccountNbr?: string | null, telecomAccountNbr?: string | null }> };

export type GetAccountsWithPriorYearCreditChargeReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetAccountsWithPriorYearCreditChargeReportQuery = { accountsWithPriorYearCreditChargeReport: Array<{ id: number, accountNbr: string, taxYear: number, businessName: string, acctTypeId: number, acctTypeDescr: string, directChargeAmount: number }> };

export type GetNegativeRefundChargesReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetNegativeRefundChargesReportQuery = { negativeRefundChargesReport: Array<{ id: number, accountNbr: string, leaseMasterAccountNbr?: string | null, telecomAccountNbr?: string | null, taxYear: number, businessName?: string | null, acctTypeId: number, acctTypeDescr: string, amount: number, comment?: string | null }> };

export type GetHomeOccupationalNonTaxableAccountsReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetHomeOccupationalNonTaxableAccountsReportQuery = { homeOccupationalNonTaxableAccountsReport: Array<{ id: number, accountNbr: string, taxYear: number, businessName: string, acctTypeId: number, acctTypeDescr: string, isReconciled: boolean, isExempt: boolean, totalTaxable: number, netAssmntChargeWithTotalDirect: number, penalty: number, payments: number, yearEndBalance: number, associatedAccounts: string, howReceived: number }> };

export type GetLmTaxDistrictAcctCheckReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetLmTaxDistrictAcctCheckReportQuery = { lmTaxDistrictAcctCheckReport: Array<{ id: number, subAccountNbr: string, saTaxDistrict: string, accountNbr: string, baTaxDistrict: string, acctTypeId: number, acctTypeDescr: string, totalTaxable: number, leaseMasterAcctNbr: string }> };

export type GetCyDeletedWithDelinquentPaymentReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetCyDeletedWithDelinquentPaymentReportQuery = { cyDeletedWithDelinquentPaymentReport: Array<{ id: number, accountNbr: string, leaseMasterAccountNbr?: string | null, telecomAccountNbr?: string | null, taxYear: number, acctTypeId: number, acctTypeDescr: string, amount: number, balance: number }> };

export type GetNewBizAcctsNotFiledOrExemptWithNoValueReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetNewBizAcctsNotFiledOrExemptWithNoValueReportQuery = { newBizAcctsNotFiledOrExemptWithNoValueReport: Array<{ id: number, accountNbr: string, taxYear: number, businessName: string, acctTypeId: number, acctTypeDescr: string }> };

export type GetAccountsToOneYearExemptReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetAccountsToOneYearExemptReportQuery = { accountsToOneYearExemptReport: Array<{ id: number, accountNbr: string, taxYear: number, businessName: string, acctTypeId: number, acctTypeDescr: string }> };

export type GetExemptAccountsWithNoFlagReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetExemptAccountsWithNoFlagReportQuery = { exemptAccountsWithNoFlagReport: Array<{ id: number, accountNbr: string, taxYear: number, businessName: string, acctTypeId: number, acctTypeDescr: string }> };

export type GetAccountsWithMissingTaxRateReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetAccountsWithMissingTaxRateReportQuery = { accountsWithMissingTaxRateReport: Array<{ id: number, accountNbr: string, taxYear: number, businessName: string, acctTypeId: number, acctTypeDescr: string, taxDistrict: string }> };

export type GetAccountsWithInvalidTaxAreaReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetAccountsWithInvalidTaxAreaReportQuery = { accountsWithInvalidTaxAreaReport: Array<{ id: number, accountNbr?: string | null, taxYear?: number | null, businessName?: string | null, acctTypeId?: number | null, acctTypeDescr?: string | null, taxDistrict?: string | null, exempt?: boolean | null, active?: boolean | null, leaseMasterAccountNbr?: string | null, recordType?: string | null }> };

export type GetTelecomSubAccountNameMismatchReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetTelecomSubAccountNameMismatchReportQuery = { telecomSubAccountNameMismatchReport: Array<{ id: number, telecomAccountNbr?: string | null, subAccountNbr?: string | null, taxDistrict?: string | null, subAccountBusinessName?: string | null, telecomBusinessName?: string | null, isReconciled?: string | null, recordType?: string | null }> };

export type GetLeaseMasterAccountWithoutSubAccountsReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetLeaseMasterAccountWithoutSubAccountsReportQuery = { leaseMasterAccountWithoutSubAccountsReport: Array<{ id: number, leaseMasterAccountNbr: string, subAccountCount: number }> };

export type GetCurrentYearRollingToDelinquentTablesQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetCurrentYearRollingToDelinquentTablesQuery = { currentYearRollingToDelinquentTables: Array<{ id: number, accountNbr: string, taxYear: number, businessName?: string | null, acctTypeId: number, acctTypeDescr: string, amount: number, howReceived?: string | null, isReconciled?: boolean | null, leaseMasterAccountNbr?: string | null, telecomAccountNbr?: string | null }> };

export type GetOneYearExemptStatusReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetOneYearExemptStatusReportQuery = { oneYearExemptStatusReport: Array<{ id: number, accountNbr: string, taxYear: number, businessName: string, acctTypeId: number, acctTypeDescr: string, isReconciled: boolean, isExempt: boolean, totalTaxable: number, netAssmntChargeWithTotalDirect: number, penalty: number, payments: number, yearEndBalance: number, associatedAccounts: string }> };

export type GetEstimatedValuesReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetEstimatedValuesReportQuery = { estimatedValuesReport: Array<{ id: number, accountNbr: string, taxYear: number, businessName: string, acctTypeId: number, acctTypeDescr: string, isReconciled: boolean, isExempt: boolean, totalTaxable: number, totalEstimatedValue: number, sicCode: string, sicCodeDescription: string }> };

export type GetLeaseMasterAccountsWithBalanceReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetLeaseMasterAccountsWithBalanceReportQuery = { leaseMasterAccountsWithBalanceReport: Array<{ id: number, subAccountNbr: string, leaseMasterAccountNbr: string, subAccountBalance: number, lmActive: boolean, lmExempt: boolean, lmHowFiled: string }> };

export type GetLeaseMasterOneYearExemptReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetLeaseMasterOneYearExemptReportQuery = { leaseMasterOneYearExemptReport: Array<{ id: number, accountNbr: string, businessName: string, acctTypeId: number, acctTypeDescr: string, isExempt: boolean, totalDirect: number, payments: number, netAssmntCharge: number, penalty: number, yearEndBalance: number }> };

export type GetAccWithDirChargeDelTaxReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetAccWithDirChargeDelTaxReportQuery = { accWithDirChargeDelTaxReport: Array<{ id: number, accountNbr: string, taxYear: number, businessName: string, acctTypeId: number, acctTypeDescr: string, directChargeAmount: number }> };

export type GetNewBusinessNotreconciledReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetNewBusinessNotreconciledReportQuery = { newBusinessNotReconciledReport: Array<{ id: number, taxYear: number, accountNbr: string, businessName: string, acctTypeId: number, acctTypeDescr: string }> };

export type GetCountOfAccountsByAcctTypeReportQueryVariables = Exact<{
  priorTaxYear: Scalars['Int']['input'];
  currentTaxYear: Scalars['Int']['input'];
}>;


export type GetCountOfAccountsByAcctTypeReportQuery = { countOfAccountsByAcctTypeReport: Array<{ id: number, acctTypeId: number, acctTypeDescr: string, priorYear: number, currentYear: number, notes: string }> };

export type GetPriorYearRolledToDelinquentReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;


export type GetPriorYearRolledToDelinquentReportQuery = { pyRolledToDelinquentTablesReport: Array<{ id: number, accountNbr: string, taxYear: number, businessName?: string | null, acctTypeId: number, acctTypeDescr: string, amount: number, howReceived?: string | null, isReconciled?: boolean | null, leaseMasterAccountNbr?: string | null, telecomAccountNbr?: string | null }> };

export type GetIronCountyTaxableValueReportQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetIronCountyTaxableValueReportQuery = { ironCountyTaxableValueReport: Array<{ id: number, account: string, description: string, taxableValue: number, propertyCode?: string | null, quantity: number, yearAcquired: number }> };

export type GetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesQuery = { getRoles: Array<{ id: string, name: string, description: string, permissions: Array<{ id: string, name: string }> }> };

export type GetPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPermissionsQuery = { getPermissions: Array<{ id: string, name: string }> };

export type GetRoleQueryVariables = Exact<{
  roleId: Scalars['Int']['input'];
}>;


export type GetRoleQuery = { getRole: { id: string, name: string, description: string, permissions: Array<{ id: string, name: string }> } };

export type GetRolesFromUserQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetRolesFromUserQuery = { getRolesFromUser: Array<{ id: string, name: string, description: string, permissions: Array<{ id: string, name: string }> }> };

export type DeleteRoleMutationVariables = Exact<{
  roleId: Scalars['Int']['input'];
}>;


export type DeleteRoleMutation = { deleteRole: boolean };

export type AddRoleToUserMutationVariables = Exact<{
  roleId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
}>;


export type AddRoleToUserMutation = { addRoleToUser: boolean };

export type RemoveRoleFromUserMutationVariables = Exact<{
  roleId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
}>;


export type RemoveRoleFromUserMutation = { removeRoleFromUser: boolean };

export type UpdateRoleMutationVariables = Exact<{
  roleId: Scalars['Int']['input'];
  role: RoleInput;
}>;


export type UpdateRoleMutation = { updateRole: boolean };

export type SaveRoleMutationVariables = Exact<{
  role: RoleInput;
}>;


export type SaveRoleMutation = { saveRole: boolean };

export type GetReconciliationContextQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
}>;


export type GetReconciliationContextQuery = { reconciliationContext: { taxYear: number, accountId: number, accountNumber: string, businessName: string, completedSteps: Array<string>, fullName: string, buildingPermitExists?: boolean | null } };

export type GetSicCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSicCodesQuery = { sicCodes: Array<{ code: string, description: string, isActive: boolean }> };

export type GetSicCodeMastersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSicCodeMastersQuery = { sicCodeMasters: Array<{ id: string, isActive: boolean, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string }> };

export type GetAllCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCodesQuery = { allCodes: { sicCodes: Array<{ code: string, description: string, isActive: boolean }>, sicSiloCodes: Array<{ code: string, description: string, isActive: boolean }>, subSiloCodes: Array<{ code: string, description: string, isActive: boolean }> } };

export type GetSicSiloCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSicSiloCodesQuery = { sicSiloCodes: Array<{ code: string, description: string, isActive: boolean }> };

export type GetSubSiloCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubSiloCodesQuery = { subSiloCodes: Array<{ code: string, description: string, isActive: boolean }> };

export type SaveSicCodesMutationVariables = Exact<{
  sicCodes: Array<CodeRowInput> | CodeRowInput;
}>;


export type SaveSicCodesMutation = { saveSicCodes: Array<{ code: string, description: string, isActive: boolean }> };

export type SaveSicSiloCodesMutationVariables = Exact<{
  sicSiloCodes: Array<CodeRowInput> | CodeRowInput;
}>;


export type SaveSicSiloCodesMutation = { saveSicSiloCodes: Array<{ code: string, description: string, isActive: boolean }> };

export type SaveSubSiloCodesMutationVariables = Exact<{
  subSiloCodes: Array<CodeRowInput> | CodeRowInput;
}>;


export type SaveSubSiloCodesMutation = { saveSubSiloCodes: Array<{ code: string, description: string, isActive: boolean }> };

export type SaveSicCodeMastersMutationVariables = Exact<{
  sicCodeMasters: Array<CodeRowMasterInput> | CodeRowMasterInput;
}>;


export type SaveSicCodeMastersMutation = { saveSicCodeMasters: Array<{ id: string, isActive: boolean, sicCode: string, sicSiloCode: string, subSiloCode: string }> };

export type GetSimiliarBusinessesQueryVariables = Exact<{
  similarBusinessSearchInput: SimilarBusinessSearchInput;
}>;


export type GetSimiliarBusinessesQuery = { similarBusinesses: Array<{ accountNumber: string, businessName: string, similarAddress: string }> };

export type GetSimilarBusinessesLeaseMasterQueryVariables = Exact<{
  similarBusinessSearchLeaseMasterInput: SimilarBusinessSearchLeaseMasterInput;
}>;


export type GetSimilarBusinessesLeaseMasterQuery = { similarBusinessesLeaseMaster: Array<{ accountNumber: string, name: string }> };

export type GetSimilarTelecomBusinessesQueryVariables = Exact<{
  similarTelecomBusinessInput: SimilarTelecomBusinessInput;
}>;


export type GetSimilarTelecomBusinessesQuery = { similarTelecomBusinesses: Array<{ name: string, accountNumber: string }> };

export type GetSubAccountSummaryQueryVariables = Exact<{
  leaseMasterId: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetSubAccountSummaryQuery = { getSubAccountSummary: Array<{ accountId: string, accountNumber: string, jurisdictionId: number, leaseMasterId: number, taxYear: number, recordType: string, taxDistrict: string, locationCount: number, totalAssetCount: number, bafInActiveAccountsCount: number, invalidTaxDistrictCount: number, isExempt: boolean, isActive: boolean, accountSummary: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, penaltyCharge?: number | null, payments?: number | null, interest?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null } }> };

export type GetSubAccountByLeaseMasterIdSubAccountIdQueryVariables = Exact<{
  leaseMasterId: Scalars['ID']['input'];
  subAccountId: Scalars['ID']['input'];
}>;


export type GetSubAccountByLeaseMasterIdSubAccountIdQuery = { getSubAccountByLeaseMasterIdSubAccountId: { accountId: string, accountNumber: string, taxDistrict: string, jurisdictionId: number, recordType: string, taxYear: number, leaseMasterId: number, locationCount: number, totalAssetCount: number, bafInActiveAccountsCount: number, invalidTaxDistrictCount: number, isExempt: boolean, isActive: boolean, accountSummary: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, penaltyCharge?: number | null, payments?: number | null, interest?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null, totalBalanceWithDelinquent?: number | null } } };

export type CreateSubAccountTaxDistrictMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  taxDistrict: Scalars['String']['input'];
}>;


export type CreateSubAccountTaxDistrictMutation = { createSubAccountTaxDistrict: { accountId: string, accountNumber: string, taxDistrict: string, locationCount: number, totalAssetCount: number, isExempt: boolean, isActive: boolean, accountSummary: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, penaltyCharge?: number | null, payments?: number | null, interest?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null, totalBalanceWithDelinquent?: number | null } } };

export type UpdateSubAccountTaxDistrictMutationVariables = Exact<{
  subAccountTaxDistrict: SubAccountTaxDistrictInput;
}>;


export type UpdateSubAccountTaxDistrictMutation = { updateSubAccountTaxDistrict: { accountId: string, accountNumber: string, taxDistrict: string, locationCount: number, totalAssetCount: number, isExempt: boolean, isActive: boolean, accountSummary: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, penaltyCharge?: number | null, payments?: number | null, interest?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null, totalBalanceWithDelinquent?: number | null } } };

export type SubAccountSearchQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
  taxYear?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SubAccountSearchQuery = { subAccountSearch: { totalCount: number, result?: { kind: SubAccountKind, accountNumber: string, businessName: string, leaseMasterAccountNumber?: string | null, telecomAccountNumber?: string | null, taxArea?: string | null } | null } };

export type GetTaxAreaListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxAreaListQuery = { taxAreaList: Array<{ taxArea: string, taxSubArea: Array<string> }> };

export type TelecomSearchAccountsQueryVariables = Exact<{
  filters?: InputMaybe<TelecomSearchFilters>;
}>;


export type TelecomSearchAccountsQuery = { telecomSearchAccounts?: { totalRecordCount: number, results?: Array<{ id: string, accountNumber: string, businessName: string, isActive: boolean, status: string, isReconciled: boolean }> | null } | null };

export type GetTelecomSubAccountsQueryVariables = Exact<{
  telecomMasterId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetTelecomSubAccountsQuery = { telecomSubAccounts: Array<{ accountId?: number | null, accountNumber?: string | null, jurisdictionId: number, taxDistrict: string, totalAssetCount?: number | null, invalidTaxDistrictCount?: number | null, applyPenalty: boolean, isExempt: boolean, isActive: boolean, accountSummary: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, penaltyCharge?: number | null, payments?: number | null, interest?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null, totalBalanceWithDelinquent?: number | null } }> };

export type GetTelecomSubAccountQueryVariables = Exact<{
  telecomMasterId: Scalars['Int']['input'];
  accountId: Scalars['Int']['input'];
}>;


export type GetTelecomSubAccountQuery = { telecomSubAccount: { accountId?: number | null, accountNumber?: string | null, jurisdictionId: number, taxDistrict: string, totalAssetCount?: number | null, invalidTaxDistrictCount?: number | null, applyPenalty: boolean, isExempt: boolean, isActive: boolean, accountSummary: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, penaltyCharge?: number | null, payments?: number | null, interest?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null, totalBalanceWithDelinquent?: number | null } } };

export type CreateTelecomSubAccountMutationVariables = Exact<{
  telecomMasterId: Scalars['Int']['input'];
  taxDistrict: Scalars['String']['input'];
}>;


export type CreateTelecomSubAccountMutation = { createTelecomSubAccount: { accountId?: number | null, accountNumber?: string | null, jurisdictionId: number, taxDistrict: string, totalAssetCount?: number | null, invalidTaxDistrictCount?: number | null, applyPenalty: boolean, isExempt: boolean, isActive: boolean, accountSummary: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, penaltyCharge?: number | null, payments?: number | null, interest?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null, totalBalanceWithDelinquent?: number | null } } };

export type SaveTelecomSubAccountMutationVariables = Exact<{
  input: SaveTelecomSubAccountInput;
}>;


export type SaveTelecomSubAccountMutation = { saveTelecomSubAccount: { accountId?: number | null, accountNumber?: string | null, jurisdictionId: number, taxDistrict: string, totalAssetCount?: number | null, invalidTaxDistrictCount?: number | null, applyPenalty: boolean, isExempt: boolean, isActive: boolean, accountSummary: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, penaltyCharge?: number | null, payments?: number | null, interest?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null, totalBalanceWithDelinquent?: number | null } } };

export type ChangeMcatTelecomTaxAreaStatusMutationVariables = Exact<{
  input: ChangeMcatTelecomTaxAreaStatusInput;
}>;


export type ChangeMcatTelecomTaxAreaStatusMutation = { changeMCATTelecomTaxAreaStatus: boolean };

export type GetTelecomMcatAreasQueryVariables = Exact<{
  params: TelecomMcatAreaParams;
}>;


export type GetTelecomMcatAreasQuery = { telecomMcatAreas: { telecomMasterId: number, taxYear: number, isActive: boolean, isExempt: boolean, applyPenalty: boolean, jurisdiction: { id: string, name: string }, accountSummary: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, penaltyCharge?: number | null, payments?: number | null, interest?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null, totalBalanceWithDelinquent?: number | null }, subAccounts: Array<{ accountId?: number | null, accountNumber?: string | null, jurisdictionId: number, taxDistrict: string, applyPenalty: boolean, isExempt: boolean, isActive: boolean, accountSummary: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, penaltyCharge?: number | null, payments?: number | null, interest?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null, totalBalanceWithDelinquent?: number | null } }> } };

export type GetTelecomMcatSubAccountQueryVariables = Exact<{
  params: TelecomMcatSubAccountParams;
}>;


export type GetTelecomMcatSubAccountQuery = { telecomMcatSubAccount: { accountId?: number | null, accountNumber?: string | null, jurisdictionId: number, taxDistrict: string, applyPenalty: boolean, isExempt: boolean, isActive: boolean, accountSummary: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, penaltyCharge?: number | null, payments?: number | null, interest?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null, totalBalanceWithDelinquent?: number | null } } };

export type TelecomStatsSupportPhoneQueryVariables = Exact<{ [key: string]: never; }>;


export type TelecomStatsSupportPhoneQuery = { telecomStatsSupportPhone?: string | null };

export type CreateTelecomAccountMutationVariables = Exact<{
  input: CreateTelecomBusinessAccountInput;
}>;


export type CreateTelecomAccountMutation = { createTelecomAccount?: { id: string, accountNumber: string, businessName: string, registeredEntityName?: string | null, description?: string | null, ein?: string | null, applyPenalty: boolean, isActive: boolean, isDisabled: boolean, sicCode?: { id: string } | null, lastModified: { username?: string | null, lastChanged?: string | null }, reconciliation: { reconciledDate?: string | null, reconciledBy?: { email: string, fullName: string, id: number, isActive: boolean, isVerified: boolean, username: string } | null }, filingStatus: { filingYear?: number | null, dateReceived?: string | null, hasExemption?: boolean | null, howFiled?: { id: string, label: string } | null, howReceived?: { id: string, label: string } | null }, bankruptcy: { bankruptcyType?: { id: string, label: string } | null }, audit: { auditYear?: number | null }, businessAccountType?: { id: string, label: string } | null, accountSummary?: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, payments?: number | null, penaltyCharge?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null } | null } | null };

export type GetTelecomSubAccountAssetsQueryVariables = Exact<{
  telecomMasterId: Scalars['Int']['input'];
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetTelecomSubAccountAssetsQuery = { telecomSubAccountAssets: Array<{ id: string, classification?: string | null, classificationDescription?: string | null, description?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, percentGood?: number | null, taxableValue?: number | null, ein?: number | null, updateDate?: string | null, isActive?: boolean | null }>, getClassifications: Array<{ id: string, clsf?: string | null, scheduleId?: number | null, description?: string | null }>, getTaxRate: { id: string, taxRate?: number | null } };

export type SaveTelecomSubAccountAssetsMutationVariables = Exact<{
  telecomMasterId: Scalars['Int']['input'];
  accountId: Scalars['Int']['input'];
  assets: Array<AssetInput> | AssetInput;
}>;


export type SaveTelecomSubAccountAssetsMutation = { saveTelecomSubAccountAssets: Array<{ id: string, classification?: string | null, classificationDescription?: string | null, description?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, percentGood?: number | null, taxableValue?: number | null, ein?: number | null, updateDate?: string | null, isActive?: boolean | null }> };

export type GetTelecomSubAccountLessorsQueryVariables = Exact<{
  telecomMasterId: Scalars['Int']['input'];
  accountId: Scalars['Int']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetTelecomSubAccountLessorsQuery = { telecomSubAccountLessors: Array<{ id?: string | null, name?: string | null, contactLinkId?: string | null, contactType?: { id: string, label: string } | null, address?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, phone?: string | null, phoneExtension?: string | null } | null, assets?: Array<{ id: string, leaseId?: string | null, leaseAccountId?: string | null, leaseNumber?: string | null, contactLinkId?: string | null, description?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, annualLeaseAmount?: number | null, initialValue?: number | null, leaseStartDate?: string | null, leaseEndDate?: string | null, fileUrl?: string | null, fileName?: string | null, blobName?: string | null, isActive?: boolean | null }> | null }> };

export type SaveTelecomSubAccountLessorsMutationVariables = Exact<{
  telecomMasterId: Scalars['Int']['input'];
  accountId: Scalars['Int']['input'];
  lessor: LessorInput;
}>;


export type SaveTelecomSubAccountLessorsMutation = { saveTelecomSubAccountLessor: { id?: string | null, name?: string | null, contactLinkId?: string | null, contactType?: { id: string, label: string } | null, address?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, phone?: string | null, phoneExtension?: string | null } | null, assets?: Array<{ id: string, leaseId?: string | null, leaseAccountId?: string | null, leaseNumber?: string | null, contactLinkId?: string | null, description?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, annualLeaseAmount?: number | null, initialValue?: number | null, leaseStartDate?: string | null, leaseEndDate?: string | null, fileUrl?: string | null, fileName?: string | null, blobName?: string | null, isActive?: boolean | null }> | null } };

export type GetTelecomMcatAssetsQueryVariables = Exact<{
  params: TelecomMcatAssetsInput;
}>;


export type GetTelecomMcatAssetsQuery = { telecomMcatAssets: Array<{ id: string, description?: string | null, yearAcquired?: number | null, quantity: number, costPer: number, percentGood: number, taxableValue: number, taxRate?: number | null, netAsmtCharge?: number | null, telecomMasterId: number, telecomAccountNumber: string, taxDistrict: string, accountId?: number | null, accountNumber?: string | null, taxYear: number, uploadDate?: string | null, processDate?: string | null, updateDate?: string | null, ein?: number | null, isReconciled?: boolean | null, reconcileDate?: string | null, isActive?: boolean | null, classification?: { id: string, label?: string | null } | null, jurisdiction: { id: string, name: string } }>, getClassifications: Array<{ id: string, clsf?: string | null, scheduleId?: number | null, description?: string | null }> };

export type GetTelecomMcatLessorsQueryVariables = Exact<{
  params: TelecomMcatAssetsInput;
}>;


export type GetTelecomMcatLessorsQuery = { telecomMcatLessors: Array<{ id?: string | null, name?: string | null, contactLinkId?: string | null, contactType?: { id: string, label: string } | null, address?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, phone?: string | null, phoneExtension?: string | null } | null, assets?: Array<{ id: string, leaseId?: string | null, leaseAccountId?: string | null, leaseNumber?: string | null, contactLinkId?: string | null, description?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, annualLeaseAmount?: number | null, initialValue?: number | null, leaseStartDate?: string | null, leaseEndDate?: string | null, fileUrl?: string | null, fileName?: string | null, blobName?: string | null, isActive?: boolean | null }> | null }> };

export type SaveTelecomMcatLessorMutationVariables = Exact<{
  input: SaveTelecomMcatLessorInput;
}>;


export type SaveTelecomMcatLessorMutation = { saveTelecomMcatLessor: Array<{ id?: string | null, name?: string | null, contactLinkId?: string | null, contactType?: { id: string, label: string } | null, address?: { inCareOf?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, phone?: string | null, phoneExtension?: string | null } | null, assets?: Array<{ id: string, leaseId?: string | null, leaseAccountId?: string | null, leaseNumber?: string | null, contactLinkId?: string | null, description?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, annualLeaseAmount?: number | null, initialValue?: number | null, leaseStartDate?: string | null, leaseEndDate?: string | null, fileUrl?: string | null, fileName?: string | null, blobName?: string | null, isActive?: boolean | null }> | null }> };

export type GetTelecomMasterAssetsQueryVariables = Exact<{
  telecomMasterId: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetTelecomMasterAssetsQuery = { telecomMasterAssets: Array<{ id: number, subAccountId: number, subAccountNumber: string, taxDistrict: string, description?: string | null, yearAcquired: number, quantity: number, costPer: number, percentGood?: number | null, taxableValue?: number | null, isActive: boolean, classification: { id: string, label?: string | null } }> };

export type GetTelecomMcatStagedAssetsQueryVariables = Exact<{
  telecomMasterId: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetTelecomMcatStagedAssetsQuery = { telecomMcatStagedAssets: Array<{ id: string, accountNumber: string, taxDistrict: string, description: string, yearAcquired: number, quantity: number, costPer: number, percentGood: number, taxableValue: number, netAsmtCharge?: number | null, jurisdiction: { id: string, name: string }, classification: { id: string, label?: string | null } }> };

export type GetTelecomMcatAssetFilesQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetTelecomMcatAssetFilesQuery = { telecomMcatAssetFiles: Array<{ filename: string, url: string }> };

export type SaveTelecomMcatAssetsMutationVariables = Exact<{
  assets: Array<McatAssetInput> | McatAssetInput;
}>;


export type SaveTelecomMcatAssetsMutation = { saveTelecomMcatAssets: Array<{ id: string, description?: string | null, yearAcquired?: number | null, quantity: number, costPer: number, percentGood: number, taxableValue: number, taxRate?: number | null, netAsmtCharge?: number | null, telecomMasterId: number, telecomAccountNumber: string, taxDistrict: string, accountId?: number | null, accountNumber?: string | null, taxYear: number, uploadDate?: string | null, processDate?: string | null, updateDate?: string | null, ein?: number | null, isReconciled?: boolean | null, reconcileDate?: string | null, isActive?: boolean | null, classification?: { id: string, label?: string | null } | null, jurisdiction: { id: string, name: string } }> };

export type SaveTelecomMcatPropertyAssetListMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  accountNumber: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
  isLeased: Scalars['Boolean']['input'];
}>;


export type SaveTelecomMcatPropertyAssetListMutation = { saveTelecomMcatPropertyAssetList: { accountNumber: string, fileName: string, validationReport?: string | null } };

export type RemoveTelecomStagingDataMutationVariables = Exact<{
  input: RemoveTelecomStagingDataInput;
}>;


export type RemoveTelecomStagingDataMutation = { removeTelecomStagingData: boolean };

export type GetTelecomBusinessAccountQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetTelecomBusinessAccountQuery = { telecomBusinessAccount?: { id: string, accountNumber: string, businessName: string, registeredEntityName?: string | null, description?: string | null, ein?: string | null, applyPenalty: boolean, isActive: boolean, isDisabled: boolean, sicCode?: { id: string, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string, isActive: boolean } | null, lastModified: { username?: string | null, lastChanged?: string | null }, reconciliation: { reconciledDate?: string | null, reconciledBy?: { id: number, fullName: string, username: string, email: string, isActive: boolean, isVerified: boolean } | null }, filingStatus: { hasExemption?: boolean | null, dateReceived?: string | null, howFiled?: { id: string, label: string } | null, howReceived?: { id: string, label: string } | null }, audit: { auditYear?: number | null, auditReconcileDate?: string | null, auditedBy?: { id: number, fullName: string, username: string, email: string, isActive: boolean, isVerified: boolean } | null }, bankruptcy: { bankruptcyType?: { id: string, label: string } | null }, businessAccountType?: { id: string, label: string } | null, accountSummary?: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, payments?: number | null, interest?: number | null, penaltyCharge?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null } | null } | null };

export type SaveTelecomAccountMutationVariables = Exact<{
  input: TelecomBusinessAccountInput;
}>;


export type SaveTelecomAccountMutation = { saveTelecomAccount?: { id: string, accountNumber: string, businessName: string, registeredEntityName?: string | null, description?: string | null, ein?: string | null, applyPenalty: boolean, isActive: boolean, isDisabled: boolean, sicCode?: { id: string, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string, isActive: boolean } | null, lastModified: { username?: string | null, lastChanged?: string | null }, reconciliation: { reconciledDate?: string | null, reconciledBy?: { id: number, fullName: string, username: string, email: string, isActive: boolean, isVerified: boolean } | null }, filingStatus: { hasExemption?: boolean | null, dateReceived?: string | null, howFiled?: { id: string, label: string } | null, howReceived?: { id: string, label: string } | null }, audit: { auditYear?: number | null, auditReconcileDate?: string | null, auditedBy?: { id: number, fullName: string, username: string, email: string, isActive: boolean, isVerified: boolean } | null }, bankruptcy: { bankruptcyType?: { id: string, label: string } | null }, businessAccountType?: { id: string, label: string } | null, accountSummary?: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, payments?: number | null, penaltyCharge?: number | null, interest?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null } | null } | null };

export type UpdateTelecomExemptAndGetSummaryAmountMutationVariables = Exact<{
  telecomMasterId: Scalars['String']['input'];
  isExempt: Scalars['Boolean']['input'];
}>;


export type UpdateTelecomExemptAndGetSummaryAmountMutation = { updateTelecomExemptAndGetSummaryAmount: { assessmentCharge?: number | null, cost?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, directCharge?: number | null, interest?: number | null, payments?: number | null, penaltyCharge?: number | null, taxRate?: number | null, taxable?: number | null, totalBalance?: number | null, totalBalanceWithDelinquent?: number | null } };

export type ChangeTelecomAccountStatusMutationVariables = Exact<{
  telecomMasterId: Scalars['Int']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type ChangeTelecomAccountStatusMutation = { changeTelecomAccountStatus: boolean };

export type SearchTelecomByAccountNumberMutationVariables = Exact<{
  accountNumber: Scalars['String']['input'];
}>;


export type SearchTelecomByAccountNumberMutation = { searchTelecomBusinessAccountInfoByNumber?: { id?: string | null, businessName?: string | null, status: AccountSearchStatus } | null };

export type TelecomMcatSearchAccountsQueryVariables = Exact<{
  filters?: InputMaybe<TelecomMcatSearchFilters>;
}>;


export type TelecomMcatSearchAccountsQuery = { telecomMcatSearchAccounts?: { totalRecordCount: number, results?: Array<{ id: string, accountNumber: string, businessName: string, isActive: boolean, status: string, isReconciled: boolean }> | null } | null };

export type GetMcatTelecomAccountQueryVariables = Exact<{
  accountNbr: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
  jurisdiction?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMcatTelecomAccountQuery = { getMCATTelecomAccount?: { id: string, accountNumber: string, pin?: string | null, businessName: string, registeredEntityName?: string | null, description?: string | null, ein?: string | null, applyPenalty: boolean, isActive: boolean, isDisabled: boolean, businessAccountType?: { id: string, label: string } | null, sicCode?: { id: string, sicCode: string, sicCodeDescription?: string | null, sicSiloCode: string, subSiloCode: string, isActive: boolean } | null, lastModified: { username?: string | null, lastChanged?: string | null }, reconciliation: { reconciledDate?: string | null, reconciledBy?: { id: number, username: string, fullName: string, email: string, isActive: boolean, isVerified: boolean } | null }, filingStatus: { filingYear?: number | null, dateReceived?: string | null, hasExemption?: boolean | null, howFiled?: { id: string, label: string } | null, howReceived?: { id: string, label: string } | null }, bankruptcy: { bankruptcyType?: { id: string, label: string } | null }, audit: { auditYear?: number | null, auditReconcileDate?: string | null, auditedBy?: { id: number, fullName: string, username: string, email: string, isActive: boolean, isVerified: boolean } | null }, accountSummary?: { cost?: number | null, taxable?: number | null, taxRate?: number | null, assessmentCharge?: number | null, directCharge?: number | null, payments?: number | null, interest?: number | null, penaltyCharge?: number | null, currentBalance?: number | null, delinquentBalance?: number | null, totalBalance?: number | null } | null } | null };

export type GetMcatTelecomListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMcatTelecomListQuery = { getMCATTelecomList: Array<{ telecomMasterId: number, telecomAccountNbr: string, businessName: string, isActive?: boolean | null, applyPenalty?: boolean | null, filedDate?: string | null, transferDate?: string | null }> };

export type GetMcatTelecomJurisdictionsQueryVariables = Exact<{
  accountNbr: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetMcatTelecomJurisdictionsQuery = { getMCATTelecomJurisdictions: Array<{ id: string, name: string }> };

export type GetMcatTelecomContactsQueryVariables = Exact<{
  telecomId: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetMcatTelecomContactsQuery = { getMCATTelecomContacts: Array<{ id?: string | null, name?: string | null, email?: string | null, phone?: string | null, phoneExtension?: string | null, cellphone?: string | null, isPrimary?: boolean | null, sameAsBusinessAddress?: boolean | null, contactType?: { id: string, label: string } | null, mailingAddress?: { addressLine1?: string | null, addressLine2?: string | null, inCareOf?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { code: string, name: string } | null } | null }> };

export type GetTelecomAssetStagingReportQueryVariables = Exact<{
  telecomMasterId: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetTelecomAssetStagingReportQuery = { telecomAssetStagingReport: Array<{ id: number, taxYear: number, telecomMasterId?: number | null, telecomAccountNbr?: string | null, jurisdiction?: number | null, countyName?: string | null, taxDistrict?: string | null, accountId?: number | null, accountNbr?: string | null, clsf?: string | null, customerDesc?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, percentGood?: number | null, taxRate?: number | null, taxableValue?: number | null, netAsmntCharge?: number | null, isLeased?: boolean | null, lessorName?: string | null, lessorAddress1?: string | null, lessorAddress2?: string | null, lessorCity?: string | null, lessorState?: string | null, lessorZip?: string | null, lessorPhone?: string | null, lessorPhoneExt?: string | null, leaseStartDate?: string | null, leaseEndDate?: string | null, annuaLeaseAmt?: number | null, initialValue?: number | null, isReconciled?: boolean | null, reconcileDate?: string | null, uploadDate?: string | null, recordType?: string | null, isActive?: boolean | null, transferDate?: string | null, updateDate?: string | null, updatedBy?: number | null }> };

export type GetTelecomContactInfoReportQueryVariables = Exact<{
  telecomMasterId: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetTelecomContactInfoReportQuery = { telecomContactInfoReport: Array<{ id: number, accountNbr: string, businessName: string, pinCode: string, fullName: string, contactType?: string | null, careOf?: string | null, address?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, phoneOffice?: string | null, phoneExten?: string | null, phoneMobile?: string | null, emailAddress?: string | null }> };

export type GetTelecomFilingDifferenceReportQueryVariables = Exact<{
  telecomMasterId: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetTelecomFilingDifferenceReportQuery = { telecomFilingDifferenceReport: Array<{ id: number, telecomMasterId: number, countyName?: string | null, taxDistrict?: string | null, clsf?: string | null, customerDesc?: string | null, yearAcquired?: number | null, quantity?: number | null, costPer?: number | null, changeCode?: string | null, columnChanged?: string | null, beforeValue?: string | null }> };

export type GetTelecomYearlyTaxableDifferenceReportQueryVariables = Exact<{
  telecomMasterId: Scalars['ID']['input'];
  taxYear: Scalars['Int']['input'];
}>;


export type GetTelecomYearlyTaxableDifferenceReportQuery = { telecomYearlyTaxableDifferenceReport: Array<{ id: number, telecomMasterId: number, telecomAccountNbr?: string | null, jurisdiction?: number | null, countyName?: string | null, priorTaxYear?: number | null, currentTaxYear?: number | null, priorYearTaxable?: number | null, currentYearTaxable?: number | null, yearlyDifference?: number | null }> };

export type RemoveMcatTelecomWorkflowMutationVariables = Exact<{
  accountNumber: Scalars['String']['input'];
}>;


export type RemoveMcatTelecomWorkflowMutation = { removeMCATTelecomWorkflow: boolean };

export type TransferTelecomMcatAssetsToProductionMutationVariables = Exact<{
  telecomInput: TransferTelecomAssetsToProductionInput;
}>;


export type TransferTelecomMcatAssetsToProductionMutation = { transferTelecomMcatAssetsToProduction: boolean };

export type RegenerateMcatTelecomPinMutationVariables = Exact<{
  accountNumber: Scalars['String']['input'];
}>;


export type RegenerateMcatTelecomPinMutation = { regenerateMCATTelecomPin: string };

export type ChangeMcatTelecomActiveStatusMutationVariables = Exact<{
  accountNumber: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
}>;


export type ChangeMcatTelecomActiveStatusMutation = { changeMCATTelecomActiveStatus: boolean };

export type ChangeMcatTelecomApplyPenaltyStatusMutationVariables = Exact<{
  accountNumber: Scalars['String']['input'];
  applyPenalty: Scalars['Boolean']['input'];
}>;


export type ChangeMcatTelecomApplyPenaltyStatusMutation = { changeMCATTelecomApplyPenaltyStatus: boolean };

export type ChangeMcatTelecomApplyPenaltyStatusByJurisdictionMutationVariables = Exact<{
  accountNumber: Scalars['String']['input'];
  jurisdictionId: Scalars['Int']['input'];
  applyPenalty: Scalars['Boolean']['input'];
}>;


export type ChangeMcatTelecomApplyPenaltyStatusByJurisdictionMutation = { changeMCATTelecomApplyPenaltyStatusByJurisdiction: boolean };

export type ChangeMcatTelecomExemptStatusByJurisdictionMutationVariables = Exact<{
  accountNumber: Scalars['String']['input'];
  jurisdictionId: Scalars['Int']['input'];
  isExempt: Scalars['Boolean']['input'];
}>;


export type ChangeMcatTelecomExemptStatusByJurisdictionMutation = { changeMCATTelecomExemptStatusByJurisdiction: boolean };

export type SearchQueryVariables = Exact<{
  searchFilters?: InputMaybe<SearchFilters>;
}>;


export type SearchQuery = { search: Array<{ id: number, username: string, email: string, fullName: string, title?: string | null, phone?: string | null, isActive: boolean, isVerified: boolean, roles?: Array<{ id: number, name: string }> | null }> };

export type GetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileQuery = { getProfile: { username: string, email: string } };

export type CreateUserMutationVariables = Exact<{
  newUser: NewUser;
}>;


export type CreateUserMutation = { createUser: boolean };

export type UpdateUserMutationVariables = Exact<{
  updatedUser: UpdatedUser;
  id: Scalars['Int']['input'];
}>;


export type UpdateUserMutation = { updateUser: boolean };

export type ImpersonateUserMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ImpersonateUserMutation = { impersonateUser: { token?: string | null } };



export const GetAccountTypesDocument = `
    query GetAccountTypes($filterBy: FilterAccountTypeBy) {
  accountTypes(filterBy: $filterBy) {
    id
    label
  }
}
    `;

export const useGetAccountTypesQuery = <
      TData = GetAccountTypesQuery,
      TError = unknown
    >(
      variables?: GetAccountTypesQueryVariables,
      options?: UseQueryOptions<GetAccountTypesQuery, TError, TData>
    ) => {
    
    return useQuery<GetAccountTypesQuery, TError, TData>(
      variables === undefined ? ['GetAccountTypes'] : ['GetAccountTypes', variables],
      useFetchData<GetAccountTypesQuery, GetAccountTypesQueryVariables>(GetAccountTypesDocument).bind(null, variables),
      options
    )};

export const SaveAccountTypeDocument = `
    mutation SaveAccountType($accountType: [AccountTypeInput!]!) {
  saveAccountType(accountType: $accountType) {
    id
    label
  }
}
    `;

export const useSaveAccountTypeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveAccountTypeMutation, TError, SaveAccountTypeMutationVariables, TContext>) => {
    
    return useMutation<SaveAccountTypeMutation, TError, SaveAccountTypeMutationVariables, TContext>(
      ['SaveAccountType'],
      useFetchData<SaveAccountTypeMutation, SaveAccountTypeMutationVariables>(SaveAccountTypeDocument),
      options
    )};

export const GetClassificationsDocument = `
    query GetClassifications {
  getClassifications {
    id
    clsf
    scheduleId
    description
  }
}
    `;

export const useGetClassificationsQuery = <
      TData = GetClassificationsQuery,
      TError = unknown
    >(
      variables?: GetClassificationsQueryVariables,
      options?: UseQueryOptions<GetClassificationsQuery, TError, TData>
    ) => {
    
    return useQuery<GetClassificationsQuery, TError, TData>(
      variables === undefined ? ['GetClassifications'] : ['GetClassifications', variables],
      useFetchData<GetClassificationsQuery, GetClassificationsQueryVariables>(GetClassificationsDocument).bind(null, variables),
      options
    )};

export const GetBasicCostByClassificationDocument = `
    query GetBasicCostByClassification($taxYear: Int!) {
  getClassifications {
    id
    clsf
    scheduleId
    description
    basicCost(taxYear: $taxYear) {
      id
      scheduleId
      baseYear
      propertyYear
      percentGood
    }
  }
}
    `;

export const useGetBasicCostByClassificationQuery = <
      TData = GetBasicCostByClassificationQuery,
      TError = unknown
    >(
      variables: GetBasicCostByClassificationQueryVariables,
      options?: UseQueryOptions<GetBasicCostByClassificationQuery, TError, TData>
    ) => {
    
    return useQuery<GetBasicCostByClassificationQuery, TError, TData>(
      ['GetBasicCostByClassification', variables],
      useFetchData<GetBasicCostByClassificationQuery, GetBasicCostByClassificationQueryVariables>(GetBasicCostByClassificationDocument).bind(null, variables),
      options
    )};

export const SaveClassificationsDocument = `
    mutation SaveClassifications($classifications: [ClassificationInput!]!) {
  saveClassifications(classifications: $classifications) {
    id
    clsf
    scheduleId
    description
  }
}
    `;

export const useSaveClassificationsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveClassificationsMutation, TError, SaveClassificationsMutationVariables, TContext>) => {
    
    return useMutation<SaveClassificationsMutation, TError, SaveClassificationsMutationVariables, TContext>(
      ['SaveClassifications'],
      useFetchData<SaveClassificationsMutation, SaveClassificationsMutationVariables>(SaveClassificationsDocument),
      options
    )};

export const SaveBasicCostDocument = `
    mutation SaveBasicCost($basicCost: SaveBasicCostByClassInput!) {
  saveBasicCost(cost: $basicCost) {
    id
    scheduleId
    baseYear
    propertyYear
    percentGood
  }
}
    `;

export const useSaveBasicCostMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveBasicCostMutation, TError, SaveBasicCostMutationVariables, TContext>) => {
    
    return useMutation<SaveBasicCostMutation, TError, SaveBasicCostMutationVariables, TContext>(
      ['SaveBasicCost'],
      useFetchData<SaveBasicCostMutation, SaveBasicCostMutationVariables>(SaveBasicCostDocument),
      options
    )};

export const GetAssetsDocument = `
    query GetAssets($accountId: Int!, $taxYear: Int!) {
  getAssets(accountId: $accountId, taxYear: $taxYear) {
    accountNumber
    isActive
    isExempt
    assets {
      id
      classification
      classificationDescription
      description
      yearAcquired
      quantity
      costPer
      percentGood
      taxableValue
      ein
      updateDate
      isActive
    }
  }
  getClassifications {
    id
    clsf
    scheduleId
    description
  }
  getTaxRate(accountId: $accountId, taxYear: $taxYear) {
    id
    taxRate
  }
  uploadAssetsTemplate
  currentTaxYear
}
    `;

export const useGetAssetsQuery = <
      TData = GetAssetsQuery,
      TError = unknown
    >(
      variables: GetAssetsQueryVariables,
      options?: UseQueryOptions<GetAssetsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAssetsQuery, TError, TData>(
      ['GetAssets', variables],
      useFetchData<GetAssetsQuery, GetAssetsQueryVariables>(GetAssetsDocument).bind(null, variables),
      options
    )};

export const SaveAssetsDocument = `
    mutation SaveAssets($accountId: Int!, $assets: [AssetInput!]!) {
  saveAssets(accountId: $accountId, assets: $assets) {
    id
    classification
    classificationDescription
    description
    yearAcquired
    quantity
    costPer
    percentGood
    taxableValue
    ein
    updateDate
    isActive
  }
}
    `;

export const useSaveAssetsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveAssetsMutation, TError, SaveAssetsMutationVariables, TContext>) => {
    
    return useMutation<SaveAssetsMutation, TError, SaveAssetsMutationVariables, TContext>(
      ['SaveAssets'],
      useFetchData<SaveAssetsMutation, SaveAssetsMutationVariables>(SaveAssetsDocument),
      options
    )};

export const CalculateTaxableValueDocument = `
    mutation CalculateTaxableValue($input: CalculateTaxableValueInput!) {
  calculateTaxableValue(input: $input) {
    percentGood
    taxableValue
  }
}
    `;

export const useCalculateTaxableValueMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CalculateTaxableValueMutation, TError, CalculateTaxableValueMutationVariables, TContext>) => {
    
    return useMutation<CalculateTaxableValueMutation, TError, CalculateTaxableValueMutationVariables, TContext>(
      ['CalculateTaxableValue'],
      useFetchData<CalculateTaxableValueMutation, CalculateTaxableValueMutationVariables>(CalculateTaxableValueDocument),
      options
    )};

export const UploadAssetsDocument = `
    mutation UploadAssets($uploadedAssetInput: UploadAssetInput!) {
  uploadAssets(uploadedAssetsInput: $uploadedAssetInput) {
    fileName
    message
    errorFileName
    errorFileUrl
    assets {
      id
      classification
      classificationDescription
      description
      yearAcquired
      quantity
      costPer
      percentGood
      taxableValue
      ein
      updateDate
      isActive
    }
  }
}
    `;

export const useUploadAssetsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UploadAssetsMutation, TError, UploadAssetsMutationVariables, TContext>) => {
    
    return useMutation<UploadAssetsMutation, TError, UploadAssetsMutationVariables, TContext>(
      ['UploadAssets'],
      useFetchData<UploadAssetsMutation, UploadAssetsMutationVariables>(UploadAssetsDocument),
      options
    )};

export const UploadLeaseAssetsDocument = `
    mutation UploadLeaseAssets($uploadLeaseAssetsInput: UploadLeaseAssetInput!) {
  uploadLeaseAssets(uploadLeaseAssetsInput: $uploadLeaseAssetsInput) {
    fileName
    message
    errorFileName
    errorFileUrl
    assets {
      id
      classification
      classificationDescription
      description
      yearAcquired
      quantity
      costPer
      percentGood
      taxableValue
      ein
      updateDate
      isActive
    }
  }
}
    `;

export const useUploadLeaseAssetsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UploadLeaseAssetsMutation, TError, UploadLeaseAssetsMutationVariables, TContext>) => {
    
    return useMutation<UploadLeaseAssetsMutation, TError, UploadLeaseAssetsMutationVariables, TContext>(
      ['UploadLeaseAssets'],
      useFetchData<UploadLeaseAssetsMutation, UploadLeaseAssetsMutationVariables>(UploadLeaseAssetsDocument),
      options
    )};

export const GetAssociatedAccountsDocument = `
    query GetAssociatedAccounts($accountId: Int!, $accountIdString: String!, $taxYear: Int!) {
  associatedAccounts(accountId: $accountId, taxYear: $taxYear) {
    id
    totalTaxableValue
    accounts {
      id
      accountId
      accountNumber
      businessName
      accountType
      address
      isExempt
      isReconciled
      isVerified
      isActive
      taxableValue
    }
  }
  getBusinessAccount(accountId: $accountIdString, taxYear: $taxYear) {
    id
    accountNumber
    pin
    businessName
    description
    parcelNumber
    areaNumber
    accountStatus
    sicCode {
      id
      sicCode
      sicCodeDescription
      sicSiloCode
      subSiloCode
      isActive
    }
    yearOpened
    ein
    website
    isHomeOccupational
    registeredEntityName
    hasAssociatedAccounts
    isActive
    isAccountReadOnly
    lastModified {
      username
      lastChangedDate
    }
    reconciliation {
      reconciledBy {
        id
        fullName
        username
        email
        isActive
        isVerified
      }
      reconciledDate
    }
    filingStatus {
      hasBuildingPermit
      hasAttachment
      hasExemption
      filingYear
      dateReceived
      howFiled {
        id
        label
      }
      howReceived {
        id
        label
      }
    }
    audit {
      auditYear
    }
    primaryContact {
      id
      name
      email
      contactType {
        id
        label
      }
      phone
      phoneExtension
      cellphone
      mailingAddress {
        inCareOf
        addressLine1
        addressLine2
        city
        state
        zipCode
        country {
          code
          name
        }
      }
    }
    parcelUseType {
      id
      label
    }
    entityType {
      id
      label
    }
    industrialPark {
      id
      code
      label
    }
    accountType {
      id
      label
    }
    businessAppraiserRegion {
      id
      groupingValue1
      groupingValue2
      regionName
    }
    situsAddress {
      addressLine1
      addressLine2
      city
      state
      zipCode
    }
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      penaltyCharge
      interest
      payments
      currentBalance
      delinquentBalance
      totalBalance
    }
  }
  currentTaxYear
}
    `;

export const useGetAssociatedAccountsQuery = <
      TData = GetAssociatedAccountsQuery,
      TError = unknown
    >(
      variables: GetAssociatedAccountsQueryVariables,
      options?: UseQueryOptions<GetAssociatedAccountsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAssociatedAccountsQuery, TError, TData>(
      ['GetAssociatedAccounts', variables],
      useFetchData<GetAssociatedAccountsQuery, GetAssociatedAccountsQueryVariables>(GetAssociatedAccountsDocument).bind(null, variables),
      options
    )};

export const SaveAssociatedAccountsDocument = `
    mutation SaveAssociatedAccounts($group: AssociatedAccountGroupInput!) {
  saveAssociatedAccounts(group: $group) {
    id
    totalTaxableValue
    accounts {
      id
      accountId
      accountNumber
      businessName
      accountType
      address
      isExempt
      isReconciled
      isVerified
      isActive
      taxableValue
    }
  }
}
    `;

export const useSaveAssociatedAccountsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveAssociatedAccountsMutation, TError, SaveAssociatedAccountsMutationVariables, TContext>) => {
    
    return useMutation<SaveAssociatedAccountsMutation, TError, SaveAssociatedAccountsMutationVariables, TContext>(
      ['SaveAssociatedAccounts'],
      useFetchData<SaveAssociatedAccountsMutation, SaveAssociatedAccountsMutationVariables>(SaveAssociatedAccountsDocument),
      options
    )};

export const SearchAccountAddressDocument = `
    mutation SearchAccountAddress($accountNumber: String!) {
  searchAssociatedAccountAddress(accountNumber: $accountNumber) {
    id
    accountId
    accountNumber
    businessName
    accountType
    address
    isExempt
    isReconciled
    isVerified
    taxableValue
  }
}
    `;

export const useSearchAccountAddressMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SearchAccountAddressMutation, TError, SearchAccountAddressMutationVariables, TContext>) => {
    
    return useMutation<SearchAccountAddressMutation, TError, SearchAccountAddressMutationVariables, TContext>(
      ['SearchAccountAddress'],
      useFetchData<SearchAccountAddressMutation, SearchAccountAddressMutationVariables>(SearchAccountAddressDocument),
      options
    )};

export const LoginDocument = `
    mutation Login($username: String!, $password: String!, $jurisdictionId: Int!) {
  login(username: $username, password: $password, jurisdictionId: $jurisdictionId) {
    ... on SuccessfulAuthType {
      token
    }
    ... on FailedAuthType {
      title
      status
    }
  }
}
    `;

export const useLoginMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LoginMutation, TError, LoginMutationVariables, TContext>) => {
    
    return useMutation<LoginMutation, TError, LoginMutationVariables, TContext>(
      ['Login'],
      useFetchData<LoginMutation, LoginMutationVariables>(LoginDocument),
      options
    )};

export const ChangePasswordDocument = `
    mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
  changePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
    ... on SuccessfulAuthType {
      token
    }
    ... on FailedAuthType {
      title
      status
    }
  }
}
    `;

export const useChangePasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChangePasswordMutation, TError, ChangePasswordMutationVariables, TContext>) => {
    
    return useMutation<ChangePasswordMutation, TError, ChangePasswordMutationVariables, TContext>(
      ['ChangePassword'],
      useFetchData<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument),
      options
    )};

export const PaperFilingTokenDocument = `
    mutation PaperFilingToken {
  paperFilingToken {
    token
  }
}
    `;

export const usePaperFilingTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PaperFilingTokenMutation, TError, PaperFilingTokenMutationVariables, TContext>) => {
    
    return useMutation<PaperFilingTokenMutation, TError, PaperFilingTokenMutationVariables, TContext>(
      ['PaperFilingToken'],
      useFetchData<PaperFilingTokenMutation, PaperFilingTokenMutationVariables>(PaperFilingTokenDocument),
      options
    )};

export const ForgotPasswordDocument = `
    mutation ForgotPassword($email: String!) {
  forgotPassword(email: $email)
}
    `;

export const useForgotPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ForgotPasswordMutation, TError, ForgotPasswordMutationVariables, TContext>) => {
    
    return useMutation<ForgotPasswordMutation, TError, ForgotPasswordMutationVariables, TContext>(
      ['ForgotPassword'],
      useFetchData<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument),
      options
    )};

export const ResetPasswordDocument = `
    mutation ResetPassword($encryptedValue: String!, $password: String!) {
  resetPassword(encryptedValue: $encryptedValue, password: $password) {
    token
  }
}
    `;

export const useResetPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>) => {
    
    return useMutation<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>(
      ['ResetPassword'],
      useFetchData<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument),
      options
    )};

export const MasterLoginDocument = `
    mutation MasterLogin($username: String!, $password: String!) {
  masterLogin(username: $username, password: $password) {
    token
  }
}
    `;

export const useMasterLoginMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MasterLoginMutation, TError, MasterLoginMutationVariables, TContext>) => {
    
    return useMutation<MasterLoginMutation, TError, MasterLoginMutationVariables, TContext>(
      ['MasterLogin'],
      useFetchData<MasterLoginMutation, MasterLoginMutationVariables>(MasterLoginDocument),
      options
    )};

export const McatLoginDocument = `
    mutation McatLogin($username: String!, $password: String!) {
  mcatLogin(username: $username, password: $password) {
    token
  }
}
    `;

export const useMcatLoginMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<McatLoginMutation, TError, McatLoginMutationVariables, TContext>) => {
    
    return useMutation<McatLoginMutation, TError, McatLoginMutationVariables, TContext>(
      ['McatLogin'],
      useFetchData<McatLoginMutation, McatLoginMutationVariables>(McatLoginDocument),
      options
    )};

export const GeneratePresignedUploadFileDocument = `
    mutation GeneratePresignedUploadFile($input: SASUploadFileInput!) {
  generatePresignedUploadFile(input: $input) {
    blobName
    fileName
    url
  }
}
    `;

export const useGeneratePresignedUploadFileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GeneratePresignedUploadFileMutation, TError, GeneratePresignedUploadFileMutationVariables, TContext>) => {
    
    return useMutation<GeneratePresignedUploadFileMutation, TError, GeneratePresignedUploadFileMutationVariables, TContext>(
      ['GeneratePresignedUploadFile'],
      useFetchData<GeneratePresignedUploadFileMutation, GeneratePresignedUploadFileMutationVariables>(GeneratePresignedUploadFileDocument),
      options
    )};

export const GenerateSasReadFileDocument = `
    query GenerateSASReadFile($fileName: String!) {
  generateSASReadFile(fileName: $fileName)
}
    `;

export const useGenerateSasReadFileQuery = <
      TData = GenerateSasReadFileQuery,
      TError = unknown
    >(
      variables: GenerateSasReadFileQueryVariables,
      options?: UseQueryOptions<GenerateSasReadFileQuery, TError, TData>
    ) => {
    
    return useQuery<GenerateSasReadFileQuery, TError, TData>(
      ['GenerateSASReadFile', variables],
      useFetchData<GenerateSasReadFileQuery, GenerateSasReadFileQueryVariables>(GenerateSasReadFileDocument).bind(null, variables),
      options
    )};

export const ExecuteBafBatchPenaltyDocument = `
    mutation ExecuteBafBatchPenalty($taxYear: Int!) {
  executeBafBatchPenalty(taxYear: $taxYear)
}
    `;

export const useExecuteBafBatchPenaltyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ExecuteBafBatchPenaltyMutation, TError, ExecuteBafBatchPenaltyMutationVariables, TContext>) => {
    
    return useMutation<ExecuteBafBatchPenaltyMutation, TError, ExecuteBafBatchPenaltyMutationVariables, TContext>(
      ['ExecuteBafBatchPenalty'],
      useFetchData<ExecuteBafBatchPenaltyMutation, ExecuteBafBatchPenaltyMutationVariables>(ExecuteBafBatchPenaltyDocument),
      options
    )};

export const ExecuteLeaseBatchPenaltyDocument = `
    mutation ExecuteLeaseBatchPenalty($taxYear: Int!) {
  executeLeaseBatchPenalty(taxYear: $taxYear)
}
    `;

export const useExecuteLeaseBatchPenaltyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ExecuteLeaseBatchPenaltyMutation, TError, ExecuteLeaseBatchPenaltyMutationVariables, TContext>) => {
    
    return useMutation<ExecuteLeaseBatchPenaltyMutation, TError, ExecuteLeaseBatchPenaltyMutationVariables, TContext>(
      ['ExecuteLeaseBatchPenalty'],
      useFetchData<ExecuteLeaseBatchPenaltyMutation, ExecuteLeaseBatchPenaltyMutationVariables>(ExecuteLeaseBatchPenaltyDocument),
      options
    )};

export const ExecuteTelecomBatchPenaltyDocument = `
    mutation ExecuteTelecomBatchPenalty($taxYear: Int!) {
  executeTelecomBatchPenalty(taxYear: $taxYear)
}
    `;

export const useExecuteTelecomBatchPenaltyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ExecuteTelecomBatchPenaltyMutation, TError, ExecuteTelecomBatchPenaltyMutationVariables, TContext>) => {
    
    return useMutation<ExecuteTelecomBatchPenaltyMutation, TError, ExecuteTelecomBatchPenaltyMutationVariables, TContext>(
      ['ExecuteTelecomBatchPenalty'],
      useFetchData<ExecuteTelecomBatchPenaltyMutation, ExecuteTelecomBatchPenaltyMutationVariables>(ExecuteTelecomBatchPenaltyDocument),
      options
    )};

export const SearchBusinessAccountDocument = `
    query SearchBusinessAccount($searchFilters: SearchBusinessAccountInput!) {
  searchBusinessAccount(searchFilters: $searchFilters) {
    searchBusinessAccount {
      taxYear
      accountNbr
      accountId
      isActive
      businessName
      address {
        addressLine1
        addressLine2
        city
        state
        zipCode
      }
      contactId
      accountNbr
      taxDistrict
      isActive
      isReconciled
      appraisalRegion {
        id
        label
      }
      howReceived {
        id
        label
      }
      howFiled {
        id
        label
      }
      balance
      recordType
      status
    }
    totalRecordCount
  }
}
    `;

export const useSearchBusinessAccountQuery = <
      TData = SearchBusinessAccountQuery,
      TError = unknown
    >(
      variables: SearchBusinessAccountQueryVariables,
      options?: UseQueryOptions<SearchBusinessAccountQuery, TError, TData>
    ) => {
    
    return useQuery<SearchBusinessAccountQuery, TError, TData>(
      ['SearchBusinessAccount', variables],
      useFetchData<SearchBusinessAccountQuery, SearchBusinessAccountQueryVariables>(SearchBusinessAccountDocument).bind(null, variables),
      options
    )};

export const GetCreateAccountInfoDocument = `
    query GetCreateAccountInfo {
  getBusinessAppraiserRegionList {
    regionName
    columnsNames {
      groupingLabel1
      groupingLabel2
    }
    rows {
      id
      groupingValue1
      groupingValue2
      regionName
    }
  }
  countries {
    code
    name
  }
  accountTypes {
    id
    label
  }
  taxAreaList {
    taxArea
    taxSubArea
  }
  sicCodeMasters {
    id
    sicCode
    sicCodeDescription
    sicSiloCode
    subSiloCode
    isActive
  }
}
    `;

export const useGetCreateAccountInfoQuery = <
      TData = GetCreateAccountInfoQuery,
      TError = unknown
    >(
      variables?: GetCreateAccountInfoQueryVariables,
      options?: UseQueryOptions<GetCreateAccountInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetCreateAccountInfoQuery, TError, TData>(
      variables === undefined ? ['GetCreateAccountInfo'] : ['GetCreateAccountInfo', variables],
      useFetchData<GetCreateAccountInfoQuery, GetCreateAccountInfoQueryVariables>(GetCreateAccountInfoDocument).bind(null, variables),
      options
    )};

export const CreateBusinessAccountDocument = `
    mutation CreateBusinessAccount($account: CreateBusinessAccountInput!) {
  createBusinessAccount(account: $account) {
    id
    accountNumber
    pin
    businessName
    description
    parcelNumber
    areaNumber
    sicCode {
      id
      sicCode
      sicCodeDescription
      sicSiloCode
      subSiloCode
      isActive
    }
    naicsCategory {
      id
      category
    }
    naicsCode {
      id
      category
      subCategory
    }
    yearOpened
    ein
    website
    isHomeOccupational
    registeredEntityName
    hasAssociatedAccounts
    applyPenalty
    isActive
    isAccountReadOnly
    lastModified {
      username
      lastChangedDate
    }
    reconciliation {
      reconciledBy {
        id
        fullName
        username
        email
        isActive
        isVerified
      }
    }
    filingStatus {
      hasBuildingPermit
      hasAttachment
      hasExemption
      filingYear
      dateReceived
      howFiled {
        id
        label
      }
      howReceived {
        id
        label
      }
    }
    audit {
      auditYear
    }
    primaryContact {
      id
      name
      email
      contactType {
        id
        label
      }
      phone
      phoneExtension
      cellphone
      mailingAddress {
        inCareOf
        addressLine1
        addressLine2
        city
        state
        zipCode
        country {
          code
          name
        }
      }
    }
    parcelUseType {
      id
      label
    }
    entityType {
      id
      label
    }
    industrialPark {
      id
      code
      label
    }
    accountType {
      id
      label
    }
    businessAppraiserRegion {
      id
      groupingValue1
      groupingValue2
      regionName
    }
    situsAddress {
      addressLine1
      addressLine2
      city
      state
      zipCode
    }
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      penaltyCharge
      interest
      payments
      currentBalance
      delinquentBalance
      totalBalance
      totalBalanceWithDelinquent
    }
  }
}
    `;

export const useCreateBusinessAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateBusinessAccountMutation, TError, CreateBusinessAccountMutationVariables, TContext>) => {
    
    return useMutation<CreateBusinessAccountMutation, TError, CreateBusinessAccountMutationVariables, TContext>(
      ['CreateBusinessAccount'],
      useFetchData<CreateBusinessAccountMutation, CreateBusinessAccountMutationVariables>(CreateBusinessAccountDocument),
      options
    )};

export const GetBusinessAccountDocument = `
    query GetBusinessAccount($accountId: String!, $taxYear: Int!) {
  getBusinessAccount(accountId: $accountId, taxYear: $taxYear) {
    id
    accountNumber
    adminLink
    pin
    businessName
    description
    parcelNumber
    areaNumber
    accountStatus
    sicCode {
      id
      sicCode
      sicCodeDescription
      sicSiloCode
      subSiloCode
      isActive
    }
    naicsCategory {
      id
      category
    }
    naicsCode {
      id
      category
      subCategory
    }
    yearOpened
    ein
    website
    isHomeOccupational
    registeredEntityName
    hasAssociatedAccounts
    isActive
    isAccountReadOnly
    applyPenalty
    leaseMasterNumberAssociation
    lastModified {
      username
      lastChangedDate
    }
    reconciliation {
      reconciledBy {
        id
        fullName
        username
        email
        isActive
        isVerified
      }
      reconciledDate
    }
    filingStatus {
      hasBuildingPermit
      hasAttachment
      hasExemption
      filingYear
      dateReceived
      howFiled {
        id
        label
      }
      howReceived {
        id
        label
      }
    }
    audit {
      auditYear
    }
    primaryContact {
      id
      name
      email
      contactType {
        id
        label
      }
      phone
      phoneExtension
      cellphone
      mailingAddress {
        inCareOf
        addressLine1
        addressLine2
        city
        state
        zipCode
        country {
          code
          name
        }
      }
    }
    parcelUseType {
      id
      label
    }
    entityType {
      id
      label
    }
    industrialPark {
      id
      code
      label
    }
    accountType {
      id
      label
    }
    businessAppraiserRegion {
      id
      groupingValue1
      groupingValue2
      regionName
    }
    situsAddress {
      addressLine1
      addressLine2
      city
      state
      zipCode
    }
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      penaltyCharge
      interest
      payments
      currentBalance
      delinquentBalance
      totalBalance
      totalBalanceWithDelinquent
    }
    hasCurrentPaymentPlan
    hasDelinquentPaymentPlan
  }
  industrialParkOptions {
    id
    code
    label
  }
  parcelUseTypeList {
    id
    label
  }
  howFiledList {
    id
    label
  }
  howReceivedList {
    id
    label
  }
  accountTypes {
    id
    label
  }
  taxAreaList {
    taxArea
    taxSubArea
  }
  countries {
    code
    name
  }
  contactTypes {
    id
    label
  }
  entityTypes {
    id
    label
  }
  getBusinessAppraiserRegionList {
    regionName
    columnsNames {
      groupingLabel1
      groupingLabel2
    }
    rows {
      id
      groupingValue1
      groupingValue2
      regionName
    }
  }
  sicCodeMasters {
    id
    isActive
    sicCode
    sicCodeDescription
    sicSiloCode
    subSiloCode
  }
  naicsCategories {
    id
    category
  }
  naicsCodes {
    id
    category
    subCategory
  }
  currentTaxYear
}
    `;

export const useGetBusinessAccountQuery = <
      TData = GetBusinessAccountQuery,
      TError = unknown
    >(
      variables: GetBusinessAccountQueryVariables,
      options?: UseQueryOptions<GetBusinessAccountQuery, TError, TData>
    ) => {
    
    return useQuery<GetBusinessAccountQuery, TError, TData>(
      ['GetBusinessAccount', variables],
      useFetchData<GetBusinessAccountQuery, GetBusinessAccountQueryVariables>(GetBusinessAccountDocument).bind(null, variables),
      options
    )};

export const SaveBusinessAccountDocument = `
    mutation SaveBusinessAccount($businessAccount: BusinessAccountInput!) {
  saveBusinessAccount(businessAccount: $businessAccount) {
    id
    accountNumber
    businessName
    description
    parcelNumber
    areaNumber
    sicCode {
      id
      sicCode
      sicCodeDescription
      sicSiloCode
      subSiloCode
      isActive
    }
    naicsCategory {
      id
      category
    }
    naicsCode {
      id
      category
      subCategory
    }
    yearOpened
    ein
    website
    isHomeOccupational
    registeredEntityName
    hasAssociatedAccounts
    isActive
    isAccountReadOnly
    applyPenalty
    lastModified {
      username
      lastChangedDate
    }
    reconciliation {
      reconciledBy {
        id
        fullName
        username
        email
        isActive
        isVerified
      }
      reconciledDate
    }
    filingStatus {
      hasBuildingPermit
      hasAttachment
      hasExemption
      filingYear
      dateReceived
      howFiled {
        id
        label
      }
      howReceived {
        id
        label
      }
    }
    audit {
      auditYear
    }
    parcelUseType {
      id
      label
    }
    entityType {
      id
      label
    }
    industrialPark {
      id
      code
      label
    }
    accountType {
      id
      label
    }
    businessAppraiserRegion {
      id
      groupingValue1
      groupingValue2
      regionName
    }
    situsAddress {
      addressLine1
      addressLine2
      city
      state
      zipCode
    }
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      penaltyCharge
      interest
      payments
      currentBalance
      delinquentBalance
      totalBalance
      totalBalanceWithDelinquent
    }
  }
}
    `;

export const useSaveBusinessAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveBusinessAccountMutation, TError, SaveBusinessAccountMutationVariables, TContext>) => {
    
    return useMutation<SaveBusinessAccountMutation, TError, SaveBusinessAccountMutationVariables, TContext>(
      ['SaveBusinessAccount'],
      useFetchData<SaveBusinessAccountMutation, SaveBusinessAccountMutationVariables>(SaveBusinessAccountDocument),
      options
    )};

export const RegeneratePinDocument = `
    mutation RegeneratePin($pinInput: PinInput!) {
  regeneratePin(pinInput: $pinInput)
}
    `;

export const useRegeneratePinMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RegeneratePinMutation, TError, RegeneratePinMutationVariables, TContext>) => {
    
    return useMutation<RegeneratePinMutation, TError, RegeneratePinMutationVariables, TContext>(
      ['RegeneratePin'],
      useFetchData<RegeneratePinMutation, RegeneratePinMutationVariables>(RegeneratePinDocument),
      options
    )};

export const ChangeBusinessAccountStatusDocument = `
    mutation ChangeBusinessAccountStatus($accountStatus: AccountStatusInput!) {
  changeBusinessAccountStatus(accountStatus: $accountStatus)
}
    `;

export const useChangeBusinessAccountStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChangeBusinessAccountStatusMutation, TError, ChangeBusinessAccountStatusMutationVariables, TContext>) => {
    
    return useMutation<ChangeBusinessAccountStatusMutation, TError, ChangeBusinessAccountStatusMutationVariables, TContext>(
      ['ChangeBusinessAccountStatus'],
      useFetchData<ChangeBusinessAccountStatusMutation, ChangeBusinessAccountStatusMutationVariables>(ChangeBusinessAccountStatusDocument),
      options
    )};

export const GetPinAndLinkedAccountsDocument = `
    query GetPinAndLinkedAccounts($pinInput: PinInput!) {
  getPinAndLinkedAccounts(pinInput: $pinInput) {
    pin
    linkedUsers {
      linkId
      userId
      username
      fullName
    }
  }
}
    `;

export const useGetPinAndLinkedAccountsQuery = <
      TData = GetPinAndLinkedAccountsQuery,
      TError = unknown
    >(
      variables: GetPinAndLinkedAccountsQueryVariables,
      options?: UseQueryOptions<GetPinAndLinkedAccountsQuery, TError, TData>
    ) => {
    
    return useQuery<GetPinAndLinkedAccountsQuery, TError, TData>(
      ['GetPinAndLinkedAccounts', variables],
      useFetchData<GetPinAndLinkedAccountsQuery, GetPinAndLinkedAccountsQueryVariables>(GetPinAndLinkedAccountsDocument).bind(null, variables),
      options
    )};

export const RemoveLinkedAccountDocument = `
    mutation RemoveLinkedAccount($linkId: ID!) {
  removeLinkedAccount(linkId: $linkId)
}
    `;

export const useRemoveLinkedAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveLinkedAccountMutation, TError, RemoveLinkedAccountMutationVariables, TContext>) => {
    
    return useMutation<RemoveLinkedAccountMutation, TError, RemoveLinkedAccountMutationVariables, TContext>(
      ['RemoveLinkedAccount'],
      useFetchData<RemoveLinkedAccountMutation, RemoveLinkedAccountMutationVariables>(RemoveLinkedAccountDocument),
      options
    )};

export const CalculatePenaltyDocument = `
    mutation CalculatePenalty($accountId: String!, $taxYear: Int!) {
  calculatePenalty(accountId: $accountId, taxYear: $taxYear) {
    penalty
  }
}
    `;

export const useCalculatePenaltyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CalculatePenaltyMutation, TError, CalculatePenaltyMutationVariables, TContext>) => {
    
    return useMutation<CalculatePenaltyMutation, TError, CalculatePenaltyMutationVariables, TContext>(
      ['CalculatePenalty'],
      useFetchData<CalculatePenaltyMutation, CalculatePenaltyMutationVariables>(CalculatePenaltyDocument),
      options
    )};

export const UpdateExemptAndGetSummaryAmountDocument = `
    mutation updateExemptAndGetSummaryAmount($accountId: String!, $isExempt: Boolean!, $taxYear: Int!) {
  updateExemptAndGetSummaryAmount(
    accountId: $accountId
    isExempt: $isExempt
    taxYear: $taxYear
  ) {
    assessmentCharge
    cost
    currentBalance
    delinquentBalance
    directCharge
    interest
    payments
    penaltyCharge
    taxRate
    taxable
    totalBalance
    totalBalanceWithDelinquent
  }
}
    `;

export const useUpdateExemptAndGetSummaryAmountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateExemptAndGetSummaryAmountMutation, TError, UpdateExemptAndGetSummaryAmountMutationVariables, TContext>) => {
    
    return useMutation<UpdateExemptAndGetSummaryAmountMutation, TError, UpdateExemptAndGetSummaryAmountMutationVariables, TContext>(
      ['updateExemptAndGetSummaryAmount'],
      useFetchData<UpdateExemptAndGetSummaryAmountMutation, UpdateExemptAndGetSummaryAmountMutationVariables>(UpdateExemptAndGetSummaryAmountDocument),
      options
    )};

export const GetBusinessAccountIdByNumberDocument = `
    query GetBusinessAccountIdByNumber($accountNumber: String!, $taxYear: Int!) {
  getBusinessAccountIdByNumber(accountNumber: $accountNumber, taxYear: $taxYear) {
    accountId
  }
}
    `;

export const useGetBusinessAccountIdByNumberQuery = <
      TData = GetBusinessAccountIdByNumberQuery,
      TError = unknown
    >(
      variables: GetBusinessAccountIdByNumberQueryVariables,
      options?: UseQueryOptions<GetBusinessAccountIdByNumberQuery, TError, TData>
    ) => {
    
    return useQuery<GetBusinessAccountIdByNumberQuery, TError, TData>(
      ['GetBusinessAccountIdByNumber', variables],
      useFetchData<GetBusinessAccountIdByNumberQuery, GetBusinessAccountIdByNumberQueryVariables>(GetBusinessAccountIdByNumberDocument).bind(null, variables),
      options
    )};

export const SearchBusinessByAccountNumberDocument = `
    mutation SearchBusinessByAccountNumber($accountNumber: String!, $leaseMasterId: ID!, $subAccountId: ID!) {
  searchBusinessByAccountNumber(
    accountNumber: $accountNumber
    leaseMasterId: $leaseMasterId
    subAccountId: $subAccountId
  ) {
    ... on TaxDistrictBusinessAccountRow {
      leaseMasterId
      subAccountId
      businessAccountId
      jurisdictionId
      isHoldingAccount
      accountNumber
      businessName
      invalidTaxDistrict
      bafIsActive
      address {
        contactId
        addressLine1
        addressLine2
        city
        state
        zipCode
      }
      isActive
      __typename
    }
    ... on EntityNotFound {
      message
      __typename
    }
  }
}
    `;

export const useSearchBusinessByAccountNumberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SearchBusinessByAccountNumberMutation, TError, SearchBusinessByAccountNumberMutationVariables, TContext>) => {
    
    return useMutation<SearchBusinessByAccountNumberMutation, TError, SearchBusinessByAccountNumberMutationVariables, TContext>(
      ['SearchBusinessByAccountNumber'],
      useFetchData<SearchBusinessByAccountNumberMutation, SearchBusinessByAccountNumberMutationVariables>(SearchBusinessByAccountNumberDocument),
      options
    )};

export const GetTaxDistrictBusinessAccountListDocument = `
    query GetTaxDistrictBusinessAccountList($leaseMasterId: ID!, $subAccountId: ID!, $taxYear: Int!) {
  taxDistrictBusinessAccountList(
    leaseMasterId: $leaseMasterId
    subAccountId: $subAccountId
    taxYear: $taxYear
  ) {
    jurisdictionId
    leaseMasterId
    subAccountId
    businessAccountId
    isHoldingAccount
    accountNumber
    businessName
    invalidTaxDistrict
    bafIsActive
    address {
      contactId
      addressLine1
      addressLine2
      city
      state
      zipCode
    }
    isActive
  }
}
    `;

export const useGetTaxDistrictBusinessAccountListQuery = <
      TData = GetTaxDistrictBusinessAccountListQuery,
      TError = unknown
    >(
      variables: GetTaxDistrictBusinessAccountListQueryVariables,
      options?: UseQueryOptions<GetTaxDistrictBusinessAccountListQuery, TError, TData>
    ) => {
    
    return useQuery<GetTaxDistrictBusinessAccountListQuery, TError, TData>(
      ['GetTaxDistrictBusinessAccountList', variables],
      useFetchData<GetTaxDistrictBusinessAccountListQuery, GetTaxDistrictBusinessAccountListQueryVariables>(GetTaxDistrictBusinessAccountListDocument).bind(null, variables),
      options
    )};

export const SaveTaxDistrictBusinessAccountListDocument = `
    mutation SaveTaxDistrictBusinessAccountList($businessAccountList: [TaxDistrictBusinessAccountRowInput!]!) {
  saveTaxDistrictBusinessAccountList(businessAccountList: $businessAccountList) {
    jurisdictionId
    leaseMasterId
    subAccountId
    businessAccountId
    isHoldingAccount
    accountNumber
    businessName
    invalidTaxDistrict
    bafIsActive
    address {
      contactId
      addressLine1
      addressLine2
      city
      state
      zipCode
    }
    isActive
  }
}
    `;

export const useSaveTaxDistrictBusinessAccountListMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveTaxDistrictBusinessAccountListMutation, TError, SaveTaxDistrictBusinessAccountListMutationVariables, TContext>) => {
    
    return useMutation<SaveTaxDistrictBusinessAccountListMutation, TError, SaveTaxDistrictBusinessAccountListMutationVariables, TContext>(
      ['SaveTaxDistrictBusinessAccountList'],
      useFetchData<SaveTaxDistrictBusinessAccountListMutation, SaveTaxDistrictBusinessAccountListMutationVariables>(SaveTaxDistrictBusinessAccountListDocument),
      options
    )};

export const CreateHoldingAccountDocument = `
    mutation CreateHoldingAccount($holdingAccountInput: CreateHoldingAccountInput!) {
  createHoldingAccount(holdingAccountInput: $holdingAccountInput) {
    value
  }
}
    `;

export const useCreateHoldingAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateHoldingAccountMutation, TError, CreateHoldingAccountMutationVariables, TContext>) => {
    
    return useMutation<CreateHoldingAccountMutation, TError, CreateHoldingAccountMutationVariables, TContext>(
      ['CreateHoldingAccount'],
      useFetchData<CreateHoldingAccountMutation, CreateHoldingAccountMutationVariables>(CreateHoldingAccountDocument),
      options
    )};

export const ReopenFilingDocument = `
    mutation ReopenFiling($accountId: String!) {
  reopenFiling(accountId: $accountId)
}
    `;

export const useReopenFilingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReopenFilingMutation, TError, ReopenFilingMutationVariables, TContext>) => {
    
    return useMutation<ReopenFilingMutation, TError, ReopenFilingMutationVariables, TContext>(
      ['ReopenFiling'],
      useFetchData<ReopenFilingMutation, ReopenFilingMutationVariables>(ReopenFilingDocument),
      options
    )};

export const GetBusinessAppraiserRegionListDocument = `
    query GetBusinessAppraiserRegionList {
  getBusinessAppraiserRegionList {
    regionName
    columnsNames {
      groupingLabel1
      groupingLabel2
    }
    rows {
      id
      groupingValue1
      groupingValue2
      regionName
    }
  }
}
    `;

export const useGetBusinessAppraiserRegionListQuery = <
      TData = GetBusinessAppraiserRegionListQuery,
      TError = unknown
    >(
      variables?: GetBusinessAppraiserRegionListQueryVariables,
      options?: UseQueryOptions<GetBusinessAppraiserRegionListQuery, TError, TData>
    ) => {
    
    return useQuery<GetBusinessAppraiserRegionListQuery, TError, TData>(
      variables === undefined ? ['GetBusinessAppraiserRegionList'] : ['GetBusinessAppraiserRegionList', variables],
      useFetchData<GetBusinessAppraiserRegionListQuery, GetBusinessAppraiserRegionListQueryVariables>(GetBusinessAppraiserRegionListDocument).bind(null, variables),
      options
    )};

export const GetRegionAndIdListDocument = `
    query GetRegionAndIDList {
  getBusinessAppraiserRegionList {
    rows {
      id
      groupingValue1
      groupingValue2
    }
  }
}
    `;

export const useGetRegionAndIdListQuery = <
      TData = GetRegionAndIdListQuery,
      TError = unknown
    >(
      variables?: GetRegionAndIdListQueryVariables,
      options?: UseQueryOptions<GetRegionAndIdListQuery, TError, TData>
    ) => {
    
    return useQuery<GetRegionAndIdListQuery, TError, TData>(
      variables === undefined ? ['GetRegionAndIDList'] : ['GetRegionAndIDList', variables],
      useFetchData<GetRegionAndIdListQuery, GetRegionAndIdListQueryVariables>(GetRegionAndIdListDocument).bind(null, variables),
      options
    )};

export const GetAppraiserRegionsDocument = `
    query GetAppraiserRegions {
  appraiserRegions {
    id
    region
    name
    code
    accountCount
    newBusinessCount
    isActive
    updateDate
    updatedBy
  }
}
    `;

export const useGetAppraiserRegionsQuery = <
      TData = GetAppraiserRegionsQuery,
      TError = unknown
    >(
      variables?: GetAppraiserRegionsQueryVariables,
      options?: UseQueryOptions<GetAppraiserRegionsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAppraiserRegionsQuery, TError, TData>(
      variables === undefined ? ['GetAppraiserRegions'] : ['GetAppraiserRegions', variables],
      useFetchData<GetAppraiserRegionsQuery, GetAppraiserRegionsQueryVariables>(GetAppraiserRegionsDocument).bind(null, variables),
      options
    )};

export const SaveAppraiserRegionDocument = `
    mutation SaveAppraiserRegion($appraiserRegion: SaveAppraiserRegionInput!) {
  saveAppraiserRegion(appraiserRegion: $appraiserRegion)
}
    `;

export const useSaveAppraiserRegionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveAppraiserRegionMutation, TError, SaveAppraiserRegionMutationVariables, TContext>) => {
    
    return useMutation<SaveAppraiserRegionMutation, TError, SaveAppraiserRegionMutationVariables, TContext>(
      ['SaveAppraiserRegion'],
      useFetchData<SaveAppraiserRegionMutation, SaveAppraiserRegionMutationVariables>(SaveAppraiserRegionDocument),
      options
    )};

export const AccountsByAppraiserRegionDocument = `
    query AccountsByAppraiserRegion($regionId: String!) {
  accountsByAppraiserRegion(regionId: $regionId) {
    id
    accountId
    accountNumber
    businessName
    regionId
    name
    code
    region
  }
}
    `;

export const useAccountsByAppraiserRegionQuery = <
      TData = AccountsByAppraiserRegionQuery,
      TError = unknown
    >(
      variables: AccountsByAppraiserRegionQueryVariables,
      options?: UseQueryOptions<AccountsByAppraiserRegionQuery, TError, TData>
    ) => {
    
    return useQuery<AccountsByAppraiserRegionQuery, TError, TData>(
      ['AccountsByAppraiserRegion', variables],
      useFetchData<AccountsByAppraiserRegionQuery, AccountsByAppraiserRegionQueryVariables>(AccountsByAppraiserRegionDocument).bind(null, variables),
      options
    )};

export const GetAppraiserRegionJurConfigDocument = `
    query GetAppraiserRegionJurConfig {
  appraiserRegionJurConfig {
    areaName
    groupingLabel1
    groupingLabel2
  }
}
    `;

export const useGetAppraiserRegionJurConfigQuery = <
      TData = GetAppraiserRegionJurConfigQuery,
      TError = unknown
    >(
      variables?: GetAppraiserRegionJurConfigQueryVariables,
      options?: UseQueryOptions<GetAppraiserRegionJurConfigQuery, TError, TData>
    ) => {
    
    return useQuery<GetAppraiserRegionJurConfigQuery, TError, TData>(
      variables === undefined ? ['GetAppraiserRegionJurConfig'] : ['GetAppraiserRegionJurConfig', variables],
      useFetchData<GetAppraiserRegionJurConfigQuery, GetAppraiserRegionJurConfigQueryVariables>(GetAppraiserRegionJurConfigDocument).bind(null, variables),
      options
    )};

export const MergeAppraiserRegionsDocument = `
    mutation MergeAppraiserRegions($mergeAppraiserRegionsInput: MergeAppraiserRegionsInput!) {
  mergeAppraiserRegions(mergeAppraiserRegionsInput: $mergeAppraiserRegionsInput) {
    updatedAccounts
  }
}
    `;

export const useMergeAppraiserRegionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MergeAppraiserRegionsMutation, TError, MergeAppraiserRegionsMutationVariables, TContext>) => {
    
    return useMutation<MergeAppraiserRegionsMutation, TError, MergeAppraiserRegionsMutationVariables, TContext>(
      ['MergeAppraiserRegions'],
      useFetchData<MergeAppraiserRegionsMutation, MergeAppraiserRegionsMutationVariables>(MergeAppraiserRegionsDocument),
      options
    )};

export const BulkUpdateAppraiserRegionDocument = `
    mutation BulkUpdateAppraiserRegion($input: BulkUpdateAppraiserRegionInput!) {
  bulkUpdateAppraiserRegion(input: $input) {
    status
    rowsRead
    updatedAccounts
    failedRows
    results {
      rowNumber
      accountNumber
      businessName
      errorMessage
    }
  }
}
    `;

export const useBulkUpdateAppraiserRegionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BulkUpdateAppraiserRegionMutation, TError, BulkUpdateAppraiserRegionMutationVariables, TContext>) => {
    
    return useMutation<BulkUpdateAppraiserRegionMutation, TError, BulkUpdateAppraiserRegionMutationVariables, TContext>(
      ['BulkUpdateAppraiserRegion'],
      useFetchData<BulkUpdateAppraiserRegionMutation, BulkUpdateAppraiserRegionMutationVariables>(BulkUpdateAppraiserRegionDocument),
      options
    )};

export const GetCreateContactDataDocument = `
    query GetCreateContactData {
  countries {
    code
    name
  }
  contactTypes {
    id
    label
  }
}
    `;

export const useGetCreateContactDataQuery = <
      TData = GetCreateContactDataQuery,
      TError = unknown
    >(
      variables?: GetCreateContactDataQueryVariables,
      options?: UseQueryOptions<GetCreateContactDataQuery, TError, TData>
    ) => {
    
    return useQuery<GetCreateContactDataQuery, TError, TData>(
      variables === undefined ? ['GetCreateContactData'] : ['GetCreateContactData', variables],
      useFetchData<GetCreateContactDataQuery, GetCreateContactDataQueryVariables>(GetCreateContactDataDocument).bind(null, variables),
      options
    )};

export const GetContactListDocument = `
    query GetContactList($accountId: Int!, $taxYear: Int!) {
  contacts(accountId: $accountId, taxYear: $taxYear) {
    id
    name
    email
    phone
    phoneExtension
    cellphone
    isPrimary
    sameAsBusinessAddress
    contactType {
      id
      label
    }
    mailingAddress {
      inCareOf
      addressLine1
      addressLine2
      city
      state
      zipCode
      country {
        code
        name
      }
    }
  }
}
    `;

export const useGetContactListQuery = <
      TData = GetContactListQuery,
      TError = unknown
    >(
      variables: GetContactListQueryVariables,
      options?: UseQueryOptions<GetContactListQuery, TError, TData>
    ) => {
    
    return useQuery<GetContactListQuery, TError, TData>(
      ['GetContactList', variables],
      useFetchData<GetContactListQuery, GetContactListQueryVariables>(GetContactListDocument).bind(null, variables),
      options
    )};

export const CreateContactDocument = `
    mutation CreateContact($accountId: Int!, $taxYear: Int!, $contact: ContactInput!) {
  createContact(accountId: $accountId, taxYear: $taxYear, contact: $contact) {
    id
    name
    email
    phone
    phoneExtension
    cellphone
    isPrimary
    sameAsBusinessAddress
    contactType {
      id
      label
    }
    mailingAddress {
      inCareOf
      addressLine1
      addressLine2
      city
      state
      zipCode
      country {
        code
        name
      }
    }
  }
}
    `;

export const useCreateContactMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateContactMutation, TError, CreateContactMutationVariables, TContext>) => {
    
    return useMutation<CreateContactMutation, TError, CreateContactMutationVariables, TContext>(
      ['CreateContact'],
      useFetchData<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument),
      options
    )};

export const SaveContactDocument = `
    mutation SaveContact($accountId: Int!, $taxYear: Int!, $contact: ContactInput!) {
  saveContact(accountId: $accountId, taxYear: $taxYear, contact: $contact) {
    id
    name
    email
    phone
    phoneExtension
    cellphone
    isPrimary
    sameAsBusinessAddress
    contactType {
      id
      label
    }
    mailingAddress {
      inCareOf
      addressLine1
      addressLine2
      city
      state
      zipCode
      country {
        code
        name
      }
    }
  }
}
    `;

export const useSaveContactMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveContactMutation, TError, SaveContactMutationVariables, TContext>) => {
    
    return useMutation<SaveContactMutation, TError, SaveContactMutationVariables, TContext>(
      ['SaveContact'],
      useFetchData<SaveContactMutation, SaveContactMutationVariables>(SaveContactDocument),
      options
    )};

export const RemoveContactDocument = `
    mutation RemoveContact($accountId: Int!, $id: ID!, $primaryContact: ContactInput) {
  removeContact(accountId: $accountId, id: $id, primaryContact: $primaryContact) {
    isDeleted
    primaryContact {
      id
      name
      email
      name
      phone
      phoneExtension
      cellphone
      isPrimary
      sameAsBusinessAddress
      contactType {
        id
        label
      }
      mailingAddress {
        inCareOf
        addressLine1
        addressLine2
        city
        state
        zipCode
        country {
          code
          name
        }
      }
    }
  }
}
    `;

export const useRemoveContactMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveContactMutation, TError, RemoveContactMutationVariables, TContext>) => {
    
    return useMutation<RemoveContactMutation, TError, RemoveContactMutationVariables, TContext>(
      ['RemoveContact'],
      useFetchData<RemoveContactMutation, RemoveContactMutationVariables>(RemoveContactDocument),
      options
    )};

export const CreateLeaseMasterContactDocument = `
    mutation CreateLeaseMasterContact($accountId: Int!, $contact: ContactInput!) {
  createLeaseMasterContact(accountId: $accountId, contact: $contact) {
    id
    contactType {
      id
      label
    }
    name
    email
    phone
    phoneExtension
    cellphone
    isPrimary
    sameAsBusinessAddress
    mailingAddress {
      addressLine1
      addressLine2
      inCareOf
      city
      state
      zipCode
      country {
        code
        name
      }
    }
  }
}
    `;

export const useCreateLeaseMasterContactMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateLeaseMasterContactMutation, TError, CreateLeaseMasterContactMutationVariables, TContext>) => {
    
    return useMutation<CreateLeaseMasterContactMutation, TError, CreateLeaseMasterContactMutationVariables, TContext>(
      ['CreateLeaseMasterContact'],
      useFetchData<CreateLeaseMasterContactMutation, CreateLeaseMasterContactMutationVariables>(CreateLeaseMasterContactDocument),
      options
    )};

export const SaveLeaseMasterContactDocument = `
    mutation SaveLeaseMasterContact($accountId: Int!, $contact: ContactInput!) {
  saveLeaseMasterContact(accountId: $accountId, contact: $contact) {
    id
    contactType {
      id
      label
    }
    name
    email
    phone
    phoneExtension
    cellphone
    isPrimary
    sameAsBusinessAddress
    mailingAddress {
      addressLine1
      addressLine2
      inCareOf
      city
      state
      zipCode
      country {
        code
        name
      }
    }
  }
}
    `;

export const useSaveLeaseMasterContactMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveLeaseMasterContactMutation, TError, SaveLeaseMasterContactMutationVariables, TContext>) => {
    
    return useMutation<SaveLeaseMasterContactMutation, TError, SaveLeaseMasterContactMutationVariables, TContext>(
      ['SaveLeaseMasterContact'],
      useFetchData<SaveLeaseMasterContactMutation, SaveLeaseMasterContactMutationVariables>(SaveLeaseMasterContactDocument),
      options
    )};

export const RemoveLeaseMasterContactDocument = `
    mutation RemoveLeaseMasterContact($accountId: Int!, $id: ID!, $primaryContact: ContactInput) {
  removeLeaseMasterContact(
    accountId: $accountId
    id: $id
    primaryContact: $primaryContact
  ) {
    isDeleted
    primaryContact {
      id
      contactType {
        id
        label
      }
      name
      email
      phone
      phoneExtension
      cellphone
      isPrimary
      sameAsBusinessAddress
      mailingAddress {
        addressLine1
        addressLine2
        inCareOf
        city
        state
        zipCode
        country {
          code
          name
        }
      }
    }
  }
}
    `;

export const useRemoveLeaseMasterContactMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveLeaseMasterContactMutation, TError, RemoveLeaseMasterContactMutationVariables, TContext>) => {
    
    return useMutation<RemoveLeaseMasterContactMutation, TError, RemoveLeaseMasterContactMutationVariables, TContext>(
      ['RemoveLeaseMasterContact'],
      useFetchData<RemoveLeaseMasterContactMutation, RemoveLeaseMasterContactMutationVariables>(RemoveLeaseMasterContactDocument),
      options
    )};

export const GetLeaseMasterContactsDocument = `
    query GetLeaseMasterContacts($accountId: Int!, $taxYear: Int!) {
  leaseMasterContact(accountId: $accountId, taxYear: $taxYear) {
    id
    contactType {
      id
      label
    }
    name
    email
    phone
    phoneExtension
    cellphone
    isPrimary
    sameAsBusinessAddress
    mailingAddress {
      addressLine1
      addressLine2
      inCareOf
      city
      state
      zipCode
      country {
        code
        name
      }
    }
  }
}
    `;

export const useGetLeaseMasterContactsQuery = <
      TData = GetLeaseMasterContactsQuery,
      TError = unknown
    >(
      variables: GetLeaseMasterContactsQueryVariables,
      options?: UseQueryOptions<GetLeaseMasterContactsQuery, TError, TData>
    ) => {
    
    return useQuery<GetLeaseMasterContactsQuery, TError, TData>(
      ['GetLeaseMasterContacts', variables],
      useFetchData<GetLeaseMasterContactsQuery, GetLeaseMasterContactsQueryVariables>(GetLeaseMasterContactsDocument).bind(null, variables),
      options
    )};

export const SetLeaseMasterPrimaryContactDocument = `
    mutation SetLeaseMasterPrimaryContact($accountId: Int!, $id: ID!) {
  setLeaseMasterPrimaryContact(accountId: $accountId, id: $id)
}
    `;

export const useSetLeaseMasterPrimaryContactMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetLeaseMasterPrimaryContactMutation, TError, SetLeaseMasterPrimaryContactMutationVariables, TContext>) => {
    
    return useMutation<SetLeaseMasterPrimaryContactMutation, TError, SetLeaseMasterPrimaryContactMutationVariables, TContext>(
      ['SetLeaseMasterPrimaryContact'],
      useFetchData<SetLeaseMasterPrimaryContactMutation, SetLeaseMasterPrimaryContactMutationVariables>(SetLeaseMasterPrimaryContactDocument),
      options
    )};

export const GetTelecomContactsDocument = `
    query GetTelecomContacts($accountId: Int!, $taxYear: Int!) {
  telecomContacts(accountId: $accountId, taxYear: $taxYear) {
    id
    contactType {
      id
      label
    }
    name
    email
    phone
    phoneExtension
    cellphone
    isPrimary
    sameAsBusinessAddress
    mailingAddress {
      addressLine1
      addressLine2
      inCareOf
      city
      state
      zipCode
      country {
        code
        name
      }
    }
  }
}
    `;

export const useGetTelecomContactsQuery = <
      TData = GetTelecomContactsQuery,
      TError = unknown
    >(
      variables: GetTelecomContactsQueryVariables,
      options?: UseQueryOptions<GetTelecomContactsQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomContactsQuery, TError, TData>(
      ['GetTelecomContacts', variables],
      useFetchData<GetTelecomContactsQuery, GetTelecomContactsQueryVariables>(GetTelecomContactsDocument).bind(null, variables),
      options
    )};

export const CreateTelecomContactDocument = `
    mutation CreateTelecomContact($accountId: Int!, $contact: ContactInput!) {
  createTelecomContact(accountId: $accountId, contact: $contact) {
    id
    contactType {
      id
      label
    }
    name
    email
    phone
    phoneExtension
    cellphone
    isPrimary
    sameAsBusinessAddress
    mailingAddress {
      addressLine1
      addressLine2
      inCareOf
      city
      state
      zipCode
      country {
        code
        name
      }
    }
  }
}
    `;

export const useCreateTelecomContactMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTelecomContactMutation, TError, CreateTelecomContactMutationVariables, TContext>) => {
    
    return useMutation<CreateTelecomContactMutation, TError, CreateTelecomContactMutationVariables, TContext>(
      ['CreateTelecomContact'],
      useFetchData<CreateTelecomContactMutation, CreateTelecomContactMutationVariables>(CreateTelecomContactDocument),
      options
    )};

export const SaveTelecomContactDocument = `
    mutation SaveTelecomContact($accountId: Int!, $contact: ContactInput!) {
  saveTelecomContact(accountId: $accountId, contact: $contact) {
    id
    contactType {
      id
      label
    }
    name
    email
    phone
    phoneExtension
    cellphone
    isPrimary
    sameAsBusinessAddress
    mailingAddress {
      addressLine1
      addressLine2
      inCareOf
      city
      state
      zipCode
      country {
        code
        name
      }
    }
  }
}
    `;

export const useSaveTelecomContactMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveTelecomContactMutation, TError, SaveTelecomContactMutationVariables, TContext>) => {
    
    return useMutation<SaveTelecomContactMutation, TError, SaveTelecomContactMutationVariables, TContext>(
      ['SaveTelecomContact'],
      useFetchData<SaveTelecomContactMutation, SaveTelecomContactMutationVariables>(SaveTelecomContactDocument),
      options
    )};

export const RemoveTelecomContactDocument = `
    mutation RemoveTelecomContact($accountId: Int!, $id: ID!, $primaryContact: ContactInput) {
  removeTelecomContact(
    accountId: $accountId
    id: $id
    primaryContact: $primaryContact
  ) {
    isDeleted
    primaryContact {
      id
      contactType {
        id
        label
      }
      name
      email
      phone
      phoneExtension
      cellphone
      isPrimary
      sameAsBusinessAddress
      mailingAddress {
        addressLine1
        addressLine2
        inCareOf
        city
        state
        zipCode
        country {
          code
          name
        }
      }
    }
  }
}
    `;

export const useRemoveTelecomContactMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTelecomContactMutation, TError, RemoveTelecomContactMutationVariables, TContext>) => {
    
    return useMutation<RemoveTelecomContactMutation, TError, RemoveTelecomContactMutationVariables, TContext>(
      ['RemoveTelecomContact'],
      useFetchData<RemoveTelecomContactMutation, RemoveTelecomContactMutationVariables>(RemoveTelecomContactDocument),
      options
    )};

export const SetTelecomPrimaryContactDocument = `
    mutation SetTelecomPrimaryContact($accountId: Int!, $id: ID!) {
  setTelecomPrimaryContact(accountId: $accountId, id: $id)
}
    `;

export const useSetTelecomPrimaryContactMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetTelecomPrimaryContactMutation, TError, SetTelecomPrimaryContactMutationVariables, TContext>) => {
    
    return useMutation<SetTelecomPrimaryContactMutation, TError, SetTelecomPrimaryContactMutationVariables, TContext>(
      ['SetTelecomPrimaryContact'],
      useFetchData<SetTelecomPrimaryContactMutation, SetTelecomPrimaryContactMutationVariables>(SetTelecomPrimaryContactDocument),
      options
    )};

export const GetCountriesDocument = `
    query GetCountries {
  countries {
    code
    name
  }
}
    `;

export const useGetCountriesQuery = <
      TData = GetCountriesQuery,
      TError = unknown
    >(
      variables?: GetCountriesQueryVariables,
      options?: UseQueryOptions<GetCountriesQuery, TError, TData>
    ) => {
    
    return useQuery<GetCountriesQuery, TError, TData>(
      variables === undefined ? ['GetCountries'] : ['GetCountries', variables],
      useFetchData<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument).bind(null, variables),
      options
    )};

export const GetCountySettingsDocument = `
    query GetCountySettings($searchFilters: SearchFilters) {
  countySettings {
    countyName
    supportPhone
    supportEmail
    workDays
    workHours
    locationAddress
    mailingAddress
    supportLinkURL
    contacts {
      id
      name
      title
      email
      phone
    }
  }
  search(searchFilters: $searchFilters) {
    id
    username
    email
    fullName
    title
    phone
    isActive
    isVerified
  }
}
    `;

export const useGetCountySettingsQuery = <
      TData = GetCountySettingsQuery,
      TError = unknown
    >(
      variables?: GetCountySettingsQueryVariables,
      options?: UseQueryOptions<GetCountySettingsQuery, TError, TData>
    ) => {
    
    return useQuery<GetCountySettingsQuery, TError, TData>(
      variables === undefined ? ['GetCountySettings'] : ['GetCountySettings', variables],
      useFetchData<GetCountySettingsQuery, GetCountySettingsQueryVariables>(GetCountySettingsDocument).bind(null, variables),
      options
    )};

export const SaveCountyContactsDocument = `
    mutation SaveCountyContacts($contacts: [String!]!) {
  saveCountyContacts(contactIds: $contacts) {
    countyName
    supportPhone
    supportEmail
    workDays
    workHours
    locationAddress
    mailingAddress
    supportLinkURL
    contacts {
      id
      name
      title
      email
      phone
    }
  }
}
    `;

export const useSaveCountyContactsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveCountyContactsMutation, TError, SaveCountyContactsMutationVariables, TContext>) => {
    
    return useMutation<SaveCountyContactsMutation, TError, SaveCountyContactsMutationVariables, TContext>(
      ['SaveCountyContacts'],
      useFetchData<SaveCountyContactsMutation, SaveCountyContactsMutationVariables>(SaveCountyContactsDocument),
      options
    )};

export const GetCurrentTaxYearDocument = `
    query GetCurrentTaxYear {
  currentTaxYear
}
    `;

export const useGetCurrentTaxYearQuery = <
      TData = GetCurrentTaxYearQuery,
      TError = unknown
    >(
      variables?: GetCurrentTaxYearQueryVariables,
      options?: UseQueryOptions<GetCurrentTaxYearQuery, TError, TData>
    ) => {
    
    return useQuery<GetCurrentTaxYearQuery, TError, TData>(
      variables === undefined ? ['GetCurrentTaxYear'] : ['GetCurrentTaxYear', variables],
      useFetchData<GetCurrentTaxYearQuery, GetCurrentTaxYearQueryVariables>(GetCurrentTaxYearDocument).bind(null, variables),
      options
    )};

export const AccountDelinquencyDocument = `
    query AccountDelinquency($accountId: Int!, $accountIdString: String!, $taxYear: Int!) {
  accountDelinquency(accountId: $accountId, taxYear: $taxYear) {
    accountId
    accountNumber
    businessName
    accountType
    originalDelinquentYear
    totalInterest
    totalPenalties
    totalCharges
    totalTax
    delinquentBalance
    lastPaymentDate
    transactions {
      id
      delinquentYearId
      taxYear
      taxDistrict
      assessmentCharge
      calculatedAssessmentCharge
      directCharges
      calculatedDirectCharges
      penalties
      calculatedPenalties
      interest
      calculatedInterest
      total
      interestPaid
      interestNotPaid
      interestOffset
      interestUpdated
      totalPaid
    }
    summary {
      assessmentCharge
      totalDirectCharge
      totalPayments
      penaltyCharge
      interest
      balance
      balanceWithDelinquent
    }
    paymentPlan {
      id
      total
      terms {
        dueDate
        amount
      }
    }
  }
  paymentTypes {
    id
    description
  }
  getBusinessAccount(accountId: $accountIdString, taxYear: $taxYear) {
    id
    accountNumber
    isActive
    filingStatus {
      hasAttachment
      howFiled {
        id
        label
      }
    }
  }
}
    `;

export const useAccountDelinquencyQuery = <
      TData = AccountDelinquencyQuery,
      TError = unknown
    >(
      variables: AccountDelinquencyQueryVariables,
      options?: UseQueryOptions<AccountDelinquencyQuery, TError, TData>
    ) => {
    
    return useQuery<AccountDelinquencyQuery, TError, TData>(
      ['AccountDelinquency', variables],
      useFetchData<AccountDelinquencyQuery, AccountDelinquencyQueryVariables>(AccountDelinquencyDocument).bind(null, variables),
      options
    )};

export const CalculateAccountDelinquencyDocument = `
    mutation CalculateAccountDelinquency($delinquency: CalculateAccountDelinquencyInput!, $taxYear: Int!, $reset: Boolean) {
  calculateAccountDelinquency(
    delinquency: $delinquency
    taxYear: $taxYear
    reset: $reset
  ) {
    accountId
    totalInterest
    totalPenalties
    totalCharges
    totalTax
    delinquentBalance
    transactions {
      id
      delinquentYearId
      taxYear
      taxDistrict
      assessmentCharge
      calculatedAssessmentCharge
      directCharges
      calculatedDirectCharges
      penalties
      calculatedPenalties
      interest
      calculatedInterest
      total
      interestPaid
      interestNotPaid
      interestOffset
      interestUpdated
      totalPaid
    }
    summary {
      assessmentCharge
      totalDirectCharge
      totalPayments
      penaltyCharge
      interest
      balance
      balanceWithDelinquent
    }
  }
}
    `;

export const useCalculateAccountDelinquencyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CalculateAccountDelinquencyMutation, TError, CalculateAccountDelinquencyMutationVariables, TContext>) => {
    
    return useMutation<CalculateAccountDelinquencyMutation, TError, CalculateAccountDelinquencyMutationVariables, TContext>(
      ['CalculateAccountDelinquency'],
      useFetchData<CalculateAccountDelinquencyMutation, CalculateAccountDelinquencyMutationVariables>(CalculateAccountDelinquencyDocument),
      options
    )};

export const CreateDelinquentPaymentDocument = `
    mutation CreateDelinquentPayment($payment: CreateDelinquentPaymentInput!) {
  createDelinquentPayment(payment: $payment) {
    paymentId
    delinquency {
      accountId
      accountNumber
      businessName
      accountType
      originalDelinquentYear
      totalInterest
      totalPenalties
      totalCharges
      totalTax
      delinquentBalance
      lastPaymentDate
      transactions {
        id
        delinquentYearId
        taxYear
        taxDistrict
        assessmentCharge
        calculatedAssessmentCharge
        directCharges
        calculatedDirectCharges
        penalties
        calculatedPenalties
        interest
        calculatedInterest
        total
        interestPaid
        interestNotPaid
        interestOffset
        interestUpdated
        totalPaid
      }
      summary {
        assessmentCharge
        totalDirectCharge
        totalPayments
        penaltyCharge
        interest
        balance
        balanceWithDelinquent
      }
      paymentPlan {
        id
        total
        terms {
          dueDate
          amount
        }
      }
    }
  }
}
    `;

export const useCreateDelinquentPaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDelinquentPaymentMutation, TError, CreateDelinquentPaymentMutationVariables, TContext>) => {
    
    return useMutation<CreateDelinquentPaymentMutation, TError, CreateDelinquentPaymentMutationVariables, TContext>(
      ['CreateDelinquentPayment'],
      useFetchData<CreateDelinquentPaymentMutation, CreateDelinquentPaymentMutationVariables>(CreateDelinquentPaymentDocument),
      options
    )};

export const EditDelinquentPaymentDocument = `
    mutation EditDelinquentPayment($payment: EditDelinquentPaymentInput!) {
  editDelinquentPayment(payment: $payment)
}
    `;

export const useEditDelinquentPaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditDelinquentPaymentMutation, TError, EditDelinquentPaymentMutationVariables, TContext>) => {
    
    return useMutation<EditDelinquentPaymentMutation, TError, EditDelinquentPaymentMutationVariables, TContext>(
      ['EditDelinquentPayment'],
      useFetchData<EditDelinquentPaymentMutation, EditDelinquentPaymentMutationVariables>(EditDelinquentPaymentDocument),
      options
    )};

export const DelinquentYearSummaryDocument = `
    query DelinquentYearSummary($dateReceived: String!) {
  delinquentYearSummary(dateReceived: $dateReceived) {
    payments {
      id
      receiptNumber
      accountId
      accountNumber
      businessName
      receivedFrom
      dateReceived
      paymentAmount
      paymentType {
        id
        description
      }
      paymentStatus {
        id
        description
      }
      checkNumber
      isVoided
      ein {
        id
        name
      }
    }
    totalCash
    totalChecks
    totalCredit
    totalEChecks
    totalReturnedChecks
    totalReturnedEChecks
    grandTotal
  }
}
    `;

export const useDelinquentYearSummaryQuery = <
      TData = DelinquentYearSummaryQuery,
      TError = unknown
    >(
      variables: DelinquentYearSummaryQueryVariables,
      options?: UseQueryOptions<DelinquentYearSummaryQuery, TError, TData>
    ) => {
    
    return useQuery<DelinquentYearSummaryQuery, TError, TData>(
      ['DelinquentYearSummary', variables],
      useFetchData<DelinquentYearSummaryQuery, DelinquentYearSummaryQueryVariables>(DelinquentYearSummaryDocument).bind(null, variables),
      options
    )};

export const DelinquentPaymentHistoryDocument = `
    query DelinquentPaymentHistory($accountNumber: String!) {
  delinquentPaymentHistory(accountNumber: $accountNumber) {
    id
    receiptNumber
    accountId
    accountNumber
    receivedFrom
    amount
    paymentType {
      id
      description
    }
    paymentStatus {
      id
      description
    }
    checkNumber
    date
  }
}
    `;

export const useDelinquentPaymentHistoryQuery = <
      TData = DelinquentPaymentHistoryQuery,
      TError = unknown
    >(
      variables: DelinquentPaymentHistoryQueryVariables,
      options?: UseQueryOptions<DelinquentPaymentHistoryQuery, TError, TData>
    ) => {
    
    return useQuery<DelinquentPaymentHistoryQuery, TError, TData>(
      ['DelinquentPaymentHistory', variables],
      useFetchData<DelinquentPaymentHistoryQuery, DelinquentPaymentHistoryQueryVariables>(DelinquentPaymentHistoryDocument).bind(null, variables),
      options
    )};

export const GetDelinquentYearTransactionsDocument = `
    query GetDelinquentYearTransactions($accountNumber: String!) {
  delinquentYearTransactions(accountNumber: $accountNumber) {
    accountId
    accountNumber
    businessName
    delinquentYearId
    delinquentYears {
      id
      taxYear
      taxDistrict
      balance
      transactions {
        id
        amount
        dateReceived
        receiptNumber
        ein
        isVoid
        directCharge {
          id
          description
        }
      }
    }
  }
}
    `;

export const useGetDelinquentYearTransactionsQuery = <
      TData = GetDelinquentYearTransactionsQuery,
      TError = unknown
    >(
      variables: GetDelinquentYearTransactionsQueryVariables,
      options?: UseQueryOptions<GetDelinquentYearTransactionsQuery, TError, TData>
    ) => {
    
    return useQuery<GetDelinquentYearTransactionsQuery, TError, TData>(
      ['GetDelinquentYearTransactions', variables],
      useFetchData<GetDelinquentYearTransactionsQuery, GetDelinquentYearTransactionsQueryVariables>(GetDelinquentYearTransactionsDocument).bind(null, variables),
      options
    )};

export const CreateDelinquentAdjustmentDocument = `
    mutation CreateDelinquentAdjustment($delinquentAdjustment: DelinquentAdjustmentInput!) {
  createDelinquentAdjustment(delinquentAdjustment: $delinquentAdjustment)
}
    `;

export const useCreateDelinquentAdjustmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDelinquentAdjustmentMutation, TError, CreateDelinquentAdjustmentMutationVariables, TContext>) => {
    
    return useMutation<CreateDelinquentAdjustmentMutation, TError, CreateDelinquentAdjustmentMutationVariables, TContext>(
      ['CreateDelinquentAdjustment'],
      useFetchData<CreateDelinquentAdjustmentMutation, CreateDelinquentAdjustmentMutationVariables>(CreateDelinquentAdjustmentDocument),
      options
    )};

export const GetSubAccountsForDelinquencyDocument = `
    query GetSubAccountsForDelinquency($leaseMasterAccountNumber: String!, $taxYear: Int!) {
  getSubAccounts(
    leaseMasterAccountNumber: $leaseMasterAccountNumber
    taxYear: $taxYear
  ) {
    id
    businessName
    subAccounts {
      id
      accountNumber
      taxDistrict
      hasDelinquentBalance
    }
  }
  paymentTypes {
    id
    description
  }
}
    `;

export const useGetSubAccountsForDelinquencyQuery = <
      TData = GetSubAccountsForDelinquencyQuery,
      TError = unknown
    >(
      variables: GetSubAccountsForDelinquencyQueryVariables,
      options?: UseQueryOptions<GetSubAccountsForDelinquencyQuery, TError, TData>
    ) => {
    
    return useQuery<GetSubAccountsForDelinquencyQuery, TError, TData>(
      ['GetSubAccountsForDelinquency', variables],
      useFetchData<GetSubAccountsForDelinquencyQuery, GetSubAccountsForDelinquencyQueryVariables>(GetSubAccountsForDelinquencyDocument).bind(null, variables),
      options
    )};

export const MasterAccountDelinquencyDocument = `
    query MasterAccountDelinquency($accountId: Int!, $taxYear: Int!) {
  accountDelinquency(accountId: $accountId, taxYear: $taxYear) {
    accountId
    accountNumber
    businessName
    accountType
    originalDelinquentYear
    totalInterest
    totalPenalties
    totalCharges
    totalTax
    delinquentBalance
    lastPaymentDate
    transactions {
      id
      delinquentYearId
      taxYear
      taxDistrict
      assessmentCharge
      calculatedAssessmentCharge
      directCharges
      calculatedDirectCharges
      penalties
      calculatedPenalties
      interest
      calculatedInterest
      total
    }
    summary {
      assessmentCharge
      totalDirectCharge
      totalPayments
      penaltyCharge
      interest
      balance
      balanceWithDelinquent
    }
    paymentPlan {
      id
      total
      terms {
        dueDate
        amount
      }
    }
  }
}
    `;

export const useMasterAccountDelinquencyQuery = <
      TData = MasterAccountDelinquencyQuery,
      TError = unknown
    >(
      variables: MasterAccountDelinquencyQueryVariables,
      options?: UseQueryOptions<MasterAccountDelinquencyQuery, TError, TData>
    ) => {
    
    return useQuery<MasterAccountDelinquencyQuery, TError, TData>(
      ['MasterAccountDelinquency', variables],
      useFetchData<MasterAccountDelinquencyQuery, MasterAccountDelinquencyQueryVariables>(MasterAccountDelinquencyDocument).bind(null, variables),
      options
    )};

export const MasterAccountDelinquentSummaryDocument = `
    query MasterAccountDelinquentSummary($masterAccountNumber: String!, $dateReceived: String!, $isTelecom: Boolean) {
  masterAccountDelinquentSummary(
    masterAccountNumber: $masterAccountNumber
    dateReceived: $dateReceived
    isTelecom: $isTelecom
  ) {
    accountTotals {
      totalPayments
      totalTax
      totalCharges
      totalPenalties
      totalInterest
      currentBalance
      totalCurrentAndDelinquent
    }
    delinquentAccountTotals {
      totalPayments
      totalTax
      totalCharges
      totalPenalties
      totalInterest
      delinquentBalance
    }
    subAccountTotals {
      subAccountId
      subAccountNumber
      taxDistrict
      payments
      netAssessmentCharge
      directCharges
      penalties
      interest
      total
    }
  }
}
    `;

export const useMasterAccountDelinquentSummaryQuery = <
      TData = MasterAccountDelinquentSummaryQuery,
      TError = unknown
    >(
      variables: MasterAccountDelinquentSummaryQueryVariables,
      options?: UseQueryOptions<MasterAccountDelinquentSummaryQuery, TError, TData>
    ) => {
    
    return useQuery<MasterAccountDelinquentSummaryQuery, TError, TData>(
      ['MasterAccountDelinquentSummary', variables],
      useFetchData<MasterAccountDelinquentSummaryQuery, MasterAccountDelinquentSummaryQueryVariables>(MasterAccountDelinquentSummaryDocument).bind(null, variables),
      options
    )};

export const GetTelecomSubAccountsForDelinquencyDocument = `
    query GetTelecomSubAccountsForDelinquency($telecomMasterId: Int!, $taxYear: Int!) {
  telecomSubAccounts(telecomMasterId: $telecomMasterId, taxYear: $taxYear) {
    accountId
    accountNumber
    taxDistrict
    hasDelinquentBalance
  }
  paymentTypes {
    id
    description
  }
}
    `;

export const useGetTelecomSubAccountsForDelinquencyQuery = <
      TData = GetTelecomSubAccountsForDelinquencyQuery,
      TError = unknown
    >(
      variables: GetTelecomSubAccountsForDelinquencyQueryVariables,
      options?: UseQueryOptions<GetTelecomSubAccountsForDelinquencyQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomSubAccountsForDelinquencyQuery, TError, TData>(
      ['GetTelecomSubAccountsForDelinquency', variables],
      useFetchData<GetTelecomSubAccountsForDelinquencyQuery, GetTelecomSubAccountsForDelinquencyQueryVariables>(GetTelecomSubAccountsForDelinquencyDocument).bind(null, variables),
      options
    )};

export const GetDirectChargeTypesDocument = `
    query GetDirectChargeTypes {
  getDirectChargeTypes {
    id
    description
  }
}
    `;

export const useGetDirectChargeTypesQuery = <
      TData = GetDirectChargeTypesQuery,
      TError = unknown
    >(
      variables?: GetDirectChargeTypesQueryVariables,
      options?: UseQueryOptions<GetDirectChargeTypesQuery, TError, TData>
    ) => {
    
    return useQuery<GetDirectChargeTypesQuery, TError, TData>(
      variables === undefined ? ['GetDirectChargeTypes'] : ['GetDirectChargeTypes', variables],
      useFetchData<GetDirectChargeTypesQuery, GetDirectChargeTypesQueryVariables>(GetDirectChargeTypesDocument).bind(null, variables),
      options
    )};

export const GetDirectChargesDocument = `
    query GetDirectCharges($accountId: ID!, $accountIdString: String!, $taxYear: Int!) {
  getDirectCharges(accountId: $accountId, taxYear: $taxYear) {
    accountId
    accountNumber
    taxYear
    jurisdiction
    ein {
      id
      name
    }
    businessName
    accountSummary {
      assessmentCharge
      balance
      balanceDueWithInterest
      interest
      isExempt
      penaltyCharge
      taxRate
      totalCost
      totalDirectCharge
      totalPayments
      totalTaxable
    }
    directCharges {
      id
      amount
      comment
      isActive
      updateDate
      entryDate
      ein {
        id
        name
      }
      type {
        id
        description
      }
    }
  }
  getDirectChargeTypes {
    id
    description
  }
  getBusinessAccount(accountId: $accountIdString, taxYear: $taxYear) {
    id
    accountNumber
    isActive
  }
}
    `;

export const useGetDirectChargesQuery = <
      TData = GetDirectChargesQuery,
      TError = unknown
    >(
      variables: GetDirectChargesQueryVariables,
      options?: UseQueryOptions<GetDirectChargesQuery, TError, TData>
    ) => {
    
    return useQuery<GetDirectChargesQuery, TError, TData>(
      ['GetDirectCharges', variables],
      useFetchData<GetDirectChargesQuery, GetDirectChargesQueryVariables>(GetDirectChargesDocument).bind(null, variables),
      options
    )};

export const GetSubAccountDirectChargesDocument = `
    query GetSubAccountDirectCharges($accountId: ID!, $taxYear: Int!, $jurisdiction: Int) {
  getDirectCharges(
    accountId: $accountId
    taxYear: $taxYear
    jurisdiction: $jurisdiction
  ) {
    accountId
    accountNumber
    taxYear
    jurisdiction
    ein {
      id
      name
    }
    businessName
    accountSummary {
      assessmentCharge
      balance
      balanceDueWithInterest
      interest
      isExempt
      penaltyCharge
      taxRate
      totalCost
      totalDirectCharge
      totalPayments
      totalTaxable
    }
    directCharges {
      id
      amount
      comment
      isActive
      updateDate
      entryDate
      ein {
        id
        name
      }
      type {
        id
        description
      }
    }
  }
  getDirectChargeTypes {
    id
    description
  }
}
    `;

export const useGetSubAccountDirectChargesQuery = <
      TData = GetSubAccountDirectChargesQuery,
      TError = unknown
    >(
      variables: GetSubAccountDirectChargesQueryVariables,
      options?: UseQueryOptions<GetSubAccountDirectChargesQuery, TError, TData>
    ) => {
    
    return useQuery<GetSubAccountDirectChargesQuery, TError, TData>(
      ['GetSubAccountDirectCharges', variables],
      useFetchData<GetSubAccountDirectChargesQuery, GetSubAccountDirectChargesQueryVariables>(GetSubAccountDirectChargesDocument).bind(null, variables),
      options
    )};

export const SaveDirectChargesDocument = `
    mutation SaveDirectCharges($accountId: Int!, $taxYear: Int!, $directCharges: [DirectChargeInput!]!) {
  saveDirectCharges(
    accountId: $accountId
    taxYear: $taxYear
    directCharges: $directCharges
  ) {
    accountId
    accountNumber
    taxYear
    jurisdiction
    ein {
      id
      name
    }
    businessName
    accountSummary {
      assessmentCharge
      balance
      balanceDueWithInterest
      interest
      isExempt
      penaltyCharge
      taxRate
      totalCost
      totalDirectCharge
      totalPayments
      totalTaxable
    }
    directCharges {
      id
      amount
      comment
      isActive
      updateDate
      entryDate
      ein {
        id
        name
      }
      type {
        id
        description
      }
    }
  }
}
    `;

export const useSaveDirectChargesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveDirectChargesMutation, TError, SaveDirectChargesMutationVariables, TContext>) => {
    
    return useMutation<SaveDirectChargesMutation, TError, SaveDirectChargesMutationVariables, TContext>(
      ['SaveDirectCharges'],
      useFetchData<SaveDirectChargesMutation, SaveDirectChargesMutationVariables>(SaveDirectChargesDocument),
      options
    )};

export const GetEntityTypesDocument = `
    query GetEntityTypes {
  entityTypes {
    id
    label
  }
}
    `;

export const useGetEntityTypesQuery = <
      TData = GetEntityTypesQuery,
      TError = unknown
    >(
      variables?: GetEntityTypesQueryVariables,
      options?: UseQueryOptions<GetEntityTypesQuery, TError, TData>
    ) => {
    
    return useQuery<GetEntityTypesQuery, TError, TData>(
      variables === undefined ? ['GetEntityTypes'] : ['GetEntityTypes', variables],
      useFetchData<GetEntityTypesQuery, GetEntityTypesQueryVariables>(GetEntityTypesDocument).bind(null, variables),
      options
    )};

export const FiledStatusListDocument = `
    query FiledStatusList {
  filedStatusList {
    id
    label
  }
}
    `;

export const useFiledStatusListQuery = <
      TData = FiledStatusListQuery,
      TError = unknown
    >(
      variables?: FiledStatusListQueryVariables,
      options?: UseQueryOptions<FiledStatusListQuery, TError, TData>
    ) => {
    
    return useQuery<FiledStatusListQuery, TError, TData>(
      variables === undefined ? ['FiledStatusList'] : ['FiledStatusList', variables],
      useFetchData<FiledStatusListQuery, FiledStatusListQueryVariables>(FiledStatusListDocument).bind(null, variables),
      options
    )};

export const HowFiledListDocument = `
    query HowFiledList {
  howFiledList {
    id
    label
  }
}
    `;

export const useHowFiledListQuery = <
      TData = HowFiledListQuery,
      TError = unknown
    >(
      variables?: HowFiledListQueryVariables,
      options?: UseQueryOptions<HowFiledListQuery, TError, TData>
    ) => {
    
    return useQuery<HowFiledListQuery, TError, TData>(
      variables === undefined ? ['HowFiledList'] : ['HowFiledList', variables],
      useFetchData<HowFiledListQuery, HowFiledListQueryVariables>(HowFiledListDocument).bind(null, variables),
      options
    )};

export const HowReceivedDocument = `
    query HowReceived {
  howReceivedList {
    id
    label
  }
}
    `;

export const useHowReceivedQuery = <
      TData = HowReceivedQuery,
      TError = unknown
    >(
      variables?: HowReceivedQueryVariables,
      options?: UseQueryOptions<HowReceivedQuery, TError, TData>
    ) => {
    
    return useQuery<HowReceivedQuery, TError, TData>(
      variables === undefined ? ['HowReceived'] : ['HowReceived', variables],
      useFetchData<HowReceivedQuery, HowReceivedQueryVariables>(HowReceivedDocument).bind(null, variables),
      options
    )};

export const GetIndustrialParkOptionsDocument = `
    query GetIndustrialParkOptions {
  industrialParkOptions {
    id
    code
    label
  }
}
    `;

export const useGetIndustrialParkOptionsQuery = <
      TData = GetIndustrialParkOptionsQuery,
      TError = unknown
    >(
      variables?: GetIndustrialParkOptionsQueryVariables,
      options?: UseQueryOptions<GetIndustrialParkOptionsQuery, TError, TData>
    ) => {
    
    return useQuery<GetIndustrialParkOptionsQuery, TError, TData>(
      variables === undefined ? ['GetIndustrialParkOptions'] : ['GetIndustrialParkOptions', variables],
      useFetchData<GetIndustrialParkOptionsQuery, GetIndustrialParkOptionsQueryVariables>(GetIndustrialParkOptionsDocument).bind(null, variables),
      options
    )};

export const GetIndustrialParksDocument = `
    query GetIndustrialParks {
  industrialParks {
    id
    code
    label
    accountCount
    newBusinessCount
    isActive
  }
}
    `;

export const useGetIndustrialParksQuery = <
      TData = GetIndustrialParksQuery,
      TError = unknown
    >(
      variables?: GetIndustrialParksQueryVariables,
      options?: UseQueryOptions<GetIndustrialParksQuery, TError, TData>
    ) => {
    
    return useQuery<GetIndustrialParksQuery, TError, TData>(
      variables === undefined ? ['GetIndustrialParks'] : ['GetIndustrialParks', variables],
      useFetchData<GetIndustrialParksQuery, GetIndustrialParksQueryVariables>(GetIndustrialParksDocument).bind(null, variables),
      options
    )};

export const SaveIndustrialParkDocument = `
    mutation SaveIndustrialPark($input: IndustrialParkInput!) {
  saveIndustrialPark(input: $input) {
    id
    code
    label
    accountCount
    newBusinessCount
    isActive
  }
}
    `;

export const useSaveIndustrialParkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveIndustrialParkMutation, TError, SaveIndustrialParkMutationVariables, TContext>) => {
    
    return useMutation<SaveIndustrialParkMutation, TError, SaveIndustrialParkMutationVariables, TContext>(
      ['SaveIndustrialPark'],
      useFetchData<SaveIndustrialParkMutation, SaveIndustrialParkMutationVariables>(SaveIndustrialParkDocument),
      options
    )};

export const AccountsByIndustrialParkDocument = `
    query AccountsByIndustrialPark($industrialPark: String!) {
  accountsByIndustrialPark(industrialPark: $industrialPark) {
    accountId
    accountNumber
    businessName
    industrialParkId
    code
    label
  }
}
    `;

export const useAccountsByIndustrialParkQuery = <
      TData = AccountsByIndustrialParkQuery,
      TError = unknown
    >(
      variables: AccountsByIndustrialParkQueryVariables,
      options?: UseQueryOptions<AccountsByIndustrialParkQuery, TError, TData>
    ) => {
    
    return useQuery<AccountsByIndustrialParkQuery, TError, TData>(
      ['AccountsByIndustrialPark', variables],
      useFetchData<AccountsByIndustrialParkQuery, AccountsByIndustrialParkQueryVariables>(AccountsByIndustrialParkDocument).bind(null, variables),
      options
    )};

export const BulkUpdateIndustrialParkDocument = `
    mutation BulkUpdateIndustrialPark($input: BulkUpdateIndustrialParkInput!) {
  bulkUpdateIndustrialPark(input: $input) {
    status
    rowsRead
    updatedAccounts
    failedRows
    results {
      rowNumber
      accountNumber
      businessName
      errorMessage
    }
  }
}
    `;

export const useBulkUpdateIndustrialParkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BulkUpdateIndustrialParkMutation, TError, BulkUpdateIndustrialParkMutationVariables, TContext>) => {
    
    return useMutation<BulkUpdateIndustrialParkMutation, TError, BulkUpdateIndustrialParkMutationVariables, TContext>(
      ['BulkUpdateIndustrialPark'],
      useFetchData<BulkUpdateIndustrialParkMutation, BulkUpdateIndustrialParkMutationVariables>(BulkUpdateIndustrialParkDocument),
      options
    )};

export const GetJurisdictionsDocument = `
    query GetJurisdictions($isImplemented: Boolean) {
  getJurisdictions(isImplemented: $isImplemented) {
    id
    name
  }
}
    `;

export const useGetJurisdictionsQuery = <
      TData = GetJurisdictionsQuery,
      TError = unknown
    >(
      variables?: GetJurisdictionsQueryVariables,
      options?: UseQueryOptions<GetJurisdictionsQuery, TError, TData>
    ) => {
    
    return useQuery<GetJurisdictionsQuery, TError, TData>(
      variables === undefined ? ['GetJurisdictions'] : ['GetJurisdictions', variables],
      useFetchData<GetJurisdictionsQuery, GetJurisdictionsQueryVariables>(GetJurisdictionsDocument).bind(null, variables),
      options
    )};

export const GetLeaseMasterAssetsDocument = `
    query GetLeaseMasterAssets($leaseMasterId: ID!, $taxYear: Int!) {
  leaseMasterAssets(leaseMasterId: $leaseMasterId, taxYear: $taxYear) {
    id
    subAccountId
    subAccountNumber
    taxDistrict
    description
    classification {
      id
      label
    }
    yearAcquired
    quantity
    costPer
    percentGood
    taxableValue
    isActive
  }
}
    `;

export const useGetLeaseMasterAssetsQuery = <
      TData = GetLeaseMasterAssetsQuery,
      TError = unknown
    >(
      variables: GetLeaseMasterAssetsQueryVariables,
      options?: UseQueryOptions<GetLeaseMasterAssetsQuery, TError, TData>
    ) => {
    
    return useQuery<GetLeaseMasterAssetsQuery, TError, TData>(
      ['GetLeaseMasterAssets', variables],
      useFetchData<GetLeaseMasterAssetsQuery, GetLeaseMasterAssetsQueryVariables>(GetLeaseMasterAssetsDocument).bind(null, variables),
      options
    )};

export const LeaseMasterAssocDocument = `
    query LeaseMasterAssoc($accountId: Int!, $taxYear: Int!) {
  leaseMasterAssoc(accountId: $accountId, taxYear: $taxYear) {
    businessName
    leaseMasterAccountNbr
    isReconciled
  }
}
    `;

export const useLeaseMasterAssocQuery = <
      TData = LeaseMasterAssocQuery,
      TError = unknown
    >(
      variables: LeaseMasterAssocQueryVariables,
      options?: UseQueryOptions<LeaseMasterAssocQuery, TError, TData>
    ) => {
    
    return useQuery<LeaseMasterAssocQuery, TError, TData>(
      ['LeaseMasterAssoc', variables],
      useFetchData<LeaseMasterAssocQuery, LeaseMasterAssocQueryVariables>(LeaseMasterAssocDocument).bind(null, variables),
      options
    )};

export const GetLeaseMasterBusinessAccountDocument = `
    query GetLeaseMasterBusinessAccount($accountNumber: String!, $taxYear: Int!) {
  leaseMasterBusinessAccount(accountNumber: $accountNumber, taxYear: $taxYear) {
    id
    accountNumber
    adminLink
    businessName
    registeredEntityName
    description
    sicCode {
      id
      sicCode
      sicCodeDescription
      sicSiloCode
      subSiloCode
      isActive
    }
    ein
    telecomAccountNumber
    applyPenalty
    isActive
    isDisabled
    lastModified {
      username
      lastChanged
    }
    reconciliation {
      reconciledDate
      reconciledBy {
        id
        fullName
        username
        email
        isActive
        isVerified
      }
    }
    filingStatus {
      hasAttachment
      hasBuildingPermit
      hasExemption
      dateReceived
      howFiled {
        id
        label
      }
      howReceived {
        id
        label
      }
    }
    audit {
      auditYear
    }
    bankruptcy {
      bankruptcyType {
        id
        label
      }
    }
    entityType {
      id
      label
    }
    accountType {
      id
      label
    }
    businessAccountType {
      id
      label
    }
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      payments
      interest
      penaltyCharge
      currentBalance
      delinquentBalance
      totalBalance
    }
  }
}
    `;

export const useGetLeaseMasterBusinessAccountQuery = <
      TData = GetLeaseMasterBusinessAccountQuery,
      TError = unknown
    >(
      variables: GetLeaseMasterBusinessAccountQueryVariables,
      options?: UseQueryOptions<GetLeaseMasterBusinessAccountQuery, TError, TData>
    ) => {
    
    return useQuery<GetLeaseMasterBusinessAccountQuery, TError, TData>(
      ['GetLeaseMasterBusinessAccount', variables],
      useFetchData<GetLeaseMasterBusinessAccountQuery, GetLeaseMasterBusinessAccountQueryVariables>(GetLeaseMasterBusinessAccountDocument).bind(null, variables),
      options
    )};

export const SaveLeaseMasterAccountDocument = `
    mutation SaveLeaseMasterAccount($input: LeaseMasterBusinessAccountInput!) {
  saveLeaseMasterAccount(input: $input) {
    id
    accountNumber
    adminLink
    businessName
    registeredEntityName
    description
    sicCode {
      id
      sicCode
      sicCodeDescription
      sicSiloCode
      subSiloCode
      isActive
    }
    ein
    telecomAccountNumber
    applyPenalty
    isActive
    isDisabled
    lastModified {
      username
      lastChanged
    }
    reconciliation {
      reconciledDate
      reconciledBy {
        id
        fullName
        username
        email
        isActive
        isVerified
      }
    }
    filingStatus {
      hasAttachment
      hasBuildingPermit
      hasExemption
      dateReceived
      howFiled {
        id
        label
      }
      howReceived {
        id
        label
      }
    }
    audit {
      auditYear
    }
    bankruptcy {
      bankruptcyType {
        id
        label
      }
    }
    entityType {
      id
      label
    }
    accountType {
      id
      label
    }
    businessAccountType {
      id
      label
    }
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      payments
      penaltyCharge
      interest
      currentBalance
      delinquentBalance
      totalBalance
    }
  }
}
    `;

export const useSaveLeaseMasterAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveLeaseMasterAccountMutation, TError, SaveLeaseMasterAccountMutationVariables, TContext>) => {
    
    return useMutation<SaveLeaseMasterAccountMutation, TError, SaveLeaseMasterAccountMutationVariables, TContext>(
      ['SaveLeaseMasterAccount'],
      useFetchData<SaveLeaseMasterAccountMutation, SaveLeaseMasterAccountMutationVariables>(SaveLeaseMasterAccountDocument),
      options
    )};

export const CreateLeaseMasterAccountDocument = `
    mutation CreateLeaseMasterAccount($input: CreateLessorAccountInput!) {
  createLeaseMasterAccount(input: $input) {
    sicCode {
      id
      sicCode
      sicCodeDescription
      sicSiloCode
      subSiloCode
    }
    id
    accountNumber
    businessName
    description
    ein
    accountType {
      id
      label
    }
    accountSummary {
      assessmentCharge
      directCharge
      penaltyCharge
      payments
    }
    reconciliation {
      reconciledBy {
        id
        fullName
        username
        email
        isActive
        isVerified
      }
      reconciledDate
    }
    filingStatus {
      howReceived {
        id
        label
      }
    }
  }
}
    `;

export const useCreateLeaseMasterAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateLeaseMasterAccountMutation, TError, CreateLeaseMasterAccountMutationVariables, TContext>) => {
    
    return useMutation<CreateLeaseMasterAccountMutation, TError, CreateLeaseMasterAccountMutationVariables, TContext>(
      ['CreateLeaseMasterAccount'],
      useFetchData<CreateLeaseMasterAccountMutation, CreateLeaseMasterAccountMutationVariables>(CreateLeaseMasterAccountDocument),
      options
    )};

export const SearchLeaseMasterBusinessAccountDocument = `
    query SearchLeaseMasterBusinessAccount($filters: SearchLeaseMasterBusinessAccountInput!) {
  searchLeaseMasterBusinessAccount(filters: $filters) {
    totalAccounts
    leaseAccounts {
      accountId
      accountNumber
      businessName
      isActive
      isReconciled
      filingStatus
      taxYear
      countyName
    }
  }
}
    `;

export const useSearchLeaseMasterBusinessAccountQuery = <
      TData = SearchLeaseMasterBusinessAccountQuery,
      TError = unknown
    >(
      variables: SearchLeaseMasterBusinessAccountQueryVariables,
      options?: UseQueryOptions<SearchLeaseMasterBusinessAccountQuery, TError, TData>
    ) => {
    
    return useQuery<SearchLeaseMasterBusinessAccountQuery, TError, TData>(
      ['SearchLeaseMasterBusinessAccount', variables],
      useFetchData<SearchLeaseMasterBusinessAccountQuery, SearchLeaseMasterBusinessAccountQueryVariables>(SearchLeaseMasterBusinessAccountDocument).bind(null, variables),
      options
    )};

export const ValidateTelecomMasterAccountDocument = `
    mutation ValidateTelecomMasterAccount($telecomAccountNumber: String!) {
  validateTelecomMasterAccountNumber(telecomAccountNumber: $telecomAccountNumber)
}
    `;

export const useValidateTelecomMasterAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ValidateTelecomMasterAccountMutation, TError, ValidateTelecomMasterAccountMutationVariables, TContext>) => {
    
    return useMutation<ValidateTelecomMasterAccountMutation, TError, ValidateTelecomMasterAccountMutationVariables, TContext>(
      ['ValidateTelecomMasterAccount'],
      useFetchData<ValidateTelecomMasterAccountMutation, ValidateTelecomMasterAccountMutationVariables>(ValidateTelecomMasterAccountDocument),
      options
    )};

export const ChangeLeaseMasterAccountStatusDocument = `
    mutation ChangeLeaseMasterAccountStatus($accountStatus: AccountStatusInput!) {
  changeLeaseMasterAccountStatus(accountStatus: $accountStatus)
}
    `;

export const useChangeLeaseMasterAccountStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChangeLeaseMasterAccountStatusMutation, TError, ChangeLeaseMasterAccountStatusMutationVariables, TContext>) => {
    
    return useMutation<ChangeLeaseMasterAccountStatusMutation, TError, ChangeLeaseMasterAccountStatusMutationVariables, TContext>(
      ['ChangeLeaseMasterAccountStatus'],
      useFetchData<ChangeLeaseMasterAccountStatusMutation, ChangeLeaseMasterAccountStatusMutationVariables>(ChangeLeaseMasterAccountStatusDocument),
      options
    )};

export const UpdateLeaseExemptAndGetSummaryAmountDocument = `
    mutation updateLeaseExemptAndGetSummaryAmount($leaseMasterId: String!, $isExempt: Boolean!) {
  updateLeaseExemptAndGetSummaryAmount(
    leaseMasterId: $leaseMasterId
    isExempt: $isExempt
  ) {
    assessmentCharge
    cost
    currentBalance
    delinquentBalance
    directCharge
    interest
    payments
    penaltyCharge
    taxRate
    taxable
    totalBalance
    totalBalanceWithDelinquent
  }
}
    `;

export const useUpdateLeaseExemptAndGetSummaryAmountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLeaseExemptAndGetSummaryAmountMutation, TError, UpdateLeaseExemptAndGetSummaryAmountMutationVariables, TContext>) => {
    
    return useMutation<UpdateLeaseExemptAndGetSummaryAmountMutation, TError, UpdateLeaseExemptAndGetSummaryAmountMutationVariables, TContext>(
      ['updateLeaseExemptAndGetSummaryAmount'],
      useFetchData<UpdateLeaseExemptAndGetSummaryAmountMutation, UpdateLeaseExemptAndGetSummaryAmountMutationVariables>(UpdateLeaseExemptAndGetSummaryAmountDocument),
      options
    )};

export const SearchLeaseBusinessAccountInfoByNumberDocument = `
    mutation SearchLeaseBusinessAccountInfoByNumber($accountNumber: String!) {
  searchLeaseBusinessAccountInfoByNumber(accountNumber: $accountNumber) {
    id
    businessName
    delinquentBalance
    status
  }
}
    `;

export const useSearchLeaseBusinessAccountInfoByNumberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SearchLeaseBusinessAccountInfoByNumberMutation, TError, SearchLeaseBusinessAccountInfoByNumberMutationVariables, TContext>) => {
    
    return useMutation<SearchLeaseBusinessAccountInfoByNumberMutation, TError, SearchLeaseBusinessAccountInfoByNumberMutationVariables, TContext>(
      ['SearchLeaseBusinessAccountInfoByNumber'],
      useFetchData<SearchLeaseBusinessAccountInfoByNumberMutation, SearchLeaseBusinessAccountInfoByNumberMutationVariables>(SearchLeaseBusinessAccountInfoByNumberDocument),
      options
    )};

export const ChangeLeaseMasterSubAccountStatusDocument = `
    mutation ChangeLeaseMasterSubAccountStatus($accountStatus: SubAccountStatusInput!) {
  changeLeaseMasterSubAccountStatus(accountStatus: $accountStatus)
}
    `;

export const useChangeLeaseMasterSubAccountStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChangeLeaseMasterSubAccountStatusMutation, TError, ChangeLeaseMasterSubAccountStatusMutationVariables, TContext>) => {
    
    return useMutation<ChangeLeaseMasterSubAccountStatusMutation, TError, ChangeLeaseMasterSubAccountStatusMutationVariables, TContext>(
      ['ChangeLeaseMasterSubAccountStatus'],
      useFetchData<ChangeLeaseMasterSubAccountStatusMutation, ChangeLeaseMasterSubAccountStatusMutationVariables>(ChangeLeaseMasterSubAccountStatusDocument),
      options
    )};

export const ValidateLeaseMasterAccountDocument = `
    mutation ValidateLeaseMasterAccount($leaseMasterAccountNumber: String!, $subAccountNumber: String!) {
  validateLeaseMasterAccount(
    leaseMasterAccountNumber: $leaseMasterAccountNumber
    subAccountNumber: $subAccountNumber
  )
}
    `;

export const useValidateLeaseMasterAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ValidateLeaseMasterAccountMutation, TError, ValidateLeaseMasterAccountMutationVariables, TContext>) => {
    
    return useMutation<ValidateLeaseMasterAccountMutation, TError, ValidateLeaseMasterAccountMutationVariables, TContext>(
      ['ValidateLeaseMasterAccount'],
      useFetchData<ValidateLeaseMasterAccountMutation, ValidateLeaseMasterAccountMutationVariables>(ValidateLeaseMasterAccountDocument),
      options
    )};

export const GetSubAccountLocationAssetsDocument = `
    query GetSubAccountLocationAssets($leaseMasterId: ID!, $subAccountId: ID!, $subAccountNumericId: Int!, $locationAccountId: ID!, $taxYear: Int!) {
  leasedAssetsForSubAccountLocation(
    leaseMasterId: $leaseMasterId
    subAccountId: $subAccountId
    locationAccountId: $locationAccountId
    taxYear: $taxYear
  ) {
    id
    leaseAccountId
    contactLinkId
    classification {
      id
      label
    }
    description
    yearAcquired
    quantity
    costPer
    percentGood
    taxableValue
    isActive
    ein
    updateDate
  }
  getClassifications {
    id
    clsf
    scheduleId
    description
  }
  getTaxRate(accountId: $subAccountNumericId, taxYear: $taxYear) {
    id
    taxRate
  }
  uploadLeasedAssetsTemplate
}
    `;

export const useGetSubAccountLocationAssetsQuery = <
      TData = GetSubAccountLocationAssetsQuery,
      TError = unknown
    >(
      variables: GetSubAccountLocationAssetsQueryVariables,
      options?: UseQueryOptions<GetSubAccountLocationAssetsQuery, TError, TData>
    ) => {
    
    return useQuery<GetSubAccountLocationAssetsQuery, TError, TData>(
      ['GetSubAccountLocationAssets', variables],
      useFetchData<GetSubAccountLocationAssetsQuery, GetSubAccountLocationAssetsQueryVariables>(GetSubAccountLocationAssetsDocument).bind(null, variables),
      options
    )};

export const SaveSubAccountLocationAssetsDocument = `
    mutation SaveSubAccountLocationAssets($input: SaveLeasedAssetForSubAccountLocationInput!) {
  saveLeasedAssetsForSubAccountLocation(input: $input) {
    id
    leaseAccountId
    contactLinkId
    classification {
      id
      label
    }
    description
    yearAcquired
    quantity
    costPer
    percentGood
    taxableValue
    isActive
    ein
    updateDate
  }
}
    `;

export const useSaveSubAccountLocationAssetsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveSubAccountLocationAssetsMutation, TError, SaveSubAccountLocationAssetsMutationVariables, TContext>) => {
    
    return useMutation<SaveSubAccountLocationAssetsMutation, TError, SaveSubAccountLocationAssetsMutationVariables, TContext>(
      ['SaveSubAccountLocationAssets'],
      useFetchData<SaveSubAccountLocationAssetsMutation, SaveSubAccountLocationAssetsMutationVariables>(SaveSubAccountLocationAssetsDocument),
      options
    )};

export const SearchLeasedAssetsForReconciliationDocument = `
    query SearchLeasedAssetsForReconciliation($filters: SearchLeasedAssetsForReconciliationInput!) {
  searchLeasedAssetForReconciliation(filters: $filters) {
    id
    accountId
    accountNumber
    leaseMasterAccountNumber
    subAccountNumber
    contactLinkId
    description
    yearAcquired
    rentPerMonth
    costPer
    leaseStartDate
    leaseEndDate
    leaseId
    leaseNumber
    lessor {
      name
      address
    }
    fileUrl
    fileName
    blobName
    entryDate
    isActive
    isReconciled
  }
}
    `;

export const useSearchLeasedAssetsForReconciliationQuery = <
      TData = SearchLeasedAssetsForReconciliationQuery,
      TError = unknown
    >(
      variables: SearchLeasedAssetsForReconciliationQueryVariables,
      options?: UseQueryOptions<SearchLeasedAssetsForReconciliationQuery, TError, TData>
    ) => {
    
    return useQuery<SearchLeasedAssetsForReconciliationQuery, TError, TData>(
      ['SearchLeasedAssetsForReconciliation', variables],
      useFetchData<SearchLeasedAssetsForReconciliationQuery, SearchLeasedAssetsForReconciliationQueryVariables>(SearchLeasedAssetsForReconciliationDocument).bind(null, variables),
      options
    )};

export const SearchLeaseMasterAccountSuggestionsDocument = `
    query SearchLeaseMasterAccountSuggestions($accountNumber: ID!) {
  searchLeaseMasterAccountSuggestions(accountNumber: $accountNumber) {
    leaseMasterAccountName
    leaseMasterAccountNumber
    subAccountNumber
  }
}
    `;

export const useSearchLeaseMasterAccountSuggestionsQuery = <
      TData = SearchLeaseMasterAccountSuggestionsQuery,
      TError = unknown
    >(
      variables: SearchLeaseMasterAccountSuggestionsQueryVariables,
      options?: UseQueryOptions<SearchLeaseMasterAccountSuggestionsQuery, TError, TData>
    ) => {
    
    return useQuery<SearchLeaseMasterAccountSuggestionsQuery, TError, TData>(
      ['SearchLeaseMasterAccountSuggestions', variables],
      useFetchData<SearchLeaseMasterAccountSuggestionsQuery, SearchLeaseMasterAccountSuggestionsQueryVariables>(SearchLeaseMasterAccountSuggestionsDocument).bind(null, variables),
      options
    )};

export const ReconcileLeaseMasterAssetsDocument = `
    mutation ReconcileLeaseMasterAssets($assets: [ReconcileLeaseMasterAssetInput!]!) {
  reconcileLeaseMasterAssets(assets: $assets)
}
    `;

export const useReconcileLeaseMasterAssetsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReconcileLeaseMasterAssetsMutation, TError, ReconcileLeaseMasterAssetsMutationVariables, TContext>) => {
    
    return useMutation<ReconcileLeaseMasterAssetsMutation, TError, ReconcileLeaseMasterAssetsMutationVariables, TContext>(
      ['ReconcileLeaseMasterAssets'],
      useFetchData<ReconcileLeaseMasterAssetsMutation, ReconcileLeaseMasterAssetsMutationVariables>(ReconcileLeaseMasterAssetsDocument),
      options
    )};

export const GetMassAccountBatchesDocument = `
    query GetMassAccountBatches {
  massAccountBatches {
    id
    description
    status
    uploadDate
    totalRecords
  }
  massAccountTemplate
}
    `;

export const useGetMassAccountBatchesQuery = <
      TData = GetMassAccountBatchesQuery,
      TError = unknown
    >(
      variables?: GetMassAccountBatchesQueryVariables,
      options?: UseQueryOptions<GetMassAccountBatchesQuery, TError, TData>
    ) => {
    
    return useQuery<GetMassAccountBatchesQuery, TError, TData>(
      variables === undefined ? ['GetMassAccountBatches'] : ['GetMassAccountBatches', variables],
      useFetchData<GetMassAccountBatchesQuery, GetMassAccountBatchesQueryVariables>(GetMassAccountBatchesDocument).bind(null, variables),
      options
    )};

export const GetMassAccountBatchDocument = `
    query GetMassAccountBatch($id: Int!) {
  massAccountBatch(id: $id) {
    id
    businessName
    address
    mailingAddress
    accountType
    sicCode
    status {
      id
      name
    }
  }
}
    `;

export const useGetMassAccountBatchQuery = <
      TData = GetMassAccountBatchQuery,
      TError = unknown
    >(
      variables: GetMassAccountBatchQueryVariables,
      options?: UseQueryOptions<GetMassAccountBatchQuery, TError, TData>
    ) => {
    
    return useQuery<GetMassAccountBatchQuery, TError, TData>(
      ['GetMassAccountBatch', variables],
      useFetchData<GetMassAccountBatchQuery, GetMassAccountBatchQueryVariables>(GetMassAccountBatchDocument).bind(null, variables),
      options
    )};

export const CreateMassAccountBatchDocument = `
    mutation CreateMassAccountBatch($batch: CreateMassAccountBatchInput!) {
  createMassAccountBatch(batch: $batch) {
    id
    errors
  }
}
    `;

export const useCreateMassAccountBatchMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateMassAccountBatchMutation, TError, CreateMassAccountBatchMutationVariables, TContext>) => {
    
    return useMutation<CreateMassAccountBatchMutation, TError, CreateMassAccountBatchMutationVariables, TContext>(
      ['CreateMassAccountBatch'],
      useFetchData<CreateMassAccountBatchMutation, CreateMassAccountBatchMutationVariables>(CreateMassAccountBatchDocument),
      options
    )};

export const DeleteMassAccountBatchDocument = `
    mutation DeleteMassAccountBatch($id: Int!) {
  deleteMassAccountBatch(id: $id)
}
    `;

export const useDeleteMassAccountBatchMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMassAccountBatchMutation, TError, DeleteMassAccountBatchMutationVariables, TContext>) => {
    
    return useMutation<DeleteMassAccountBatchMutation, TError, DeleteMassAccountBatchMutationVariables, TContext>(
      ['DeleteMassAccountBatch'],
      useFetchData<DeleteMassAccountBatchMutation, DeleteMassAccountBatchMutationVariables>(DeleteMassAccountBatchDocument),
      options
    )};

export const ApproveMassAccountBatchDocument = `
    mutation ApproveMassAccountBatch($id: Int!) {
  approveMassAccountBatch(id: $id) {
    createdAccounts {
      id
      accountId
      accountNumber
      businessName
    }
    failedAccounts {
      id
      errorMessage
    }
  }
}
    `;

export const useApproveMassAccountBatchMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ApproveMassAccountBatchMutation, TError, ApproveMassAccountBatchMutationVariables, TContext>) => {
    
    return useMutation<ApproveMassAccountBatchMutation, TError, ApproveMassAccountBatchMutationVariables, TContext>(
      ['ApproveMassAccountBatch'],
      useFetchData<ApproveMassAccountBatchMutation, ApproveMassAccountBatchMutationVariables>(ApproveMassAccountBatchDocument),
      options
    )};

export const GetBatchBusinessAccountDictionariesDocument = `
    query GetBatchBusinessAccountDictionaries {
  getBusinessAppraiserRegionList {
    regionName
    columnsNames {
      groupingLabel1
      groupingLabel2
    }
    rows {
      id
      groupingValue1
      groupingValue2
      regionName
    }
  }
  countries {
    code
    name
  }
  accountTypes {
    id
    label
  }
  taxAreaList {
    taxArea
    taxSubArea
  }
  sicCodeMasters {
    id
    sicCode
    sicCodeDescription
    sicSiloCode
    subSiloCode
    isActive
  }
  parcelUseTypeList {
    id
    label
  }
  contactTypes {
    id
    label
  }
}
    `;

export const useGetBatchBusinessAccountDictionariesQuery = <
      TData = GetBatchBusinessAccountDictionariesQuery,
      TError = unknown
    >(
      variables?: GetBatchBusinessAccountDictionariesQueryVariables,
      options?: UseQueryOptions<GetBatchBusinessAccountDictionariesQuery, TError, TData>
    ) => {
    
    return useQuery<GetBatchBusinessAccountDictionariesQuery, TError, TData>(
      variables === undefined ? ['GetBatchBusinessAccountDictionaries'] : ['GetBatchBusinessAccountDictionaries', variables],
      useFetchData<GetBatchBusinessAccountDictionariesQuery, GetBatchBusinessAccountDictionariesQueryVariables>(GetBatchBusinessAccountDictionariesDocument).bind(null, variables),
      options
    )};

export const GetBatchBusinessAccountDocument = `
    query GetBatchBusinessAccount($id: Int!) {
  batchBusinessAccount(id: $id) {
    id
    businessName
    description
    accountType
    sicCode
    parcelUseType
    parcelNumber
    accountNumber
    mailingAddress {
      inCareOf
      addressLine1
      addressLine2
      city
      state
      country {
        code
        name
      }
      zipCode
    }
    situsAddress {
      addressLine1
      addressLine2
      city
      state
      country {
        code
        name
      }
      zipCode
    }
    contact {
      name
      contactType
      email
      phone
      phoneExtension
    }
    taxArea
    taxSubArea
    appraiserRegion
    cityCode
    status {
      id
      name
    }
  }
}
    `;

export const useGetBatchBusinessAccountQuery = <
      TData = GetBatchBusinessAccountQuery,
      TError = unknown
    >(
      variables: GetBatchBusinessAccountQueryVariables,
      options?: UseQueryOptions<GetBatchBusinessAccountQuery, TError, TData>
    ) => {
    
    return useQuery<GetBatchBusinessAccountQuery, TError, TData>(
      ['GetBatchBusinessAccount', variables],
      useFetchData<GetBatchBusinessAccountQuery, GetBatchBusinessAccountQueryVariables>(GetBatchBusinessAccountDocument).bind(null, variables),
      options
    )};

export const SaveBatchBusinessAccountDocument = `
    mutation SaveBatchBusinessAccount($id: Int!, $account: BatchBusinessAccountInput!) {
  saveBatchBusinessAccount(id: $id, account: $account)
}
    `;

export const useSaveBatchBusinessAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveBatchBusinessAccountMutation, TError, SaveBatchBusinessAccountMutationVariables, TContext>) => {
    
    return useMutation<SaveBatchBusinessAccountMutation, TError, SaveBatchBusinessAccountMutationVariables, TContext>(
      ['SaveBatchBusinessAccount'],
      useFetchData<SaveBatchBusinessAccountMutation, SaveBatchBusinessAccountMutationVariables>(SaveBatchBusinessAccountDocument),
      options
    )};

export const DeleteBatchBusinessAccountDocument = `
    mutation DeleteBatchBusinessAccount($id: Int!) {
  deleteBatchBusinessAccount(id: $id)
}
    `;

export const useDeleteBatchBusinessAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteBatchBusinessAccountMutation, TError, DeleteBatchBusinessAccountMutationVariables, TContext>) => {
    
    return useMutation<DeleteBatchBusinessAccountMutation, TError, DeleteBatchBusinessAccountMutationVariables, TContext>(
      ['DeleteBatchBusinessAccount'],
      useFetchData<DeleteBatchBusinessAccountMutation, DeleteBatchBusinessAccountMutationVariables>(DeleteBatchBusinessAccountDocument),
      options
    )};

export const AccountForMassPaymentDocument = `
    query AccountForMassPayment($accountNumber: String!, $interestDate: String!) {
  accountForMassPayment(
    accountNumber: $accountNumber
    interestDate: $interestDate
  ) {
    accountId
    businessName
    howFiled
    howFiledDescr
    howReceived
    howReceivedDescr
    filedDate
    filedBy
    filedByDisplay
    currentUserName
    interest
  }
}
    `;

export const useAccountForMassPaymentQuery = <
      TData = AccountForMassPaymentQuery,
      TError = unknown
    >(
      variables: AccountForMassPaymentQueryVariables,
      options?: UseQueryOptions<AccountForMassPaymentQuery, TError, TData>
    ) => {
    
    return useQuery<AccountForMassPaymentQuery, TError, TData>(
      ['AccountForMassPayment', variables],
      useFetchData<AccountForMassPaymentQuery, AccountForMassPaymentQueryVariables>(AccountForMassPaymentDocument).bind(null, variables),
      options
    )};

export const UpdateMassPaymentFilingStatusDocument = `
    mutation UpdateMassPaymentFilingStatus($input: MassPaymentFilingStatusInput!) {
  updateMassPaymentFilingStatus(input: $input) {
    accountId
    howFiled
    howReceived
    filedDate
    filedBy
    filedByDisplay
  }
}
    `;

export const useUpdateMassPaymentFilingStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMassPaymentFilingStatusMutation, TError, UpdateMassPaymentFilingStatusMutationVariables, TContext>) => {
    
    return useMutation<UpdateMassPaymentFilingStatusMutation, TError, UpdateMassPaymentFilingStatusMutationVariables, TContext>(
      ['UpdateMassPaymentFilingStatus'],
      useFetchData<UpdateMassPaymentFilingStatusMutation, UpdateMassPaymentFilingStatusMutationVariables>(UpdateMassPaymentFilingStatusDocument),
      options
    )};

export const MovePermitInitialFormDataDocument = `
    query MovePermitInitialFormData($accountNumber: String!) {
  movePermitInitialFormData(accountNumber: $accountNumber) {
    taxYear
    jurisdiction
    accountId
    accountNumber
    leaseMasterAccountId
    leaseMasterAccountNumber
    issueDate
    ownerName
    modelDescription
    modelYear
    serialNumber
    permitIssuedTo
    permitIssuedBy
    addressFrom {
      address
      city
      state
    }
    addressTo {
      address
      city
      state
    }
    taxAmountPaid
    datePaid
    receiptNumber
    isActive
  }
}
    `;

export const useMovePermitInitialFormDataQuery = <
      TData = MovePermitInitialFormDataQuery,
      TError = unknown
    >(
      variables: MovePermitInitialFormDataQueryVariables,
      options?: UseQueryOptions<MovePermitInitialFormDataQuery, TError, TData>
    ) => {
    
    return useQuery<MovePermitInitialFormDataQuery, TError, TData>(
      ['MovePermitInitialFormData', variables],
      useFetchData<MovePermitInitialFormDataQuery, MovePermitInitialFormDataQueryVariables>(MovePermitInitialFormDataDocument).bind(null, variables),
      options
    )};

export const CreateMovePermitDocument = `
    mutation CreateMovePermit($movePermit: CreateMovePermitInput!) {
  createMovePermit(movePermit: $movePermit) {
    id
    taxYear
    jurisdiction
    accountId
    accountNumber
    leaseMasterAccountNumber
    permitTypeId
    issueDate
    ownerName
    modelDescription
    modelYear
    serialNumber
    permitIssuedTo
    permitIssuedBy
    addressFrom {
      address
      city
      state
    }
    addressTo {
      address
      city
      state
    }
    taxAmountPaid
    datePaid
    receiptNumber
    note {
      id
      text
    }
    updateDate
    updatedBy
    isActive
  }
}
    `;

export const useCreateMovePermitMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateMovePermitMutation, TError, CreateMovePermitMutationVariables, TContext>) => {
    
    return useMutation<CreateMovePermitMutation, TError, CreateMovePermitMutationVariables, TContext>(
      ['CreateMovePermit'],
      useFetchData<CreateMovePermitMutation, CreateMovePermitMutationVariables>(CreateMovePermitDocument),
      options
    )};

export const EditMovePermitDocument = `
    mutation EditMovePermit($movePermit: EditMovePermitInput!) {
  editMovePermit(movePermit: $movePermit) {
    id
    taxYear
    jurisdiction
    accountId
    accountNumber
    leaseMasterAccountNumber
    permitTypeId
    issueDate
    ownerName
    modelDescription
    modelYear
    serialNumber
    permitIssuedTo
    permitIssuedBy
    addressFrom {
      address
      city
      state
    }
    addressTo {
      address
      city
      state
    }
    taxAmountPaid
    datePaid
    receiptNumber
    note {
      id
      text
    }
    updateDate
    updatedBy
    isActive
  }
}
    `;

export const useEditMovePermitMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditMovePermitMutation, TError, EditMovePermitMutationVariables, TContext>) => {
    
    return useMutation<EditMovePermitMutation, TError, EditMovePermitMutationVariables, TContext>(
      ['EditMovePermit'],
      useFetchData<EditMovePermitMutation, EditMovePermitMutationVariables>(EditMovePermitDocument),
      options
    )};

export const SearchMovePermitsDocument = `
    query SearchMovePermits($searchFilters: MovePermitSearchInput!) {
  movePermits(searchFilters: $searchFilters) {
    totalRecordCount
    movePermits {
      id
      taxYear
      jurisdiction
      accountId
      accountNumber
      leaseMasterAccountNumber
      permitTypeId
      issueDate
      ownerName
      modelDescription
      modelYear
      serialNumber
      permitIssuedTo
      permitIssuedBy
      addressFrom {
        address
        city
        state
      }
      addressTo {
        address
        city
        state
      }
      taxAmountPaid
      datePaid
      receiptNumber
      note {
        id
        text
      }
      updateDate
      updatedBy
      isActive
    }
  }
}
    `;

export const useSearchMovePermitsQuery = <
      TData = SearchMovePermitsQuery,
      TError = unknown
    >(
      variables: SearchMovePermitsQueryVariables,
      options?: UseQueryOptions<SearchMovePermitsQuery, TError, TData>
    ) => {
    
    return useQuery<SearchMovePermitsQuery, TError, TData>(
      ['SearchMovePermits', variables],
      useFetchData<SearchMovePermitsQuery, SearchMovePermitsQueryVariables>(SearchMovePermitsDocument).bind(null, variables),
      options
    )};

export const GetSubAccountsForMovePermitDocument = `
    query GetSubAccountsForMovePermit($leaseMasterAccountNumber: String!, $taxYear: Int!) {
  getSubAccounts(
    leaseMasterAccountNumber: $leaseMasterAccountNumber
    taxYear: $taxYear
  ) {
    id
    businessName
    subAccounts {
      id
      accountNumber
      taxDistrict
      hasDelinquentBalance
    }
  }
}
    `;

export const useGetSubAccountsForMovePermitQuery = <
      TData = GetSubAccountsForMovePermitQuery,
      TError = unknown
    >(
      variables: GetSubAccountsForMovePermitQueryVariables,
      options?: UseQueryOptions<GetSubAccountsForMovePermitQuery, TError, TData>
    ) => {
    
    return useQuery<GetSubAccountsForMovePermitQuery, TError, TData>(
      ['GetSubAccountsForMovePermit', variables],
      useFetchData<GetSubAccountsForMovePermitQuery, GetSubAccountsForMovePermitQueryVariables>(GetSubAccountsForMovePermitDocument).bind(null, variables),
      options
    )};

export const GetNotesDocument = `
    query GetNotes($accountId: ID!) {
  notes(accountId: $accountId) {
    id
    content
    section
    subsection
    systemGenerated
    taxYear
    createDate
    updateDate
    author {
      id
      name
    }
    edited
  }
}
    `;

export const useGetNotesQuery = <
      TData = GetNotesQuery,
      TError = unknown
    >(
      variables: GetNotesQueryVariables,
      options?: UseQueryOptions<GetNotesQuery, TError, TData>
    ) => {
    
    return useQuery<GetNotesQuery, TError, TData>(
      ['GetNotes', variables],
      useFetchData<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument).bind(null, variables),
      options
    )};

export const GetLeaseMasterNotesDocument = `
    query GetLeaseMasterNotes($leaseMasterId: ID!) {
  leaseMasterNotes(leaseMasterId: $leaseMasterId) {
    id
    content
    section
    subsection
    systemGenerated
    taxYear
    createDate
    updateDate
    author {
      id
      name
    }
    edited
  }
}
    `;

export const useGetLeaseMasterNotesQuery = <
      TData = GetLeaseMasterNotesQuery,
      TError = unknown
    >(
      variables: GetLeaseMasterNotesQueryVariables,
      options?: UseQueryOptions<GetLeaseMasterNotesQuery, TError, TData>
    ) => {
    
    return useQuery<GetLeaseMasterNotesQuery, TError, TData>(
      ['GetLeaseMasterNotes', variables],
      useFetchData<GetLeaseMasterNotesQuery, GetLeaseMasterNotesQueryVariables>(GetLeaseMasterNotesDocument).bind(null, variables),
      options
    )};

export const GetTelecomNotesDocument = `
    query GetTelecomNotes($telecomId: ID!) {
  telecomNotes(telecomId: $telecomId) {
    id
    content
    section
    subsection
    systemGenerated
    taxYear
    createDate
    updateDate
    author {
      id
      name
    }
    edited
  }
}
    `;

export const useGetTelecomNotesQuery = <
      TData = GetTelecomNotesQuery,
      TError = unknown
    >(
      variables: GetTelecomNotesQueryVariables,
      options?: UseQueryOptions<GetTelecomNotesQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomNotesQuery, TError, TData>(
      ['GetTelecomNotes', variables],
      useFetchData<GetTelecomNotesQuery, GetTelecomNotesQueryVariables>(GetTelecomNotesDocument).bind(null, variables),
      options
    )};

export const SaveNoteDocument = `
    mutation SaveNote($note: NoteInput!) {
  saveNote(note: $note) {
    id
    content
    section
    subsection
    systemGenerated
    taxYear
    createDate
    updateDate
    author {
      id
      name
    }
    edited
  }
}
    `;

export const useSaveNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveNoteMutation, TError, SaveNoteMutationVariables, TContext>) => {
    
    return useMutation<SaveNoteMutation, TError, SaveNoteMutationVariables, TContext>(
      ['SaveNote'],
      useFetchData<SaveNoteMutation, SaveNoteMutationVariables>(SaveNoteDocument),
      options
    )};

export const SaveLeaseMasterNoteDocument = `
    mutation SaveLeaseMasterNote($note: NoteInput!) {
  saveLeaseMasterNote(note: $note) {
    id
    content
    section
    subsection
    systemGenerated
    taxYear
    createDate
    updateDate
    author {
      id
      name
    }
    edited
  }
}
    `;

export const useSaveLeaseMasterNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveLeaseMasterNoteMutation, TError, SaveLeaseMasterNoteMutationVariables, TContext>) => {
    
    return useMutation<SaveLeaseMasterNoteMutation, TError, SaveLeaseMasterNoteMutationVariables, TContext>(
      ['SaveLeaseMasterNote'],
      useFetchData<SaveLeaseMasterNoteMutation, SaveLeaseMasterNoteMutationVariables>(SaveLeaseMasterNoteDocument),
      options
    )};

export const SaveTelecomNoteDocument = `
    mutation SaveTelecomNote($note: NoteInput!) {
  saveTelecomNote(note: $note) {
    id
    content
    section
    subsection
    systemGenerated
    taxYear
    createDate
    updateDate
    author {
      id
      name
    }
    edited
  }
}
    `;

export const useSaveTelecomNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveTelecomNoteMutation, TError, SaveTelecomNoteMutationVariables, TContext>) => {
    
    return useMutation<SaveTelecomNoteMutation, TError, SaveTelecomNoteMutationVariables, TContext>(
      ['SaveTelecomNote'],
      useFetchData<SaveTelecomNoteMutation, SaveTelecomNoteMutationVariables>(SaveTelecomNoteDocument),
      options
    )};

export const GetPaymentPlansDocument = `
    query GetPaymentPlans($accountId: Int!, $taxYear: Int!) {
  getPaymentPlan(accountId: $accountId, taxYear: $taxYear) {
    accountId
    accountNumber
    accountTypeId
    businessName
    taxYear
    ein {
      id
      name
    }
    paymentPlanTypes
    paymentPlans {
      id
      contractNumber
      planType
      taxYear
      terms
      details {
        id
        amount
        paymentDate
        comment
        isPaid
      }
      totals {
        currentYearDue
        currentYearDueWithInterest
        delinquentBalance
        totalPayments
        totalPaymentsLeft
      }
    }
    totals {
      delinquentBalance
      currentYearDue
      currentYearDueWithInterest
      totalPayments
      totalPaymentsLeft
    }
  }
}
    `;

export const useGetPaymentPlansQuery = <
      TData = GetPaymentPlansQuery,
      TError = unknown
    >(
      variables: GetPaymentPlansQueryVariables,
      options?: UseQueryOptions<GetPaymentPlansQuery, TError, TData>
    ) => {
    
    return useQuery<GetPaymentPlansQuery, TError, TData>(
      ['GetPaymentPlans', variables],
      useFetchData<GetPaymentPlansQuery, GetPaymentPlansQueryVariables>(GetPaymentPlansDocument).bind(null, variables),
      options
    )};

export const CalculatePaymentPlanDocument = `
    mutation CalculatePaymentPlan($calculatePaymentPlanInput: CalculatePaymentPlanInput!) {
  calculatePaymentPlan(calculatePaymentPlanInput: $calculatePaymentPlanInput) {
    id
    contractNumber
    planType
    taxYear
    terms
    details {
      id
      amount
      paymentDate
      comment
      isPaid
      isUpdated
      isDeleted
    }
    totals {
      currentYearDue
      currentYearDueWithInterest
      delinquentBalance
      totalPayments
      totalPaymentsLeft
    }
  }
}
    `;

export const useCalculatePaymentPlanMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CalculatePaymentPlanMutation, TError, CalculatePaymentPlanMutationVariables, TContext>) => {
    
    return useMutation<CalculatePaymentPlanMutation, TError, CalculatePaymentPlanMutationVariables, TContext>(
      ['CalculatePaymentPlan'],
      useFetchData<CalculatePaymentPlanMutation, CalculatePaymentPlanMutationVariables>(CalculatePaymentPlanDocument),
      options
    )};

export const SavePaymentPlanDocument = `
    mutation SavePaymentPlan($savePaymentPlanInput: SavePaymentPlanInput!) {
  savePaymentPlan(savePaymentPlanInput: $savePaymentPlanInput) {
    id
    contractNumber
    planType
    terms
    taxYear
    details {
      id
      amount
      paymentDate
      comment
      isPaid
    }
    totals {
      currentYearDue
      currentYearDueWithInterest
      delinquentBalance
      totalPayments
      totalPaymentsLeft
    }
  }
}
    `;

export const useSavePaymentPlanMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SavePaymentPlanMutation, TError, SavePaymentPlanMutationVariables, TContext>) => {
    
    return useMutation<SavePaymentPlanMutation, TError, SavePaymentPlanMutationVariables, TContext>(
      ['SavePaymentPlan'],
      useFetchData<SavePaymentPlanMutation, SavePaymentPlanMutationVariables>(SavePaymentPlanDocument),
      options
    )};

export const DeletePaymentPlanDocument = `
    mutation DeletePaymentPlan($id: Int!) {
  deletePaymentPlan(paymentPlanId: $id)
}
    `;

export const useDeletePaymentPlanMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeletePaymentPlanMutation, TError, DeletePaymentPlanMutationVariables, TContext>) => {
    
    return useMutation<DeletePaymentPlanMutation, TError, DeletePaymentPlanMutationVariables, TContext>(
      ['DeletePaymentPlan'],
      useFetchData<DeletePaymentPlanMutation, DeletePaymentPlanMutationVariables>(DeletePaymentPlanDocument),
      options
    )};

export const GetPaymentPostingsDocument = `
    query GetPaymentPostings($dateReceived: String!, $isTelecom: Boolean) {
  paymentPostings(dateReceived: $dateReceived, isTelecom: $isTelecom) {
    id
    receiptNumber
    paymentType
    amount
    masterAccountNumber
    receivedFrom
    checkNumber
    isVoided
  }
  paymentTypes {
    id
    description
  }
}
    `;

export const useGetPaymentPostingsQuery = <
      TData = GetPaymentPostingsQuery,
      TError = unknown
    >(
      variables: GetPaymentPostingsQueryVariables,
      options?: UseQueryOptions<GetPaymentPostingsQuery, TError, TData>
    ) => {
    
    return useQuery<GetPaymentPostingsQuery, TError, TData>(
      ['GetPaymentPostings', variables],
      useFetchData<GetPaymentPostingsQuery, GetPaymentPostingsQueryVariables>(GetPaymentPostingsDocument).bind(null, variables),
      options
    )};

export const SavePaymentPostingsDocument = `
    mutation SavePaymentPostings($dateReceived: String!, $payments: [PaymentPostingInput!]!) {
  savePaymentPostings(dateReceived: $dateReceived, payments: $payments) {
    id
    receiptNumber
    paymentType
    amount
    masterAccountNumber
    receivedFrom
    checkNumber
    isVoided
  }
}
    `;

export const useSavePaymentPostingsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SavePaymentPostingsMutation, TError, SavePaymentPostingsMutationVariables, TContext>) => {
    
    return useMutation<SavePaymentPostingsMutation, TError, SavePaymentPostingsMutationVariables, TContext>(
      ['SavePaymentPostings'],
      useFetchData<SavePaymentPostingsMutation, SavePaymentPostingsMutationVariables>(SavePaymentPostingsDocument),
      options
    )};

export const GetPaymentHoldingsDocument = `
    query GetPaymentHoldings($accountNumber: String!) {
  paymentHoldings(accountNumber: $accountNumber) {
    id
    accountNumber
    businessName
    delinquentBalance
    payments {
      id
      receiptNumber
      amount
      checkNumber
      dateReceived
      paymentType {
        id
        description
      }
      createdBy {
        id
        username
        fullName
        email
        isActive
        isVerified
      }
    }
    subAccounts {
      id
      accountNumber
      taxDistrict
      interest
      balanceDue
      balanceDueWithInterest
    }
  }
}
    `;

export const useGetPaymentHoldingsQuery = <
      TData = GetPaymentHoldingsQuery,
      TError = unknown
    >(
      variables: GetPaymentHoldingsQueryVariables,
      options?: UseQueryOptions<GetPaymentHoldingsQuery, TError, TData>
    ) => {
    
    return useQuery<GetPaymentHoldingsQuery, TError, TData>(
      ['GetPaymentHoldings', variables],
      useFetchData<GetPaymentHoldingsQuery, GetPaymentHoldingsQueryVariables>(GetPaymentHoldingsDocument).bind(null, variables),
      options
    )};

export const AllocatePaymentsDocument = `
    mutation AllocatePayments($allocation: AllocateHoldingsToSubAccountsInput!) {
  allocateHoldingsToSubAccounts(allocation: $allocation) {
    subAccountId
    paymentId
    receiptNumber
    amount
  }
}
    `;

export const useAllocatePaymentsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AllocatePaymentsMutation, TError, AllocatePaymentsMutationVariables, TContext>) => {
    
    return useMutation<AllocatePaymentsMutation, TError, AllocatePaymentsMutationVariables, TContext>(
      ['AllocatePayments'],
      useFetchData<AllocatePaymentsMutation, AllocatePaymentsMutationVariables>(AllocatePaymentsDocument),
      options
    )};

export const CalculateMasterAccountInterestDocument = `
    mutation CalculateMasterAccountInterest($input: CalculateMasterAccountInterestInput!) {
  calculateMasterAccountInterest(input: $input) {
    id
    accountNumber
    taxDistrict
    interest
    balanceDue
    balanceDueWithInterest
  }
}
    `;

export const useCalculateMasterAccountInterestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CalculateMasterAccountInterestMutation, TError, CalculateMasterAccountInterestMutationVariables, TContext>) => {
    
    return useMutation<CalculateMasterAccountInterestMutation, TError, CalculateMasterAccountInterestMutationVariables, TContext>(
      ['CalculateMasterAccountInterest'],
      useFetchData<CalculateMasterAccountInterestMutation, CalculateMasterAccountInterestMutationVariables>(CalculateMasterAccountInterestDocument),
      options
    )};

export const GetPaymentOverviewDocument = `
    query GetPaymentOverview($accountId: Int!, $directChargeAccountId: ID!, $taxYear: Int!) {
  getDirectCharges(accountId: $directChargeAccountId, taxYear: $taxYear) {
    accountId
    accountNumber
    taxYear
    jurisdiction
    ein {
      id
      name
    }
    businessName
    accountSummary {
      assessmentCharge
      balance
      balanceDueWithInterest
      interest
      isExempt
      penaltyCharge
      taxRate
      totalCost
      totalDirectCharge
      totalPayments
      totalTaxable
    }
    directCharges {
      amount
      comment
      ein {
        id
        name
      }
      id
      type {
        id
        description
      }
      isActive
      updateDate
    }
  }
  getDirectChargeTypes {
    id
    description
  }
  getPaymentPlan(accountId: $accountId, taxYear: $taxYear) {
    accountId
    accountNumber
    accountTypeId
    businessName
    taxYear
    ein {
      id
      name
    }
    paymentPlanTypes
    paymentPlans {
      id
      contractNumber
      planType
      terms
      details {
        id
        amount
        paymentDate
        comment
        isPaid
      }
      totals {
        currentYearDue
        currentYearDueWithInterest
        delinquentBalance
        totalPayments
        totalPaymentsLeft
      }
    }
  }
}
    `;

export const useGetPaymentOverviewQuery = <
      TData = GetPaymentOverviewQuery,
      TError = unknown
    >(
      variables: GetPaymentOverviewQueryVariables,
      options?: UseQueryOptions<GetPaymentOverviewQuery, TError, TData>
    ) => {
    
    return useQuery<GetPaymentOverviewQuery, TError, TData>(
      ['GetPaymentOverview', variables],
      useFetchData<GetPaymentOverviewQuery, GetPaymentOverviewQueryVariables>(GetPaymentOverviewDocument).bind(null, variables),
      options
    )};

export const GetAccountPaymentsDocument = `
    query GetAccountPayments($accountId: Int!, $accountIdString: String!, $taxYear: Int!) {
  paymentTypes {
    id
    description
  }
  paymentStatus {
    id
    description
  }
  howReceivedList {
    id
    label
  }
  payments(accountId: $accountId, taxYear: $taxYear) {
    id
    accountId
    accountNumber
    taxYear
    receiptNumber
    businessName
    paymentAmount
    interestPaid
    interestAccrued
    penaltyAmount
    penaltyPaid
    paymentType {
      id
      description
    }
    paymentStatus {
      id
      description
    }
    howReceived {
      id
      label
    }
    receivedFrom
    dateReceived
    checkNumber
    isReconciled
    ein {
      id
      name
    }
  }
  getBusinessAccount(accountId: $accountIdString, taxYear: $taxYear) {
    id
    accountNumber
    businessName
    isActive
    filingStatus {
      hasAttachment
      howFiled {
        id
        label
      }
    }
  }
}
    `;

export const useGetAccountPaymentsQuery = <
      TData = GetAccountPaymentsQuery,
      TError = unknown
    >(
      variables: GetAccountPaymentsQueryVariables,
      options?: UseQueryOptions<GetAccountPaymentsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAccountPaymentsQuery, TError, TData>(
      ['GetAccountPayments', variables],
      useFetchData<GetAccountPaymentsQuery, GetAccountPaymentsQueryVariables>(GetAccountPaymentsDocument).bind(null, variables),
      options
    )};

export const SearchPaymentsDocument = `
    query SearchPayments($filters: SearchPaymentInput!) {
  searchPayments(filters: $filters) {
    id
    accountId
    accountNumber
    taxYear
    receiptNumber
    businessName
    paymentAmount
    interestPaid
    interestAccrued
    penaltyAmount
    penaltyPaid
    paymentType {
      id
      description
    }
    paymentStatus {
      id
      description
    }
    howReceived {
      id
      label
    }
    receivedFrom
    dateReceived
    checkNumber
    masterAccountNumber
    ein {
      id
      name
    }
  }
}
    `;

export const useSearchPaymentsQuery = <
      TData = SearchPaymentsQuery,
      TError = unknown
    >(
      variables: SearchPaymentsQueryVariables,
      options?: UseQueryOptions<SearchPaymentsQuery, TError, TData>
    ) => {
    
    return useQuery<SearchPaymentsQuery, TError, TData>(
      ['SearchPayments', variables],
      useFetchData<SearchPaymentsQuery, SearchPaymentsQueryVariables>(SearchPaymentsDocument).bind(null, variables),
      options
    )};

export const GetPaymentCollectionsDocument = `
    query GetPaymentCollections {
  paymentTypes {
    id
    description
  }
  paymentStatus {
    id
    description
  }
  howReceivedList {
    id
    label
  }
}
    `;

export const useGetPaymentCollectionsQuery = <
      TData = GetPaymentCollectionsQuery,
      TError = unknown
    >(
      variables?: GetPaymentCollectionsQueryVariables,
      options?: UseQueryOptions<GetPaymentCollectionsQuery, TError, TData>
    ) => {
    
    return useQuery<GetPaymentCollectionsQuery, TError, TData>(
      variables === undefined ? ['GetPaymentCollections'] : ['GetPaymentCollections', variables],
      useFetchData<GetPaymentCollectionsQuery, GetPaymentCollectionsQueryVariables>(GetPaymentCollectionsDocument).bind(null, variables),
      options
    )};

export const GetAccountPaymentInitialValuesDocument = `
    query GetAccountPaymentInitialValues($accountId: Int!) {
  paymentTemplate(accountId: $accountId) {
    payment {
      id
      accountId
      accountNumber
      taxYear
      receiptNumber
      businessName
      paymentAmount
      interestPaid
      interestAccrued
      penaltyAmount
      penaltyPaid
      paymentType {
        id
        description
      }
      paymentStatus {
        id
        description
      }
      receivedFrom
      dateReceived
      checkNumber
      ein {
        id
        name
      }
    }
    summary {
      assessmentCharge
      totalDirectCharge
      totalPayments
      penaltyCharge
      totalCost
      totalTaxable
      interest
      balance
      balanceDueWithInterest
      taxRate
      isExempt
    }
    paymentPlan {
      id
      terms {
        amount
        dueDate
      }
      total
    }
    howFiled {
      id
      label
    }
    howReceived {
      id
      label
    }
  }
}
    `;

export const useGetAccountPaymentInitialValuesQuery = <
      TData = GetAccountPaymentInitialValuesQuery,
      TError = unknown
    >(
      variables: GetAccountPaymentInitialValuesQueryVariables,
      options?: UseQueryOptions<GetAccountPaymentInitialValuesQuery, TError, TData>
    ) => {
    
    return useQuery<GetAccountPaymentInitialValuesQuery, TError, TData>(
      ['GetAccountPaymentInitialValues', variables],
      useFetchData<GetAccountPaymentInitialValuesQuery, GetAccountPaymentInitialValuesQueryVariables>(GetAccountPaymentInitialValuesDocument).bind(null, variables),
      options
    )};

export const CurrentReturnedPaymentDocument = `
    query CurrentReturnedPayment($accountNumber: String!) {
  currentReturnedPayment(accountNumber: $accountNumber) {
    ein {
      id
      name
    }
    accountNumber
    businessName
    accountId
    dateReturned
    dateReceived
    paymentType {
      id
      description
    }
    amount
  }
}
    `;

export const useCurrentReturnedPaymentQuery = <
      TData = CurrentReturnedPaymentQuery,
      TError = unknown
    >(
      variables: CurrentReturnedPaymentQueryVariables,
      options?: UseQueryOptions<CurrentReturnedPaymentQuery, TError, TData>
    ) => {
    
    return useQuery<CurrentReturnedPaymentQuery, TError, TData>(
      ['CurrentReturnedPayment', variables],
      useFetchData<CurrentReturnedPaymentQuery, CurrentReturnedPaymentQueryVariables>(CurrentReturnedPaymentDocument).bind(null, variables),
      options
    )};

export const DelinquentReturnedPaymentDocument = `
    query DelinquentReturnedPayment($accountNumber: String!) {
  delinquentReturnedPayment(accountNumber: $accountNumber) {
    ein {
      id
      name
    }
    businessName
    accountNumber
    accountId
    dateReturned
    payments {
      id
      date
      receiptNumber
      receivedFrom
      amount
      checkNumber
      paymentType {
        id
        description
      }
      leftOverInterest
    }
  }
}
    `;

export const useDelinquentReturnedPaymentQuery = <
      TData = DelinquentReturnedPaymentQuery,
      TError = unknown
    >(
      variables: DelinquentReturnedPaymentQueryVariables,
      options?: UseQueryOptions<DelinquentReturnedPaymentQuery, TError, TData>
    ) => {
    
    return useQuery<DelinquentReturnedPaymentQuery, TError, TData>(
      ['DelinquentReturnedPayment', variables],
      useFetchData<DelinquentReturnedPaymentQuery, DelinquentReturnedPaymentQueryVariables>(DelinquentReturnedPaymentDocument).bind(null, variables),
      options
    )};

export const PaymentTypesDocument = `
    query PaymentTypes {
  paymentTypes {
    description
    id
  }
}
    `;

export const usePaymentTypesQuery = <
      TData = PaymentTypesQuery,
      TError = unknown
    >(
      variables?: PaymentTypesQueryVariables,
      options?: UseQueryOptions<PaymentTypesQuery, TError, TData>
    ) => {
    
    return useQuery<PaymentTypesQuery, TError, TData>(
      variables === undefined ? ['PaymentTypes'] : ['PaymentTypes', variables],
      useFetchData<PaymentTypesQuery, PaymentTypesQueryVariables>(PaymentTypesDocument).bind(null, variables),
      options
    )};

export const CreatePaymentDocument = `
    mutation CreatePayment($payment: CreatePaymentInput!) {
  createPayment(payment: $payment) {
    id
    accountId
    taxYear
    receiptNumber
    businessName
    paymentAmount
    interestPaid
    interestAccrued
    penaltyAmount
    penaltyPaid
    paymentType {
      id
      description
    }
    paymentStatus {
      id
      description
    }
    receivedFrom
    dateReceived
    checkNumber
    ein {
      id
      name
    }
  }
}
    `;

export const useCreatePaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePaymentMutation, TError, CreatePaymentMutationVariables, TContext>) => {
    
    return useMutation<CreatePaymentMutation, TError, CreatePaymentMutationVariables, TContext>(
      ['CreatePayment'],
      useFetchData<CreatePaymentMutation, CreatePaymentMutationVariables>(CreatePaymentDocument),
      options
    )};

export const EditPaymentDocument = `
    mutation EditPayment($payment: EditPaymentInput!) {
  editPayment(payment: $payment) {
    id
    receiptNumber
    accountId
    accountNumber
    businessName
    receivedFrom
    dateReceived
    paymentAmount
    paymentType {
      id
      description
    }
    paymentStatus {
      id
      description
    }
    isReconciled
    checkNumber
    masterAccountNumber
    ein {
      id
      name
    }
  }
}
    `;

export const useEditPaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditPaymentMutation, TError, EditPaymentMutationVariables, TContext>) => {
    
    return useMutation<EditPaymentMutation, TError, EditPaymentMutationVariables, TContext>(
      ['EditPayment'],
      useFetchData<EditPaymentMutation, EditPaymentMutationVariables>(EditPaymentDocument),
      options
    )};

export const PaymentCurrentYearSummaryDocument = `
    query PaymentCurrentYearSummary($dateReceived: String!, $ein: Int) {
  currentYearSummary(dateReceived: $dateReceived, ein: $ein) {
    payments {
      id
      receiptNumber
      accountId
      accountNumber
      taxYear
      businessName
      receivedFrom
      dateReceived
      paymentAmount
      paymentType {
        id
        description
      }
      paymentStatus {
        id
        description
      }
      howReceived {
        id
        label
      }
      isReconciled
      checkNumber
      masterAccountNumber
      ein {
        id
        name
      }
    }
    totalCash
    totalChecks
    totalCredit
    totalEChecks
    totalReturnedChecks
    totalReturnedEChecks
    grandTotal
  }
}
    `;

export const usePaymentCurrentYearSummaryQuery = <
      TData = PaymentCurrentYearSummaryQuery,
      TError = unknown
    >(
      variables: PaymentCurrentYearSummaryQueryVariables,
      options?: UseQueryOptions<PaymentCurrentYearSummaryQuery, TError, TData>
    ) => {
    
    return useQuery<PaymentCurrentYearSummaryQuery, TError, TData>(
      ['PaymentCurrentYearSummary', variables],
      useFetchData<PaymentCurrentYearSummaryQuery, PaymentCurrentYearSummaryQueryVariables>(PaymentCurrentYearSummaryDocument).bind(null, variables),
      options
    )};

export const DailyPaymentTotalsDocument = `
    query DailyPaymentTotals($dateReceived: String!, $ein: Int) {
  dailyPaymentTotals(dateReceived: $dateReceived, ein: $ein) {
    current {
      cash
      check
      credit
      eChecks
      returnedChecks
      returnedEChecks
      total
    }
    delinquent {
      cash
      check
      credit
      eChecks
      returnedChecks
      returnedEChecks
      total
    }
    dailyTotal {
      cash
      check
      credit
      eChecks
      returnedChecks
      returnedEChecks
      total
    }
    bankDeposit {
      cashDeposit
      checkDeposit
      total
    }
    returnedItems {
      currentChecks
      currentEChecks
      delinquentChecks
      delinquentEChecks
    }
  }
}
    `;

export const useDailyPaymentTotalsQuery = <
      TData = DailyPaymentTotalsQuery,
      TError = unknown
    >(
      variables: DailyPaymentTotalsQueryVariables,
      options?: UseQueryOptions<DailyPaymentTotalsQuery, TError, TData>
    ) => {
    
    return useQuery<DailyPaymentTotalsQuery, TError, TData>(
      ['DailyPaymentTotals', variables],
      useFetchData<DailyPaymentTotalsQuery, DailyPaymentTotalsQueryVariables>(DailyPaymentTotalsDocument).bind(null, variables),
      options
    )};

export const CalculateInterestDocument = `
    mutation CalculateInterest($accountId: Int!, $dateReceived: String!) {
  calculateInterest(accountId: $accountId, dateReceived: $dateReceived) {
    interest
  }
}
    `;

export const useCalculateInterestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CalculateInterestMutation, TError, CalculateInterestMutationVariables, TContext>) => {
    
    return useMutation<CalculateInterestMutation, TError, CalculateInterestMutationVariables, TContext>(
      ['CalculateInterest'],
      useFetchData<CalculateInterestMutation, CalculateInterestMutationVariables>(CalculateInterestDocument),
      options
    )};

export const CreateReturnedPaymentDocument = `
    mutation CreateReturnedPayment($payment: ReturnedPaymentInput!) {
  createReturnedPayment(payment: $payment) {
    ein {
      id
      name
    }
    accountNumber
    businessName
    accountId
    dateReturned
    dateReceived
    paymentType {
      id
      description
    }
    amount
  }
}
    `;

export const useCreateReturnedPaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReturnedPaymentMutation, TError, CreateReturnedPaymentMutationVariables, TContext>) => {
    
    return useMutation<CreateReturnedPaymentMutation, TError, CreateReturnedPaymentMutationVariables, TContext>(
      ['CreateReturnedPayment'],
      useFetchData<CreateReturnedPaymentMutation, CreateReturnedPaymentMutationVariables>(CreateReturnedPaymentDocument),
      options
    )};

export const CreateDelinquentReturnedPaymentDocument = `
    mutation CreateDelinquentReturnedPayment($payment: CreateDelinquentReturnedPaymentInput!) {
  createDelinquentReturnedPayment(payment: $payment) {
    accountId
    dateReturned
    paymentId
  }
}
    `;

export const useCreateDelinquentReturnedPaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDelinquentReturnedPaymentMutation, TError, CreateDelinquentReturnedPaymentMutationVariables, TContext>) => {
    
    return useMutation<CreateDelinquentReturnedPaymentMutation, TError, CreateDelinquentReturnedPaymentMutationVariables, TContext>(
      ['CreateDelinquentReturnedPayment'],
      useFetchData<CreateDelinquentReturnedPaymentMutation, CreateDelinquentReturnedPaymentMutationVariables>(CreateDelinquentReturnedPaymentDocument),
      options
    )};

export const GetDelinquentPaymentVoidDocument = `
    query GetDelinquentPaymentVoid($receiptNumber: String!) {
  delinquentPaymentVoid(receiptNumber: $receiptNumber) {
    accountId
    accountNumber
    businessName
    payment {
      id
      date
      receiptNumber
      receivedFrom
      amount
      checkNumber
      paymentType {
        id
        description
      }
      ein
      leftOverInterest
      isAdjustment
    }
    transactions {
      id
      directCharge {
        id
        description
      }
      amount
      receiptNumber
      dateReceived
      ein
    }
  }
}
    `;

export const useGetDelinquentPaymentVoidQuery = <
      TData = GetDelinquentPaymentVoidQuery,
      TError = unknown
    >(
      variables: GetDelinquentPaymentVoidQueryVariables,
      options?: UseQueryOptions<GetDelinquentPaymentVoidQuery, TError, TData>
    ) => {
    
    return useQuery<GetDelinquentPaymentVoidQuery, TError, TData>(
      ['GetDelinquentPaymentVoid', variables],
      useFetchData<GetDelinquentPaymentVoidQuery, GetDelinquentPaymentVoidQueryVariables>(GetDelinquentPaymentVoidDocument).bind(null, variables),
      options
    )};

export const VoidDelinquentPaymentDocument = `
    mutation VoidDelinquentPayment($input: VoidDelinquentPaymentInput!) {
  voidDelinquentPayment(input: $input)
}
    `;

export const useVoidDelinquentPaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<VoidDelinquentPaymentMutation, TError, VoidDelinquentPaymentMutationVariables, TContext>) => {
    
    return useMutation<VoidDelinquentPaymentMutation, TError, VoidDelinquentPaymentMutationVariables, TContext>(
      ['VoidDelinquentPayment'],
      useFetchData<VoidDelinquentPaymentMutation, VoidDelinquentPaymentMutationVariables>(VoidDelinquentPaymentDocument),
      options
    )};

export const GetDelqPaymentVoidSearchDocument = `
    query GetDelqPaymentVoidSearch($input: DelqPaymentVoidSearchInput!) {
  delqPaymentVoidSearch(input: $input) {
    delqAcctPaymentId
    accountNbr
    businessName
    dateReceived
    receiptNumber
    paymentTypeDescr
    checkNumber
    amount
    receivedFrom
    isAdjustment
    masterAccountNbr
    ein
  }
}
    `;

export const useGetDelqPaymentVoidSearchQuery = <
      TData = GetDelqPaymentVoidSearchQuery,
      TError = unknown
    >(
      variables: GetDelqPaymentVoidSearchQueryVariables,
      options?: UseQueryOptions<GetDelqPaymentVoidSearchQuery, TError, TData>
    ) => {
    
    return useQuery<GetDelqPaymentVoidSearchQuery, TError, TData>(
      ['GetDelqPaymentVoidSearch', variables],
      useFetchData<GetDelqPaymentVoidSearchQuery, GetDelqPaymentVoidSearchQueryVariables>(GetDelqPaymentVoidSearchDocument).bind(null, variables),
      options
    )};

export const GetSubAccountPaymentsDocument = `
    query GetSubAccountPayments($filters: SearchPaymentInput!) {
  searchPayments(filters: $filters) {
    id
    accountId
    accountNumber
    taxYear
    receiptNumber
    businessName
    paymentAmount
    interestPaid
    interestAccrued
    penaltyAmount
    penaltyPaid
    paymentType {
      id
      description
    }
    paymentStatus {
      id
      description
    }
    howReceived {
      id
      label
    }
    receivedFrom
    dateReceived
    checkNumber
    ein {
      id
      name
    }
  }
  paymentTypes {
    id
    description
  }
  paymentStatus {
    id
    description
  }
}
    `;

export const useGetSubAccountPaymentsQuery = <
      TData = GetSubAccountPaymentsQuery,
      TError = unknown
    >(
      variables: GetSubAccountPaymentsQueryVariables,
      options?: UseQueryOptions<GetSubAccountPaymentsQuery, TError, TData>
    ) => {
    
    return useQuery<GetSubAccountPaymentsQuery, TError, TData>(
      ['GetSubAccountPayments', variables],
      useFetchData<GetSubAccountPaymentsQuery, GetSubAccountPaymentsQueryVariables>(GetSubAccountPaymentsDocument).bind(null, variables),
      options
    )};

export const GetReconciliationAccountInformationDocument = `
    query GetReconciliationAccountInformation($accountId: Int!) {
  reconciliationAccountInformation(accountId: $accountId) {
    originalVersion {
      jurisdiction
      taxYear
      accountId
      recordType
      federalTaxId
      description
      registeredEntityName
      isHomeBusiness
      isAttached
      isReconciled
      yearOpened
      website
      taxDistrict
      parcelNumber
      currentYearPayments
      delinquentYearPayments
      accountType {
        id
        label
      }
      entityType {
        id
        label
      }
      sicCode {
        id
        sicCode
        sicCodeDescription
        sicSiloCode
        subSiloCode
        isActive
      }
      naicsCode {
        id
        category
        subCategory
      }
      naicsCategory {
        id
        category
      }
      businessAppraiserRegion {
        id
        groupingValue1
        groupingValue2
        regionName
      }
      howFiled {
        id
        label
      }
      timeSpentFiling {
        id
        label
      }
    }
    taxPayerVersion {
      jurisdiction
      taxYear
      accountId
      recordType
      federalTaxId
      description
      registeredEntityName
      isHomeBusiness
      isAttached
      isReconciled
      yearOpened
      website
      taxDistrict
      parcelNumber
      currentYearPayments
      delinquentYearPayments
      accountType {
        id
        label
      }
      entityType {
        id
        label
      }
      sicCode {
        id
        sicCode
        sicCodeDescription
        sicSiloCode
        subSiloCode
        isActive
      }
      naicsCode {
        id
        category
        subCategory
      }
      naicsCategory {
        id
        category
      }
      businessAppraiserRegion {
        id
        groupingValue1
        groupingValue2
        regionName
      }
      howFiled {
        id
        label
      }
      timeSpentFiling {
        id
        label
      }
    }
    auditorVersion {
      jurisdiction
      taxYear
      accountId
      recordType
      federalTaxId
      description
      registeredEntityName
      isHomeBusiness
      isAttached
      isReconciled
      yearOpened
      website
      taxDistrict
      parcelNumber
      currentYearPayments
      delinquentYearPayments
      accountType {
        id
        label
      }
      entityType {
        id
        label
      }
      sicCode {
        id
        sicCode
        sicCodeDescription
        sicSiloCode
        subSiloCode
        isActive
      }
      naicsCode {
        id
        category
        subCategory
      }
      naicsCategory {
        id
        category
      }
      businessAppraiserRegion {
        id
        groupingValue1
        groupingValue2
        regionName
      }
      howFiled {
        id
        label
      }
      timeSpentFiling {
        id
        label
      }
    }
  }
  entityTypes {
    id
    label
  }
  howFiledList {
    id
    label
  }
  sicCodeMasters {
    id
    isActive
    sicCode
    sicCodeDescription
    sicSiloCode
    subSiloCode
  }
  getBusinessAppraiserRegionList {
    regionName
    columnsNames {
      groupingLabel1
      groupingLabel2
    }
    rows {
      id
      groupingValue1
      groupingValue2
      regionName
    }
  }
  naicsCategories {
    id
    category
  }
  naicsCodes {
    id
    category
    subCategory
  }
}
    `;

export const useGetReconciliationAccountInformationQuery = <
      TData = GetReconciliationAccountInformationQuery,
      TError = unknown
    >(
      variables: GetReconciliationAccountInformationQueryVariables,
      options?: UseQueryOptions<GetReconciliationAccountInformationQuery, TError, TData>
    ) => {
    
    return useQuery<GetReconciliationAccountInformationQuery, TError, TData>(
      ['GetReconciliationAccountInformation', variables],
      useFetchData<GetReconciliationAccountInformationQuery, GetReconciliationAccountInformationQueryVariables>(GetReconciliationAccountInformationDocument).bind(null, variables),
      options
    )};

export const ReconcileAccountInformationDocument = `
    mutation ReconcileAccountInformation($account: ReconciliationAccountInformationInput!) {
  reconcileAccountInformation(account: $account) {
    jurisdiction
    taxYear
    accountId
    recordType
    federalTaxId
    description
    registeredEntityName
    isHomeBusiness
    isAttached
    isReconciled
    yearOpened
    website
    taxDistrict
    parcelNumber
    currentYearPayments
    delinquentYearPayments
    accountType {
      id
      label
    }
    entityType {
      id
      label
    }
    sicCode {
      id
      sicCode
      sicCodeDescription
      sicSiloCode
      subSiloCode
      isActive
    }
    naicsCode {
      id
      category
      subCategory
    }
    naicsCategory {
      id
      category
    }
    businessAppraiserRegion {
      id
      groupingValue1
      groupingValue2
      regionName
    }
    howFiled {
      id
      label
    }
    timeSpentFiling {
      id
      label
    }
  }
}
    `;

export const useReconcileAccountInformationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReconcileAccountInformationMutation, TError, ReconcileAccountInformationMutationVariables, TContext>) => {
    
    return useMutation<ReconcileAccountInformationMutation, TError, ReconcileAccountInformationMutationVariables, TContext>(
      ['ReconcileAccountInformation'],
      useFetchData<ReconcileAccountInformationMutation, ReconcileAccountInformationMutationVariables>(ReconcileAccountInformationDocument),
      options
    )};

export const GetReconciliationContactsDocument = `
    query GetReconciliationContacts($accountId: Int!, $accountIdString: String!, $taxYear: Int!) {
  reconciliationContacts(accountId: $accountId) {
    id
    originalVersion {
      id
      contactType {
        id
        label
      }
      name
      email
      phone
      phoneExtension
      cellphone
      isPrimary
      sameAsBusinessAddress
      mailingAddress {
        inCareOf
        addressLine1
        addressLine2
        city
        state
        country {
          code
          name
        }
        zipCode
      }
    }
    taxPayerVersion {
      id
      contactType {
        id
        label
      }
      name
      email
      phone
      phoneExtension
      cellphone
      isPrimary
      sameAsBusinessAddress
      mailingAddress {
        inCareOf
        addressLine1
        addressLine2
        city
        state
        country {
          code
          name
        }
        zipCode
      }
    }
    auditorVersion {
      id
      contactType {
        id
        label
      }
      name
      email
      phone
      phoneExtension
      cellphone
      isPrimary
      sameAsBusinessAddress
      mailingAddress {
        inCareOf
        addressLine1
        addressLine2
        city
        state
        country {
          code
          name
        }
        zipCode
      }
    }
  }
  getBusinessAccount(accountId: $accountIdString, taxYear: $taxYear) {
    id
    situsAddress {
      addressLine1
      addressLine2
      city
      state
      zipCode
    }
  }
  countries {
    code
    name
  }
  contactTypes {
    id
    label
  }
}
    `;

export const useGetReconciliationContactsQuery = <
      TData = GetReconciliationContactsQuery,
      TError = unknown
    >(
      variables: GetReconciliationContactsQueryVariables,
      options?: UseQueryOptions<GetReconciliationContactsQuery, TError, TData>
    ) => {
    
    return useQuery<GetReconciliationContactsQuery, TError, TData>(
      ['GetReconciliationContacts', variables],
      useFetchData<GetReconciliationContactsQuery, GetReconciliationContactsQueryVariables>(GetReconciliationContactsDocument).bind(null, variables),
      options
    )};

export const ReconcileContactsDocument = `
    mutation ReconcileContacts($accountId: Int!, $contacts: [ReconcileContactInput!]!) {
  reconcileContacts(accountId: $accountId, contacts: $contacts) {
    id
    contactType {
      id
      label
    }
    name
    email
    phone
    phoneExtension
    cellphone
    isPrimary
    sameAsBusinessAddress
    mailingAddress {
      inCareOf
      addressLine1
      addressLine2
      city
      state
      country {
        code
        name
      }
      zipCode
    }
  }
}
    `;

export const useReconcileContactsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReconcileContactsMutation, TError, ReconcileContactsMutationVariables, TContext>) => {
    
    return useMutation<ReconcileContactsMutation, TError, ReconcileContactsMutationVariables, TContext>(
      ['ReconcileContacts'],
      useFetchData<ReconcileContactsMutation, ReconcileContactsMutationVariables>(ReconcileContactsDocument),
      options
    )};

export const GetReconciliationAssetsDocument = `
    query GetReconciliationAssets($accountId: Int!, $accountIdString: String!, $taxYear: Int!) {
  reconciliationAssets(accountId: $accountId) {
    id
    originalVersion {
      id
      classification
      classificationDescription
      costPer
      description
      percentGood
      quantity
      taxableValue
      yearAcquired
      isActive
    }
    taxPayerVersion {
      id
      classification
      classificationDescription
      costPer
      description
      percentGood
      quantity
      taxableValue
      yearAcquired
      isActive
    }
    auditorVersion {
      id
      classification
      classificationDescription
      costPer
      description
      percentGood
      quantity
      taxableValue
      yearAcquired
      isActive
    }
  }
  getClassifications {
    id
    clsf
    scheduleId
    description
  }
  getTaxRate(accountId: $accountId, taxYear: $taxYear) {
    id
    taxRate
  }
  getBusinessAccount(accountId: $accountIdString, taxYear: $taxYear) {
    id
    filingStatus {
      hasExemption
    }
  }
}
    `;

export const useGetReconciliationAssetsQuery = <
      TData = GetReconciliationAssetsQuery,
      TError = unknown
    >(
      variables: GetReconciliationAssetsQueryVariables,
      options?: UseQueryOptions<GetReconciliationAssetsQuery, TError, TData>
    ) => {
    
    return useQuery<GetReconciliationAssetsQuery, TError, TData>(
      ['GetReconciliationAssets', variables],
      useFetchData<GetReconciliationAssetsQuery, GetReconciliationAssetsQueryVariables>(GetReconciliationAssetsDocument).bind(null, variables),
      options
    )};

export const ReconcileAssetsDocument = `
    mutation ReconcileAssets($accountId: Int!, $assets: [AssetInput!]!) {
  reconcileAssets(accountId: $accountId, assets: $assets) {
    id
    classification
    classificationDescription
    costPer
    description
    percentGood
    quantity
    taxableValue
    yearAcquired
  }
}
    `;

export const useReconcileAssetsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReconcileAssetsMutation, TError, ReconcileAssetsMutationVariables, TContext>) => {
    
    return useMutation<ReconcileAssetsMutation, TError, ReconcileAssetsMutationVariables, TContext>(
      ['ReconcileAssets'],
      useFetchData<ReconcileAssetsMutation, ReconcileAssetsMutationVariables>(ReconcileAssetsDocument),
      options
    )};

export const SkipAssetReconciliationDocument = `
    mutation SkipAssetReconciliation($accountId: Int!) {
  skipAssetReconciliation(accountId: $accountId)
}
    `;

export const useSkipAssetReconciliationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SkipAssetReconciliationMutation, TError, SkipAssetReconciliationMutationVariables, TContext>) => {
    
    return useMutation<SkipAssetReconciliationMutation, TError, SkipAssetReconciliationMutationVariables, TContext>(
      ['SkipAssetReconciliation'],
      useFetchData<SkipAssetReconciliationMutation, SkipAssetReconciliationMutationVariables>(SkipAssetReconciliationDocument),
      options
    )};

export const GetReconciliationLessorsDocument = `
    query GetReconciliationLessors($accountId: Int!) {
  reconciliationLessors(accountId: $accountId) {
    id
    originalVersion {
      id
      contactLinkId
      contactType {
        id
        label
      }
      name
      address {
        inCareOf
        addressLine1
        addressLine2
        city
        state
        country {
          code
          name
        }
        zipCode
      }
    }
    taxPayerVersion {
      id
      contactLinkId
      contactType {
        id
        label
      }
      name
      address {
        inCareOf
        addressLine1
        addressLine2
        city
        state
        country {
          code
          name
        }
        zipCode
      }
    }
    auditorVersion {
      id
      contactLinkId
      contactType {
        id
        label
      }
      name
      address {
        inCareOf
        addressLine1
        addressLine2
        city
        state
        country {
          code
          name
        }
        zipCode
      }
    }
    leasedAssets {
      id
      originalVersion {
        id
        leaseId
        leaseAccountId
        leaseNumber
        contactLinkId
        description
        yearAcquired
        quantity
        costPer
        annualLeaseAmount
        initialValue
        leaseStartDate
        leaseEndDate
        fileUrl
        fileName
        blobName
        isActive
      }
      taxPayerVersion {
        id
        leaseId
        leaseAccountId
        leaseNumber
        contactLinkId
        description
        yearAcquired
        quantity
        costPer
        annualLeaseAmount
        initialValue
        leaseStartDate
        leaseEndDate
        fileUrl
        fileName
        blobName
        isActive
      }
      auditorVersion {
        id
        leaseId
        leaseAccountId
        leaseNumber
        contactLinkId
        description
        yearAcquired
        quantity
        costPer
        annualLeaseAmount
        initialValue
        leaseStartDate
        leaseEndDate
        fileUrl
        fileName
        blobName
        isActive
      }
    }
  }
}
    `;

export const useGetReconciliationLessorsQuery = <
      TData = GetReconciliationLessorsQuery,
      TError = unknown
    >(
      variables: GetReconciliationLessorsQueryVariables,
      options?: UseQueryOptions<GetReconciliationLessorsQuery, TError, TData>
    ) => {
    
    return useQuery<GetReconciliationLessorsQuery, TError, TData>(
      ['GetReconciliationLessors', variables],
      useFetchData<GetReconciliationLessorsQuery, GetReconciliationLessorsQueryVariables>(GetReconciliationLessorsDocument).bind(null, variables),
      options
    )};

export const ReconcileLessorsDocument = `
    mutation ReconcileLessors($accountId: Int!, $lessors: [LessorInput!]!) {
  reconcileLessors(accountId: $accountId, lessors: $lessors) {
    id
    contactLinkId
    contactType {
      id
      label
    }
    name
    address {
      inCareOf
      addressLine1
      addressLine2
      city
      state
      country {
        code
        name
      }
      zipCode
    }
    assets {
      id
      leaseId
      leaseAccountId
      leaseNumber
      contactLinkId
      description
      yearAcquired
      quantity
      costPer
      annualLeaseAmount
      initialValue
      leaseStartDate
      leaseEndDate
      fileUrl
      fileName
      blobName
    }
  }
}
    `;

export const useReconcileLessorsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReconcileLessorsMutation, TError, ReconcileLessorsMutationVariables, TContext>) => {
    
    return useMutation<ReconcileLessorsMutation, TError, ReconcileLessorsMutationVariables, TContext>(
      ['ReconcileLessors'],
      useFetchData<ReconcileLessorsMutation, ReconcileLessorsMutationVariables>(ReconcileLessorsDocument),
      options
    )};

export const SkipLessorReconciliationDocument = `
    mutation SkipLessorReconciliation($accountId: Int!) {
  skipLessorReconciliation(accountId: $accountId)
}
    `;

export const useSkipLessorReconciliationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SkipLessorReconciliationMutation, TError, SkipLessorReconciliationMutationVariables, TContext>) => {
    
    return useMutation<SkipLessorReconciliationMutation, TError, SkipLessorReconciliationMutationVariables, TContext>(
      ['SkipLessorReconciliation'],
      useFetchData<SkipLessorReconciliationMutation, SkipLessorReconciliationMutationVariables>(SkipLessorReconciliationDocument),
      options
    )};

export const GetReconciliationFilingSummaryDocument = `
    query GetReconciliationFilingSummary($accountId: Int!) {
  reconciliationSummary(accountId: $accountId) {
    originalVersion {
      totalDirectCharge
      totalTaxableValue
      netAssessmentCharge
      penalty
      interest
      delinquentTax
      payments
      balance
      note
      isExempt
      applyPenalty
      contact {
        id
        name
        email
        phone
        phoneExtension
      }
      howFiled {
        id
        label
      }
      timeSpentFiling {
        id
        label
      }
    }
    taxPayerVersion {
      totalDirectCharge
      totalTaxableValue
      netAssessmentCharge
      penalty
      interest
      delinquentTax
      payments
      balance
      note
      isExempt
      applyPenalty
      contact {
        id
        name
        email
        phone
        phoneExtension
      }
      howFiled {
        id
        label
      }
      timeSpentFiling {
        id
        label
      }
    }
    auditorVersion {
      totalDirectCharge
      totalTaxableValue
      netAssessmentCharge
      penalty
      interest
      delinquentTax
      payments
      balance
      note
      isExempt
      applyPenalty
      contact {
        id
        name
        email
        phone
        phoneExtension
      }
      howFiled {
        id
        label
      }
      timeSpentFiling {
        id
        label
      }
    }
  }
  timeSpentFiling {
    id
    label
  }
  howFiledList {
    id
    label
  }
}
    `;

export const useGetReconciliationFilingSummaryQuery = <
      TData = GetReconciliationFilingSummaryQuery,
      TError = unknown
    >(
      variables: GetReconciliationFilingSummaryQueryVariables,
      options?: UseQueryOptions<GetReconciliationFilingSummaryQuery, TError, TData>
    ) => {
    
    return useQuery<GetReconciliationFilingSummaryQuery, TError, TData>(
      ['GetReconciliationFilingSummary', variables],
      useFetchData<GetReconciliationFilingSummaryQuery, GetReconciliationFilingSummaryQueryVariables>(GetReconciliationFilingSummaryDocument).bind(null, variables),
      options
    )};

export const ReconcileFilingSummaryDocument = `
    mutation ReconcileFilingSummary($accountId: Int!, $filingSummary: FilingSummaryInput!) {
  reconcileSummary(accountId: $accountId, filingSummary: $filingSummary) {
    totalDirectCharge
    totalTaxableValue
    netAssessmentCharge
    penalty
    interest
    delinquentTax
    payments
    balance
    note
    contact {
      id
      name
      email
      phone
      phoneExtension
    }
    howFiled {
      id
      label
    }
    timeSpentFiling {
      id
      label
    }
  }
}
    `;

export const useReconcileFilingSummaryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReconcileFilingSummaryMutation, TError, ReconcileFilingSummaryMutationVariables, TContext>) => {
    
    return useMutation<ReconcileFilingSummaryMutation, TError, ReconcileFilingSummaryMutationVariables, TContext>(
      ['ReconcileFilingSummary'],
      useFetchData<ReconcileFilingSummaryMutation, ReconcileFilingSummaryMutationVariables>(ReconcileFilingSummaryDocument),
      options
    )};

export const CompleteReconciliationDocument = `
    mutation CompleteReconciliation($accountId: Int!) {
  completeReconciliation(accountId: $accountId)
}
    `;

export const useCompleteReconciliationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CompleteReconciliationMutation, TError, CompleteReconciliationMutationVariables, TContext>) => {
    
    return useMutation<CompleteReconciliationMutation, TError, CompleteReconciliationMutationVariables, TContext>(
      ['CompleteReconciliation'],
      useFetchData<CompleteReconciliationMutation, CompleteReconciliationMutationVariables>(CompleteReconciliationDocument),
      options
    )};

export const SearchRefundsDocument = `
    query SearchRefunds {
  searchRefunds {
    year
    accountId
    leaseMasterId
    accountNumber
    taxArea
    businessName
    accountType
    address1
    address2
    city
    state
    country
    zipCode
    careOf
    mailingName
    balance
    isActive
    isExempt
    isReconciled
    paymentsReceived
    isSpecial
  }
}
    `;

export const useSearchRefundsQuery = <
      TData = SearchRefundsQuery,
      TError = unknown
    >(
      variables?: SearchRefundsQueryVariables,
      options?: UseQueryOptions<SearchRefundsQuery, TError, TData>
    ) => {
    
    return useQuery<SearchRefundsQuery, TError, TData>(
      variables === undefined ? ['SearchRefunds'] : ['SearchRefunds', variables],
      useFetchData<SearchRefundsQuery, SearchRefundsQueryVariables>(SearchRefundsDocument).bind(null, variables),
      options
    )};

export const GetSpecialRefundDocument = `
    query GetSpecialRefund($accountNumber: String!, $isLeaseMaster: Boolean!) {
  getSpecialRefund(accountNumber: $accountNumber, isLeaseMaster: $isLeaseMaster) {
    year
    accountId
    leaseMasterId
    accountNumber
    taxArea
    businessName
    accountType
    address1
    address2
    city
    state
    country
    zipCode
    careOf
    mailingName
    balance
    isActive
    isExempt
    isReconciled
    paymentsReceived
    isSpecial
  }
}
    `;

export const useGetSpecialRefundQuery = <
      TData = GetSpecialRefundQuery,
      TError = unknown
    >(
      variables: GetSpecialRefundQueryVariables,
      options?: UseQueryOptions<GetSpecialRefundQuery, TError, TData>
    ) => {
    
    return useQuery<GetSpecialRefundQuery, TError, TData>(
      ['GetSpecialRefund', variables],
      useFetchData<GetSpecialRefundQuery, GetSpecialRefundQueryVariables>(GetSpecialRefundDocument).bind(null, variables),
      options
    )};

export const GetRefundBatchDocument = `
    query GetRefundBatch($refundBatchId: Int!) {
  getRefundBatch(refundBatchId: $refundBatchId) {
    id
    batchStatusId
    batchStatus
    createdDate
    updatedDate
    canBeEdited
    canBeDeleted
    canBePaid
    processedDate
    refunds {
      id
      year
      accountId
      leaseMasterId
      accountNumber
      taxArea
      businessName
      accountType
      address1
      address2
      city
      state
      country
      zipCode
      careOf
      mailingName
      balance
      isActive
      isExempt
      isReconciled
      paymentsReceived
      isSpecial
      refundReason
      refundReasonId
      notes
    }
  }
}
    `;

export const useGetRefundBatchQuery = <
      TData = GetRefundBatchQuery,
      TError = unknown
    >(
      variables: GetRefundBatchQueryVariables,
      options?: UseQueryOptions<GetRefundBatchQuery, TError, TData>
    ) => {
    
    return useQuery<GetRefundBatchQuery, TError, TData>(
      ['GetRefundBatch', variables],
      useFetchData<GetRefundBatchQuery, GetRefundBatchQueryVariables>(GetRefundBatchDocument).bind(null, variables),
      options
    )};

export const SearchBatchesDocument = `
    query SearchBatches($searchBatchInput: SearchBatchInput!) {
  searchBatches(searchBatchInput: $searchBatchInput) {
    id
    batchStatusId
    batchStatus
    createdDate
    updatedDate
    processedDate
    refundsCount
    canBeEdited
    canBeDeleted
    canBePaid
  }
}
    `;

export const useSearchBatchesQuery = <
      TData = SearchBatchesQuery,
      TError = unknown
    >(
      variables: SearchBatchesQueryVariables,
      options?: UseQueryOptions<SearchBatchesQuery, TError, TData>
    ) => {
    
    return useQuery<SearchBatchesQuery, TError, TData>(
      ['SearchBatches', variables],
      useFetchData<SearchBatchesQuery, SearchBatchesQueryVariables>(SearchBatchesDocument).bind(null, variables),
      options
    )};

export const GetBatchStatusesDocument = `
    query GetBatchStatuses {
  getBatchStatuses {
    id
    name
  }
}
    `;

export const useGetBatchStatusesQuery = <
      TData = GetBatchStatusesQuery,
      TError = unknown
    >(
      variables?: GetBatchStatusesQueryVariables,
      options?: UseQueryOptions<GetBatchStatusesQuery, TError, TData>
    ) => {
    
    return useQuery<GetBatchStatusesQuery, TError, TData>(
      variables === undefined ? ['GetBatchStatuses'] : ['GetBatchStatuses', variables],
      useFetchData<GetBatchStatusesQuery, GetBatchStatusesQueryVariables>(GetBatchStatusesDocument).bind(null, variables),
      options
    )};

export const GetRefundReasonsDocument = `
    query GetRefundReasons {
  getRefundReasons {
    id
    name
  }
}
    `;

export const useGetRefundReasonsQuery = <
      TData = GetRefundReasonsQuery,
      TError = unknown
    >(
      variables?: GetRefundReasonsQueryVariables,
      options?: UseQueryOptions<GetRefundReasonsQuery, TError, TData>
    ) => {
    
    return useQuery<GetRefundReasonsQuery, TError, TData>(
      variables === undefined ? ['GetRefundReasons'] : ['GetRefundReasons', variables],
      useFetchData<GetRefundReasonsQuery, GetRefundReasonsQueryVariables>(GetRefundReasonsDocument).bind(null, variables),
      options
    )};

export const CreateBatchDocument = `
    mutation CreateBatch($createBatchInput: CreateBatchInput!) {
  createBatch(createBatchInput: $createBatchInput) {
    id
  }
}
    `;

export const useCreateBatchMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateBatchMutation, TError, CreateBatchMutationVariables, TContext>) => {
    
    return useMutation<CreateBatchMutation, TError, CreateBatchMutationVariables, TContext>(
      ['CreateBatch'],
      useFetchData<CreateBatchMutation, CreateBatchMutationVariables>(CreateBatchDocument),
      options
    )};

export const DeleteBatchDocument = `
    mutation DeleteBatch($batchId: Int!) {
  deleteBatch(batchId: $batchId)
}
    `;

export const useDeleteBatchMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteBatchMutation, TError, DeleteBatchMutationVariables, TContext>) => {
    
    return useMutation<DeleteBatchMutation, TError, DeleteBatchMutationVariables, TContext>(
      ['DeleteBatch'],
      useFetchData<DeleteBatchMutation, DeleteBatchMutationVariables>(DeleteBatchDocument),
      options
    )};

export const UpdateBatchDocument = `
    mutation UpdateBatch($batchId: Int!, $updateBatchInput: UpdateBatchInput!) {
  updateBatch(batchId: $batchId, updateBatchInput: $updateBatchInput)
}
    `;

export const useUpdateBatchMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBatchMutation, TError, UpdateBatchMutationVariables, TContext>) => {
    
    return useMutation<UpdateBatchMutation, TError, UpdateBatchMutationVariables, TContext>(
      ['UpdateBatch'],
      useFetchData<UpdateBatchMutation, UpdateBatchMutationVariables>(UpdateBatchDocument),
      options
    )};

export const SendBatchToTreasurerDocument = `
    mutation SendBatchToTreasurer($batchId: Int!) {
  sendBatchToTreasurer(batchId: $batchId)
}
    `;

export const useSendBatchToTreasurerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendBatchToTreasurerMutation, TError, SendBatchToTreasurerMutationVariables, TContext>) => {
    
    return useMutation<SendBatchToTreasurerMutation, TError, SendBatchToTreasurerMutationVariables, TContext>(
      ['SendBatchToTreasurer'],
      useFetchData<SendBatchToTreasurerMutation, SendBatchToTreasurerMutationVariables>(SendBatchToTreasurerDocument),
      options
    )};

export const SetBatchToPaidDocument = `
    mutation SetBatchToPaid($batchId: Int!) {
  setBatchToPaid(batchId: $batchId)
}
    `;

export const useSetBatchToPaidMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetBatchToPaidMutation, TError, SetBatchToPaidMutationVariables, TContext>) => {
    
    return useMutation<SetBatchToPaidMutation, TError, SetBatchToPaidMutationVariables, TContext>(
      ['SetBatchToPaid'],
      useFetchData<SetBatchToPaidMutation, SetBatchToPaidMutationVariables>(SetBatchToPaidDocument),
      options
    )};

export const ExportToCsvDocument = `
    mutation ExportToCsv($batchId: Int!) {
  exportToCsv(batchId: $batchId) {
    fileContent
    fileName
  }
}
    `;

export const useExportToCsvMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ExportToCsvMutation, TError, ExportToCsvMutationVariables, TContext>) => {
    
    return useMutation<ExportToCsvMutation, TError, ExportToCsvMutationVariables, TContext>(
      ['ExportToCsv'],
      useFetchData<ExportToCsvMutation, ExportToCsvMutationVariables>(ExportToCsvDocument),
      options
    )};

export const GetRentalHomeOccOverExemptReportDocument = `
    query GetRentalHomeOccOverExemptReport($taxYear: Int!) {
  rentalHomeOccOverExemptNotFiledReport(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
    isReconciled
    isExempt
    totalTaxable
    netAssmntChargeWithTotalDirect
    penalty
    payments
    yearEndBalance
    associatedAccounts
  }
}
    `;

export const useGetRentalHomeOccOverExemptReportQuery = <
      TData = GetRentalHomeOccOverExemptReportQuery,
      TError = unknown
    >(
      variables: GetRentalHomeOccOverExemptReportQueryVariables,
      options?: UseQueryOptions<GetRentalHomeOccOverExemptReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetRentalHomeOccOverExemptReportQuery, TError, TData>(
      ['GetRentalHomeOccOverExemptReport', variables],
      useFetchData<GetRentalHomeOccOverExemptReportQuery, GetRentalHomeOccOverExemptReportQueryVariables>(GetRentalHomeOccOverExemptReportDocument).bind(null, variables),
      options
    )};

export const GetIsAttachedReportDocument = `
    query GetIsAttachedReport($taxYear: Int!) {
  isAttachedReport(taxYear: $taxYear) {
    id
    accountNbr
    acctTypeDescr
    acctTypeId
    balance
    businessName
    parcelId
    taxYear
    totalTaxable
  }
}
    `;

export const useGetIsAttachedReportQuery = <
      TData = GetIsAttachedReportQuery,
      TError = unknown
    >(
      variables: GetIsAttachedReportQueryVariables,
      options?: UseQueryOptions<GetIsAttachedReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetIsAttachedReportQuery, TError, TData>(
      ['GetIsAttachedReport', variables],
      useFetchData<GetIsAttachedReportQuery, GetIsAttachedReportQueryVariables>(GetIsAttachedReportDocument).bind(null, variables),
      options
    )};

export const GetCyDeletedWithPaymentReportDocument = `
    query GetCyDeletedWithPaymentReport($taxYear: Int!) {
  cyDeletedWithPaymentReport(taxYear: $taxYear) {
    id
    accountNbr
    amount
    balance
    acctTypeDescr
    acctTypeId
    taxYear
  }
}
    `;

export const useGetCyDeletedWithPaymentReportQuery = <
      TData = GetCyDeletedWithPaymentReportQuery,
      TError = unknown
    >(
      variables: GetCyDeletedWithPaymentReportQueryVariables,
      options?: UseQueryOptions<GetCyDeletedWithPaymentReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetCyDeletedWithPaymentReportQuery, TError, TData>(
      ['GetCyDeletedWithPaymentReport', variables],
      useFetchData<GetCyDeletedWithPaymentReportQuery, GetCyDeletedWithPaymentReportQueryVariables>(GetCyDeletedWithPaymentReportDocument).bind(null, variables),
      options
    )};

export const GetRentalsTwentyOrLessUnitsReportDocument = `
    query GetRentalsTwentyOrLessUnitsReport($taxYear: Int!) {
  rentalsTwentyOrLessUnitsReport(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
    isReconciled
    isExempt
    totalTaxable
    netAssmntChargeWithTotalDirect
    penalty
    payments
    yearEndBalance
    associatedAccounts
  }
}
    `;

export const useGetRentalsTwentyOrLessUnitsReportQuery = <
      TData = GetRentalsTwentyOrLessUnitsReportQuery,
      TError = unknown
    >(
      variables: GetRentalsTwentyOrLessUnitsReportQueryVariables,
      options?: UseQueryOptions<GetRentalsTwentyOrLessUnitsReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetRentalsTwentyOrLessUnitsReportQuery, TError, TData>(
      ['GetRentalsTwentyOrLessUnitsReport', variables],
      useFetchData<GetRentalsTwentyOrLessUnitsReportQuery, GetRentalsTwentyOrLessUnitsReportQueryVariables>(GetRentalsTwentyOrLessUnitsReportDocument).bind(null, variables),
      options
    )};

export const GetExistingBusinessNotExemptBelowThresholdReportDocument = `
    query GetExistingBusinessNotExemptBelowThresholdReport($taxYear: Int!) {
  existingBusinessNotExemptBelowThresholdReport(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
    isReconciled
    isExempt
    totalTaxable
    netAssmntChargeWithTotalDirect
    penalty
    payments
    yearEndBalance
    associatedAccounts
  }
}
    `;

export const useGetExistingBusinessNotExemptBelowThresholdReportQuery = <
      TData = GetExistingBusinessNotExemptBelowThresholdReportQuery,
      TError = unknown
    >(
      variables: GetExistingBusinessNotExemptBelowThresholdReportQueryVariables,
      options?: UseQueryOptions<GetExistingBusinessNotExemptBelowThresholdReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetExistingBusinessNotExemptBelowThresholdReportQuery, TError, TData>(
      ['GetExistingBusinessNotExemptBelowThresholdReport', variables],
      useFetchData<GetExistingBusinessNotExemptBelowThresholdReportQuery, GetExistingBusinessNotExemptBelowThresholdReportQueryVariables>(GetExistingBusinessNotExemptBelowThresholdReportDocument).bind(null, variables),
      options
    )};

export const GetDuplicatedAssociatedBusinessAccountsReportDocument = `
    query GetDuplicatedAssociatedBusinessAccountsReport($taxYear: Int!) {
  duplicatedAssociatedBusinessAccountsReport(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
  }
}
    `;

export const useGetDuplicatedAssociatedBusinessAccountsReportQuery = <
      TData = GetDuplicatedAssociatedBusinessAccountsReportQuery,
      TError = unknown
    >(
      variables: GetDuplicatedAssociatedBusinessAccountsReportQueryVariables,
      options?: UseQueryOptions<GetDuplicatedAssociatedBusinessAccountsReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetDuplicatedAssociatedBusinessAccountsReportQuery, TError, TData>(
      ['GetDuplicatedAssociatedBusinessAccountsReport', variables],
      useFetchData<GetDuplicatedAssociatedBusinessAccountsReportQuery, GetDuplicatedAssociatedBusinessAccountsReportQueryVariables>(GetDuplicatedAssociatedBusinessAccountsReportDocument).bind(null, variables),
      options
    )};

export const GetExistingBusinessNotFiledLessThanExemptReportDocument = `
    query GetExistingBusinessNotFiledLessThanExemptReport($taxYear: Int!) {
  existingBusinessNotFiledLessThanExemptReport(taxYear: $taxYear) {
    id
    accountNbr
    acctTypeDescr
    acctTypeId
    businessName
    taxYear
    totalTaxable
    taxDistrict
    taxRate
    appraiserRegion
    netAssmntCharge
  }
}
    `;

export const useGetExistingBusinessNotFiledLessThanExemptReportQuery = <
      TData = GetExistingBusinessNotFiledLessThanExemptReportQuery,
      TError = unknown
    >(
      variables: GetExistingBusinessNotFiledLessThanExemptReportQueryVariables,
      options?: UseQueryOptions<GetExistingBusinessNotFiledLessThanExemptReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetExistingBusinessNotFiledLessThanExemptReportQuery, TError, TData>(
      ['GetExistingBusinessNotFiledLessThanExemptReport', variables],
      useFetchData<GetExistingBusinessNotFiledLessThanExemptReportQuery, GetExistingBusinessNotFiledLessThanExemptReportQueryVariables>(GetExistingBusinessNotFiledLessThanExemptReportDocument).bind(null, variables),
      options
    )};

export const GetAccountBalanceReportDocument = `
    query GetAccountBalanceReport {
  accountBalanceReport {
    reportDate
    accountDetails {
      id
      accountNbr
      acctJurisdiction
      acctTaxYear
      acctType
      businessName
      mailingName
      mailingCareOf
      mailingAddress1
      mailingAddress2
      mailingCity
      mailingState
      mailingZip
      situsName
      situsCareOf
      situsAddress1
      situsAddress2
      situsCity
      situsState
      situsZip
      penalty
      currentBalance
      delinquentBalance
      totalBalance
    }
  }
}
    `;

export const useGetAccountBalanceReportQuery = <
      TData = GetAccountBalanceReportQuery,
      TError = unknown
    >(
      variables?: GetAccountBalanceReportQueryVariables,
      options?: UseQueryOptions<GetAccountBalanceReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetAccountBalanceReportQuery, TError, TData>(
      variables === undefined ? ['GetAccountBalanceReport'] : ['GetAccountBalanceReport', variables],
      useFetchData<GetAccountBalanceReportQuery, GetAccountBalanceReportQueryVariables>(GetAccountBalanceReportDocument).bind(null, variables),
      options
    )};

export const GetBalanceDueReasonsListDocument = `
    query GetBalanceDueReasonsList($isTelecom: Boolean!) {
  balanceDueReasonsList(isTelecom: $isTelecom) {
    id
    reason
  }
}
    `;

export const useGetBalanceDueReasonsListQuery = <
      TData = GetBalanceDueReasonsListQuery,
      TError = unknown
    >(
      variables: GetBalanceDueReasonsListQueryVariables,
      options?: UseQueryOptions<GetBalanceDueReasonsListQuery, TError, TData>
    ) => {
    
    return useQuery<GetBalanceDueReasonsListQuery, TError, TData>(
      ['GetBalanceDueReasonsList', variables],
      useFetchData<GetBalanceDueReasonsListQuery, GetBalanceDueReasonsListQueryVariables>(GetBalanceDueReasonsListDocument).bind(null, variables),
      options
    )};

export const GetAccountsWithCreditBalanceReportDocument = `
    query GetAccountsWithCreditBalanceReport($taxYear: Int!) {
  accountsWithCreditBalanceReport(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
    yearEndBalance
    isExempt
  }
}
    `;

export const useGetAccountsWithCreditBalanceReportQuery = <
      TData = GetAccountsWithCreditBalanceReportQuery,
      TError = unknown
    >(
      variables: GetAccountsWithCreditBalanceReportQueryVariables,
      options?: UseQueryOptions<GetAccountsWithCreditBalanceReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetAccountsWithCreditBalanceReportQuery, TError, TData>(
      ['GetAccountsWithCreditBalanceReport', variables],
      useFetchData<GetAccountsWithCreditBalanceReportQuery, GetAccountsWithCreditBalanceReportQueryVariables>(GetAccountsWithCreditBalanceReportDocument).bind(null, variables),
      options
    )};

export const GetCurrentYearDeletedWithDelinqBalanceReportDocument = `
    query GetCurrentYearDeletedWithDelinqBalanceReport($taxYear: Int!) {
  currentYearDeletedWithDelinqBalanceReport(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
    amount
    leaseMasterAccountNbr
    telecomAccountNbr
  }
}
    `;

export const useGetCurrentYearDeletedWithDelinqBalanceReportQuery = <
      TData = GetCurrentYearDeletedWithDelinqBalanceReportQuery,
      TError = unknown
    >(
      variables: GetCurrentYearDeletedWithDelinqBalanceReportQueryVariables,
      options?: UseQueryOptions<GetCurrentYearDeletedWithDelinqBalanceReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetCurrentYearDeletedWithDelinqBalanceReportQuery, TError, TData>(
      ['GetCurrentYearDeletedWithDelinqBalanceReport', variables],
      useFetchData<GetCurrentYearDeletedWithDelinqBalanceReportQuery, GetCurrentYearDeletedWithDelinqBalanceReportQueryVariables>(GetCurrentYearDeletedWithDelinqBalanceReportDocument).bind(null, variables),
      options
    )};

export const GetAccountsWithPriorYearCreditChargeReportDocument = `
    query GetAccountsWithPriorYearCreditChargeReport($taxYear: Int!) {
  accountsWithPriorYearCreditChargeReport(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
    directChargeAmount
  }
}
    `;

export const useGetAccountsWithPriorYearCreditChargeReportQuery = <
      TData = GetAccountsWithPriorYearCreditChargeReportQuery,
      TError = unknown
    >(
      variables: GetAccountsWithPriorYearCreditChargeReportQueryVariables,
      options?: UseQueryOptions<GetAccountsWithPriorYearCreditChargeReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetAccountsWithPriorYearCreditChargeReportQuery, TError, TData>(
      ['GetAccountsWithPriorYearCreditChargeReport', variables],
      useFetchData<GetAccountsWithPriorYearCreditChargeReportQuery, GetAccountsWithPriorYearCreditChargeReportQueryVariables>(GetAccountsWithPriorYearCreditChargeReportDocument).bind(null, variables),
      options
    )};

export const GetNegativeRefundChargesReportDocument = `
    query GetNegativeRefundChargesReport($taxYear: Int!) {
  negativeRefundChargesReport(taxYear: $taxYear) {
    id
    accountNbr
    leaseMasterAccountNbr
    telecomAccountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
    amount
    comment
  }
}
    `;

export const useGetNegativeRefundChargesReportQuery = <
      TData = GetNegativeRefundChargesReportQuery,
      TError = unknown
    >(
      variables: GetNegativeRefundChargesReportQueryVariables,
      options?: UseQueryOptions<GetNegativeRefundChargesReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetNegativeRefundChargesReportQuery, TError, TData>(
      ['GetNegativeRefundChargesReport', variables],
      useFetchData<GetNegativeRefundChargesReportQuery, GetNegativeRefundChargesReportQueryVariables>(GetNegativeRefundChargesReportDocument).bind(null, variables),
      options
    )};

export const GetHomeOccupationalNonTaxableAccountsReportDocument = `
    query GetHomeOccupationalNonTaxableAccountsReport($taxYear: Int!) {
  homeOccupationalNonTaxableAccountsReport(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
    isReconciled
    isExempt
    totalTaxable
    netAssmntChargeWithTotalDirect
    penalty
    payments
    yearEndBalance
    associatedAccounts
    howReceived
  }
}
    `;

export const useGetHomeOccupationalNonTaxableAccountsReportQuery = <
      TData = GetHomeOccupationalNonTaxableAccountsReportQuery,
      TError = unknown
    >(
      variables: GetHomeOccupationalNonTaxableAccountsReportQueryVariables,
      options?: UseQueryOptions<GetHomeOccupationalNonTaxableAccountsReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetHomeOccupationalNonTaxableAccountsReportQuery, TError, TData>(
      ['GetHomeOccupationalNonTaxableAccountsReport', variables],
      useFetchData<GetHomeOccupationalNonTaxableAccountsReportQuery, GetHomeOccupationalNonTaxableAccountsReportQueryVariables>(GetHomeOccupationalNonTaxableAccountsReportDocument).bind(null, variables),
      options
    )};

export const GetLmTaxDistrictAcctCheckReportDocument = `
    query GetLmTaxDistrictAcctCheckReport($taxYear: Int!) {
  lmTaxDistrictAcctCheckReport(taxYear: $taxYear) {
    id
    subAccountNbr
    saTaxDistrict
    accountNbr
    baTaxDistrict
    acctTypeId
    acctTypeDescr
    totalTaxable
    leaseMasterAcctNbr
  }
}
    `;

export const useGetLmTaxDistrictAcctCheckReportQuery = <
      TData = GetLmTaxDistrictAcctCheckReportQuery,
      TError = unknown
    >(
      variables: GetLmTaxDistrictAcctCheckReportQueryVariables,
      options?: UseQueryOptions<GetLmTaxDistrictAcctCheckReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetLmTaxDistrictAcctCheckReportQuery, TError, TData>(
      ['GetLmTaxDistrictAcctCheckReport', variables],
      useFetchData<GetLmTaxDistrictAcctCheckReportQuery, GetLmTaxDistrictAcctCheckReportQueryVariables>(GetLmTaxDistrictAcctCheckReportDocument).bind(null, variables),
      options
    )};

export const GetCyDeletedWithDelinquentPaymentReportDocument = `
    query GetCyDeletedWithDelinquentPaymentReport($taxYear: Int!) {
  cyDeletedWithDelinquentPaymentReport(taxYear: $taxYear) {
    id
    accountNbr
    leaseMasterAccountNbr
    telecomAccountNbr
    taxYear
    acctTypeId
    acctTypeDescr
    amount
    balance
  }
}
    `;

export const useGetCyDeletedWithDelinquentPaymentReportQuery = <
      TData = GetCyDeletedWithDelinquentPaymentReportQuery,
      TError = unknown
    >(
      variables: GetCyDeletedWithDelinquentPaymentReportQueryVariables,
      options?: UseQueryOptions<GetCyDeletedWithDelinquentPaymentReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetCyDeletedWithDelinquentPaymentReportQuery, TError, TData>(
      ['GetCyDeletedWithDelinquentPaymentReport', variables],
      useFetchData<GetCyDeletedWithDelinquentPaymentReportQuery, GetCyDeletedWithDelinquentPaymentReportQueryVariables>(GetCyDeletedWithDelinquentPaymentReportDocument).bind(null, variables),
      options
    )};

export const GetNewBizAcctsNotFiledOrExemptWithNoValueReportDocument = `
    query GetNewBizAcctsNotFiledOrExemptWithNoValueReport($taxYear: Int!) {
  newBizAcctsNotFiledOrExemptWithNoValueReport(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
  }
}
    `;

export const useGetNewBizAcctsNotFiledOrExemptWithNoValueReportQuery = <
      TData = GetNewBizAcctsNotFiledOrExemptWithNoValueReportQuery,
      TError = unknown
    >(
      variables: GetNewBizAcctsNotFiledOrExemptWithNoValueReportQueryVariables,
      options?: UseQueryOptions<GetNewBizAcctsNotFiledOrExemptWithNoValueReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetNewBizAcctsNotFiledOrExemptWithNoValueReportQuery, TError, TData>(
      ['GetNewBizAcctsNotFiledOrExemptWithNoValueReport', variables],
      useFetchData<GetNewBizAcctsNotFiledOrExemptWithNoValueReportQuery, GetNewBizAcctsNotFiledOrExemptWithNoValueReportQueryVariables>(GetNewBizAcctsNotFiledOrExemptWithNoValueReportDocument).bind(null, variables),
      options
    )};

export const GetAccountsToOneYearExemptReportDocument = `
    query GetAccountsToOneYearExemptReport($taxYear: Int!) {
  accountsToOneYearExemptReport(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
  }
}
    `;

export const useGetAccountsToOneYearExemptReportQuery = <
      TData = GetAccountsToOneYearExemptReportQuery,
      TError = unknown
    >(
      variables: GetAccountsToOneYearExemptReportQueryVariables,
      options?: UseQueryOptions<GetAccountsToOneYearExemptReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetAccountsToOneYearExemptReportQuery, TError, TData>(
      ['GetAccountsToOneYearExemptReport', variables],
      useFetchData<GetAccountsToOneYearExemptReportQuery, GetAccountsToOneYearExemptReportQueryVariables>(GetAccountsToOneYearExemptReportDocument).bind(null, variables),
      options
    )};

export const GetExemptAccountsWithNoFlagReportDocument = `
    query GetExemptAccountsWithNoFlagReport($taxYear: Int!) {
  exemptAccountsWithNoFlagReport(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
  }
}
    `;

export const useGetExemptAccountsWithNoFlagReportQuery = <
      TData = GetExemptAccountsWithNoFlagReportQuery,
      TError = unknown
    >(
      variables: GetExemptAccountsWithNoFlagReportQueryVariables,
      options?: UseQueryOptions<GetExemptAccountsWithNoFlagReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetExemptAccountsWithNoFlagReportQuery, TError, TData>(
      ['GetExemptAccountsWithNoFlagReport', variables],
      useFetchData<GetExemptAccountsWithNoFlagReportQuery, GetExemptAccountsWithNoFlagReportQueryVariables>(GetExemptAccountsWithNoFlagReportDocument).bind(null, variables),
      options
    )};

export const GetAccountsWithMissingTaxRateReportDocument = `
    query GetAccountsWithMissingTaxRateReport($taxYear: Int!) {
  accountsWithMissingTaxRateReport(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
    taxDistrict
  }
}
    `;

export const useGetAccountsWithMissingTaxRateReportQuery = <
      TData = GetAccountsWithMissingTaxRateReportQuery,
      TError = unknown
    >(
      variables: GetAccountsWithMissingTaxRateReportQueryVariables,
      options?: UseQueryOptions<GetAccountsWithMissingTaxRateReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetAccountsWithMissingTaxRateReportQuery, TError, TData>(
      ['GetAccountsWithMissingTaxRateReport', variables],
      useFetchData<GetAccountsWithMissingTaxRateReportQuery, GetAccountsWithMissingTaxRateReportQueryVariables>(GetAccountsWithMissingTaxRateReportDocument).bind(null, variables),
      options
    )};

export const GetAccountsWithInvalidTaxAreaReportDocument = `
    query GetAccountsWithInvalidTaxAreaReport($taxYear: Int!) {
  accountsWithInvalidTaxAreaReport(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
    taxDistrict
    exempt
    active
    leaseMasterAccountNbr
    recordType
  }
}
    `;

export const useGetAccountsWithInvalidTaxAreaReportQuery = <
      TData = GetAccountsWithInvalidTaxAreaReportQuery,
      TError = unknown
    >(
      variables: GetAccountsWithInvalidTaxAreaReportQueryVariables,
      options?: UseQueryOptions<GetAccountsWithInvalidTaxAreaReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetAccountsWithInvalidTaxAreaReportQuery, TError, TData>(
      ['GetAccountsWithInvalidTaxAreaReport', variables],
      useFetchData<GetAccountsWithInvalidTaxAreaReportQuery, GetAccountsWithInvalidTaxAreaReportQueryVariables>(GetAccountsWithInvalidTaxAreaReportDocument).bind(null, variables),
      options
    )};

export const GetTelecomSubAccountNameMismatchReportDocument = `
    query GetTelecomSubAccountNameMismatchReport($taxYear: Int!) {
  telecomSubAccountNameMismatchReport(taxYear: $taxYear) {
    id
    telecomAccountNbr
    subAccountNbr
    taxDistrict
    subAccountBusinessName
    telecomBusinessName
    isReconciled
    recordType
  }
}
    `;

export const useGetTelecomSubAccountNameMismatchReportQuery = <
      TData = GetTelecomSubAccountNameMismatchReportQuery,
      TError = unknown
    >(
      variables: GetTelecomSubAccountNameMismatchReportQueryVariables,
      options?: UseQueryOptions<GetTelecomSubAccountNameMismatchReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomSubAccountNameMismatchReportQuery, TError, TData>(
      ['GetTelecomSubAccountNameMismatchReport', variables],
      useFetchData<GetTelecomSubAccountNameMismatchReportQuery, GetTelecomSubAccountNameMismatchReportQueryVariables>(GetTelecomSubAccountNameMismatchReportDocument).bind(null, variables),
      options
    )};

export const GetLeaseMasterAccountWithoutSubAccountsReportDocument = `
    query GetLeaseMasterAccountWithoutSubAccountsReport($taxYear: Int!) {
  leaseMasterAccountWithoutSubAccountsReport(taxYear: $taxYear) {
    id
    leaseMasterAccountNbr
    subAccountCount
  }
}
    `;

export const useGetLeaseMasterAccountWithoutSubAccountsReportQuery = <
      TData = GetLeaseMasterAccountWithoutSubAccountsReportQuery,
      TError = unknown
    >(
      variables: GetLeaseMasterAccountWithoutSubAccountsReportQueryVariables,
      options?: UseQueryOptions<GetLeaseMasterAccountWithoutSubAccountsReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetLeaseMasterAccountWithoutSubAccountsReportQuery, TError, TData>(
      ['GetLeaseMasterAccountWithoutSubAccountsReport', variables],
      useFetchData<GetLeaseMasterAccountWithoutSubAccountsReportQuery, GetLeaseMasterAccountWithoutSubAccountsReportQueryVariables>(GetLeaseMasterAccountWithoutSubAccountsReportDocument).bind(null, variables),
      options
    )};

export const GetCurrentYearRollingToDelinquentTablesDocument = `
    query GetCurrentYearRollingToDelinquentTables($taxYear: Int!) {
  currentYearRollingToDelinquentTables(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
    amount
    howReceived
    isReconciled
    leaseMasterAccountNbr
    telecomAccountNbr
  }
}
    `;

export const useGetCurrentYearRollingToDelinquentTablesQuery = <
      TData = GetCurrentYearRollingToDelinquentTablesQuery,
      TError = unknown
    >(
      variables: GetCurrentYearRollingToDelinquentTablesQueryVariables,
      options?: UseQueryOptions<GetCurrentYearRollingToDelinquentTablesQuery, TError, TData>
    ) => {
    
    return useQuery<GetCurrentYearRollingToDelinquentTablesQuery, TError, TData>(
      ['GetCurrentYearRollingToDelinquentTables', variables],
      useFetchData<GetCurrentYearRollingToDelinquentTablesQuery, GetCurrentYearRollingToDelinquentTablesQueryVariables>(GetCurrentYearRollingToDelinquentTablesDocument).bind(null, variables),
      options
    )};

export const GetOneYearExemptStatusReportDocument = `
    query GetOneYearExemptStatusReport($taxYear: Int!) {
  oneYearExemptStatusReport(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
    isReconciled
    isExempt
    totalTaxable
    netAssmntChargeWithTotalDirect
    penalty
    payments
    yearEndBalance
    associatedAccounts
  }
}
    `;

export const useGetOneYearExemptStatusReportQuery = <
      TData = GetOneYearExemptStatusReportQuery,
      TError = unknown
    >(
      variables: GetOneYearExemptStatusReportQueryVariables,
      options?: UseQueryOptions<GetOneYearExemptStatusReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetOneYearExemptStatusReportQuery, TError, TData>(
      ['GetOneYearExemptStatusReport', variables],
      useFetchData<GetOneYearExemptStatusReportQuery, GetOneYearExemptStatusReportQueryVariables>(GetOneYearExemptStatusReportDocument).bind(null, variables),
      options
    )};

export const GetEstimatedValuesReportDocument = `
    query GetEstimatedValuesReport($taxYear: Int!) {
  estimatedValuesReport(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
    isReconciled
    isExempt
    totalTaxable
    totalEstimatedValue
    sicCode
    sicCodeDescription
  }
}
    `;

export const useGetEstimatedValuesReportQuery = <
      TData = GetEstimatedValuesReportQuery,
      TError = unknown
    >(
      variables: GetEstimatedValuesReportQueryVariables,
      options?: UseQueryOptions<GetEstimatedValuesReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetEstimatedValuesReportQuery, TError, TData>(
      ['GetEstimatedValuesReport', variables],
      useFetchData<GetEstimatedValuesReportQuery, GetEstimatedValuesReportQueryVariables>(GetEstimatedValuesReportDocument).bind(null, variables),
      options
    )};

export const GetLeaseMasterAccountsWithBalanceReportDocument = `
    query GetLeaseMasterAccountsWithBalanceReport($taxYear: Int!) {
  leaseMasterAccountsWithBalanceReport(taxYear: $taxYear) {
    id
    subAccountNbr
    leaseMasterAccountNbr
    subAccountBalance
    lmActive
    lmExempt
    lmHowFiled
  }
}
    `;

export const useGetLeaseMasterAccountsWithBalanceReportQuery = <
      TData = GetLeaseMasterAccountsWithBalanceReportQuery,
      TError = unknown
    >(
      variables: GetLeaseMasterAccountsWithBalanceReportQueryVariables,
      options?: UseQueryOptions<GetLeaseMasterAccountsWithBalanceReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetLeaseMasterAccountsWithBalanceReportQuery, TError, TData>(
      ['GetLeaseMasterAccountsWithBalanceReport', variables],
      useFetchData<GetLeaseMasterAccountsWithBalanceReportQuery, GetLeaseMasterAccountsWithBalanceReportQueryVariables>(GetLeaseMasterAccountsWithBalanceReportDocument).bind(null, variables),
      options
    )};

export const GetLeaseMasterOneYearExemptReportDocument = `
    query GetLeaseMasterOneYearExemptReport($taxYear: Int!) {
  leaseMasterOneYearExemptReport(taxYear: $taxYear) {
    id
    accountNbr
    businessName
    acctTypeId
    acctTypeDescr
    isExempt
    totalDirect
    payments
    netAssmntCharge
    penalty
    yearEndBalance
  }
}
    `;

export const useGetLeaseMasterOneYearExemptReportQuery = <
      TData = GetLeaseMasterOneYearExemptReportQuery,
      TError = unknown
    >(
      variables: GetLeaseMasterOneYearExemptReportQueryVariables,
      options?: UseQueryOptions<GetLeaseMasterOneYearExemptReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetLeaseMasterOneYearExemptReportQuery, TError, TData>(
      ['GetLeaseMasterOneYearExemptReport', variables],
      useFetchData<GetLeaseMasterOneYearExemptReportQuery, GetLeaseMasterOneYearExemptReportQueryVariables>(GetLeaseMasterOneYearExemptReportDocument).bind(null, variables),
      options
    )};

export const GetAccWithDirChargeDelTaxReportDocument = `
    query GetAccWithDirChargeDelTaxReport($taxYear: Int!) {
  accWithDirChargeDelTaxReport(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
    directChargeAmount
  }
}
    `;

export const useGetAccWithDirChargeDelTaxReportQuery = <
      TData = GetAccWithDirChargeDelTaxReportQuery,
      TError = unknown
    >(
      variables: GetAccWithDirChargeDelTaxReportQueryVariables,
      options?: UseQueryOptions<GetAccWithDirChargeDelTaxReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetAccWithDirChargeDelTaxReportQuery, TError, TData>(
      ['GetAccWithDirChargeDelTaxReport', variables],
      useFetchData<GetAccWithDirChargeDelTaxReportQuery, GetAccWithDirChargeDelTaxReportQueryVariables>(GetAccWithDirChargeDelTaxReportDocument).bind(null, variables),
      options
    )};

export const GetNewBusinessNotreconciledReportDocument = `
    query GetNewBusinessNotreconciledReport($taxYear: Int!) {
  newBusinessNotReconciledReport(taxYear: $taxYear) {
    id
    taxYear
    accountNbr
    businessName
    acctTypeId
    acctTypeDescr
  }
}
    `;

export const useGetNewBusinessNotreconciledReportQuery = <
      TData = GetNewBusinessNotreconciledReportQuery,
      TError = unknown
    >(
      variables: GetNewBusinessNotreconciledReportQueryVariables,
      options?: UseQueryOptions<GetNewBusinessNotreconciledReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetNewBusinessNotreconciledReportQuery, TError, TData>(
      ['GetNewBusinessNotreconciledReport', variables],
      useFetchData<GetNewBusinessNotreconciledReportQuery, GetNewBusinessNotreconciledReportQueryVariables>(GetNewBusinessNotreconciledReportDocument).bind(null, variables),
      options
    )};

export const GetCountOfAccountsByAcctTypeReportDocument = `
    query GetCountOfAccountsByAcctTypeReport($priorTaxYear: Int!, $currentTaxYear: Int!) {
  countOfAccountsByAcctTypeReport(
    priorTaxYear: $priorTaxYear
    currentTaxYear: $currentTaxYear
  ) {
    id
    acctTypeId
    acctTypeDescr
    priorYear
    currentYear
    notes
  }
}
    `;

export const useGetCountOfAccountsByAcctTypeReportQuery = <
      TData = GetCountOfAccountsByAcctTypeReportQuery,
      TError = unknown
    >(
      variables: GetCountOfAccountsByAcctTypeReportQueryVariables,
      options?: UseQueryOptions<GetCountOfAccountsByAcctTypeReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetCountOfAccountsByAcctTypeReportQuery, TError, TData>(
      ['GetCountOfAccountsByAcctTypeReport', variables],
      useFetchData<GetCountOfAccountsByAcctTypeReportQuery, GetCountOfAccountsByAcctTypeReportQueryVariables>(GetCountOfAccountsByAcctTypeReportDocument).bind(null, variables),
      options
    )};

export const GetPriorYearRolledToDelinquentReportDocument = `
    query GetPriorYearRolledToDelinquentReport($taxYear: Int!) {
  pyRolledToDelinquentTablesReport(taxYear: $taxYear) {
    id
    accountNbr
    taxYear
    businessName
    acctTypeId
    acctTypeDescr
    amount
    howReceived
    isReconciled
    leaseMasterAccountNbr
    telecomAccountNbr
  }
}
    `;

export const useGetPriorYearRolledToDelinquentReportQuery = <
      TData = GetPriorYearRolledToDelinquentReportQuery,
      TError = unknown
    >(
      variables: GetPriorYearRolledToDelinquentReportQueryVariables,
      options?: UseQueryOptions<GetPriorYearRolledToDelinquentReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetPriorYearRolledToDelinquentReportQuery, TError, TData>(
      ['GetPriorYearRolledToDelinquentReport', variables],
      useFetchData<GetPriorYearRolledToDelinquentReportQuery, GetPriorYearRolledToDelinquentReportQueryVariables>(GetPriorYearRolledToDelinquentReportDocument).bind(null, variables),
      options
    )};

export const GetIronCountyTaxableValueReportDocument = `
    query GetIronCountyTaxableValueReport($taxYear: Int!, $startDate: String!, $endDate: String!) {
  ironCountyTaxableValueReport(
    taxYear: $taxYear
    startDate: $startDate
    endDate: $endDate
  ) {
    id
    account
    description
    taxableValue
    propertyCode
    quantity
    yearAcquired
  }
}
    `;

export const useGetIronCountyTaxableValueReportQuery = <
      TData = GetIronCountyTaxableValueReportQuery,
      TError = unknown
    >(
      variables: GetIronCountyTaxableValueReportQueryVariables,
      options?: UseQueryOptions<GetIronCountyTaxableValueReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetIronCountyTaxableValueReportQuery, TError, TData>(
      ['GetIronCountyTaxableValueReport', variables],
      useFetchData<GetIronCountyTaxableValueReportQuery, GetIronCountyTaxableValueReportQueryVariables>(GetIronCountyTaxableValueReportDocument).bind(null, variables),
      options
    )};

export const GetRolesDocument = `
    query GetRoles {
  getRoles {
    id
    name
    description
    permissions {
      id
      name
    }
  }
}
    `;

export const useGetRolesQuery = <
      TData = GetRolesQuery,
      TError = unknown
    >(
      variables?: GetRolesQueryVariables,
      options?: UseQueryOptions<GetRolesQuery, TError, TData>
    ) => {
    
    return useQuery<GetRolesQuery, TError, TData>(
      variables === undefined ? ['GetRoles'] : ['GetRoles', variables],
      useFetchData<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument).bind(null, variables),
      options
    )};

export const GetPermissionsDocument = `
    query GetPermissions {
  getPermissions {
    id
    name
  }
}
    `;

export const useGetPermissionsQuery = <
      TData = GetPermissionsQuery,
      TError = unknown
    >(
      variables?: GetPermissionsQueryVariables,
      options?: UseQueryOptions<GetPermissionsQuery, TError, TData>
    ) => {
    
    return useQuery<GetPermissionsQuery, TError, TData>(
      variables === undefined ? ['GetPermissions'] : ['GetPermissions', variables],
      useFetchData<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument).bind(null, variables),
      options
    )};

export const GetRoleDocument = `
    query GetRole($roleId: Int!) {
  getRole(roleId: $roleId) {
    id
    name
    description
    permissions {
      id
      name
    }
  }
}
    `;

export const useGetRoleQuery = <
      TData = GetRoleQuery,
      TError = unknown
    >(
      variables: GetRoleQueryVariables,
      options?: UseQueryOptions<GetRoleQuery, TError, TData>
    ) => {
    
    return useQuery<GetRoleQuery, TError, TData>(
      ['GetRole', variables],
      useFetchData<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument).bind(null, variables),
      options
    )};

export const GetRolesFromUserDocument = `
    query GetRolesFromUser($userId: Int!) {
  getRolesFromUser(userId: $userId) {
    id
    name
    description
    permissions {
      id
      name
    }
  }
}
    `;

export const useGetRolesFromUserQuery = <
      TData = GetRolesFromUserQuery,
      TError = unknown
    >(
      variables: GetRolesFromUserQueryVariables,
      options?: UseQueryOptions<GetRolesFromUserQuery, TError, TData>
    ) => {
    
    return useQuery<GetRolesFromUserQuery, TError, TData>(
      ['GetRolesFromUser', variables],
      useFetchData<GetRolesFromUserQuery, GetRolesFromUserQueryVariables>(GetRolesFromUserDocument).bind(null, variables),
      options
    )};

export const DeleteRoleDocument = `
    mutation DeleteRole($roleId: Int!) {
  deleteRole(roleId: $roleId)
}
    `;

export const useDeleteRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteRoleMutation, TError, DeleteRoleMutationVariables, TContext>) => {
    
    return useMutation<DeleteRoleMutation, TError, DeleteRoleMutationVariables, TContext>(
      ['DeleteRole'],
      useFetchData<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument),
      options
    )};

export const AddRoleToUserDocument = `
    mutation AddRoleToUser($roleId: Int!, $userId: Int!) {
  addRoleToUser(roleId: $roleId, userId: $userId)
}
    `;

export const useAddRoleToUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddRoleToUserMutation, TError, AddRoleToUserMutationVariables, TContext>) => {
    
    return useMutation<AddRoleToUserMutation, TError, AddRoleToUserMutationVariables, TContext>(
      ['AddRoleToUser'],
      useFetchData<AddRoleToUserMutation, AddRoleToUserMutationVariables>(AddRoleToUserDocument),
      options
    )};

export const RemoveRoleFromUserDocument = `
    mutation RemoveRoleFromUser($roleId: Int!, $userId: Int!) {
  removeRoleFromUser(roleId: $roleId, userId: $userId)
}
    `;

export const useRemoveRoleFromUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveRoleFromUserMutation, TError, RemoveRoleFromUserMutationVariables, TContext>) => {
    
    return useMutation<RemoveRoleFromUserMutation, TError, RemoveRoleFromUserMutationVariables, TContext>(
      ['RemoveRoleFromUser'],
      useFetchData<RemoveRoleFromUserMutation, RemoveRoleFromUserMutationVariables>(RemoveRoleFromUserDocument),
      options
    )};

export const UpdateRoleDocument = `
    mutation UpdateRole($roleId: Int!, $role: RoleInput!) {
  updateRole(roleId: $roleId, role: $role)
}
    `;

export const useUpdateRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateRoleMutation, TError, UpdateRoleMutationVariables, TContext>) => {
    
    return useMutation<UpdateRoleMutation, TError, UpdateRoleMutationVariables, TContext>(
      ['UpdateRole'],
      useFetchData<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument),
      options
    )};

export const SaveRoleDocument = `
    mutation SaveRole($role: RoleInput!) {
  saveRole(role: $role)
}
    `;

export const useSaveRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveRoleMutation, TError, SaveRoleMutationVariables, TContext>) => {
    
    return useMutation<SaveRoleMutation, TError, SaveRoleMutationVariables, TContext>(
      ['SaveRole'],
      useFetchData<SaveRoleMutation, SaveRoleMutationVariables>(SaveRoleDocument),
      options
    )};

export const GetReconciliationContextDocument = `
    query GetReconciliationContext($accountId: Int!) {
  reconciliationContext(accountId: $accountId) {
    taxYear
    accountId
    accountNumber
    businessName
    completedSteps
    fullName
    buildingPermitExists
  }
}
    `;

export const useGetReconciliationContextQuery = <
      TData = GetReconciliationContextQuery,
      TError = unknown
    >(
      variables: GetReconciliationContextQueryVariables,
      options?: UseQueryOptions<GetReconciliationContextQuery, TError, TData>
    ) => {
    
    return useQuery<GetReconciliationContextQuery, TError, TData>(
      ['GetReconciliationContext', variables],
      useFetchData<GetReconciliationContextQuery, GetReconciliationContextQueryVariables>(GetReconciliationContextDocument).bind(null, variables),
      options
    )};

export const GetSicCodesDocument = `
    query GetSicCodes {
  sicCodes {
    code
    description
    isActive
  }
}
    `;

export const useGetSicCodesQuery = <
      TData = GetSicCodesQuery,
      TError = unknown
    >(
      variables?: GetSicCodesQueryVariables,
      options?: UseQueryOptions<GetSicCodesQuery, TError, TData>
    ) => {
    
    return useQuery<GetSicCodesQuery, TError, TData>(
      variables === undefined ? ['GetSicCodes'] : ['GetSicCodes', variables],
      useFetchData<GetSicCodesQuery, GetSicCodesQueryVariables>(GetSicCodesDocument).bind(null, variables),
      options
    )};

export const GetSicCodeMastersDocument = `
    query GetSicCodeMasters {
  sicCodeMasters {
    id
    isActive
    sicCode
    sicCodeDescription
    sicSiloCode
    subSiloCode
  }
}
    `;

export const useGetSicCodeMastersQuery = <
      TData = GetSicCodeMastersQuery,
      TError = unknown
    >(
      variables?: GetSicCodeMastersQueryVariables,
      options?: UseQueryOptions<GetSicCodeMastersQuery, TError, TData>
    ) => {
    
    return useQuery<GetSicCodeMastersQuery, TError, TData>(
      variables === undefined ? ['GetSicCodeMasters'] : ['GetSicCodeMasters', variables],
      useFetchData<GetSicCodeMastersQuery, GetSicCodeMastersQueryVariables>(GetSicCodeMastersDocument).bind(null, variables),
      options
    )};

export const GetAllCodesDocument = `
    query GetAllCodes {
  allCodes {
    sicCodes {
      code
      description
      isActive
    }
    sicSiloCodes {
      code
      description
      isActive
    }
    subSiloCodes {
      code
      description
      isActive
    }
  }
}
    `;

export const useGetAllCodesQuery = <
      TData = GetAllCodesQuery,
      TError = unknown
    >(
      variables?: GetAllCodesQueryVariables,
      options?: UseQueryOptions<GetAllCodesQuery, TError, TData>
    ) => {
    
    return useQuery<GetAllCodesQuery, TError, TData>(
      variables === undefined ? ['GetAllCodes'] : ['GetAllCodes', variables],
      useFetchData<GetAllCodesQuery, GetAllCodesQueryVariables>(GetAllCodesDocument).bind(null, variables),
      options
    )};

export const GetSicSiloCodesDocument = `
    query GetSicSiloCodes {
  sicSiloCodes {
    code
    description
    isActive
  }
}
    `;

export const useGetSicSiloCodesQuery = <
      TData = GetSicSiloCodesQuery,
      TError = unknown
    >(
      variables?: GetSicSiloCodesQueryVariables,
      options?: UseQueryOptions<GetSicSiloCodesQuery, TError, TData>
    ) => {
    
    return useQuery<GetSicSiloCodesQuery, TError, TData>(
      variables === undefined ? ['GetSicSiloCodes'] : ['GetSicSiloCodes', variables],
      useFetchData<GetSicSiloCodesQuery, GetSicSiloCodesQueryVariables>(GetSicSiloCodesDocument).bind(null, variables),
      options
    )};

export const GetSubSiloCodesDocument = `
    query GetSubSiloCodes {
  subSiloCodes {
    code
    description
    isActive
  }
}
    `;

export const useGetSubSiloCodesQuery = <
      TData = GetSubSiloCodesQuery,
      TError = unknown
    >(
      variables?: GetSubSiloCodesQueryVariables,
      options?: UseQueryOptions<GetSubSiloCodesQuery, TError, TData>
    ) => {
    
    return useQuery<GetSubSiloCodesQuery, TError, TData>(
      variables === undefined ? ['GetSubSiloCodes'] : ['GetSubSiloCodes', variables],
      useFetchData<GetSubSiloCodesQuery, GetSubSiloCodesQueryVariables>(GetSubSiloCodesDocument).bind(null, variables),
      options
    )};

export const SaveSicCodesDocument = `
    mutation SaveSicCodes($sicCodes: [CodeRowInput!]!) {
  saveSicCodes(sicCodes: $sicCodes) {
    code
    description
    isActive
  }
}
    `;

export const useSaveSicCodesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveSicCodesMutation, TError, SaveSicCodesMutationVariables, TContext>) => {
    
    return useMutation<SaveSicCodesMutation, TError, SaveSicCodesMutationVariables, TContext>(
      ['SaveSicCodes'],
      useFetchData<SaveSicCodesMutation, SaveSicCodesMutationVariables>(SaveSicCodesDocument),
      options
    )};

export const SaveSicSiloCodesDocument = `
    mutation SaveSicSiloCodes($sicSiloCodes: [CodeRowInput!]!) {
  saveSicSiloCodes(sicSiloCodes: $sicSiloCodes) {
    code
    description
    isActive
  }
}
    `;

export const useSaveSicSiloCodesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveSicSiloCodesMutation, TError, SaveSicSiloCodesMutationVariables, TContext>) => {
    
    return useMutation<SaveSicSiloCodesMutation, TError, SaveSicSiloCodesMutationVariables, TContext>(
      ['SaveSicSiloCodes'],
      useFetchData<SaveSicSiloCodesMutation, SaveSicSiloCodesMutationVariables>(SaveSicSiloCodesDocument),
      options
    )};

export const SaveSubSiloCodesDocument = `
    mutation SaveSubSiloCodes($subSiloCodes: [CodeRowInput!]!) {
  saveSubSiloCodes(subSiloCodes: $subSiloCodes) {
    code
    description
    isActive
  }
}
    `;

export const useSaveSubSiloCodesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveSubSiloCodesMutation, TError, SaveSubSiloCodesMutationVariables, TContext>) => {
    
    return useMutation<SaveSubSiloCodesMutation, TError, SaveSubSiloCodesMutationVariables, TContext>(
      ['SaveSubSiloCodes'],
      useFetchData<SaveSubSiloCodesMutation, SaveSubSiloCodesMutationVariables>(SaveSubSiloCodesDocument),
      options
    )};

export const SaveSicCodeMastersDocument = `
    mutation SaveSicCodeMasters($sicCodeMasters: [CodeRowMasterInput!]!) {
  saveSicCodeMasters(sicCodeMasters: $sicCodeMasters) {
    id
    isActive
    sicCode
    sicSiloCode
    subSiloCode
  }
}
    `;

export const useSaveSicCodeMastersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveSicCodeMastersMutation, TError, SaveSicCodeMastersMutationVariables, TContext>) => {
    
    return useMutation<SaveSicCodeMastersMutation, TError, SaveSicCodeMastersMutationVariables, TContext>(
      ['SaveSicCodeMasters'],
      useFetchData<SaveSicCodeMastersMutation, SaveSicCodeMastersMutationVariables>(SaveSicCodeMastersDocument),
      options
    )};

export const GetSimiliarBusinessesDocument = `
    query GetSimiliarBusinesses($similarBusinessSearchInput: SimilarBusinessSearchInput!) {
  similarBusinesses(similarBusinessSearchInput: $similarBusinessSearchInput) {
    accountNumber
    businessName
    similarAddress
  }
}
    `;

export const useGetSimiliarBusinessesQuery = <
      TData = GetSimiliarBusinessesQuery,
      TError = unknown
    >(
      variables: GetSimiliarBusinessesQueryVariables,
      options?: UseQueryOptions<GetSimiliarBusinessesQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimiliarBusinessesQuery, TError, TData>(
      ['GetSimiliarBusinesses', variables],
      useFetchData<GetSimiliarBusinessesQuery, GetSimiliarBusinessesQueryVariables>(GetSimiliarBusinessesDocument).bind(null, variables),
      options
    )};

export const GetSimilarBusinessesLeaseMasterDocument = `
    query GetSimilarBusinessesLeaseMaster($similarBusinessSearchLeaseMasterInput: SimilarBusinessSearchLeaseMasterInput!) {
  similarBusinessesLeaseMaster(
    similarBusinessSearchLeaseMasterInput: $similarBusinessSearchLeaseMasterInput
  ) {
    accountNumber
    name
  }
}
    `;

export const useGetSimilarBusinessesLeaseMasterQuery = <
      TData = GetSimilarBusinessesLeaseMasterQuery,
      TError = unknown
    >(
      variables: GetSimilarBusinessesLeaseMasterQueryVariables,
      options?: UseQueryOptions<GetSimilarBusinessesLeaseMasterQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimilarBusinessesLeaseMasterQuery, TError, TData>(
      ['GetSimilarBusinessesLeaseMaster', variables],
      useFetchData<GetSimilarBusinessesLeaseMasterQuery, GetSimilarBusinessesLeaseMasterQueryVariables>(GetSimilarBusinessesLeaseMasterDocument).bind(null, variables),
      options
    )};

export const GetSimilarTelecomBusinessesDocument = `
    query GetSimilarTelecomBusinesses($similarTelecomBusinessInput: SimilarTelecomBusinessInput!) {
  similarTelecomBusinesses(
    similarTelecomBusinessInput: $similarTelecomBusinessInput
  ) {
    name
    accountNumber
  }
}
    `;

export const useGetSimilarTelecomBusinessesQuery = <
      TData = GetSimilarTelecomBusinessesQuery,
      TError = unknown
    >(
      variables: GetSimilarTelecomBusinessesQueryVariables,
      options?: UseQueryOptions<GetSimilarTelecomBusinessesQuery, TError, TData>
    ) => {
    
    return useQuery<GetSimilarTelecomBusinessesQuery, TError, TData>(
      ['GetSimilarTelecomBusinesses', variables],
      useFetchData<GetSimilarTelecomBusinessesQuery, GetSimilarTelecomBusinessesQueryVariables>(GetSimilarTelecomBusinessesDocument).bind(null, variables),
      options
    )};

export const GetSubAccountSummaryDocument = `
    query GetSubAccountSummary($leaseMasterId: ID!, $taxYear: Int!) {
  getSubAccountSummary(leaseMasterId: $leaseMasterId, taxYear: $taxYear) {
    accountId
    accountNumber
    jurisdictionId
    leaseMasterId
    taxYear
    recordType
    taxDistrict
    locationCount
    totalAssetCount
    bafInActiveAccountsCount
    invalidTaxDistrictCount
    isExempt
    isActive
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      penaltyCharge
      payments
      interest
      currentBalance
      delinquentBalance
      totalBalance
    }
  }
}
    `;

export const useGetSubAccountSummaryQuery = <
      TData = GetSubAccountSummaryQuery,
      TError = unknown
    >(
      variables: GetSubAccountSummaryQueryVariables,
      options?: UseQueryOptions<GetSubAccountSummaryQuery, TError, TData>
    ) => {
    
    return useQuery<GetSubAccountSummaryQuery, TError, TData>(
      ['GetSubAccountSummary', variables],
      useFetchData<GetSubAccountSummaryQuery, GetSubAccountSummaryQueryVariables>(GetSubAccountSummaryDocument).bind(null, variables),
      options
    )};

export const GetSubAccountByLeaseMasterIdSubAccountIdDocument = `
    query GetSubAccountByLeaseMasterIdSubAccountId($leaseMasterId: ID!, $subAccountId: ID!) {
  getSubAccountByLeaseMasterIdSubAccountId(
    leaseMasterId: $leaseMasterId
    subAccountId: $subAccountId
  ) {
    accountId
    accountNumber
    taxDistrict
    jurisdictionId
    recordType
    taxYear
    leaseMasterId
    locationCount
    totalAssetCount
    bafInActiveAccountsCount
    invalidTaxDistrictCount
    isExempt
    isActive
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      penaltyCharge
      payments
      interest
      currentBalance
      delinquentBalance
      totalBalance
      totalBalanceWithDelinquent
    }
  }
}
    `;

export const useGetSubAccountByLeaseMasterIdSubAccountIdQuery = <
      TData = GetSubAccountByLeaseMasterIdSubAccountIdQuery,
      TError = unknown
    >(
      variables: GetSubAccountByLeaseMasterIdSubAccountIdQueryVariables,
      options?: UseQueryOptions<GetSubAccountByLeaseMasterIdSubAccountIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetSubAccountByLeaseMasterIdSubAccountIdQuery, TError, TData>(
      ['GetSubAccountByLeaseMasterIdSubAccountId', variables],
      useFetchData<GetSubAccountByLeaseMasterIdSubAccountIdQuery, GetSubAccountByLeaseMasterIdSubAccountIdQueryVariables>(GetSubAccountByLeaseMasterIdSubAccountIdDocument).bind(null, variables),
      options
    )};

export const CreateSubAccountTaxDistrictDocument = `
    mutation CreateSubAccountTaxDistrict($accountId: ID!, $taxDistrict: String!) {
  createSubAccountTaxDistrict(accountId: $accountId, taxDistrict: $taxDistrict) {
    accountId
    accountNumber
    taxDistrict
    locationCount
    totalAssetCount
    isExempt
    isActive
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      penaltyCharge
      payments
      interest
      currentBalance
      delinquentBalance
      totalBalance
      totalBalanceWithDelinquent
    }
  }
}
    `;

export const useCreateSubAccountTaxDistrictMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSubAccountTaxDistrictMutation, TError, CreateSubAccountTaxDistrictMutationVariables, TContext>) => {
    
    return useMutation<CreateSubAccountTaxDistrictMutation, TError, CreateSubAccountTaxDistrictMutationVariables, TContext>(
      ['CreateSubAccountTaxDistrict'],
      useFetchData<CreateSubAccountTaxDistrictMutation, CreateSubAccountTaxDistrictMutationVariables>(CreateSubAccountTaxDistrictDocument),
      options
    )};

export const UpdateSubAccountTaxDistrictDocument = `
    mutation UpdateSubAccountTaxDistrict($subAccountTaxDistrict: SubAccountTaxDistrictInput!) {
  updateSubAccountTaxDistrict(subAccountTaxDistrict: $subAccountTaxDistrict) {
    accountId
    accountNumber
    taxDistrict
    locationCount
    totalAssetCount
    isExempt
    isActive
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      penaltyCharge
      payments
      interest
      currentBalance
      delinquentBalance
      totalBalance
      totalBalanceWithDelinquent
    }
  }
}
    `;

export const useUpdateSubAccountTaxDistrictMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSubAccountTaxDistrictMutation, TError, UpdateSubAccountTaxDistrictMutationVariables, TContext>) => {
    
    return useMutation<UpdateSubAccountTaxDistrictMutation, TError, UpdateSubAccountTaxDistrictMutationVariables, TContext>(
      ['UpdateSubAccountTaxDistrict'],
      useFetchData<UpdateSubAccountTaxDistrictMutation, UpdateSubAccountTaxDistrictMutationVariables>(UpdateSubAccountTaxDistrictDocument),
      options
    )};

export const SubAccountSearchDocument = `
    query SubAccountSearch($accountNumber: String!, $taxYear: Int) {
  subAccountSearch(accountNumber: $accountNumber, taxYear: $taxYear) {
    result {
      kind
      accountNumber
      businessName
      leaseMasterAccountNumber
      telecomAccountNumber
      taxArea
    }
    totalCount
  }
}
    `;

export const useSubAccountSearchQuery = <
      TData = SubAccountSearchQuery,
      TError = unknown
    >(
      variables: SubAccountSearchQueryVariables,
      options?: UseQueryOptions<SubAccountSearchQuery, TError, TData>
    ) => {
    
    return useQuery<SubAccountSearchQuery, TError, TData>(
      ['SubAccountSearch', variables],
      useFetchData<SubAccountSearchQuery, SubAccountSearchQueryVariables>(SubAccountSearchDocument).bind(null, variables),
      options
    )};

export const GetTaxAreaListDocument = `
    query GetTaxAreaList {
  taxAreaList {
    taxArea
    taxSubArea
  }
}
    `;

export const useGetTaxAreaListQuery = <
      TData = GetTaxAreaListQuery,
      TError = unknown
    >(
      variables?: GetTaxAreaListQueryVariables,
      options?: UseQueryOptions<GetTaxAreaListQuery, TError, TData>
    ) => {
    
    return useQuery<GetTaxAreaListQuery, TError, TData>(
      variables === undefined ? ['GetTaxAreaList'] : ['GetTaxAreaList', variables],
      useFetchData<GetTaxAreaListQuery, GetTaxAreaListQueryVariables>(GetTaxAreaListDocument).bind(null, variables),
      options
    )};

export const TelecomSearchAccountsDocument = `
    query TelecomSearchAccounts($filters: TelecomSearchFilters) {
  telecomSearchAccounts(Filters: $filters) {
    totalRecordCount
    results {
      id
      accountNumber
      businessName
      isActive
      status
      isReconciled
    }
  }
}
    `;

export const useTelecomSearchAccountsQuery = <
      TData = TelecomSearchAccountsQuery,
      TError = unknown
    >(
      variables?: TelecomSearchAccountsQueryVariables,
      options?: UseQueryOptions<TelecomSearchAccountsQuery, TError, TData>
    ) => {
    
    return useQuery<TelecomSearchAccountsQuery, TError, TData>(
      variables === undefined ? ['TelecomSearchAccounts'] : ['TelecomSearchAccounts', variables],
      useFetchData<TelecomSearchAccountsQuery, TelecomSearchAccountsQueryVariables>(TelecomSearchAccountsDocument).bind(null, variables),
      options
    )};

export const GetTelecomSubAccountsDocument = `
    query GetTelecomSubAccounts($telecomMasterId: Int!, $taxYear: Int!) {
  telecomSubAccounts(telecomMasterId: $telecomMasterId, taxYear: $taxYear) {
    accountId
    accountNumber
    jurisdictionId
    taxDistrict
    totalAssetCount
    invalidTaxDistrictCount
    applyPenalty
    isExempt
    isActive
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      penaltyCharge
      payments
      interest
      currentBalance
      delinquentBalance
      totalBalance
      totalBalanceWithDelinquent
    }
  }
}
    `;

export const useGetTelecomSubAccountsQuery = <
      TData = GetTelecomSubAccountsQuery,
      TError = unknown
    >(
      variables: GetTelecomSubAccountsQueryVariables,
      options?: UseQueryOptions<GetTelecomSubAccountsQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomSubAccountsQuery, TError, TData>(
      ['GetTelecomSubAccounts', variables],
      useFetchData<GetTelecomSubAccountsQuery, GetTelecomSubAccountsQueryVariables>(GetTelecomSubAccountsDocument).bind(null, variables),
      options
    )};

export const GetTelecomSubAccountDocument = `
    query GetTelecomSubAccount($telecomMasterId: Int!, $accountId: Int!) {
  telecomSubAccount(telecomMasterId: $telecomMasterId, accountId: $accountId) {
    accountId
    accountNumber
    jurisdictionId
    taxDistrict
    totalAssetCount
    invalidTaxDistrictCount
    applyPenalty
    isExempt
    isActive
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      penaltyCharge
      payments
      interest
      currentBalance
      delinquentBalance
      totalBalance
      totalBalanceWithDelinquent
    }
  }
}
    `;

export const useGetTelecomSubAccountQuery = <
      TData = GetTelecomSubAccountQuery,
      TError = unknown
    >(
      variables: GetTelecomSubAccountQueryVariables,
      options?: UseQueryOptions<GetTelecomSubAccountQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomSubAccountQuery, TError, TData>(
      ['GetTelecomSubAccount', variables],
      useFetchData<GetTelecomSubAccountQuery, GetTelecomSubAccountQueryVariables>(GetTelecomSubAccountDocument).bind(null, variables),
      options
    )};

export const CreateTelecomSubAccountDocument = `
    mutation CreateTelecomSubAccount($telecomMasterId: Int!, $taxDistrict: String!) {
  createTelecomSubAccount(
    telecomMasterId: $telecomMasterId
    taxDistrict: $taxDistrict
  ) {
    accountId
    accountNumber
    jurisdictionId
    taxDistrict
    totalAssetCount
    invalidTaxDistrictCount
    applyPenalty
    isExempt
    isActive
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      penaltyCharge
      payments
      interest
      currentBalance
      delinquentBalance
      totalBalance
      totalBalanceWithDelinquent
    }
  }
}
    `;

export const useCreateTelecomSubAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTelecomSubAccountMutation, TError, CreateTelecomSubAccountMutationVariables, TContext>) => {
    
    return useMutation<CreateTelecomSubAccountMutation, TError, CreateTelecomSubAccountMutationVariables, TContext>(
      ['CreateTelecomSubAccount'],
      useFetchData<CreateTelecomSubAccountMutation, CreateTelecomSubAccountMutationVariables>(CreateTelecomSubAccountDocument),
      options
    )};

export const SaveTelecomSubAccountDocument = `
    mutation SaveTelecomSubAccount($input: SaveTelecomSubAccountInput!) {
  saveTelecomSubAccount(input: $input) {
    accountId
    accountNumber
    jurisdictionId
    taxDistrict
    totalAssetCount
    invalidTaxDistrictCount
    applyPenalty
    isExempt
    isActive
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      penaltyCharge
      payments
      interest
      currentBalance
      delinquentBalance
      totalBalance
      totalBalanceWithDelinquent
    }
  }
}
    `;

export const useSaveTelecomSubAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveTelecomSubAccountMutation, TError, SaveTelecomSubAccountMutationVariables, TContext>) => {
    
    return useMutation<SaveTelecomSubAccountMutation, TError, SaveTelecomSubAccountMutationVariables, TContext>(
      ['SaveTelecomSubAccount'],
      useFetchData<SaveTelecomSubAccountMutation, SaveTelecomSubAccountMutationVariables>(SaveTelecomSubAccountDocument),
      options
    )};

export const ChangeMcatTelecomTaxAreaStatusDocument = `
    mutation ChangeMcatTelecomTaxAreaStatus($input: ChangeMCATTelecomTaxAreaStatusInput!) {
  changeMCATTelecomTaxAreaStatus(input: $input)
}
    `;

export const useChangeMcatTelecomTaxAreaStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChangeMcatTelecomTaxAreaStatusMutation, TError, ChangeMcatTelecomTaxAreaStatusMutationVariables, TContext>) => {
    
    return useMutation<ChangeMcatTelecomTaxAreaStatusMutation, TError, ChangeMcatTelecomTaxAreaStatusMutationVariables, TContext>(
      ['ChangeMcatTelecomTaxAreaStatus'],
      useFetchData<ChangeMcatTelecomTaxAreaStatusMutation, ChangeMcatTelecomTaxAreaStatusMutationVariables>(ChangeMcatTelecomTaxAreaStatusDocument),
      options
    )};

export const GetTelecomMcatAreasDocument = `
    query GetTelecomMcatAreas($params: TelecomMcatAreaParams!) {
  telecomMcatAreas(params: $params) {
    telecomMasterId
    jurisdiction {
      id
      name
    }
    taxYear
    isActive
    isExempt
    applyPenalty
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      penaltyCharge
      payments
      interest
      currentBalance
      delinquentBalance
      totalBalance
      totalBalanceWithDelinquent
    }
    subAccounts {
      accountId
      accountNumber
      jurisdictionId
      taxDistrict
      applyPenalty
      isExempt
      isActive
      accountSummary {
        cost
        taxable
        taxRate
        assessmentCharge
        directCharge
        penaltyCharge
        payments
        interest
        currentBalance
        delinquentBalance
        totalBalance
        totalBalanceWithDelinquent
      }
    }
  }
}
    `;

export const useGetTelecomMcatAreasQuery = <
      TData = GetTelecomMcatAreasQuery,
      TError = unknown
    >(
      variables: GetTelecomMcatAreasQueryVariables,
      options?: UseQueryOptions<GetTelecomMcatAreasQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomMcatAreasQuery, TError, TData>(
      ['GetTelecomMcatAreas', variables],
      useFetchData<GetTelecomMcatAreasQuery, GetTelecomMcatAreasQueryVariables>(GetTelecomMcatAreasDocument).bind(null, variables),
      options
    )};

export const GetTelecomMcatSubAccountDocument = `
    query GetTelecomMcatSubAccount($params: TelecomMcatSubAccountParams!) {
  telecomMcatSubAccount(params: $params) {
    accountId
    accountNumber
    jurisdictionId
    taxDistrict
    applyPenalty
    isExempt
    isActive
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      penaltyCharge
      payments
      interest
      currentBalance
      delinquentBalance
      totalBalance
      totalBalanceWithDelinquent
    }
  }
}
    `;

export const useGetTelecomMcatSubAccountQuery = <
      TData = GetTelecomMcatSubAccountQuery,
      TError = unknown
    >(
      variables: GetTelecomMcatSubAccountQueryVariables,
      options?: UseQueryOptions<GetTelecomMcatSubAccountQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomMcatSubAccountQuery, TError, TData>(
      ['GetTelecomMcatSubAccount', variables],
      useFetchData<GetTelecomMcatSubAccountQuery, GetTelecomMcatSubAccountQueryVariables>(GetTelecomMcatSubAccountDocument).bind(null, variables),
      options
    )};

export const TelecomStatsSupportPhoneDocument = `
    query TelecomStatsSupportPhone {
  telecomStatsSupportPhone
}
    `;

export const useTelecomStatsSupportPhoneQuery = <
      TData = TelecomStatsSupportPhoneQuery,
      TError = unknown
    >(
      variables?: TelecomStatsSupportPhoneQueryVariables,
      options?: UseQueryOptions<TelecomStatsSupportPhoneQuery, TError, TData>
    ) => {
    
    return useQuery<TelecomStatsSupportPhoneQuery, TError, TData>(
      variables === undefined ? ['TelecomStatsSupportPhone'] : ['TelecomStatsSupportPhone', variables],
      useFetchData<TelecomStatsSupportPhoneQuery, TelecomStatsSupportPhoneQueryVariables>(TelecomStatsSupportPhoneDocument).bind(null, variables),
      options
    )};

export const CreateTelecomAccountDocument = `
    mutation createTelecomAccount($input: CreateTelecomBusinessAccountInput!) {
  createTelecomAccount(input: $input) {
    id
    accountNumber
    businessName
    registeredEntityName
    description
    sicCode {
      id
    }
    ein
    applyPenalty
    isActive
    isDisabled
    lastModified {
      username
      lastChanged
    }
    reconciliation {
      reconciledDate
      reconciledBy {
        email
        fullName
        id
        isActive
        isVerified
        username
      }
    }
    filingStatus {
      filingYear
      howFiled {
        id
        label
      }
      howReceived {
        id
        label
      }
      dateReceived
      hasExemption
    }
    bankruptcy {
      bankruptcyType {
        id
        label
      }
    }
    audit {
      auditYear
    }
    businessAccountType {
      id
      label
    }
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      payments
      penaltyCharge
      currentBalance
      delinquentBalance
      totalBalance
    }
  }
}
    `;

export const useCreateTelecomAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTelecomAccountMutation, TError, CreateTelecomAccountMutationVariables, TContext>) => {
    
    return useMutation<CreateTelecomAccountMutation, TError, CreateTelecomAccountMutationVariables, TContext>(
      ['createTelecomAccount'],
      useFetchData<CreateTelecomAccountMutation, CreateTelecomAccountMutationVariables>(CreateTelecomAccountDocument),
      options
    )};

export const GetTelecomSubAccountAssetsDocument = `
    query GetTelecomSubAccountAssets($telecomMasterId: Int!, $accountId: Int!, $taxYear: Int!) {
  telecomSubAccountAssets(
    telecomMasterId: $telecomMasterId
    accountId: $accountId
    taxYear: $taxYear
  ) {
    id
    classification
    classificationDescription
    description
    yearAcquired
    quantity
    costPer
    percentGood
    taxableValue
    ein
    updateDate
    isActive
  }
  getClassifications {
    id
    clsf
    scheduleId
    description
  }
  getTaxRate(accountId: $accountId, taxYear: $taxYear) {
    id
    taxRate
  }
}
    `;

export const useGetTelecomSubAccountAssetsQuery = <
      TData = GetTelecomSubAccountAssetsQuery,
      TError = unknown
    >(
      variables: GetTelecomSubAccountAssetsQueryVariables,
      options?: UseQueryOptions<GetTelecomSubAccountAssetsQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomSubAccountAssetsQuery, TError, TData>(
      ['GetTelecomSubAccountAssets', variables],
      useFetchData<GetTelecomSubAccountAssetsQuery, GetTelecomSubAccountAssetsQueryVariables>(GetTelecomSubAccountAssetsDocument).bind(null, variables),
      options
    )};

export const SaveTelecomSubAccountAssetsDocument = `
    mutation SaveTelecomSubAccountAssets($telecomMasterId: Int!, $accountId: Int!, $assets: [AssetInput!]!) {
  saveTelecomSubAccountAssets(
    telecomMasterId: $telecomMasterId
    accountId: $accountId
    assets: $assets
  ) {
    id
    classification
    classificationDescription
    description
    yearAcquired
    quantity
    costPer
    percentGood
    taxableValue
    ein
    updateDate
    isActive
  }
}
    `;

export const useSaveTelecomSubAccountAssetsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveTelecomSubAccountAssetsMutation, TError, SaveTelecomSubAccountAssetsMutationVariables, TContext>) => {
    
    return useMutation<SaveTelecomSubAccountAssetsMutation, TError, SaveTelecomSubAccountAssetsMutationVariables, TContext>(
      ['SaveTelecomSubAccountAssets'],
      useFetchData<SaveTelecomSubAccountAssetsMutation, SaveTelecomSubAccountAssetsMutationVariables>(SaveTelecomSubAccountAssetsDocument),
      options
    )};

export const GetTelecomSubAccountLessorsDocument = `
    query GetTelecomSubAccountLessors($telecomMasterId: Int!, $accountId: Int!, $taxYear: Int!) {
  telecomSubAccountLessors(
    telecomMasterId: $telecomMasterId
    accountId: $accountId
    taxYear: $taxYear
  ) {
    id
    name
    contactLinkId
    contactType {
      id
      label
    }
    address {
      inCareOf
      addressLine1
      addressLine2
      city
      state
      zipCode
      phone
      phoneExtension
    }
    assets {
      id
      leaseId
      leaseAccountId
      leaseNumber
      contactLinkId
      description
      yearAcquired
      quantity
      costPer
      annualLeaseAmount
      initialValue
      leaseStartDate
      leaseEndDate
      fileUrl
      fileName
      blobName
      isActive
    }
  }
}
    `;

export const useGetTelecomSubAccountLessorsQuery = <
      TData = GetTelecomSubAccountLessorsQuery,
      TError = unknown
    >(
      variables: GetTelecomSubAccountLessorsQueryVariables,
      options?: UseQueryOptions<GetTelecomSubAccountLessorsQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomSubAccountLessorsQuery, TError, TData>(
      ['GetTelecomSubAccountLessors', variables],
      useFetchData<GetTelecomSubAccountLessorsQuery, GetTelecomSubAccountLessorsQueryVariables>(GetTelecomSubAccountLessorsDocument).bind(null, variables),
      options
    )};

export const SaveTelecomSubAccountLessorsDocument = `
    mutation SaveTelecomSubAccountLessors($telecomMasterId: Int!, $accountId: Int!, $lessor: LessorInput!) {
  saveTelecomSubAccountLessor(
    telecomMasterId: $telecomMasterId
    accountId: $accountId
    lessor: $lessor
  ) {
    id
    name
    contactLinkId
    contactType {
      id
      label
    }
    address {
      inCareOf
      addressLine1
      addressLine2
      city
      state
      zipCode
      phone
      phoneExtension
    }
    assets {
      id
      leaseId
      leaseAccountId
      leaseNumber
      contactLinkId
      description
      yearAcquired
      quantity
      costPer
      annualLeaseAmount
      initialValue
      leaseStartDate
      leaseEndDate
      fileUrl
      fileName
      blobName
      isActive
    }
  }
}
    `;

export const useSaveTelecomSubAccountLessorsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveTelecomSubAccountLessorsMutation, TError, SaveTelecomSubAccountLessorsMutationVariables, TContext>) => {
    
    return useMutation<SaveTelecomSubAccountLessorsMutation, TError, SaveTelecomSubAccountLessorsMutationVariables, TContext>(
      ['SaveTelecomSubAccountLessors'],
      useFetchData<SaveTelecomSubAccountLessorsMutation, SaveTelecomSubAccountLessorsMutationVariables>(SaveTelecomSubAccountLessorsDocument),
      options
    )};

export const GetTelecomMcatAssetsDocument = `
    query GetTelecomMcatAssets($params: TelecomMcatAssetsInput!) {
  telecomMcatAssets(params: $params) {
    id
    classification {
      id
      label
    }
    description
    yearAcquired
    quantity
    costPer
    percentGood
    taxableValue
    taxRate
    netAsmtCharge
    telecomMasterId
    telecomAccountNumber
    taxDistrict
    accountId
    accountNumber
    jurisdiction {
      id
      name
    }
    taxYear
    uploadDate
    processDate
    updateDate
    ein
    isReconciled
    reconcileDate
    isActive
  }
  getClassifications {
    id
    clsf
    scheduleId
    description
  }
}
    `;

export const useGetTelecomMcatAssetsQuery = <
      TData = GetTelecomMcatAssetsQuery,
      TError = unknown
    >(
      variables: GetTelecomMcatAssetsQueryVariables,
      options?: UseQueryOptions<GetTelecomMcatAssetsQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomMcatAssetsQuery, TError, TData>(
      ['GetTelecomMcatAssets', variables],
      useFetchData<GetTelecomMcatAssetsQuery, GetTelecomMcatAssetsQueryVariables>(GetTelecomMcatAssetsDocument).bind(null, variables),
      options
    )};

export const GetTelecomMcatLessorsDocument = `
    query GetTelecomMcatLessors($params: TelecomMcatAssetsInput!) {
  telecomMcatLessors(params: $params) {
    id
    name
    contactLinkId
    contactType {
      id
      label
    }
    address {
      inCareOf
      addressLine1
      addressLine2
      city
      state
      zipCode
      phone
      phoneExtension
    }
    assets {
      id
      leaseId
      leaseAccountId
      leaseNumber
      contactLinkId
      description
      yearAcquired
      quantity
      costPer
      annualLeaseAmount
      initialValue
      leaseStartDate
      leaseEndDate
      fileUrl
      fileName
      blobName
      isActive
    }
  }
}
    `;

export const useGetTelecomMcatLessorsQuery = <
      TData = GetTelecomMcatLessorsQuery,
      TError = unknown
    >(
      variables: GetTelecomMcatLessorsQueryVariables,
      options?: UseQueryOptions<GetTelecomMcatLessorsQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomMcatLessorsQuery, TError, TData>(
      ['GetTelecomMcatLessors', variables],
      useFetchData<GetTelecomMcatLessorsQuery, GetTelecomMcatLessorsQueryVariables>(GetTelecomMcatLessorsDocument).bind(null, variables),
      options
    )};

export const SaveTelecomMcatLessorDocument = `
    mutation SaveTelecomMcatLessor($input: SaveTelecomMcatLessorInput!) {
  saveTelecomMcatLessor(input: $input) {
    id
    name
    contactLinkId
    contactType {
      id
      label
    }
    address {
      inCareOf
      addressLine1
      addressLine2
      city
      state
      zipCode
      phone
      phoneExtension
    }
    assets {
      id
      leaseId
      leaseAccountId
      leaseNumber
      contactLinkId
      description
      yearAcquired
      quantity
      costPer
      annualLeaseAmount
      initialValue
      leaseStartDate
      leaseEndDate
      fileUrl
      fileName
      blobName
      isActive
    }
  }
}
    `;

export const useSaveTelecomMcatLessorMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveTelecomMcatLessorMutation, TError, SaveTelecomMcatLessorMutationVariables, TContext>) => {
    
    return useMutation<SaveTelecomMcatLessorMutation, TError, SaveTelecomMcatLessorMutationVariables, TContext>(
      ['SaveTelecomMcatLessor'],
      useFetchData<SaveTelecomMcatLessorMutation, SaveTelecomMcatLessorMutationVariables>(SaveTelecomMcatLessorDocument),
      options
    )};

export const GetTelecomMasterAssetsDocument = `
    query GetTelecomMasterAssets($telecomMasterId: ID!, $taxYear: Int!) {
  telecomMasterAssets(telecomMasterId: $telecomMasterId, taxYear: $taxYear) {
    id
    subAccountId
    subAccountNumber
    taxDistrict
    description
    classification {
      id
      label
    }
    yearAcquired
    quantity
    costPer
    percentGood
    taxableValue
    isActive
  }
}
    `;

export const useGetTelecomMasterAssetsQuery = <
      TData = GetTelecomMasterAssetsQuery,
      TError = unknown
    >(
      variables: GetTelecomMasterAssetsQueryVariables,
      options?: UseQueryOptions<GetTelecomMasterAssetsQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomMasterAssetsQuery, TError, TData>(
      ['GetTelecomMasterAssets', variables],
      useFetchData<GetTelecomMasterAssetsQuery, GetTelecomMasterAssetsQueryVariables>(GetTelecomMasterAssetsDocument).bind(null, variables),
      options
    )};

export const GetTelecomMcatStagedAssetsDocument = `
    query GetTelecomMcatStagedAssets($telecomMasterId: ID!, $taxYear: Int!) {
  telecomMcatStagedAssets(telecomMasterId: $telecomMasterId, taxYear: $taxYear) {
    id
    accountNumber
    jurisdiction {
      id
      name
    }
    taxDistrict
    classification {
      id
      label
    }
    description
    yearAcquired
    quantity
    costPer
    percentGood
    taxableValue
    netAsmtCharge
  }
}
    `;

export const useGetTelecomMcatStagedAssetsQuery = <
      TData = GetTelecomMcatStagedAssetsQuery,
      TError = unknown
    >(
      variables: GetTelecomMcatStagedAssetsQueryVariables,
      options?: UseQueryOptions<GetTelecomMcatStagedAssetsQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomMcatStagedAssetsQuery, TError, TData>(
      ['GetTelecomMcatStagedAssets', variables],
      useFetchData<GetTelecomMcatStagedAssetsQuery, GetTelecomMcatStagedAssetsQueryVariables>(GetTelecomMcatStagedAssetsDocument).bind(null, variables),
      options
    )};

export const GetTelecomMcatAssetFilesDocument = `
    query GetTelecomMcatAssetFiles($accountNumber: String!, $taxYear: Int!) {
  telecomMcatAssetFiles(accountNumber: $accountNumber, taxYear: $taxYear) {
    filename
    url
  }
}
    `;

export const useGetTelecomMcatAssetFilesQuery = <
      TData = GetTelecomMcatAssetFilesQuery,
      TError = unknown
    >(
      variables: GetTelecomMcatAssetFilesQueryVariables,
      options?: UseQueryOptions<GetTelecomMcatAssetFilesQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomMcatAssetFilesQuery, TError, TData>(
      ['GetTelecomMcatAssetFiles', variables],
      useFetchData<GetTelecomMcatAssetFilesQuery, GetTelecomMcatAssetFilesQueryVariables>(GetTelecomMcatAssetFilesDocument).bind(null, variables),
      options
    )};

export const SaveTelecomMcatAssetsDocument = `
    mutation SaveTelecomMcatAssets($assets: [McatAssetInput!]!) {
  saveTelecomMcatAssets(assets: $assets) {
    id
    classification {
      id
      label
    }
    description
    yearAcquired
    quantity
    costPer
    percentGood
    taxableValue
    taxRate
    netAsmtCharge
    telecomMasterId
    telecomAccountNumber
    taxDistrict
    accountId
    accountNumber
    jurisdiction {
      id
      name
    }
    taxYear
    uploadDate
    processDate
    updateDate
    ein
    isReconciled
    reconcileDate
    isActive
  }
}
    `;

export const useSaveTelecomMcatAssetsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveTelecomMcatAssetsMutation, TError, SaveTelecomMcatAssetsMutationVariables, TContext>) => {
    
    return useMutation<SaveTelecomMcatAssetsMutation, TError, SaveTelecomMcatAssetsMutationVariables, TContext>(
      ['SaveTelecomMcatAssets'],
      useFetchData<SaveTelecomMcatAssetsMutation, SaveTelecomMcatAssetsMutationVariables>(SaveTelecomMcatAssetsDocument),
      options
    )};

export const SaveTelecomMcatPropertyAssetListDocument = `
    mutation SaveTelecomMcatPropertyAssetList($fileName: String!, $accountNumber: ID!, $taxYear: Int!, $isLeased: Boolean!) {
  saveTelecomMcatPropertyAssetList(
    fileName: $fileName
    accountNumber: $accountNumber
    taxYear: $taxYear
    isLeased: $isLeased
  ) {
    accountNumber
    fileName
    validationReport
  }
}
    `;

export const useSaveTelecomMcatPropertyAssetListMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveTelecomMcatPropertyAssetListMutation, TError, SaveTelecomMcatPropertyAssetListMutationVariables, TContext>) => {
    
    return useMutation<SaveTelecomMcatPropertyAssetListMutation, TError, SaveTelecomMcatPropertyAssetListMutationVariables, TContext>(
      ['SaveTelecomMcatPropertyAssetList'],
      useFetchData<SaveTelecomMcatPropertyAssetListMutation, SaveTelecomMcatPropertyAssetListMutationVariables>(SaveTelecomMcatPropertyAssetListDocument),
      options
    )};

export const RemoveTelecomStagingDataDocument = `
    mutation RemoveTelecomStagingData($input: RemoveTelecomStagingDataInput!) {
  removeTelecomStagingData(input: $input)
}
    `;

export const useRemoveTelecomStagingDataMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTelecomStagingDataMutation, TError, RemoveTelecomStagingDataMutationVariables, TContext>) => {
    
    return useMutation<RemoveTelecomStagingDataMutation, TError, RemoveTelecomStagingDataMutationVariables, TContext>(
      ['RemoveTelecomStagingData'],
      useFetchData<RemoveTelecomStagingDataMutation, RemoveTelecomStagingDataMutationVariables>(RemoveTelecomStagingDataDocument),
      options
    )};

export const GetTelecomBusinessAccountDocument = `
    query GetTelecomBusinessAccount($accountNumber: String!, $taxYear: Int!) {
  telecomBusinessAccount(accountNumber: $accountNumber, taxYear: $taxYear) {
    id
    accountNumber
    businessName
    registeredEntityName
    description
    sicCode {
      id
      sicCode
      sicCodeDescription
      sicSiloCode
      subSiloCode
      isActive
    }
    ein
    applyPenalty
    isActive
    isDisabled
    lastModified {
      username
      lastChanged
    }
    reconciliation {
      reconciledDate
      reconciledBy {
        id
        fullName
        username
        email
        isActive
        isVerified
      }
    }
    filingStatus {
      hasExemption
      dateReceived
      howFiled {
        id
        label
      }
      howReceived {
        id
        label
      }
    }
    audit {
      auditYear
      auditedBy {
        id
        fullName
        username
        email
        isActive
        isVerified
      }
      auditReconcileDate
    }
    bankruptcy {
      bankruptcyType {
        id
        label
      }
    }
    businessAccountType {
      id
      label
    }
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      payments
      interest
      penaltyCharge
      currentBalance
      delinquentBalance
      totalBalance
    }
  }
}
    `;

export const useGetTelecomBusinessAccountQuery = <
      TData = GetTelecomBusinessAccountQuery,
      TError = unknown
    >(
      variables: GetTelecomBusinessAccountQueryVariables,
      options?: UseQueryOptions<GetTelecomBusinessAccountQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomBusinessAccountQuery, TError, TData>(
      ['GetTelecomBusinessAccount', variables],
      useFetchData<GetTelecomBusinessAccountQuery, GetTelecomBusinessAccountQueryVariables>(GetTelecomBusinessAccountDocument).bind(null, variables),
      options
    )};

export const SaveTelecomAccountDocument = `
    mutation SaveTelecomAccount($input: TelecomBusinessAccountInput!) {
  saveTelecomAccount(input: $input) {
    id
    accountNumber
    businessName
    registeredEntityName
    description
    sicCode {
      id
      sicCode
      sicCodeDescription
      sicSiloCode
      subSiloCode
      isActive
    }
    ein
    applyPenalty
    isActive
    isDisabled
    lastModified {
      username
      lastChanged
    }
    reconciliation {
      reconciledDate
      reconciledBy {
        id
        fullName
        username
        email
        isActive
        isVerified
      }
    }
    filingStatus {
      hasExemption
      dateReceived
      howFiled {
        id
        label
      }
      howReceived {
        id
        label
      }
    }
    audit {
      auditYear
      auditedBy {
        id
        fullName
        username
        email
        isActive
        isVerified
      }
      auditReconcileDate
    }
    bankruptcy {
      bankruptcyType {
        id
        label
      }
    }
    businessAccountType {
      id
      label
    }
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      payments
      penaltyCharge
      interest
      currentBalance
      delinquentBalance
      totalBalance
    }
  }
}
    `;

export const useSaveTelecomAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveTelecomAccountMutation, TError, SaveTelecomAccountMutationVariables, TContext>) => {
    
    return useMutation<SaveTelecomAccountMutation, TError, SaveTelecomAccountMutationVariables, TContext>(
      ['SaveTelecomAccount'],
      useFetchData<SaveTelecomAccountMutation, SaveTelecomAccountMutationVariables>(SaveTelecomAccountDocument),
      options
    )};

export const UpdateTelecomExemptAndGetSummaryAmountDocument = `
    mutation updateTelecomExemptAndGetSummaryAmount($telecomMasterId: String!, $isExempt: Boolean!) {
  updateTelecomExemptAndGetSummaryAmount(
    telecomMasterId: $telecomMasterId
    isExempt: $isExempt
  ) {
    assessmentCharge
    cost
    currentBalance
    delinquentBalance
    directCharge
    interest
    payments
    penaltyCharge
    taxRate
    taxable
    totalBalance
    totalBalanceWithDelinquent
  }
}
    `;

export const useUpdateTelecomExemptAndGetSummaryAmountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTelecomExemptAndGetSummaryAmountMutation, TError, UpdateTelecomExemptAndGetSummaryAmountMutationVariables, TContext>) => {
    
    return useMutation<UpdateTelecomExemptAndGetSummaryAmountMutation, TError, UpdateTelecomExemptAndGetSummaryAmountMutationVariables, TContext>(
      ['updateTelecomExemptAndGetSummaryAmount'],
      useFetchData<UpdateTelecomExemptAndGetSummaryAmountMutation, UpdateTelecomExemptAndGetSummaryAmountMutationVariables>(UpdateTelecomExemptAndGetSummaryAmountDocument),
      options
    )};

export const ChangeTelecomAccountStatusDocument = `
    mutation ChangeTelecomAccountStatus($telecomMasterId: Int!, $active: Boolean!) {
  changeTelecomAccountStatus(telecomMasterId: $telecomMasterId, active: $active)
}
    `;

export const useChangeTelecomAccountStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChangeTelecomAccountStatusMutation, TError, ChangeTelecomAccountStatusMutationVariables, TContext>) => {
    
    return useMutation<ChangeTelecomAccountStatusMutation, TError, ChangeTelecomAccountStatusMutationVariables, TContext>(
      ['ChangeTelecomAccountStatus'],
      useFetchData<ChangeTelecomAccountStatusMutation, ChangeTelecomAccountStatusMutationVariables>(ChangeTelecomAccountStatusDocument),
      options
    )};

export const SearchTelecomByAccountNumberDocument = `
    mutation SearchTelecomByAccountNumber($accountNumber: String!) {
  searchTelecomBusinessAccountInfoByNumber(accountNumber: $accountNumber) {
    id
    businessName
    status
  }
}
    `;

export const useSearchTelecomByAccountNumberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SearchTelecomByAccountNumberMutation, TError, SearchTelecomByAccountNumberMutationVariables, TContext>) => {
    
    return useMutation<SearchTelecomByAccountNumberMutation, TError, SearchTelecomByAccountNumberMutationVariables, TContext>(
      ['SearchTelecomByAccountNumber'],
      useFetchData<SearchTelecomByAccountNumberMutation, SearchTelecomByAccountNumberMutationVariables>(SearchTelecomByAccountNumberDocument),
      options
    )};

export const TelecomMcatSearchAccountsDocument = `
    query TelecomMcatSearchAccounts($filters: TelecomMcatSearchFilters) {
  telecomMcatSearchAccounts(Filters: $filters) {
    totalRecordCount
    results {
      id
      accountNumber
      businessName
      isActive
      status
      isReconciled
    }
  }
}
    `;

export const useTelecomMcatSearchAccountsQuery = <
      TData = TelecomMcatSearchAccountsQuery,
      TError = unknown
    >(
      variables?: TelecomMcatSearchAccountsQueryVariables,
      options?: UseQueryOptions<TelecomMcatSearchAccountsQuery, TError, TData>
    ) => {
    
    return useQuery<TelecomMcatSearchAccountsQuery, TError, TData>(
      variables === undefined ? ['TelecomMcatSearchAccounts'] : ['TelecomMcatSearchAccounts', variables],
      useFetchData<TelecomMcatSearchAccountsQuery, TelecomMcatSearchAccountsQueryVariables>(TelecomMcatSearchAccountsDocument).bind(null, variables),
      options
    )};

export const GetMcatTelecomAccountDocument = `
    query GetMCATTelecomAccount($accountNbr: String!, $taxYear: Int!, $jurisdiction: Int) {
  getMCATTelecomAccount(
    accountNbr: $accountNbr
    taxYear: $taxYear
    jurisdiction: $jurisdiction
  ) {
    id
    accountNumber
    pin
    businessName
    registeredEntityName
    businessAccountType {
      id
      label
    }
    description
    sicCode {
      id
      sicCode
      sicCodeDescription
      sicSiloCode
      subSiloCode
      isActive
    }
    ein
    applyPenalty
    isActive
    isDisabled
    lastModified {
      username
      lastChanged
    }
    reconciliation {
      reconciledBy {
        id
        username
        fullName
        email
        isActive
        isVerified
      }
      reconciledDate
    }
    filingStatus {
      filingYear
      howFiled {
        id
        label
      }
      howReceived {
        id
        label
      }
      dateReceived
      hasExemption
    }
    bankruptcy {
      bankruptcyType {
        id
        label
      }
    }
    audit {
      auditYear
      auditedBy {
        id
        fullName
        username
        email
        isActive
        isVerified
      }
      auditReconcileDate
    }
    accountSummary {
      cost
      taxable
      taxRate
      assessmentCharge
      directCharge
      payments
      interest
      penaltyCharge
      currentBalance
      delinquentBalance
      totalBalance
    }
  }
}
    `;

export const useGetMcatTelecomAccountQuery = <
      TData = GetMcatTelecomAccountQuery,
      TError = unknown
    >(
      variables: GetMcatTelecomAccountQueryVariables,
      options?: UseQueryOptions<GetMcatTelecomAccountQuery, TError, TData>
    ) => {
    
    return useQuery<GetMcatTelecomAccountQuery, TError, TData>(
      ['GetMCATTelecomAccount', variables],
      useFetchData<GetMcatTelecomAccountQuery, GetMcatTelecomAccountQueryVariables>(GetMcatTelecomAccountDocument).bind(null, variables),
      options
    )};

export const GetMcatTelecomListDocument = `
    query GetMCATTelecomList {
  getMCATTelecomList {
    telecomMasterId
    telecomAccountNbr
    businessName
    isActive
    applyPenalty
    filedDate
    transferDate
  }
}
    `;

export const useGetMcatTelecomListQuery = <
      TData = GetMcatTelecomListQuery,
      TError = unknown
    >(
      variables?: GetMcatTelecomListQueryVariables,
      options?: UseQueryOptions<GetMcatTelecomListQuery, TError, TData>
    ) => {
    
    return useQuery<GetMcatTelecomListQuery, TError, TData>(
      variables === undefined ? ['GetMCATTelecomList'] : ['GetMCATTelecomList', variables],
      useFetchData<GetMcatTelecomListQuery, GetMcatTelecomListQueryVariables>(GetMcatTelecomListDocument).bind(null, variables),
      options
    )};

export const GetMcatTelecomJurisdictionsDocument = `
    query GetMCATTelecomJurisdictions($accountNbr: String!, $taxYear: Int!) {
  getMCATTelecomJurisdictions(accountNbr: $accountNbr, taxYear: $taxYear) {
    id
    name
  }
}
    `;

export const useGetMcatTelecomJurisdictionsQuery = <
      TData = GetMcatTelecomJurisdictionsQuery,
      TError = unknown
    >(
      variables: GetMcatTelecomJurisdictionsQueryVariables,
      options?: UseQueryOptions<GetMcatTelecomJurisdictionsQuery, TError, TData>
    ) => {
    
    return useQuery<GetMcatTelecomJurisdictionsQuery, TError, TData>(
      ['GetMCATTelecomJurisdictions', variables],
      useFetchData<GetMcatTelecomJurisdictionsQuery, GetMcatTelecomJurisdictionsQueryVariables>(GetMcatTelecomJurisdictionsDocument).bind(null, variables),
      options
    )};

export const GetMcatTelecomContactsDocument = `
    query GetMCATTelecomContacts($telecomId: String!, $taxYear: Int!) {
  getMCATTelecomContacts(telecomId: $telecomId, taxYear: $taxYear) {
    id
    contactType {
      id
      label
    }
    name
    email
    phone
    phoneExtension
    cellphone
    isPrimary
    sameAsBusinessAddress
    mailingAddress {
      addressLine1
      addressLine2
      inCareOf
      city
      state
      zipCode
      country {
        code
        name
      }
    }
  }
}
    `;

export const useGetMcatTelecomContactsQuery = <
      TData = GetMcatTelecomContactsQuery,
      TError = unknown
    >(
      variables: GetMcatTelecomContactsQueryVariables,
      options?: UseQueryOptions<GetMcatTelecomContactsQuery, TError, TData>
    ) => {
    
    return useQuery<GetMcatTelecomContactsQuery, TError, TData>(
      ['GetMCATTelecomContacts', variables],
      useFetchData<GetMcatTelecomContactsQuery, GetMcatTelecomContactsQueryVariables>(GetMcatTelecomContactsDocument).bind(null, variables),
      options
    )};

export const GetTelecomAssetStagingReportDocument = `
    query GetTelecomAssetStagingReport($telecomMasterId: ID!, $taxYear: Int!) {
  telecomAssetStagingReport(telecomMasterId: $telecomMasterId, taxYear: $taxYear) {
    id
    taxYear
    telecomMasterId
    telecomAccountNbr
    jurisdiction
    countyName
    taxDistrict
    accountId
    accountNbr
    clsf
    customerDesc
    yearAcquired
    quantity
    costPer
    percentGood
    taxRate
    taxableValue
    netAsmntCharge
    isLeased
    lessorName
    lessorAddress1
    lessorAddress2
    lessorCity
    lessorState
    lessorZip
    lessorPhone
    lessorPhoneExt
    leaseStartDate
    leaseEndDate
    annuaLeaseAmt
    initialValue
    isReconciled
    reconcileDate
    uploadDate
    recordType
    isActive
    transferDate
    updateDate
    updatedBy
  }
}
    `;

export const useGetTelecomAssetStagingReportQuery = <
      TData = GetTelecomAssetStagingReportQuery,
      TError = unknown
    >(
      variables: GetTelecomAssetStagingReportQueryVariables,
      options?: UseQueryOptions<GetTelecomAssetStagingReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomAssetStagingReportQuery, TError, TData>(
      ['GetTelecomAssetStagingReport', variables],
      useFetchData<GetTelecomAssetStagingReportQuery, GetTelecomAssetStagingReportQueryVariables>(GetTelecomAssetStagingReportDocument).bind(null, variables),
      options
    )};

export const GetTelecomContactInfoReportDocument = `
    query GetTelecomContactInfoReport($telecomMasterId: ID!, $taxYear: Int!) {
  telecomContactInfoReport(telecomMasterId: $telecomMasterId, taxYear: $taxYear) {
    id
    accountNbr
    businessName
    pinCode
    fullName
    contactType
    careOf
    address
    city
    state
    zipcode
    phoneOffice
    phoneExten
    phoneMobile
    emailAddress
  }
}
    `;

export const useGetTelecomContactInfoReportQuery = <
      TData = GetTelecomContactInfoReportQuery,
      TError = unknown
    >(
      variables: GetTelecomContactInfoReportQueryVariables,
      options?: UseQueryOptions<GetTelecomContactInfoReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomContactInfoReportQuery, TError, TData>(
      ['GetTelecomContactInfoReport', variables],
      useFetchData<GetTelecomContactInfoReportQuery, GetTelecomContactInfoReportQueryVariables>(GetTelecomContactInfoReportDocument).bind(null, variables),
      options
    )};

export const GetTelecomFilingDifferenceReportDocument = `
    query GetTelecomFilingDifferenceReport($telecomMasterId: ID!, $taxYear: Int!) {
  telecomFilingDifferenceReport(
    telecomMasterId: $telecomMasterId
    taxYear: $taxYear
  ) {
    id
    telecomMasterId
    countyName
    taxDistrict
    clsf
    customerDesc
    yearAcquired
    quantity
    costPer
    changeCode
    columnChanged
    beforeValue
  }
}
    `;

export const useGetTelecomFilingDifferenceReportQuery = <
      TData = GetTelecomFilingDifferenceReportQuery,
      TError = unknown
    >(
      variables: GetTelecomFilingDifferenceReportQueryVariables,
      options?: UseQueryOptions<GetTelecomFilingDifferenceReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomFilingDifferenceReportQuery, TError, TData>(
      ['GetTelecomFilingDifferenceReport', variables],
      useFetchData<GetTelecomFilingDifferenceReportQuery, GetTelecomFilingDifferenceReportQueryVariables>(GetTelecomFilingDifferenceReportDocument).bind(null, variables),
      options
    )};

export const GetTelecomYearlyTaxableDifferenceReportDocument = `
    query GetTelecomYearlyTaxableDifferenceReport($telecomMasterId: ID!, $taxYear: Int!) {
  telecomYearlyTaxableDifferenceReport(
    telecomMasterId: $telecomMasterId
    taxYear: $taxYear
  ) {
    id
    telecomMasterId
    telecomAccountNbr
    jurisdiction
    countyName
    priorTaxYear
    currentTaxYear
    priorYearTaxable
    currentYearTaxable
    yearlyDifference
  }
}
    `;

export const useGetTelecomYearlyTaxableDifferenceReportQuery = <
      TData = GetTelecomYearlyTaxableDifferenceReportQuery,
      TError = unknown
    >(
      variables: GetTelecomYearlyTaxableDifferenceReportQueryVariables,
      options?: UseQueryOptions<GetTelecomYearlyTaxableDifferenceReportQuery, TError, TData>
    ) => {
    
    return useQuery<GetTelecomYearlyTaxableDifferenceReportQuery, TError, TData>(
      ['GetTelecomYearlyTaxableDifferenceReport', variables],
      useFetchData<GetTelecomYearlyTaxableDifferenceReportQuery, GetTelecomYearlyTaxableDifferenceReportQueryVariables>(GetTelecomYearlyTaxableDifferenceReportDocument).bind(null, variables),
      options
    )};

export const RemoveMcatTelecomWorkflowDocument = `
    mutation RemoveMCATTelecomWorkflow($accountNumber: String!) {
  removeMCATTelecomWorkflow(accountNumber: $accountNumber)
}
    `;

export const useRemoveMcatTelecomWorkflowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveMcatTelecomWorkflowMutation, TError, RemoveMcatTelecomWorkflowMutationVariables, TContext>) => {
    
    return useMutation<RemoveMcatTelecomWorkflowMutation, TError, RemoveMcatTelecomWorkflowMutationVariables, TContext>(
      ['RemoveMCATTelecomWorkflow'],
      useFetchData<RemoveMcatTelecomWorkflowMutation, RemoveMcatTelecomWorkflowMutationVariables>(RemoveMcatTelecomWorkflowDocument),
      options
    )};

export const TransferTelecomMcatAssetsToProductionDocument = `
    mutation TransferTelecomMcatAssetsToProduction($telecomInput: TransferTelecomAssetsToProductionInput!) {
  transferTelecomMcatAssetsToProduction(telecomInput: $telecomInput)
}
    `;

export const useTransferTelecomMcatAssetsToProductionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TransferTelecomMcatAssetsToProductionMutation, TError, TransferTelecomMcatAssetsToProductionMutationVariables, TContext>) => {
    
    return useMutation<TransferTelecomMcatAssetsToProductionMutation, TError, TransferTelecomMcatAssetsToProductionMutationVariables, TContext>(
      ['TransferTelecomMcatAssetsToProduction'],
      useFetchData<TransferTelecomMcatAssetsToProductionMutation, TransferTelecomMcatAssetsToProductionMutationVariables>(TransferTelecomMcatAssetsToProductionDocument),
      options
    )};

export const RegenerateMcatTelecomPinDocument = `
    mutation RegenerateMCATTelecomPin($accountNumber: String!) {
  regenerateMCATTelecomPin(accountNumber: $accountNumber)
}
    `;

export const useRegenerateMcatTelecomPinMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RegenerateMcatTelecomPinMutation, TError, RegenerateMcatTelecomPinMutationVariables, TContext>) => {
    
    return useMutation<RegenerateMcatTelecomPinMutation, TError, RegenerateMcatTelecomPinMutationVariables, TContext>(
      ['RegenerateMCATTelecomPin'],
      useFetchData<RegenerateMcatTelecomPinMutation, RegenerateMcatTelecomPinMutationVariables>(RegenerateMcatTelecomPinDocument),
      options
    )};

export const ChangeMcatTelecomActiveStatusDocument = `
    mutation ChangeMCATTelecomActiveStatus($accountNumber: String!, $isActive: Boolean!) {
  changeMCATTelecomActiveStatus(
    accountNumber: $accountNumber
    isActive: $isActive
  )
}
    `;

export const useChangeMcatTelecomActiveStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChangeMcatTelecomActiveStatusMutation, TError, ChangeMcatTelecomActiveStatusMutationVariables, TContext>) => {
    
    return useMutation<ChangeMcatTelecomActiveStatusMutation, TError, ChangeMcatTelecomActiveStatusMutationVariables, TContext>(
      ['ChangeMCATTelecomActiveStatus'],
      useFetchData<ChangeMcatTelecomActiveStatusMutation, ChangeMcatTelecomActiveStatusMutationVariables>(ChangeMcatTelecomActiveStatusDocument),
      options
    )};

export const ChangeMcatTelecomApplyPenaltyStatusDocument = `
    mutation ChangeMCATTelecomApplyPenaltyStatus($accountNumber: String!, $applyPenalty: Boolean!) {
  changeMCATTelecomApplyPenaltyStatus(
    accountNumber: $accountNumber
    applyPenalty: $applyPenalty
  )
}
    `;

export const useChangeMcatTelecomApplyPenaltyStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChangeMcatTelecomApplyPenaltyStatusMutation, TError, ChangeMcatTelecomApplyPenaltyStatusMutationVariables, TContext>) => {
    
    return useMutation<ChangeMcatTelecomApplyPenaltyStatusMutation, TError, ChangeMcatTelecomApplyPenaltyStatusMutationVariables, TContext>(
      ['ChangeMCATTelecomApplyPenaltyStatus'],
      useFetchData<ChangeMcatTelecomApplyPenaltyStatusMutation, ChangeMcatTelecomApplyPenaltyStatusMutationVariables>(ChangeMcatTelecomApplyPenaltyStatusDocument),
      options
    )};

export const ChangeMcatTelecomApplyPenaltyStatusByJurisdictionDocument = `
    mutation ChangeMCATTelecomApplyPenaltyStatusByJurisdiction($accountNumber: String!, $jurisdictionId: Int!, $applyPenalty: Boolean!) {
  changeMCATTelecomApplyPenaltyStatusByJurisdiction(
    accountNumber: $accountNumber
    jurisdictionId: $jurisdictionId
    applyPenalty: $applyPenalty
  )
}
    `;

export const useChangeMcatTelecomApplyPenaltyStatusByJurisdictionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChangeMcatTelecomApplyPenaltyStatusByJurisdictionMutation, TError, ChangeMcatTelecomApplyPenaltyStatusByJurisdictionMutationVariables, TContext>) => {
    
    return useMutation<ChangeMcatTelecomApplyPenaltyStatusByJurisdictionMutation, TError, ChangeMcatTelecomApplyPenaltyStatusByJurisdictionMutationVariables, TContext>(
      ['ChangeMCATTelecomApplyPenaltyStatusByJurisdiction'],
      useFetchData<ChangeMcatTelecomApplyPenaltyStatusByJurisdictionMutation, ChangeMcatTelecomApplyPenaltyStatusByJurisdictionMutationVariables>(ChangeMcatTelecomApplyPenaltyStatusByJurisdictionDocument),
      options
    )};

export const ChangeMcatTelecomExemptStatusByJurisdictionDocument = `
    mutation ChangeMCATTelecomExemptStatusByJurisdiction($accountNumber: String!, $jurisdictionId: Int!, $isExempt: Boolean!) {
  changeMCATTelecomExemptStatusByJurisdiction(
    accountNumber: $accountNumber
    jurisdictionId: $jurisdictionId
    isExempt: $isExempt
  )
}
    `;

export const useChangeMcatTelecomExemptStatusByJurisdictionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChangeMcatTelecomExemptStatusByJurisdictionMutation, TError, ChangeMcatTelecomExemptStatusByJurisdictionMutationVariables, TContext>) => {
    
    return useMutation<ChangeMcatTelecomExemptStatusByJurisdictionMutation, TError, ChangeMcatTelecomExemptStatusByJurisdictionMutationVariables, TContext>(
      ['ChangeMCATTelecomExemptStatusByJurisdiction'],
      useFetchData<ChangeMcatTelecomExemptStatusByJurisdictionMutation, ChangeMcatTelecomExemptStatusByJurisdictionMutationVariables>(ChangeMcatTelecomExemptStatusByJurisdictionDocument),
      options
    )};

export const SearchDocument = `
    query Search($searchFilters: SearchFilters) {
  search(searchFilters: $searchFilters) {
    id
    username
    email
    fullName
    title
    phone
    isActive
    isVerified
    roles {
      id
      name
    }
  }
}
    `;

export const useSearchQuery = <
      TData = SearchQuery,
      TError = unknown
    >(
      variables?: SearchQueryVariables,
      options?: UseQueryOptions<SearchQuery, TError, TData>
    ) => {
    
    return useQuery<SearchQuery, TError, TData>(
      variables === undefined ? ['Search'] : ['Search', variables],
      useFetchData<SearchQuery, SearchQueryVariables>(SearchDocument).bind(null, variables),
      options
    )};

export const GetProfileDocument = `
    query GetProfile {
  getProfile {
    username
    email
  }
}
    `;

export const useGetProfileQuery = <
      TData = GetProfileQuery,
      TError = unknown
    >(
      variables?: GetProfileQueryVariables,
      options?: UseQueryOptions<GetProfileQuery, TError, TData>
    ) => {
    
    return useQuery<GetProfileQuery, TError, TData>(
      variables === undefined ? ['GetProfile'] : ['GetProfile', variables],
      useFetchData<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument).bind(null, variables),
      options
    )};

export const CreateUserDocument = `
    mutation CreateUser($newUser: NewUser!) {
  createUser(newUser: $newUser)
}
    `;

export const useCreateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateUserMutation, TError, CreateUserMutationVariables, TContext>) => {
    
    return useMutation<CreateUserMutation, TError, CreateUserMutationVariables, TContext>(
      ['CreateUser'],
      useFetchData<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument),
      options
    )};

export const UpdateUserDocument = `
    mutation UpdateUser($updatedUser: UpdatedUser!, $id: Int!) {
  updateUser(updatedUser: $updatedUser, id: $id)
}
    `;

export const useUpdateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>) => {
    
    return useMutation<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>(
      ['UpdateUser'],
      useFetchData<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument),
      options
    )};

export const ImpersonateUserDocument = `
    mutation ImpersonateUser($id: Int!) {
  impersonateUser(id: $id) {
    token
  }
}
    `;

export const useImpersonateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ImpersonateUserMutation, TError, ImpersonateUserMutationVariables, TContext>) => {
    
    return useMutation<ImpersonateUserMutation, TError, ImpersonateUserMutationVariables, TContext>(
      ['ImpersonateUser'],
      useFetchData<ImpersonateUserMutation, ImpersonateUserMutationVariables>(ImpersonateUserDocument),
      options
    )};
